
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6R8w9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DashboardEditable", () => $300eaf56b0738430$export$33b9febc64bdf6bf);
$parcel$export(module.exports, "default", () => $300eaf56b0738430$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $966Wa = parcelRequire("966Wa");

var $lxsI7 = parcelRequire("lxsI7");

var $exb0h = parcelRequire("exb0h");

var $fWkFY = parcelRequire("fWkFY");

var $kEBPk = parcelRequire("kEBPk");

var $7CnU4 = parcelRequire("7CnU4");

var $lIqKj = parcelRequire("lIqKj");

var $jOV2f = parcelRequire("jOV2f");

var $244wN = parcelRequire("244wN");

var $eeqLP = parcelRequire("eeqLP");

var $zdVcQ = parcelRequire("zdVcQ");

var $3Dnr1 = parcelRequire("3Dnr1");

var $f9MgH = parcelRequire("f9MgH");

var $bEZRh = parcelRequire("bEZRh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $01Qi5 = parcelRequire("01Qi5");

var $lB25E = parcelRequire("lB25E");

var $cQdeb = parcelRequire("cQdeb");

var $i5UyB = parcelRequire("i5UyB");

var $aaVtE = parcelRequire("aaVtE");

var $6Ltiq = parcelRequire("6Ltiq");

var $hoIyF = parcelRequire("hoIyF");

var $jfoA0 = parcelRequire("jfoA0");

var $aPQRs = parcelRequire("aPQRs");

var $ljLL8 = parcelRequire("ljLL8");

var $9r5zP = parcelRequire("9r5zP");
const $300eaf56b0738430$export$33b9febc64bdf6bf = ()=>{
    const { data: data, error: error, loading: loading } = (0, $01Qi5.useDashboardResource)();
    const { registerConnectGadget: registerConnectGadget, unregisterConnectGadget: unregisterConnectGadget, setCustomTitle: setCustomTitle } = (0, $f9MgH.useConnectGadgetTitles)();
    const setLayout = (0, $i5UyB.useLayoutChange)();
    const showLayoutFlag = (0, $9r5zP.useLayoutChangeErrorFlag)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onLayoutHandler = (0, $eUqFw.useCallback)((...args)=>{
        setLayout(...args).catch(showLayoutFlag);
    }, [
        setLayout,
        showLayoutFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Dnr1.DashboardContentContainer), {
        analyticsExperience: (0, $kEBPk.VIEW_DASHBOARD_EDITABLE_EXPERIENCE),
        saveCustomGadgetTitle: setCustomTitle,
        resourceData: {
            data: data,
            error: error,
            loading: loading
        },
        permissionErrorFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.DashboardPermissionErrorPageAsync), null)
    }, data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOV2f.DashboardController), {
        id: data.id,
        automaticRefreshMs: data.automaticRefreshMs
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQdeb.RightPanelLayoutContainer), {
        isOpenByDefault: true,
        defaultPanelId: `${(0, $jfoA0.addGadgetPanelId)}-0`,
        rightContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoIyF.AsyncAddGadgetPanel), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aPQRs.HeaderEditable), {
        data: data,
        banners: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxsI7.default), {
            appearance: "discovery"
        }, formatMessage((0, $aaVtE.default).editingInfo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CnU4.DeprecationBanner), {
            gadgets: data.gadgets,
            gadgetId: data.id
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeqLP.EngagementBanners), null)),
        onLayoutSelected: onLayoutHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $zdVcQ.ColumnLayout), {
        data: data,
        dnd: {
            DragDropContext: $966Wa.DragDropContext,
            Draggable: $966Wa.Draggable,
            Droppable: $966Wa.Droppable
        },
        columnPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ljLL8.ColumnPlaceholder), null),
        layoutPlaceholder: null,
        onLayoutReposition: onLayoutHandler
    }, ({ isAnyDragging: isAnyDragging, ...gadgetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIqKj.DashboardControllerContextConsumer), null, ({ refreshId: refreshId, onMount: onMount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ltiq.GadgetEditable), {
                ...gadgetProps,
                isConnectDisabled: isAnyDragging,
                dashboardId: data.id,
                refreshId: refreshId,
                onMount: onMount,
                onRegisterConnectGadget: registerConnectGadget,
                onUnregisterConnectGadget: unregisterConnectGadget
            }))))) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$300eaf56b0738430$export$2e2bcd8739ae039 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $01Qi5.useDashboardResource)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { path: viewPath } = (0, $10fdS.useRouteByName)((0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW)) ?? {};
    const { path: systemDashboardPath } = (0, $10fdS.useRouteByName)((0, $exb0h.ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)) ?? {};
    const { id: id, title: title } = data ?? {};
    if (id === (0, $kEBPk.SYSTEM_DASHBOARD_ID)) return systemDashboardPath != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $lB25E.generatePath)(systemDashboardPath)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.DashboardPermissionErrorPageAsync), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $244wN.DashboardPageContainer), {
        analyticsSourceName: (0, $kEBPk.DASHBOARD_EDIT_SOURCENAME),
        analyticsExperience: (0, $kEBPk.VIEW_DASHBOARD_EDITABLE_EXPERIENCE),
        documentTitle: title ? formatMessage((0, $aaVtE.default).pageTitle, {
            dashboardName: title
        }) : formatMessage((0, $aaVtE.default).pageTitleFallback),
        unauthorisedFallback: viewPath && id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $lB25E.generatePath)(viewPath, {
                dashboardId: id
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.DashboardPermissionErrorPageAsync), null),
        unauthenticatedFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWkFY.default), null),
        resourceData: {
            data: data,
            error: error,
            loading: loading
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($300eaf56b0738430$export$33b9febc64bdf6bf, null));
};

});
parcelRegister("966Wa", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", () => $69fa0e3037063634$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $69fa0e3037063634$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $69fa0e3037063634$export$423ec2075359570a);

var $eUqFw = parcelRequire("eUqFw");

var $fzXll = parcelRequire("fzXll");

var $bqCNv = parcelRequire("bqCNv");

var $34lu7 = parcelRequire("34lu7");

var $4QJdp = parcelRequire("4QJdp");
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");
var $b02ud = parcelRequire("b02ud");

var $bn5nT = parcelRequire("bn5nT");

var $dCUwp = parcelRequire("dCUwp");

var $3YjjI = parcelRequire("3YjjI");

var $l1Zd2 = parcelRequire("l1Zd2");

var $gxvYj = parcelRequire("gxvYj");

var $5JNlj = parcelRequire("5JNlj");

var $85I24 = parcelRequire("85I24");

var $lEfVV = parcelRequire("lEfVV");

var $8kUbC = parcelRequire("8kUbC");
var $69fa0e3037063634$var$isProduction = true;
var $69fa0e3037063634$var$spacesAndTabs = /[ \t]{2,}/g;
var $69fa0e3037063634$var$lineStartWithSpaces = /^[ \t]*/gm;
var $69fa0e3037063634$var$clean = function clean(value) {
    return value.replace($69fa0e3037063634$var$spacesAndTabs, ' ').replace($69fa0e3037063634$var$lineStartWithSpaces, '').trim();
};
var $69fa0e3037063634$var$getDevMessage = function getDevMessage(message) {
    return $69fa0e3037063634$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $69fa0e3037063634$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $69fa0e3037063634$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $69fa0e3037063634$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $69fa0e3037063634$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $69fa0e3037063634$var$log(type, message) {
    var _console;
    if ($69fa0e3037063634$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$69fa0e3037063634$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $69fa0e3037063634$var$getFormattedMessage(message));
}
var $69fa0e3037063634$var$warning = $69fa0e3037063634$var$log.bind(null, 'warn');
var $69fa0e3037063634$var$error = $69fa0e3037063634$var$log.bind(null, 'error');
function $69fa0e3037063634$var$noop() {}
function $69fa0e3037063634$var$getOptions(shared, fromBinding) {
    return (0, $34lu7.default)({}, shared, fromBinding);
}
function $69fa0e3037063634$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $69fa0e3037063634$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $69fa0e3037063634$var$isProduction$1 = true;
var $69fa0e3037063634$var$prefix = 'Invariant failed';
function $69fa0e3037063634$var$RbdInvariant(message) {
    this.message = message;
}
$69fa0e3037063634$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $69fa0e3037063634$var$invariant(condition, message) {
    if (condition) return;
    if ($69fa0e3037063634$var$isProduction$1) throw new $69fa0e3037063634$var$RbdInvariant($69fa0e3037063634$var$prefix);
    else throw new $69fa0e3037063634$var$RbdInvariant($69fa0e3037063634$var$prefix + ": " + (message || ''));
}
var $69fa0e3037063634$var$ErrorBoundary = function(_React$Component) {
    (0, $bqCNv.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $69fa0e3037063634$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $69fa0e3037063634$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $69fa0e3037063634$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $69fa0e3037063634$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
var $69fa0e3037063634$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $69fa0e3037063634$var$position = function position(index) {
    return index + 1;
};
var $69fa0e3037063634$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $69fa0e3037063634$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $69fa0e3037063634$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $69fa0e3037063634$var$position(source.index);
    var endPosition = $69fa0e3037063634$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $69fa0e3037063634$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $69fa0e3037063634$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $69fa0e3037063634$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $69fa0e3037063634$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $69fa0e3037063634$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $69fa0e3037063634$var$position(source.index) + "\n";
};
var $69fa0e3037063634$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $69fa0e3037063634$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $69fa0e3037063634$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $69fa0e3037063634$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $69fa0e3037063634$var$returnedToStart(result.source) + "\n  ";
};
var $69fa0e3037063634$var$preset = {
    liftInstruction: $69fa0e3037063634$var$liftInstruction,
    onDragStart: $69fa0e3037063634$var$onDragStart,
    onDragUpdate: $69fa0e3037063634$var$onDragUpdate,
    onDragEnd: $69fa0e3037063634$var$onDragEnd
};
var $69fa0e3037063634$var$origin = {
    x: 0,
    y: 0
};
var $69fa0e3037063634$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $69fa0e3037063634$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $69fa0e3037063634$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $69fa0e3037063634$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $69fa0e3037063634$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $69fa0e3037063634$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $69fa0e3037063634$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $69fa0e3037063634$var$distance(target, point);
    }));
};
var $69fa0e3037063634$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $69fa0e3037063634$var$executeClip = function(frame, subject) {
    var result = (0, $bn5nT.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $69fa0e3037063634$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $69fa0e3037063634$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $69fa0e3037063634$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $69fa0e3037063634$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $69fa0e3037063634$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $69fa0e3037063634$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $34lu7.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $69fa0e3037063634$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $69fa0e3037063634$var$executeClip(frame.pageMarginBox, target);
    return (0, $bn5nT.getRect)(target);
};
var $69fa0e3037063634$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $69fa0e3037063634$var$scroll(page.marginBox, frame);
    var increased = $69fa0e3037063634$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $69fa0e3037063634$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $69fa0e3037063634$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $69fa0e3037063634$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $69fa0e3037063634$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $69fa0e3037063634$var$negate(scrollDiff);
    var frame = (0, $34lu7.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $34lu7.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $69fa0e3037063634$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3YjjI)))(map);
}
function $69fa0e3037063634$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $69fa0e3037063634$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $69fa0e3037063634$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $69fa0e3037063634$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $69fa0e3037063634$var$toDroppableMap = (0, $dCUwp.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $69fa0e3037063634$var$toDraggableMap = (0, $dCUwp.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $69fa0e3037063634$var$toDroppableList = (0, $dCUwp.default)(function(droppables) {
    return $69fa0e3037063634$var$values(droppables);
});
var $69fa0e3037063634$var$toDraggableList = (0, $dCUwp.default)(function(draggables) {
    return $69fa0e3037063634$var$values(draggables);
});
var $69fa0e3037063634$var$getDraggablesInsideDroppable = (0, $dCUwp.default)(function(droppableId, draggables) {
    var result = $69fa0e3037063634$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $69fa0e3037063634$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $69fa0e3037063634$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $69fa0e3037063634$var$removeDraggableFromList = (0, $dCUwp.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $69fa0e3037063634$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $69fa0e3037063634$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $34lu7.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $69fa0e3037063634$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $69fa0e3037063634$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $69fa0e3037063634$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $69fa0e3037063634$var$noDisplacedBy = {
    point: $69fa0e3037063634$var$origin,
    value: 0
};
var $69fa0e3037063634$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $69fa0e3037063634$var$noImpact = {
    displaced: $69fa0e3037063634$var$emptyGroups,
    displacedBy: $69fa0e3037063634$var$noDisplacedBy,
    at: null
};
var $69fa0e3037063634$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $69fa0e3037063634$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $69fa0e3037063634$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $69fa0e3037063634$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $69fa0e3037063634$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $69fa0e3037063634$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $69fa0e3037063634$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $69fa0e3037063634$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $69fa0e3037063634$var$origin;
    return $69fa0e3037063634$var$offsetByPosition(target, displacement);
};
var $69fa0e3037063634$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $69fa0e3037063634$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $69fa0e3037063634$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $69fa0e3037063634$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $69fa0e3037063634$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $69fa0e3037063634$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $69fa0e3037063634$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isPartiallyVisibleThroughFrame
    }));
};
var $69fa0e3037063634$var$isTotallyVisible = function isTotallyVisible(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isTotallyVisibleThroughFrame
    }));
};
var $69fa0e3037063634$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $69fa0e3037063634$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $69fa0e3037063634$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $bn5nT.getRect)((0, $bn5nT.expand)(marginBox, expandBy));
}
function $69fa0e3037063634$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $69fa0e3037063634$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $69fa0e3037063634$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $69fa0e3037063634$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $69fa0e3037063634$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $69fa0e3037063634$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $69fa0e3037063634$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $69fa0e3037063634$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $69fa0e3037063634$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $69fa0e3037063634$var$isHomeOf(draggable, destination);
    if (index == null) return $69fa0e3037063634$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $69fa0e3037063634$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $69fa0e3037063634$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $69fa0e3037063634$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $69fa0e3037063634$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $69fa0e3037063634$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $69fa0e3037063634$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $69fa0e3037063634$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $69fa0e3037063634$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $69fa0e3037063634$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $69fa0e3037063634$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $69fa0e3037063634$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $69fa0e3037063634$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($69fa0e3037063634$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $69fa0e3037063634$var$origin : $69fa0e3037063634$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $69fa0e3037063634$var$origin;
};
var $69fa0e3037063634$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $69fa0e3037063634$var$tryGetCombine(impact);
    !combine && $69fa0e3037063634$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $69fa0e3037063634$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $69fa0e3037063634$var$add(center, displaceBy);
};
var $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $69fa0e3037063634$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $69fa0e3037063634$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $69fa0e3037063634$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $69fa0e3037063634$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $69fa0e3037063634$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $69fa0e3037063634$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveInto.contentBox[axis.start] + $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $69fa0e3037063634$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $69fa0e3037063634$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($69fa0e3037063634$var$didStartAfterCritical(closestAfter, afterCritical)) return $69fa0e3037063634$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $bn5nT.offset)(closest.page, displacedBy.point);
        return $69fa0e3037063634$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($69fa0e3037063634$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $bn5nT.offset)(last.page, $69fa0e3037063634$var$negate(afterCritical.displacedBy.point));
        return $69fa0e3037063634$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $69fa0e3037063634$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $69fa0e3037063634$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $69fa0e3037063634$var$add(point, frame.scroll.diff.displacement);
};
var $69fa0e3037063634$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $69fa0e3037063634$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $69fa0e3037063634$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $69fa0e3037063634$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $69fa0e3037063634$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $69fa0e3037063634$var$scrollViewport = function(viewport, newScroll) {
    var diff = $69fa0e3037063634$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $69fa0e3037063634$var$negate(diff);
    var frame = (0, $bn5nT.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $69fa0e3037063634$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $69fa0e3037063634$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $69fa0e3037063634$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $69fa0e3037063634$var$scrollViewport(viewport, $69fa0e3037063634$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $69fa0e3037063634$var$scrollDroppable(destination, $69fa0e3037063634$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: $69fa0e3037063634$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: $69fa0e3037063634$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $69fa0e3037063634$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $34lu7.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $69fa0e3037063634$var$withViewportDisplacement = function(viewport, point) {
    return $69fa0e3037063634$var$add(viewport.scroll.diff.displacement, point);
};
var $69fa0e3037063634$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $69fa0e3037063634$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $69fa0e3037063634$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $69fa0e3037063634$var$add(draggable.client.borderBox.center, offset);
};
var $69fa0e3037063634$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $69fa0e3037063634$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $69fa0e3037063634$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $69fa0e3037063634$var$isTotallyVisibleOnAxis(args) : $69fa0e3037063634$var$isTotallyVisible(args);
};
var $69fa0e3037063634$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $69fa0e3037063634$var$isHomeOf(draggable, destination);
    var impact = $69fa0e3037063634$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $69fa0e3037063634$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $69fa0e3037063634$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $69fa0e3037063634$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $69fa0e3037063634$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $69fa0e3037063634$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $69fa0e3037063634$var$invariant(false);
    return rect;
};
var $69fa0e3037063634$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $69fa0e3037063634$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $69fa0e3037063634$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $69fa0e3037063634$var$isPartiallyVisibleThroughFrame(viewport.frame)($69fa0e3037063634$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $69fa0e3037063634$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $69fa0e3037063634$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $69fa0e3037063634$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $69fa0e3037063634$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $69fa0e3037063634$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $69fa0e3037063634$var$getKnownActive(droppable)[axis.crossAxisStart] === $69fa0e3037063634$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $69fa0e3037063634$var$isWithin($69fa0e3037063634$var$getKnownActive(droppable)[axis.start], $69fa0e3037063634$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $69fa0e3037063634$var$getKnownActive(a)[axis.start] - $69fa0e3037063634$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $69fa0e3037063634$var$closest(pageBorderBoxCenter, $69fa0e3037063634$var$getCorners($69fa0e3037063634$var$getKnownActive(a)));
        var second = $69fa0e3037063634$var$closest(pageBorderBoxCenter, $69fa0e3037063634$var$getCorners($69fa0e3037063634$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $69fa0e3037063634$var$getKnownActive(a)[axis.start] - $69fa0e3037063634$var$getKnownActive(b)[axis.start];
    })[0];
};
var $69fa0e3037063634$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $69fa0e3037063634$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $69fa0e3037063634$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $69fa0e3037063634$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $69fa0e3037063634$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $69fa0e3037063634$var$offsetByPosition(original, $69fa0e3037063634$var$negate(afterCritical.displacedBy.point)) : original;
};
var $69fa0e3037063634$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $69fa0e3037063634$var$isTotallyVisible({
            target: $69fa0e3037063634$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $69fa0e3037063634$var$distance(pageBorderBoxCenter, $69fa0e3037063634$var$withDroppableDisplacement(destination, $69fa0e3037063634$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $69fa0e3037063634$var$distance(pageBorderBoxCenter, $69fa0e3037063634$var$withDroppableDisplacement(destination, $69fa0e3037063634$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $69fa0e3037063634$var$getDisplacedBy = (0, $dCUwp.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $69fa0e3037063634$var$patch(axis.line, displacement)
    };
});
var $69fa0e3037063634$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $69fa0e3037063634$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $69fa0e3037063634$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $69fa0e3037063634$var$patch(axis.line, needsToGrowBy);
};
var $69fa0e3037063634$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $34lu7.default)({}, frame, {
        scroll: (0, $34lu7.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $69fa0e3037063634$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$69fa0e3037063634$var$isHomeOf(draggable, droppable) && $69fa0e3037063634$var$invariant(false);
    !!droppable.subject.withPlaceholder && $69fa0e3037063634$var$invariant(false);
    var placeholderSize = $69fa0e3037063634$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $69fa0e3037063634$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $69fa0e3037063634$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $34lu7.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $69fa0e3037063634$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $69fa0e3037063634$var$withMaxScroll(frame, maxScroll);
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $34lu7.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $69fa0e3037063634$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $69fa0e3037063634$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $69fa0e3037063634$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $34lu7.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $69fa0e3037063634$var$invariant(false);
    var newFrame = $69fa0e3037063634$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $34lu7.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $69fa0e3037063634$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $69fa0e3037063634$var$emptyGroups,
            displacedBy: $69fa0e3037063634$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $69fa0e3037063634$var$isHomeOf(draggable, destination) ? destination : $69fa0e3037063634$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $69fa0e3037063634$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $69fa0e3037063634$var$emptyGroups,
        index: proposedIndex
    });
};
var $69fa0e3037063634$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $69fa0e3037063634$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $69fa0e3037063634$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $69fa0e3037063634$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $69fa0e3037063634$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $69fa0e3037063634$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $69fa0e3037063634$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $69fa0e3037063634$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $69fa0e3037063634$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $69fa0e3037063634$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $69fa0e3037063634$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $69fa0e3037063634$var$isPositionInFrame(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $69fa0e3037063634$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $69fa0e3037063634$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $69fa0e3037063634$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $69fa0e3037063634$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $69fa0e3037063634$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $69fa0e3037063634$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$69fa0e3037063634$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($69fa0e3037063634$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $69fa0e3037063634$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $69fa0e3037063634$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $69fa0e3037063634$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $bn5nT.getRect)($69fa0e3037063634$var$offsetByPosition(rect, point));
};
var $69fa0e3037063634$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $69fa0e3037063634$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $69fa0e3037063634$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $69fa0e3037063634$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $69fa0e3037063634$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $69fa0e3037063634$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $69fa0e3037063634$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $69fa0e3037063634$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $69fa0e3037063634$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $69fa0e3037063634$var$isHomeOf(draggable, destination)
    });
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $69fa0e3037063634$var$combineThresholdDivisor = 4;
var $69fa0e3037063634$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $69fa0e3037063634$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $69fa0e3037063634$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $69fa0e3037063634$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $69fa0e3037063634$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $69fa0e3037063634$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $69fa0e3037063634$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $69fa0e3037063634$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $69fa0e3037063634$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $69fa0e3037063634$var$withDroppableScroll(destination, pageBorderBox);
    return $69fa0e3037063634$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $69fa0e3037063634$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $69fa0e3037063634$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $34lu7.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $69fa0e3037063634$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $69fa0e3037063634$var$whatIsDraggedOver(previousImpact);
    var now = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $69fa0e3037063634$var$removePlaceholder(lastDroppable);
    return $69fa0e3037063634$var$patchDroppableMap(droppables, updated);
};
var $69fa0e3037063634$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $69fa0e3037063634$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($69fa0e3037063634$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $69fa0e3037063634$var$addPlaceholder(droppable, draggable, draggables);
    return $69fa0e3037063634$var$patchDroppableMap(cleaned, patched);
};
var $69fa0e3037063634$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $69fa0e3037063634$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $69fa0e3037063634$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $69fa0e3037063634$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $69fa0e3037063634$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $69fa0e3037063634$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $34lu7.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $69fa0e3037063634$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $69fa0e3037063634$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $34lu7.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $69fa0e3037063634$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $69fa0e3037063634$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $69fa0e3037063634$var$getDraggables$1(last.all, draggables);
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $34lu7.default)({}, impact, {
        displaced: displaced
    });
};
var $69fa0e3037063634$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $69fa0e3037063634$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $69fa0e3037063634$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $69fa0e3037063634$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $69fa0e3037063634$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $69fa0e3037063634$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $69fa0e3037063634$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $69fa0e3037063634$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $69fa0e3037063634$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $69fa0e3037063634$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $69fa0e3037063634$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $69fa0e3037063634$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $69fa0e3037063634$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $69fa0e3037063634$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $69fa0e3037063634$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $69fa0e3037063634$var$records = {};
var $69fa0e3037063634$var$isEnabled = false;
var $69fa0e3037063634$var$isTimingsEnabled = function isTimingsEnabled() {
    return $69fa0e3037063634$var$isEnabled;
};
var $69fa0e3037063634$var$start = function start(key) {
    var now;
};
var $69fa0e3037063634$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $69fa0e3037063634$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $bn5nT.offset)(draggable.client, offset$1);
    var page = (0, $bn5nT.withScroll)(client, initialWindowScroll);
    var moved = (0, $34lu7.default)({}, draggable, {
        placeholder: (0, $34lu7.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $69fa0e3037063634$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $69fa0e3037063634$var$invariant(false);
    return frame;
};
var $69fa0e3037063634$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $69fa0e3037063634$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $69fa0e3037063634$var$add(windowScrollChange, droppableScrollChange);
        var moved = $69fa0e3037063634$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $69fa0e3037063634$var$timingsKey = 'Processing dynamic changes';
var $69fa0e3037063634$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $69fa0e3037063634$var$start($69fa0e3037063634$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $69fa0e3037063634$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $34lu7.default)({}, state.dimensions.droppables, $69fa0e3037063634$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $69fa0e3037063634$var$toDraggableMap($69fa0e3037063634$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $34lu7.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $69fa0e3037063634$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $69fa0e3037063634$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $69fa0e3037063634$var$finish($69fa0e3037063634$var$timingsKey);
    var draggingState = (0, $34lu7.default)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $34lu7.default)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $69fa0e3037063634$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $69fa0e3037063634$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $69fa0e3037063634$var$patchDimensionMap(state.dimensions, updated);
    if (!$69fa0e3037063634$var$isSnapping(state) || isEnabledChanging) return $69fa0e3037063634$var$update({
        state: state,
        dimensions: dimensions
    });
    return $69fa0e3037063634$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $69fa0e3037063634$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $34lu7.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $69fa0e3037063634$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $69fa0e3037063634$var$reducer = function(state, action) {
    if (state === void 0) state = $69fa0e3037063634$var$idle;
    if (action.type === 'FLUSH') return (0, $34lu7.default)({}, $69fa0e3037063634$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $69fa0e3037063634$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $69fa0e3037063634$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $69fa0e3037063634$var$add(client.selection, viewport.scroll.initial),
                offset: $69fa0e3037063634$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $69fa0e3037063634$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $69fa0e3037063634$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
        var _result = (0, $34lu7.default)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($69fa0e3037063634$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $69fa0e3037063634$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $69fa0e3037063634$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $69fa0e3037063634$var$scrollDroppable(target, newScroll);
        return $69fa0e3037063634$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $69fa0e3037063634$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $69fa0e3037063634$var$invariant(false);
        var updated = (0, $34lu7.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $69fa0e3037063634$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $69fa0e3037063634$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $69fa0e3037063634$var$invariant(false);
        var _updated = (0, $34lu7.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $69fa0e3037063634$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        !state.isWindowScrollAllowed && $69fa0e3037063634$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($69fa0e3037063634$var$isEqual(state.viewport.scroll.current, _newScroll)) return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        var _viewport = $69fa0e3037063634$var$scrollViewport(state.viewport, _newScroll);
        if ($69fa0e3037063634$var$isSnapping(state)) return $69fa0e3037063634$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $69fa0e3037063634$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$69fa0e3037063634$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($69fa0e3037063634$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $34lu7.default)({}, state.viewport, {
            scroll: (0, $34lu7.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $34lu7.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
        var _result2 = $69fa0e3037063634$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $69fa0e3037063634$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $69fa0e3037063634$var$invariant(false);
        var newState = (0, $34lu7.default)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $69fa0e3037063634$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $69fa0e3037063634$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $69fa0e3037063634$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $69fa0e3037063634$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $69fa0e3037063634$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $69fa0e3037063634$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $69fa0e3037063634$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $69fa0e3037063634$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $69fa0e3037063634$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $69fa0e3037063634$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $69fa0e3037063634$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $69fa0e3037063634$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $69fa0e3037063634$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $69fa0e3037063634$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $69fa0e3037063634$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $69fa0e3037063634$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $69fa0e3037063634$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $69fa0e3037063634$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $69fa0e3037063634$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $69fa0e3037063634$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $69fa0e3037063634$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($69fa0e3037063634$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $69fa0e3037063634$var$invariant(false);
                dispatch($69fa0e3037063634$var$flush());
                dispatch($69fa0e3037063634$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $69fa0e3037063634$var$validateDimensions(critical, dimensions);
                dispatch($69fa0e3037063634$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $69fa0e3037063634$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $69fa0e3037063634$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $69fa0e3037063634$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $69fa0e3037063634$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $69fa0e3037063634$var$outOfTheWayTiming = $69fa0e3037063634$var$timings.outOfTheWay + "s " + $69fa0e3037063634$var$curves.outOfTheWay;
var $69fa0e3037063634$var$transitions = {
    fluid: "opacity " + $69fa0e3037063634$var$outOfTheWayTiming,
    snap: "transform " + $69fa0e3037063634$var$outOfTheWayTiming + ", opacity " + $69fa0e3037063634$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $69fa0e3037063634$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $69fa0e3037063634$var$outOfTheWayTiming,
    placeholder: "height " + $69fa0e3037063634$var$outOfTheWayTiming + ", width " + $69fa0e3037063634$var$outOfTheWayTiming + ", margin " + $69fa0e3037063634$var$outOfTheWayTiming
};
var $69fa0e3037063634$var$moveTo = function moveTo(offset) {
    return $69fa0e3037063634$var$isEqual(offset, $69fa0e3037063634$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $69fa0e3037063634$var$transforms = {
    moveTo: $69fa0e3037063634$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $69fa0e3037063634$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $69fa0e3037063634$var$combine.scale.drop + ")";
    }
};
var $69fa0e3037063634$var$minDropTime = $69fa0e3037063634$var$timings.minDropTime, $69fa0e3037063634$var$maxDropTime = $69fa0e3037063634$var$timings.maxDropTime;
var $69fa0e3037063634$var$dropTimeRange = $69fa0e3037063634$var$maxDropTime - $69fa0e3037063634$var$minDropTime;
var $69fa0e3037063634$var$maxDropTimeAtDistance = 1500;
var $69fa0e3037063634$var$cancelDropModifier = 0.6;
var $69fa0e3037063634$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $69fa0e3037063634$var$distance(current, destination);
    if (distance$1 <= 0) return $69fa0e3037063634$var$minDropTime;
    if (distance$1 >= $69fa0e3037063634$var$maxDropTimeAtDistance) return $69fa0e3037063634$var$maxDropTime;
    var percentage = distance$1 / $69fa0e3037063634$var$maxDropTimeAtDistance;
    var duration = $69fa0e3037063634$var$minDropTime + $69fa0e3037063634$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $69fa0e3037063634$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $69fa0e3037063634$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $69fa0e3037063634$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $69fa0e3037063634$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $69fa0e3037063634$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $69fa0e3037063634$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $34lu7.default)({}, lastImpact, {
        displaced: $69fa0e3037063634$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $69fa0e3037063634$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($69fa0e3037063634$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $69fa0e3037063634$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $69fa0e3037063634$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $69fa0e3037063634$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $69fa0e3037063634$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $69fa0e3037063634$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$69fa0e3037063634$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($69fa0e3037063634$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $69fa0e3037063634$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($69fa0e3037063634$var$animateDrop(args));
        };
    };
};
var $69fa0e3037063634$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $69fa0e3037063634$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $69fa0e3037063634$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($69fa0e3037063634$var$getWindowScroll());
    }
    var scheduled = (0, $gxvYj.default)(updateScroll);
    var binding = $69fa0e3037063634$var$getWindowScrollBinding(scheduled);
    var unbind = $69fa0e3037063634$var$noop;
    function isActive() {
        return unbind !== $69fa0e3037063634$var$noop;
    }
    function start() {
        !!isActive() && $69fa0e3037063634$var$invariant(false);
        unbind = $69fa0e3037063634$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $69fa0e3037063634$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $69fa0e3037063634$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $69fa0e3037063634$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $69fa0e3037063634$var$scrollListener = function(store) {
    var listener = $69fa0e3037063634$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($69fa0e3037063634$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $69fa0e3037063634$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $69fa0e3037063634$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $69fa0e3037063634$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $69fa0e3037063634$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $69fa0e3037063634$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $69fa0e3037063634$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $69fa0e3037063634$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $69fa0e3037063634$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $69fa0e3037063634$var$withTimings = function withTimings(key, fn) {
    $69fa0e3037063634$var$start(key);
    fn();
    $69fa0e3037063634$var$finish(key);
};
var $69fa0e3037063634$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $69fa0e3037063634$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $69fa0e3037063634$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $69fa0e3037063634$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $69fa0e3037063634$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        $69fa0e3037063634$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        $69fa0e3037063634$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($69fa0e3037063634$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        var data = $69fa0e3037063634$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $69fa0e3037063634$var$withTimings('onDragStart', function() {
                return $69fa0e3037063634$var$execute(getResponders().onDragStart, data, announce, $69fa0e3037063634$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $69fa0e3037063634$var$tryGetDestination(impact);
        var combine = $69fa0e3037063634$var$tryGetCombine(impact);
        !dragging && $69fa0e3037063634$var$invariant(false);
        var hasCriticalChanged = !$69fa0e3037063634$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$69fa0e3037063634$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$69fa0e3037063634$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $34lu7.default)({}, $69fa0e3037063634$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $69fa0e3037063634$var$withTimings('onDragUpdate', function() {
                return $69fa0e3037063634$var$execute(getResponders().onDragUpdate, data, announce, $69fa0e3037063634$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $69fa0e3037063634$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $69fa0e3037063634$var$invariant(false);
        dragging = null;
        $69fa0e3037063634$var$withTimings('onDragEnd', function() {
            return $69fa0e3037063634$var$execute(getResponders().onDragEnd, result, announce, $69fa0e3037063634$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $34lu7.default)({}, $69fa0e3037063634$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $69fa0e3037063634$var$responders = function(getResponders, announce) {
    var publisher = $69fa0e3037063634$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $69fa0e3037063634$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $69fa0e3037063634$var$invariant(false);
            store.dispatch($69fa0e3037063634$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $69fa0e3037063634$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($69fa0e3037063634$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $69fa0e3037063634$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $69fa0e3037063634$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $69fa0e3037063634$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $69fa0e3037063634$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $69fa0e3037063634$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($69fa0e3037063634$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $69fa0e3037063634$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($69fa0e3037063634$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $69fa0e3037063634$var$composeEnhancers = (0, $4QJdp.compose);
var $69fa0e3037063634$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $4QJdp.createStore)($69fa0e3037063634$var$reducer, $69fa0e3037063634$var$composeEnhancers((0, $4QJdp.applyMiddleware)($69fa0e3037063634$var$style(styleMarshal), $69fa0e3037063634$var$dimensionMarshalStopper(dimensionMarshal), $69fa0e3037063634$var$lift$1(dimensionMarshal), $69fa0e3037063634$var$drop$1, $69fa0e3037063634$var$dropAnimationFinish, $69fa0e3037063634$var$dropAnimationFlushOnScroll, $69fa0e3037063634$var$pendingDrop, $69fa0e3037063634$var$autoScroll(autoScroller), $69fa0e3037063634$var$scrollListener, $69fa0e3037063634$var$focus(focusMarshal), $69fa0e3037063634$var$responders(getResponders, announce))));
};
var $69fa0e3037063634$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $69fa0e3037063634$var$timingKey = 'Publish collection from DOM';
function $69fa0e3037063634$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $69fa0e3037063634$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $69fa0e3037063634$var$start($69fa0e3037063634$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($69fa0e3037063634$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(removals),
                modified: updated
            };
            staging = $69fa0e3037063634$var$clean$1();
            $69fa0e3037063634$var$finish($69fa0e3037063634$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $69fa0e3037063634$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $69fa0e3037063634$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $69fa0e3037063634$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $69fa0e3037063634$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $69fa0e3037063634$var$invariant(false);
    return doc;
};
var $69fa0e3037063634$var$getMaxWindowScroll = function() {
    var doc = $69fa0e3037063634$var$getDocumentElement();
    var maxScroll = $69fa0e3037063634$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $69fa0e3037063634$var$getViewport = function() {
    var scroll = $69fa0e3037063634$var$getWindowScroll();
    var maxScroll = $69fa0e3037063634$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $69fa0e3037063634$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $bn5nT.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $69fa0e3037063634$var$origin,
                displacement: $69fa0e3037063634$var$origin
            }
        }
    };
    return viewport;
};
var $69fa0e3037063634$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $69fa0e3037063634$var$start(timingKey);
    var viewport = $69fa0e3037063634$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $69fa0e3037063634$var$toDraggableMap(draggables),
        droppables: $69fa0e3037063634$var$toDroppableMap(droppables)
    };
    $69fa0e3037063634$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $69fa0e3037063634$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $69fa0e3037063634$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $69fa0e3037063634$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $69fa0e3037063634$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $69fa0e3037063634$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $69fa0e3037063634$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $69fa0e3037063634$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $69fa0e3037063634$var$getScrollableDroppables = (0, $dCUwp.default)(function(droppables) {
    return $69fa0e3037063634$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $69fa0e3037063634$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $69fa0e3037063634$var$find($69fa0e3037063634$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $69fa0e3037063634$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $69fa0e3037063634$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $69fa0e3037063634$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $69fa0e3037063634$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $69fa0e3037063634$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $69fa0e3037063634$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $69fa0e3037063634$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $69fa0e3037063634$var$minScroll = 1;
var $69fa0e3037063634$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $69fa0e3037063634$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $69fa0e3037063634$var$minScroll;
    var percentageFromMaxScrollValueAt = $69fa0e3037063634$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $69fa0e3037063634$var$config.maxPixelScroll * $69fa0e3037063634$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $69fa0e3037063634$var$accelerateAt = $69fa0e3037063634$var$config.durationDampening.accelerateAt;
var $69fa0e3037063634$var$stopAt = $69fa0e3037063634$var$config.durationDampening.stopDampeningAt;
var $69fa0e3037063634$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $69fa0e3037063634$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($5JNlj)))();
    var runTime = now - startOfRange;
    if (runTime >= $69fa0e3037063634$var$stopAt) return proposedScroll;
    if (runTime < $69fa0e3037063634$var$accelerateAt) return $69fa0e3037063634$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $69fa0e3037063634$var$getPercentage({
        startOfRange: $69fa0e3037063634$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $69fa0e3037063634$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $69fa0e3037063634$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $69fa0e3037063634$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($69fa0e3037063634$var$dampenValueByTime(scroll, dragStartTime), $69fa0e3037063634$var$minScroll);
};
var $69fa0e3037063634$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $69fa0e3037063634$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $69fa0e3037063634$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $69fa0e3037063634$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $69fa0e3037063634$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $69fa0e3037063634$var$clean$2 = $69fa0e3037063634$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $69fa0e3037063634$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $69fa0e3037063634$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $69fa0e3037063634$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $69fa0e3037063634$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $69fa0e3037063634$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $69fa0e3037063634$var$clean$2({
        x: x,
        y: y
    });
    if ($69fa0e3037063634$var$isEqual(required, $69fa0e3037063634$var$origin)) return null;
    var limited = $69fa0e3037063634$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $69fa0e3037063634$var$isEqual(limited, $69fa0e3037063634$var$origin) ? null : limited;
};
var $69fa0e3037063634$var$smallestSigned = $69fa0e3037063634$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $69fa0e3037063634$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $69fa0e3037063634$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($69fa0e3037063634$var$isEqual(overlap, $69fa0e3037063634$var$origin)) return null;
        return overlap;
    };
}();
var $69fa0e3037063634$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $69fa0e3037063634$var$smallestSigned(change);
    var overlap = $69fa0e3037063634$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $69fa0e3037063634$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $69fa0e3037063634$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$69fa0e3037063634$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $69fa0e3037063634$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $69fa0e3037063634$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $69fa0e3037063634$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$69fa0e3037063634$var$canScrollDroppable(droppable, change)) return null;
    return $69fa0e3037063634$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $69fa0e3037063634$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $69fa0e3037063634$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $69fa0e3037063634$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $69fa0e3037063634$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $69fa0e3037063634$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $69fa0e3037063634$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $69fa0e3037063634$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $69fa0e3037063634$var$getBestScrollableDroppable({
        center: center,
        destination: $69fa0e3037063634$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $69fa0e3037063634$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $69fa0e3037063634$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $gxvYj.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $gxvYj.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $69fa0e3037063634$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $69fa0e3037063634$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $69fa0e3037063634$var$start('starting fluid scroller');
        !!dragging && $69fa0e3037063634$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($5JNlj)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $69fa0e3037063634$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $69fa0e3037063634$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $69fa0e3037063634$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $69fa0e3037063634$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$69fa0e3037063634$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $69fa0e3037063634$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $69fa0e3037063634$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $69fa0e3037063634$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$69fa0e3037063634$var$canScrollWindow(viewport, change)) return change;
        var overlap = $69fa0e3037063634$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $69fa0e3037063634$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $69fa0e3037063634$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
        !destination && $69fa0e3037063634$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $69fa0e3037063634$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $69fa0e3037063634$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $69fa0e3037063634$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $69fa0e3037063634$var$prefix$1 = 'data-rbd';
var $69fa0e3037063634$var$dragHandle = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $69fa0e3037063634$var$draggable = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $69fa0e3037063634$var$droppable = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $69fa0e3037063634$var$scrollContainer = {
    contextId: $69fa0e3037063634$var$prefix$1 + "-scroll-container-context-id"
};
var $69fa0e3037063634$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $69fa0e3037063634$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $69fa0e3037063634$var$noPointerEvents = 'pointer-events: none;';
var $69fa0e3037063634$var$getStyles$1 = function(contextId) {
    var getSelector = $69fa0e3037063634$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($69fa0e3037063634$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $69fa0e3037063634$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $69fa0e3037063634$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($69fa0e3037063634$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($69fa0e3037063634$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $69fa0e3037063634$var$getStyles(rules, 'always'),
        resting: $69fa0e3037063634$var$getStyles(rules, 'resting'),
        dragging: $69fa0e3037063634$var$getStyles(rules, 'dragging'),
        dropAnimating: $69fa0e3037063634$var$getStyles(rules, 'dropAnimating'),
        userCancel: $69fa0e3037063634$var$getStyles(rules, 'userCancel')
    };
};
var $69fa0e3037063634$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);
var $69fa0e3037063634$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $69fa0e3037063634$var$invariant(false);
    return head;
};
var $69fa0e3037063634$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $69fa0e3037063634$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $eUqFw.useRef)(null);
    var dynamicRef = (0, $eUqFw.useRef)(null);
    var setDynamicStyle = (0, $fzXll.useCallback)((0, $dCUwp.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $69fa0e3037063634$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $fzXll.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $69fa0e3037063634$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $69fa0e3037063634$var$invariant(false);
        var always = $69fa0e3037063634$var$createStyleEl(nonce);
        var dynamic = $69fa0e3037063634$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($69fa0e3037063634$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($69fa0e3037063634$var$prefix$1 + "-dynamic", contextId);
        $69fa0e3037063634$var$getHead().appendChild(always);
        $69fa0e3037063634$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $69fa0e3037063634$var$invariant(false);
                $69fa0e3037063634$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $fzXll.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $fzXll.useCallback)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $fzXll.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $fzXll.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $69fa0e3037063634$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $69fa0e3037063634$var$isHtmlElement(el) {
    return el instanceof $69fa0e3037063634$var$getWindowFromEl(el).HTMLElement;
}
function $69fa0e3037063634$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $69fa0e3037063634$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $69fa0e3037063634$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $69fa0e3037063634$var$find(possible, function(el) {
        return el.getAttribute($69fa0e3037063634$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(handle)) return null;
    return handle;
}
function $69fa0e3037063634$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $eUqFw.useRef)({});
    var recordRef = (0, $eUqFw.useRef)(null);
    var restoreFocusFrameRef = (0, $eUqFw.useRef)(null);
    var isMountedRef = (0, $eUqFw.useRef)(false);
    var register = (0, $fzXll.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $fzXll.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $69fa0e3037063634$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $fzXll.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $fzXll.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $fzXll.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($69fa0e3037063634$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $fzXll.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $69fa0e3037063634$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $69fa0e3037063634$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $69fa0e3037063634$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $69fa0e3037063634$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $69fa0e3037063634$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $69fa0e3037063634$var$useRegistry() {
    var registry = (0, $fzXll.useMemo)($69fa0e3037063634$var$createRegistry, []);
    (0, $eUqFw.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $69fa0e3037063634$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $69fa0e3037063634$var$getBodyElement = function() {
    var body = document.body;
    !body && $69fa0e3037063634$var$invariant(false);
    return body;
};
var $69fa0e3037063634$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $69fa0e3037063634$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $69fa0e3037063634$var$useAnnouncer(contextId) {
    var id = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($85I24)))(el.style, $69fa0e3037063634$var$visuallyHidden);
        $69fa0e3037063634$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $69fa0e3037063634$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $fzXll.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $69fa0e3037063634$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $69fa0e3037063634$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $eUqFw.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($85I24)))(el.style, {
            display: 'none'
        });
        $69fa0e3037063634$var$getBodyElement().appendChild(el);
        return function unmount() {
            $69fa0e3037063634$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $69fa0e3037063634$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $69fa0e3037063634$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $69fa0e3037063634$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $69fa0e3037063634$var$getVersion = function getVersion(value) {
    var result = $69fa0e3037063634$var$semver.exec(value);
    !(result != null) && $69fa0e3037063634$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $69fa0e3037063634$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $69fa0e3037063634$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $69fa0e3037063634$var$getVersion(peerDepValue);
    var actual = $69fa0e3037063634$var$getVersion(actualValue);
    if ($69fa0e3037063634$var$isSatisfied(peerDep, actual)) return;
};
var $69fa0e3037063634$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $69fa0e3037063634$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $69fa0e3037063634$var$useDev(useHook) {}
function $69fa0e3037063634$var$useDevSetupWarning(fn, inputs) {
    $69fa0e3037063634$var$useDev(function() {
        (0, $eUqFw.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $69fa0e3037063634$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $69fa0e3037063634$var$useStartupValidation() {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        $69fa0e3037063634$var$checkReactVersion($69fa0e3037063634$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).version);
        $69fa0e3037063634$var$checkDoctype(document);
    }, []);
}
function $69fa0e3037063634$var$usePrevious(current) {
    var ref = (0, $eUqFw.useRef)(current);
    (0, $eUqFw.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $69fa0e3037063634$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $69fa0e3037063634$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $69fa0e3037063634$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $69fa0e3037063634$var$tab = 9;
var $69fa0e3037063634$var$enter = 13;
var $69fa0e3037063634$var$escape = 27;
var $69fa0e3037063634$var$space = 32;
var $69fa0e3037063634$var$pageUp = 33;
var $69fa0e3037063634$var$pageDown = 34;
var $69fa0e3037063634$var$end = 35;
var $69fa0e3037063634$var$home = 36;
var $69fa0e3037063634$var$arrowLeft = 37;
var $69fa0e3037063634$var$arrowUp = 38;
var $69fa0e3037063634$var$arrowRight = 39;
var $69fa0e3037063634$var$arrowDown = 40;
var $69fa0e3037063634$var$_preventedKeys;
var $69fa0e3037063634$var$preventedKeys = ($69fa0e3037063634$var$_preventedKeys = {}, $69fa0e3037063634$var$_preventedKeys[$69fa0e3037063634$var$enter] = true, $69fa0e3037063634$var$_preventedKeys[$69fa0e3037063634$var$tab] = true, $69fa0e3037063634$var$_preventedKeys);
var $69fa0e3037063634$var$preventStandardKeyEvents = function(event) {
    if ($69fa0e3037063634$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $69fa0e3037063634$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $69fa0e3037063634$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $69fa0e3037063634$var$primaryButton = 0;
var $69fa0e3037063634$var$sloppyClickThreshold = 5;
function $69fa0e3037063634$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $69fa0e3037063634$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $69fa0e3037063634$var$sloppyClickThreshold;
}
var $69fa0e3037063634$var$idle$1 = {
    type: 'IDLE'
};
function $69fa0e3037063634$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $69fa0e3037063634$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $69fa0e3037063634$var$invariant(false);
                var pending = phase.point;
                if (!$69fa0e3037063634$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $69fa0e3037063634$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $69fa0e3037063634$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useMouseSensor(api) {
    var phaseRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$idle$1);
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $69fa0e3037063634$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $fzXll.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $69fa0e3037063634$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $fzXll.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $fzXll.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $69fa0e3037063634$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $fzXll.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $69fa0e3037063634$var$_scrollJumpKeys;
function $69fa0e3037063634$var$noop$1() {}
var $69fa0e3037063634$var$scrollJumpKeys = ($69fa0e3037063634$var$_scrollJumpKeys = {}, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$pageDown] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$pageUp] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$home] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$end] = true, $69fa0e3037063634$var$_scrollJumpKeys);
function $69fa0e3037063634$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $69fa0e3037063634$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($69fa0e3037063634$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $69fa0e3037063634$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop$1);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $69fa0e3037063634$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $69fa0e3037063634$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $69fa0e3037063634$var$idle$2 = {
    type: 'IDLE'
};
var $69fa0e3037063634$var$timeForLongPress = 120;
var $69fa0e3037063634$var$forcePressThreshold = 0.15;
function $69fa0e3037063634$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $69fa0e3037063634$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $69fa0e3037063634$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useMouseSensor$1(api) {
    var phaseRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$idle$2);
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop);
    var getPhase = (0, $fzXll.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $fzXll.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $fzXll.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($69fa0e3037063634$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $fzXll.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $fzXll.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getHandleBindings(args), options);
        var unbindWindow = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $fzXll.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $69fa0e3037063634$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $fzXll.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $69fa0e3037063634$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($69fa0e3037063634$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $69fa0e3037063634$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $69fa0e3037063634$var$useValidateSensorHooks(sensorHooks) {
    $69fa0e3037063634$var$useDev(function() {
        var previousRef = $69fa0e3037063634$var$usePrevious(sensorHooks);
        $69fa0e3037063634$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $69fa0e3037063634$var$invariant(false);
        });
    });
}
var $69fa0e3037063634$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $69fa0e3037063634$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($69fa0e3037063634$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $69fa0e3037063634$var$isAnInteractiveElement(parent, current.parentElement);
}
function $69fa0e3037063634$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$69fa0e3037063634$var$isHtmlElement(target)) return false;
    return $69fa0e3037063634$var$isAnInteractiveElement(draggable, target);
}
var $69fa0e3037063634$var$getBorderBoxCenterPosition = function(el) {
    return (0, $bn5nT.getRect)(el.getBoundingClientRect()).center;
};
function $69fa0e3037063634$var$isElement(el) {
    return el instanceof $69fa0e3037063634$var$getWindowFromEl(el).Element;
}
var $69fa0e3037063634$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $69fa0e3037063634$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $69fa0e3037063634$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$69fa0e3037063634$var$supportedMatchesName](selector)) return el;
    return $69fa0e3037063634$var$closestPonyfill(el.parentElement, selector);
}
function $69fa0e3037063634$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $69fa0e3037063634$var$closestPonyfill(el, selector);
}
function $69fa0e3037063634$var$getSelector(contextId) {
    return "[" + $69fa0e3037063634$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $69fa0e3037063634$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$69fa0e3037063634$var$isElement(target)) return null;
    var selector = $69fa0e3037063634$var$getSelector(contextId);
    var handle = $69fa0e3037063634$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(handle)) return null;
    return handle;
}
function $69fa0e3037063634$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $69fa0e3037063634$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($69fa0e3037063634$var$dragHandle.draggableId);
}
function $69fa0e3037063634$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $69fa0e3037063634$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $69fa0e3037063634$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $69fa0e3037063634$var$find(possible, function(el) {
        return el.getAttribute($69fa0e3037063634$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $69fa0e3037063634$var$preventDefault(event) {
    event.preventDefault();
}
function $69fa0e3037063634$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $69fa0e3037063634$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$69fa0e3037063634$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $69fa0e3037063634$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $69fa0e3037063634$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $69fa0e3037063634$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $69fa0e3037063634$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $69fa0e3037063634$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($69fa0e3037063634$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $69fa0e3037063634$var$invariant(false);
        }
        store.dispatch($69fa0e3037063634$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $69fa0e3037063634$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $69fa0e3037063634$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($69fa0e3037063634$var$drop({
                reason: reason
            }));
        }
        return (0, $34lu7.default)({
            isActive: function isActive() {
                return $69fa0e3037063634$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $gxvYj.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $69fa0e3037063634$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $34lu7.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $69fa0e3037063634$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $69fa0e3037063634$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $69fa0e3037063634$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $69fa0e3037063634$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $69fa0e3037063634$var$defaultSensors = [
    $69fa0e3037063634$var$useMouseSensor,
    $69fa0e3037063634$var$useKeyboardSensor,
    $69fa0e3037063634$var$useMouseSensor$1
];
function $69fa0e3037063634$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $69fa0e3037063634$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $eUqFw.useState)(function() {
        return $69fa0e3037063634$var$create();
    })[0];
    var tryAbandonLock = (0, $fzXll.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $fzXll.useCallback)(function(draggableId) {
        return $69fa0e3037063634$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $fzXll.useCallback)(function(draggableId, forceStop, options) {
        return $69fa0e3037063634$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $fzXll.useCallback)(function(event) {
        return $69fa0e3037063634$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $fzXll.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $fzXll.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $fzXll.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $fzXll.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $69fa0e3037063634$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $69fa0e3037063634$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $69fa0e3037063634$var$getStore(lazyRef) {
    !lazyRef.current && $69fa0e3037063634$var$invariant(false);
    return lazyRef.current;
}
function $69fa0e3037063634$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $eUqFw.useRef)(null);
    $69fa0e3037063634$var$useStartupValidation();
    var lastPropsRef = $69fa0e3037063634$var$usePrevious(props);
    var getResponders = (0, $fzXll.useCallback)(function() {
        return $69fa0e3037063634$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $69fa0e3037063634$var$useAnnouncer(contextId);
    var liftInstructionId = $69fa0e3037063634$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $69fa0e3037063634$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $fzXll.useCallback)(function(action) {
        $69fa0e3037063634$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $fzXll.useMemo)(function() {
        return (0, $4QJdp.bindActionCreators)({
            publishWhileDragging: $69fa0e3037063634$var$publishWhileDragging,
            updateDroppableScroll: $69fa0e3037063634$var$updateDroppableScroll,
            updateDroppableIsEnabled: $69fa0e3037063634$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $69fa0e3037063634$var$updateDroppableIsCombineEnabled,
            collectionStarting: $69fa0e3037063634$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $69fa0e3037063634$var$useRegistry();
    var dimensionMarshal = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createAutoScroller((0, $34lu7.default)({
            scrollWindow: $69fa0e3037063634$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $4QJdp.bindActionCreators)({
            move: $69fa0e3037063634$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $69fa0e3037063634$var$useFocusMarshal(contextId);
    var store = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $fzXll.useCallback)(function() {
        var current = $69fa0e3037063634$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($69fa0e3037063634$var$flush());
    }, []);
    var isDragging = (0, $fzXll.useCallback)(function() {
        var state = $69fa0e3037063634$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $fzXll.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $fzXll.useCallback)(function(id) {
        return $69fa0e3037063634$var$canStartDrag($69fa0e3037063634$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $fzXll.useCallback)(function() {
        return $69fa0e3037063634$var$isMovementAllowed($69fa0e3037063634$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $fzXll.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $69fa0e3037063634$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $eUqFw.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b02ud.default), {
        context: $69fa0e3037063634$var$StoreContext,
        store: store
    }, props.children));
}
var $69fa0e3037063634$var$instanceCount = 0;
function $69fa0e3037063634$export$2bfe52350fc0150d() {
    $69fa0e3037063634$var$instanceCount = 0;
}
function $69fa0e3037063634$export$237bd83162c14364(props) {
    var contextId = (0, $fzXll.useMemo)(function() {
        return "" + $69fa0e3037063634$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $69fa0e3037063634$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $69fa0e3037063634$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $69fa0e3037063634$var$isScroll = $69fa0e3037063634$var$isEqual$1('scroll');
var $69fa0e3037063634$var$isAuto = $69fa0e3037063634$var$isEqual$1('auto');
var $69fa0e3037063634$var$isVisible$1 = $69fa0e3037063634$var$isEqual$1('visible');
var $69fa0e3037063634$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $69fa0e3037063634$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $69fa0e3037063634$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $69fa0e3037063634$var$isEither(overflow, $69fa0e3037063634$var$isScroll) || $69fa0e3037063634$var$isEither(overflow, $69fa0e3037063634$var$isAuto);
};
var $69fa0e3037063634$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $69fa0e3037063634$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $69fa0e3037063634$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$69fa0e3037063634$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $69fa0e3037063634$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $69fa0e3037063634$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $69fa0e3037063634$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $69fa0e3037063634$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $69fa0e3037063634$var$getEnv = function(start) {
    var closestScrollable = $69fa0e3037063634$var$getClosestScrollable(start);
    var isFixedOnPage = $69fa0e3037063634$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $69fa0e3037063634$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $69fa0e3037063634$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $69fa0e3037063634$var$origin,
                    displacement: $69fa0e3037063634$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $69fa0e3037063634$var$vertical : $69fa0e3037063634$var$horizontal;
    var subject = $69fa0e3037063634$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $69fa0e3037063634$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $bn5nT.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $bn5nT.expand)(paddingBox, base.border);
    var client = (0, $bn5nT.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $69fa0e3037063634$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $69fa0e3037063634$var$getClient(ref, closestScrollable);
    var page = (0, $bn5nT.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $bn5nT.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $bn5nT.withScroll)(frameClient, windowScroll),
            scroll: $69fa0e3037063634$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $69fa0e3037063634$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $69fa0e3037063634$var$immediate = {
    passive: false
};
var $69fa0e3037063634$var$delayed = {
    passive: true
};
var $69fa0e3037063634$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $69fa0e3037063634$var$immediate : $69fa0e3037063634$var$delayed;
};
function $69fa0e3037063634$var$useRequiredContext(Context) {
    var result = (0, $eUqFw.useContext)(Context);
    !result && $69fa0e3037063634$var$invariant(false);
    return result;
}
var $69fa0e3037063634$var$count = 0;
function $69fa0e3037063634$var$useUniqueId(prefix) {
    var countRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$count++);
    return prefix + "::" + countRef.current;
}
var $69fa0e3037063634$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $69fa0e3037063634$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $eUqFw.useRef)(null);
    var appContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$AppContext);
    var uniqueId = $69fa0e3037063634$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $69fa0e3037063634$var$usePrevious(args);
    var descriptor = (0, $fzXll.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $eUqFw.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $fzXll.useMemo)(function() {
        return (0, $dCUwp.default)(function(x, y) {
            !whileDraggingRef.current && $69fa0e3037063634$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $69fa0e3037063634$var$origin;
        return $69fa0e3037063634$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $fzXll.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $fzXll.useMemo)(function() {
        return (0, $gxvYj.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $69fa0e3037063634$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $fzXll.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $69fa0e3037063634$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $69fa0e3037063634$var$invariant(false);
        var env = $69fa0e3037063634$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $69fa0e3037063634$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($69fa0e3037063634$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $69fa0e3037063634$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $69fa0e3037063634$var$invariant(false);
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($69fa0e3037063634$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $69fa0e3037063634$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $fzXll.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $69fa0e3037063634$var$invariant(false);
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !closest && $69fa0e3037063634$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $fzXll.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $fzXll.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $69fa0e3037063634$var$noop$2() {}
var $69fa0e3037063634$var$empty = {
    width: 0,
    height: 0,
    margin: $69fa0e3037063634$var$noSpacing
};
var $69fa0e3037063634$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $69fa0e3037063634$var$empty;
    if (animate === 'close') return $69fa0e3037063634$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $69fa0e3037063634$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $69fa0e3037063634$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $69fa0e3037063634$var$transitions.placeholder : null
    };
};
function $69fa0e3037063634$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $eUqFw.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $fzXll.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $eUqFw.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $eUqFw.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $69fa0e3037063634$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $69fa0e3037063634$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $69fa0e3037063634$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $fzXll.useCallback)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $69fa0e3037063634$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $69fa0e3037063634$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($69fa0e3037063634$var$Placeholder);
var $69fa0e3037063634$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
function $69fa0e3037063634$var$checkIsValidInnerRef(el) {
    !(el && $69fa0e3037063634$var$isHtmlElement(el)) && $69fa0e3037063634$var$invariant(false);
}
function $69fa0e3037063634$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $69fa0e3037063634$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $69fa0e3037063634$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $69fa0e3037063634$var$invariant(false);
        !(typeof props.droppableId === 'string') && $69fa0e3037063634$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$69fa0e3037063634$var$isBoolean(props.isDropDisabled) && $69fa0e3037063634$var$invariant(false);
        !$69fa0e3037063634$var$isBoolean(props.isCombineEnabled) && $69fa0e3037063634$var$invariant(false);
        !$69fa0e3037063634$var$isBoolean(props.ignoreContainerClipping) && $69fa0e3037063634$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $69fa0e3037063634$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $69fa0e3037063634$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $69fa0e3037063634$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $69fa0e3037063634$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $69fa0e3037063634$var$invariant(false);
    }
];
function $69fa0e3037063634$var$useValidation(args) {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$shared);
        if (args.props.mode === 'standard') $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$standard);
        if (args.props.mode === 'virtual') $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$virtual);
    });
}
var $69fa0e3037063634$var$AnimateInOut = function(_React$PureComponent) {
    (0, $bqCNv.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
var $69fa0e3037063634$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $69fa0e3037063634$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $69fa0e3037063634$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $69fa0e3037063634$var$transitions.snap;
    return $69fa0e3037063634$var$transitions.fluid;
};
var $69fa0e3037063634$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $69fa0e3037063634$var$combine.opacity.drop : $69fa0e3037063634$var$combine.opacity.combining;
};
var $69fa0e3037063634$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $69fa0e3037063634$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $69fa0e3037063634$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $69fa0e3037063634$var$transforms.drop(offset, isCombining) : $69fa0e3037063634$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $69fa0e3037063634$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $69fa0e3037063634$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $69fa0e3037063634$var$zIndexOptions.dropAnimating : $69fa0e3037063634$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $69fa0e3037063634$var$getSecondaryStyle(secondary) {
    return {
        transform: $69fa0e3037063634$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $69fa0e3037063634$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $69fa0e3037063634$var$getDraggingStyle(mapped) : $69fa0e3037063634$var$getSecondaryStyle(mapped);
}
function $69fa0e3037063634$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $69fa0e3037063634$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $bn5nT.calculateBox)(borderBox, computedStyles);
    var page = (0, $bn5nT.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $69fa0e3037063634$var$useDraggablePublisher(args) {
    var uniqueId = $69fa0e3037063634$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $fzXll.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $fzXll.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $fzXll.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $eUqFw.useRef)(entry);
    var isFirstPublishRef = (0, $eUqFw.useRef)(true);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $69fa0e3037063634$var$useValidation$1(props, contextId, getRef) {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $69fa0e3037063634$var$invariant(false);
        !(typeof id === 'string') && $69fa0e3037063634$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($8kUbC)))(props.index) && $69fa0e3037063634$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $69fa0e3037063634$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$69fa0e3037063634$var$findDragHandle(contextId, id) && $69fa0e3037063634$var$invariant(false);
    });
}
function $69fa0e3037063634$var$useClonePropValidation(isClone) {
    $69fa0e3037063634$var$useDev(function() {
        var initialRef = (0, $eUqFw.useRef)(isClone);
        $69fa0e3037063634$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $69fa0e3037063634$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $69fa0e3037063634$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $69fa0e3037063634$var$Draggable(props) {
    var ref = (0, $eUqFw.useRef)(null);
    var setRef = (0, $fzXll.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $fzXll.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $fzXll.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $69fa0e3037063634$var$useValidation$1(props, contextId, getRef);
    $69fa0e3037063634$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $fzXll.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $69fa0e3037063634$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $fzXll.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $69fa0e3037063634$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $fzXll.useCallback)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $fzXll.useMemo)(function() {
        var style = $69fa0e3037063634$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $fzXll.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $69fa0e3037063634$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $69fa0e3037063634$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $69fa0e3037063634$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $69fa0e3037063634$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $69fa0e3037063634$var$getDraggableSelector() {
    var memoizedOffset = (0, $dCUwp.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dCUwp.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $dCUwp.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
            var combineWith = $69fa0e3037063634$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $69fa0e3037063634$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $69fa0e3037063634$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $69fa0e3037063634$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $69fa0e3037063634$var$combine.opacity.drop : null,
                scale: _combineWith ? $69fa0e3037063634$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $69fa0e3037063634$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $69fa0e3037063634$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $69fa0e3037063634$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $69fa0e3037063634$var$getSecondarySnapshot(null)
    }
};
function $69fa0e3037063634$var$getSecondarySelector() {
    var memoizedOffset = (0, $dCUwp.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dCUwp.default)($69fa0e3037063634$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $dCUwp.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($69fa0e3037063634$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $69fa0e3037063634$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $69fa0e3037063634$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $69fa0e3037063634$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $69fa0e3037063634$var$getDraggableSelector();
    var secondarySelector = $69fa0e3037063634$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $69fa0e3037063634$var$atRest;
    };
    return selector;
};
var $69fa0e3037063634$var$mapDispatchToProps = {
    dropAnimationFinished: $69fa0e3037063634$var$dropAnimationFinished
};
var $69fa0e3037063634$var$ConnectedDraggable = (0, $94zHK.default)($69fa0e3037063634$var$makeMapStateToProps, $69fa0e3037063634$var$mapDispatchToProps, null, {
    context: $69fa0e3037063634$var$StoreContext,
    pure: true,
    areStatePropsEqual: $69fa0e3037063634$var$isStrictEqual
})($69fa0e3037063634$var$Draggable);
function $69fa0e3037063634$var$PrivateDraggable(props) {
    var droppableContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$ConnectedDraggable, props);
}
function $69fa0e3037063634$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$PrivateDraggable, (0, $34lu7.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $69fa0e3037063634$var$Droppable(props) {
    var appContext = (0, $eUqFw.useContext)($69fa0e3037063634$var$AppContext);
    !appContext && $69fa0e3037063634$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $eUqFw.useRef)(null);
    var placeholderRef = (0, $eUqFw.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $fzXll.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $fzXll.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $fzXll.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $fzXll.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $69fa0e3037063634$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $fzXll.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $69fa0e3037063634$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $69fa0e3037063634$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $fzXll.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $fzXll.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $69fa0e3037063634$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $69fa0e3037063634$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $69fa0e3037063634$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $34lu7.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $dCUwp.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $dCUwp.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$69fa0e3037063634$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $69fa0e3037063634$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $69fa0e3037063634$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$69fa0e3037063634$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $69fa0e3037063634$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $69fa0e3037063634$var$whatIsDraggedOverFromResult(completed.result) === id, $69fa0e3037063634$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$69fa0e3037063634$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $69fa0e3037063634$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $69fa0e3037063634$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $69fa0e3037063634$var$updateViewportMaxScroll
};
function $69fa0e3037063634$var$getBody() {
    !document.body && $69fa0e3037063634$var$invariant(false);
    return document.body;
}
var $69fa0e3037063634$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $69fa0e3037063634$var$getBody
};
var $69fa0e3037063634$export$423ec2075359570a = (0, $94zHK.default)($69fa0e3037063634$var$makeMapStateToProps$1, $69fa0e3037063634$var$mapDispatchToProps$1, null, {
    context: $69fa0e3037063634$var$StoreContext,
    pure: true,
    areStatePropsEqual: $69fa0e3037063634$var$isStrictEqual
})($69fa0e3037063634$var$Droppable);
$69fa0e3037063634$export$423ec2075359570a.defaultProps = $69fa0e3037063634$var$defaultProps;

});
parcelRegister("bqCNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $852037c688a362ca$export$2e2bcd8739ae039);

var $aqlSy = parcelRequire("aqlSy");

var $hhPJ7 = parcelRequire("hhPJ7");
function $852037c688a362ca$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($aqlSy)))(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $hhPJ7.default)(subClass, superClass);
}

});
parcelRegister("aqlSy", function(module, exports) {

module.exports = (parcelRequire("fKlYj"));

});
parcelRegister("fKlYj", function(module, exports) {
parcelRequire("3w0kn");

var $dhx8H = parcelRequire("dhx8H");
var $b76c3205a8a74d63$require$$Object = $dhx8H.Object;
module.exports = function create(P, D) {
    return $b76c3205a8a74d63$require$$Object.create(P, D);
};

});
parcelRegister("3w0kn", function(module, exports) {

var $5wEa2 = parcelRequire("5wEa2");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$5wEa2($5wEa2.S, 'Object', {
    create: (parcelRequire("cZpQU"))
});

});
parcelRegister("5wEa2", function(module, exports) {

var $63L5I = parcelRequire("63L5I");

var $dhx8H = parcelRequire("dhx8H");

var $8fJLB = parcelRequire("8fJLB");

var $8akT7 = parcelRequire("8akT7");

var $8uIdh = parcelRequire("8uIdh");
var $405f18044f314da9$var$PROTOTYPE = 'prototype';
var $405f18044f314da9$var$$export = function(type, name, source) {
    var IS_FORCED = type & $405f18044f314da9$var$$export.F;
    var IS_GLOBAL = type & $405f18044f314da9$var$$export.G;
    var IS_STATIC = type & $405f18044f314da9$var$$export.S;
    var IS_PROTO = type & $405f18044f314da9$var$$export.P;
    var IS_BIND = type & $405f18044f314da9$var$$export.B;
    var IS_WRAP = type & $405f18044f314da9$var$$export.W;
    var exports = IS_GLOBAL ? $dhx8H : $dhx8H[name] || ($dhx8H[name] = {});
    var expProto = exports[$405f18044f314da9$var$PROTOTYPE];
    var target = IS_GLOBAL ? $63L5I : IS_STATIC ? $63L5I[name] : ($63L5I[name] || {})[$405f18044f314da9$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $8uIdh(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $8fJLB(out, $63L5I) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$405f18044f314da9$var$PROTOTYPE] = C[$405f18044f314da9$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $8fJLB(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $405f18044f314da9$var$$export.R && expProto && !expProto[key]) $8akT7(expProto, key, out);
        }
    }
};
// type bitmap
$405f18044f314da9$var$$export.F = 1; // forced
$405f18044f314da9$var$$export.G = 2; // global
$405f18044f314da9$var$$export.S = 4; // static
$405f18044f314da9$var$$export.P = 8; // proto
$405f18044f314da9$var$$export.B = 16; // bind
$405f18044f314da9$var$$export.W = 32; // wrap
$405f18044f314da9$var$$export.U = 64; // safe
$405f18044f314da9$var$$export.R = 128; // real proto method for `library`
module.exports = $405f18044f314da9$var$$export;

});
parcelRegister("63L5I", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $46978d3810f5c50a$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $46978d3810f5c50a$var$global; // eslint-disable-line no-undef

});

parcelRegister("dhx8H", function(module, exports) {
var $9ab691a5895850dc$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $9ab691a5895850dc$var$core; // eslint-disable-line no-undef

});

parcelRegister("8fJLB", function(module, exports) {
// optional / simple context binding

var $2vhgy = parcelRequire("2vhgy");
module.exports = function(fn, that, length) {
    $2vhgy(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("2vhgy", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("8akT7", function(module, exports) {

var $9jrHv = parcelRequire("9jrHv");

var $dhKmr = parcelRequire("dhKmr");

module.exports = (parcelRequire("kD5IQ")) ? function(object, key, value) {
    return $9jrHv.f(object, key, $dhKmr(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("9jrHv", function(module, exports) {

$parcel$export(module.exports, "f", () => $6c7b6032f547fb4c$export$2d1720544b23b823, (v) => $6c7b6032f547fb4c$export$2d1720544b23b823 = v);
var $6c7b6032f547fb4c$export$2d1720544b23b823;

var $aIdHH = parcelRequire("aIdHH");

var $3Ksbk = parcelRequire("3Ksbk");

var $1zpu5 = parcelRequire("1zpu5");
var $6c7b6032f547fb4c$var$dP = Object.defineProperty;

$6c7b6032f547fb4c$export$2d1720544b23b823 = (parcelRequire("kD5IQ")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $aIdHH(O);
    P = $1zpu5(P, true);
    $aIdHH(Attributes);
    if ($3Ksbk) try {
        return $6c7b6032f547fb4c$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("aIdHH", function(module, exports) {

var $8T9YM = parcelRequire("8T9YM");
module.exports = function(it) {
    if (!$8T9YM(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("8T9YM", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("3Ksbk", function(module, exports) {



module.exports = !(parcelRequire("kD5IQ")) && !(parcelRequire("cbAAd"))(function() {
    return Object.defineProperty((parcelRequire("2fnkQ"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("kD5IQ", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("cbAAd"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("cbAAd", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("2fnkQ", function(module, exports) {

var $8T9YM = parcelRequire("8T9YM");

var $63L5I = parcelRequire("63L5I");
var $1a2f155b99584f9f$require$document = $63L5I.document;
// typeof document.createElement is 'object' in old IE
var $1a2f155b99584f9f$var$is = $8T9YM($1a2f155b99584f9f$require$document) && $8T9YM($1a2f155b99584f9f$require$document.createElement);
module.exports = function(it) {
    return $1a2f155b99584f9f$var$is ? $1a2f155b99584f9f$require$document.createElement(it) : {};
};

});


parcelRegister("1zpu5", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $8T9YM = parcelRequire("8T9YM");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$8T9YM(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("dhKmr", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("8uIdh", function(module, exports) {
var $62f36be98ddb54f8$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $62f36be98ddb54f8$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("cZpQU", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $aIdHH = parcelRequire("aIdHH");

var $1o8G4 = parcelRequire("1o8G4");

var $c3pDW = parcelRequire("c3pDW");

var $974f3c4319e9c96a$var$IE_PROTO = (parcelRequire("5PKej"))('IE_PROTO');
var $974f3c4319e9c96a$var$Empty = function() {};
var $974f3c4319e9c96a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $974f3c4319e9c96a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("2fnkQ"))('iframe');
    var i = $c3pDW.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("5JYrt")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $974f3c4319e9c96a$var$createDict = iframeDocument.F;
    while(i--)delete $974f3c4319e9c96a$var$createDict[$974f3c4319e9c96a$var$PROTOTYPE][$c3pDW[i]];
    return $974f3c4319e9c96a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $974f3c4319e9c96a$var$Empty[$974f3c4319e9c96a$var$PROTOTYPE] = $aIdHH(O);
        result = new $974f3c4319e9c96a$var$Empty();
        $974f3c4319e9c96a$var$Empty[$974f3c4319e9c96a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$974f3c4319e9c96a$var$IE_PROTO] = O;
    } else result = $974f3c4319e9c96a$var$createDict();
    return Properties === undefined ? result : $1o8G4(result, Properties);
};

});
parcelRegister("1o8G4", function(module, exports) {

var $9jrHv = parcelRequire("9jrHv");

var $aIdHH = parcelRequire("aIdHH");

var $kJc9M = parcelRequire("kJc9M");

module.exports = (parcelRequire("kD5IQ")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $aIdHH(O);
    var keys = $kJc9M(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$9jrHv.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("kJc9M", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $58JMR = parcelRequire("58JMR");

var $c3pDW = parcelRequire("c3pDW");
module.exports = Object.keys || function keys(O) {
    return $58JMR(O, $c3pDW);
};

});
parcelRegister("58JMR", function(module, exports) {

var $8uIdh = parcelRequire("8uIdh");

var $6WitF = parcelRequire("6WitF");

var $3be1377c0765345e$var$arrayIndexOf = (parcelRequire("hZ5wn"))(false);

var $3be1377c0765345e$var$IE_PROTO = (parcelRequire("5PKej"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $6WitF(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $3be1377c0765345e$var$IE_PROTO) $8uIdh(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8uIdh(O, key = names[i++])) ~$3be1377c0765345e$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("6WitF", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $jRK2B = parcelRequire("jRK2B");

var $5XrWm = parcelRequire("5XrWm");
module.exports = function(it) {
    return $jRK2B($5XrWm(it));
};

});
parcelRegister("jRK2B", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $9A6tO = parcelRequire("9A6tO");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $9A6tO(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("9A6tO", function(module, exports) {
var $6f9c80961703262c$var$toString = {}.toString;
module.exports = function(it) {
    return $6f9c80961703262c$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("5XrWm", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("hZ5wn", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $6WitF = parcelRequire("6WitF");

var $9sYrG = parcelRequire("9sYrG");

var $dmeMq = parcelRequire("dmeMq");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6WitF($this);
        var length = $9sYrG(O.length);
        var index = $dmeMq(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("9sYrG", function(module, exports) {
// 7.1.15 ToLength

var $cIXGZ = parcelRequire("cIXGZ");
var $6e459dd0a2f7e0ab$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $6e459dd0a2f7e0ab$var$min($cIXGZ(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("cIXGZ", function(module, exports) {
// 7.1.4 ToInteger
var $9437e5c320839147$var$ceil = Math.ceil;
var $9437e5c320839147$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $9437e5c320839147$var$floor : $9437e5c320839147$var$ceil)(it);
};

});


parcelRegister("dmeMq", function(module, exports) {

var $cIXGZ = parcelRequire("cIXGZ");
var $9b98cb76c764326c$var$max = Math.max;
var $9b98cb76c764326c$var$min = Math.min;
module.exports = function(index, length) {
    index = $cIXGZ(index);
    return index < 0 ? $9b98cb76c764326c$var$max(index + length, 0) : $9b98cb76c764326c$var$min(index, length);
};

});


parcelRegister("5PKej", function(module, exports) {

var $43f59377ae23d08e$var$shared = (parcelRequire("jmDxJ"))('keys');

var $c3eWa = parcelRequire("c3eWa");
module.exports = function(key) {
    return $43f59377ae23d08e$var$shared[key] || ($43f59377ae23d08e$var$shared[key] = $c3eWa(key));
};

});
parcelRegister("jmDxJ", function(module, exports) {

var $dhx8H = parcelRequire("dhx8H");

var $63L5I = parcelRequire("63L5I");
var $e18ebed786cb5a63$var$SHARED = '__core-js_shared__';
var $e18ebed786cb5a63$var$store = $63L5I[$e18ebed786cb5a63$var$SHARED] || ($63L5I[$e18ebed786cb5a63$var$SHARED] = {});

(module.exports = function(key, value) {
    return $e18ebed786cb5a63$var$store[key] || ($e18ebed786cb5a63$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $dhx8H.version,
    mode: (parcelRequire("ijzx7")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("ijzx7", function(module, exports) {
module.exports = true;

});


parcelRegister("c3eWa", function(module, exports) {
var $8c615a0c227a0f34$var$id = 0;
var $8c615a0c227a0f34$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$8c615a0c227a0f34$var$id + $8c615a0c227a0f34$var$px).toString(36));
};

});



parcelRegister("c3pDW", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("5JYrt", function(module, exports) {

var $63L5I = parcelRequire("63L5I");
var $42e00a46ad7a4675$require$document = $63L5I.document;
module.exports = $42e00a46ad7a4675$require$document && $42e00a46ad7a4675$require$document.documentElement;

});





parcelRegister("hhPJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95c260637bde23a$export$2e2bcd8739ae039);

var $5wQ82 = parcelRequire("5wQ82");
function $c95c260637bde23a$export$2e2bcd8739ae039(o, p) {
    $c95c260637bde23a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5wQ82))) ? (0, (/*@__PURE__*/$parcel$interopDefault($5wQ82))).bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c95c260637bde23a$export$2e2bcd8739ae039(o, p);
}

});
parcelRegister("5wQ82", function(module, exports) {

module.exports = (parcelRequire("1Ra8X"));

});
parcelRegister("1Ra8X", function(module, exports) {
parcelRequire("l16ba");

module.exports = (parcelRequire("dhx8H")).Object.setPrototypeOf;

});
parcelRegister("l16ba", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S, 'Object', {
    setPrototypeOf: (parcelRequire("35fJw")).set
});

});
parcelRegister("35fJw", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $8T9YM = parcelRequire("8T9YM");

var $aIdHH = parcelRequire("aIdHH");
var $23ee0b0348ea4da9$var$check = function(O, proto) {
    $aIdHH(O);
    if (!$8T9YM(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("8fJLB"))(Function.call, (parcelRequire("2PKjW")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $23ee0b0348ea4da9$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $23ee0b0348ea4da9$var$check
};

});
parcelRegister("2PKjW", function(module, exports) {

$parcel$export(module.exports, "f", () => $2104467c0339117f$export$2d1720544b23b823, (v) => $2104467c0339117f$export$2d1720544b23b823 = v);
var $2104467c0339117f$export$2d1720544b23b823;

var $4hWyV = parcelRequire("4hWyV");

var $dhKmr = parcelRequire("dhKmr");

var $6WitF = parcelRequire("6WitF");

var $1zpu5 = parcelRequire("1zpu5");

var $8uIdh = parcelRequire("8uIdh");

var $3Ksbk = parcelRequire("3Ksbk");
var $2104467c0339117f$var$gOPD = Object.getOwnPropertyDescriptor;

$2104467c0339117f$export$2d1720544b23b823 = (parcelRequire("kD5IQ")) ? $2104467c0339117f$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $6WitF(O);
    P = $1zpu5(P, true);
    if ($3Ksbk) try {
        return $2104467c0339117f$var$gOPD(O, P);
    } catch (e) {}
    if ($8uIdh(O, P)) return $dhKmr(!$4hWyV.f.call(O, P), O[P]);
};

});
parcelRegister("4hWyV", function(module, exports) {

$parcel$export(module.exports, "f", () => $31f62d36f059d1f7$export$2d1720544b23b823, (v) => $31f62d36f059d1f7$export$2d1720544b23b823 = v);
var $31f62d36f059d1f7$export$2d1720544b23b823;
$31f62d36f059d1f7$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});








parcelRegister("34lu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $23c2693f2e66cfe6$export$2e2bcd8739ae039);

var $85I24 = parcelRequire("85I24");
function $23c2693f2e66cfe6$export$2e2bcd8739ae039() {
    $23c2693f2e66cfe6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($85I24))) ? (0, (/*@__PURE__*/$parcel$interopDefault($85I24))).bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $23c2693f2e66cfe6$export$2e2bcd8739ae039.apply(this, arguments);
}

});
parcelRegister("85I24", function(module, exports) {

module.exports = (parcelRequire("aOK7Q"));

});
parcelRegister("aOK7Q", function(module, exports) {
parcelRequire("8ASim");

module.exports = (parcelRequire("dhx8H")).Object.assign;

});
parcelRegister("8ASim", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S + $5wEa2.F, 'Object', {
    assign: (parcelRequire("jxu2z"))
});

});
parcelRegister("jxu2z", function(module, exports) {
'use strict';

var $kD5IQ = parcelRequire("kD5IQ");

var $kJc9M = parcelRequire("kJc9M");

var $cAldW = parcelRequire("cAldW");

var $4hWyV = parcelRequire("4hWyV");

var $1kVaN = parcelRequire("1kVaN");

var $jRK2B = parcelRequire("jRK2B");
var $e39866c849d56a4e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$e39866c849d56a4e$var$$assign || (parcelRequire("cbAAd"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $e39866c849d56a4e$var$$assign({}, A)[S] != 7 || Object.keys($e39866c849d56a4e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $1kVaN(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $cAldW.f;
    var isEnum = $4hWyV.f;
    while(aLen > index){
        var S = $jRK2B(arguments[index++]);
        var keys = getSymbols ? $kJc9M(S).concat(getSymbols(S)) : $kJc9M(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$kD5IQ || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $e39866c849d56a4e$var$$assign;

});
parcelRegister("cAldW", function(module, exports) {

$parcel$export(module.exports, "f", () => $92994f6ff34f2a23$export$2d1720544b23b823, (v) => $92994f6ff34f2a23$export$2d1720544b23b823 = v);
var $92994f6ff34f2a23$export$2d1720544b23b823;
$92994f6ff34f2a23$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("1kVaN", function(module, exports) {
// 7.1.13 ToObject(argument)

var $5XrWm = parcelRequire("5XrWm");
module.exports = function(it) {
    return Object($5XrWm(it));
};

});






parcelRegister("4QJdp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $387f179275880db7$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $387f179275880db7$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $387f179275880db7$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $387f179275880db7$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $387f179275880db7$export$9ff26e0402cc7b7);

var $1Xn5q = parcelRequire("1Xn5q");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $387f179275880db7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $387f179275880db7$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $387f179275880db7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $387f179275880db7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $387f179275880db7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $387f179275880db7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $387f179275880db7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $387f179275880db7$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $387f179275880db7$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($387f179275880db7$var$isDate(val)) return 'date';
    if ($387f179275880db7$var$isError(val)) return 'error';
    var constructorName = $387f179275880db7$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $387f179275880db7$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $387f179275880db7$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $387f179275880db7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $387f179275880db7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $387f179275880db7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(1));
        return enhancer($387f179275880db7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$387f179275880db7$var$isPlainObject(action)) throw new Error($387f179275880db7$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $387f179275880db7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$387f179275880db7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $387f179275880db7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$387f179275880db7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $387f179275880db7$export$8928921ea2d3b126 = $387f179275880db7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $387f179275880db7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $387f179275880db7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $387f179275880db7$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$387f179275880db7$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $387f179275880db7$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $387f179275880db7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $387f179275880db7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $387f179275880db7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $387f179275880db7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($387f179275880db7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $387f179275880db7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $387f179275880db7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $387f179275880db7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $387f179275880db7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $387f179275880db7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $387f179275880db7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($387f179275880db7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $387f179275880db7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});


parcelRegister("jJs3W", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);
parcelRequire("lPIk7");
parcelRequire("035eW");
var $lEfVV = parcelRequire("lEfVV");

var $4Ut1d = parcelRequire("4Ut1d");
// with standard React renderers (ReactDOM, React Native)
(0, $4Ut1d.setBatch)((0, $lEfVV.unstable_batchedUpdates));

});
parcelRegister("lPIk7", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);

var $b02ud = parcelRequire("b02ud");

var $lwCWn = parcelRequire("lwCWn");

var $iqB4h = parcelRequire("iqB4h");

var $94zHK = parcelRequire("94zHK");

var $6N2vY = parcelRequire("6N2vY");

var $cU4FA = parcelRequire("cU4FA");

var $2bGhE = parcelRequire("2bGhE");

var $9UMSs = parcelRequire("9UMSs");

});
parcelRegister("b02ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $80219f881731fd50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $iqB4h = parcelRequire("iqB4h");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");
function $80219f881731fd50$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eUqFw.useMemo)(function() {
        var subscription = (0, $eOZYb.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eUqFw.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $iqB4h.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $80219f881731fd50$export$2e2bcd8739ae039 = $80219f881731fd50$var$Provider;

});
parcelRegister("iqB4h", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $d6a768a4a73470b3$export$cc80c08dc91f1c00);

var $eUqFw = parcelRequire("eUqFw");
var $d6a768a4a73470b3$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $d6a768a4a73470b3$export$2e2bcd8739ae039 = $d6a768a4a73470b3$export$cc80c08dc91f1c00;

});

parcelRegister("eOZYb", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $aca5ce1240833bb9$export$d567d2b9af322f8f);

var $4Ut1d = parcelRequire("4Ut1d");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $aca5ce1240833bb9$var$createListenerCollection() {
    var batch = (0, $4Ut1d.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $aca5ce1240833bb9$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $aca5ce1240833bb9$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $aca5ce1240833bb9$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $aca5ce1240833bb9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $aca5ce1240833bb9$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("4Ut1d", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $3932e6df69670101$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $3932e6df69670101$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $3932e6df69670101$var$defaultNoopBatch(callback) {
    callback();
}
var $3932e6df69670101$var$batch = $3932e6df69670101$var$defaultNoopBatch; // Allow injecting another batching function later
var $3932e6df69670101$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $3932e6df69670101$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $3932e6df69670101$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $3932e6df69670101$var$batch;
};

});


parcelRegister("8RW1t", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $67504818408d46d4$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $67504818408d46d4$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);

});


parcelRegister("lwCWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabacaeccb986465$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lxchL = parcelRequire("lxchL");

var $eUqFw = parcelRequire("eUqFw");

var $8T8or = parcelRequire("8T8or");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $fabacaeccb986465$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $fabacaeccb986465$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $fabacaeccb986465$var$EMPTY_ARRAY = [];
var $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $fabacaeccb986465$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $fabacaeccb986465$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $fabacaeccb986465$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $fabacaeccb986465$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $fabacaeccb986465$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $fabacaeccb986465$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $iqB4h.ReactReduxContext) : _ref2$context, connectOptions = (0, $6XgOP.default)(_ref2, $fabacaeccb986465$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $kU09D.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eUqFw.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eUqFw.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $6XgOP.default)(props, $fabacaeccb986465$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eUqFw.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $8T8or.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eUqFw.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eUqFw.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eUqFw.useMemo)(function() {
                if (!shouldHandleStateChanges) return $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $eOZYb.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eUqFw.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kU09D.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eUqFw.useReducer)($fabacaeccb986465$var$storeStateUpdatesReducer, $fabacaeccb986465$var$EMPTY_ARRAY, $fabacaeccb986465$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eUqFw.useRef)();
            var lastWrapperProps = (0, $eUqFw.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eUqFw.useRef)();
            var renderIsScheduled = (0, $eUqFw.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eUqFw.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eUqFw.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Connect, (0, $kU09D.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("8T8or", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eU3cC"));

});
parcelRegister("eU3cC", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $ad98c79b0cc564ad$export$a7c73072b1a182ae, (v) => $ad98c79b0cc564ad$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ad98c79b0cc564ad$export$9f27bc3417b4524d, (v) => $ad98c79b0cc564ad$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ad98c79b0cc564ad$export$db77ccec0bb4ccac, (v) => $ad98c79b0cc564ad$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35, (v) => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ad98c79b0cc564ad$export$ffb0004e005737fa, (v) => $ad98c79b0cc564ad$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ad98c79b0cc564ad$export$b624eff549462981, (v) => $ad98c79b0cc564ad$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ad98c79b0cc564ad$export$7897aa7841a5380c, (v) => $ad98c79b0cc564ad$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ad98c79b0cc564ad$export$602eac185826482c, (v) => $ad98c79b0cc564ad$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ad98c79b0cc564ad$export$e2c29f18771995cb, (v) => $ad98c79b0cc564ad$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ad98c79b0cc564ad$export$5f8d39834fd61797, (v) => $ad98c79b0cc564ad$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ad98c79b0cc564ad$export$74bf444e3cd11ea5, (v) => $ad98c79b0cc564ad$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ad98c79b0cc564ad$export$92387174baf9b227, (v) => $ad98c79b0cc564ad$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ad98c79b0cc564ad$export$ec112efeb987d9c6, (v) => $ad98c79b0cc564ad$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ad98c79b0cc564ad$export$b706b080d889d2c9, (v) => $ad98c79b0cc564ad$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ad98c79b0cc564ad$export$5be5a87408f70ddc, (v) => $ad98c79b0cc564ad$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d, (v) => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ad98c79b0cc564ad$export$455c2e768291efa6, (v) => $ad98c79b0cc564ad$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ad98c79b0cc564ad$export$9522e17588c12572, (v) => $ad98c79b0cc564ad$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ad98c79b0cc564ad$export$2110ac352bb060b9, (v) => $ad98c79b0cc564ad$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ad98c79b0cc564ad$export$56885ab8b9c456ab, (v) => $ad98c79b0cc564ad$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ad98c79b0cc564ad$export$d927fcb6adf8f9de, (v) => $ad98c79b0cc564ad$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ad98c79b0cc564ad$export$b82d16f27459e05a, (v) => $ad98c79b0cc564ad$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ad98c79b0cc564ad$export$522c17b4f5e123e8, (v) => $ad98c79b0cc564ad$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6, (v) => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ad98c79b0cc564ad$export$9b621391a187a31a, (v) => $ad98c79b0cc564ad$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ad98c79b0cc564ad$export$f5bbd400c2f4426f, (v) => $ad98c79b0cc564ad$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ad98c79b0cc564ad$export$a7c73072b1a182ae;
var $ad98c79b0cc564ad$export$9f27bc3417b4524d;
var $ad98c79b0cc564ad$export$db77ccec0bb4ccac;
var $ad98c79b0cc564ad$export$8392c0c9d3dcbd35;
var $ad98c79b0cc564ad$export$ffb0004e005737fa;
var $ad98c79b0cc564ad$export$b624eff549462981;
var $ad98c79b0cc564ad$export$7897aa7841a5380c;
var $ad98c79b0cc564ad$export$602eac185826482c;
var $ad98c79b0cc564ad$export$e2c29f18771995cb;
var $ad98c79b0cc564ad$export$5f8d39834fd61797;
var $ad98c79b0cc564ad$export$74bf444e3cd11ea5;
var $ad98c79b0cc564ad$export$92387174baf9b227;
var $ad98c79b0cc564ad$export$ec112efeb987d9c6;
var $ad98c79b0cc564ad$export$b706b080d889d2c9;
var $ad98c79b0cc564ad$export$5be5a87408f70ddc;
var $ad98c79b0cc564ad$export$45a5e7f76e0caa8d;
var $ad98c79b0cc564ad$export$455c2e768291efa6;
var $ad98c79b0cc564ad$export$9522e17588c12572;
var $ad98c79b0cc564ad$export$2110ac352bb060b9;
var $ad98c79b0cc564ad$export$56885ab8b9c456ab;
var $ad98c79b0cc564ad$export$d927fcb6adf8f9de;
var $ad98c79b0cc564ad$export$b82d16f27459e05a;
var $ad98c79b0cc564ad$export$522c17b4f5e123e8;
var $ad98c79b0cc564ad$export$1aabd8a0274ecfd6;
var $ad98c79b0cc564ad$export$9b621391a187a31a;
var $ad98c79b0cc564ad$export$f5bbd400c2f4426f;
'use strict';
var $ad98c79b0cc564ad$var$b = 60103, $ad98c79b0cc564ad$var$c = 60106, $ad98c79b0cc564ad$var$d = 60107, $ad98c79b0cc564ad$var$e = 60108, $ad98c79b0cc564ad$var$f = 60114, $ad98c79b0cc564ad$var$g = 60109, $ad98c79b0cc564ad$var$h = 60110, $ad98c79b0cc564ad$var$k = 60112, $ad98c79b0cc564ad$var$l = 60113, $ad98c79b0cc564ad$var$m = 60120, $ad98c79b0cc564ad$var$n = 60115, $ad98c79b0cc564ad$var$p = 60116, $ad98c79b0cc564ad$var$q = 60121, $ad98c79b0cc564ad$var$r = 60122, $ad98c79b0cc564ad$var$u = 60117, $ad98c79b0cc564ad$var$v = 60129, $ad98c79b0cc564ad$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $ad98c79b0cc564ad$var$x = Symbol.for;
    $ad98c79b0cc564ad$var$b = $ad98c79b0cc564ad$var$x("react.element");
    $ad98c79b0cc564ad$var$c = $ad98c79b0cc564ad$var$x("react.portal");
    $ad98c79b0cc564ad$var$d = $ad98c79b0cc564ad$var$x("react.fragment");
    $ad98c79b0cc564ad$var$e = $ad98c79b0cc564ad$var$x("react.strict_mode");
    $ad98c79b0cc564ad$var$f = $ad98c79b0cc564ad$var$x("react.profiler");
    $ad98c79b0cc564ad$var$g = $ad98c79b0cc564ad$var$x("react.provider");
    $ad98c79b0cc564ad$var$h = $ad98c79b0cc564ad$var$x("react.context");
    $ad98c79b0cc564ad$var$k = $ad98c79b0cc564ad$var$x("react.forward_ref");
    $ad98c79b0cc564ad$var$l = $ad98c79b0cc564ad$var$x("react.suspense");
    $ad98c79b0cc564ad$var$m = $ad98c79b0cc564ad$var$x("react.suspense_list");
    $ad98c79b0cc564ad$var$n = $ad98c79b0cc564ad$var$x("react.memo");
    $ad98c79b0cc564ad$var$p = $ad98c79b0cc564ad$var$x("react.lazy");
    $ad98c79b0cc564ad$var$q = $ad98c79b0cc564ad$var$x("react.block");
    $ad98c79b0cc564ad$var$r = $ad98c79b0cc564ad$var$x("react.server.block");
    $ad98c79b0cc564ad$var$u = $ad98c79b0cc564ad$var$x("react.fundamental");
    $ad98c79b0cc564ad$var$v = $ad98c79b0cc564ad$var$x("react.debug_trace_mode");
    $ad98c79b0cc564ad$var$w = $ad98c79b0cc564ad$var$x("react.legacy_hidden");
}
function $ad98c79b0cc564ad$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $ad98c79b0cc564ad$var$b:
                switch(a = a.type, a){
                    case $ad98c79b0cc564ad$var$d:
                    case $ad98c79b0cc564ad$var$f:
                    case $ad98c79b0cc564ad$var$e:
                    case $ad98c79b0cc564ad$var$l:
                    case $ad98c79b0cc564ad$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ad98c79b0cc564ad$var$h:
                            case $ad98c79b0cc564ad$var$k:
                            case $ad98c79b0cc564ad$var$p:
                            case $ad98c79b0cc564ad$var$n:
                            case $ad98c79b0cc564ad$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $ad98c79b0cc564ad$var$c:
                return t;
        }
    }
}
var $ad98c79b0cc564ad$var$z = $ad98c79b0cc564ad$var$g, $ad98c79b0cc564ad$var$A = $ad98c79b0cc564ad$var$b, $ad98c79b0cc564ad$var$B = $ad98c79b0cc564ad$var$k, $ad98c79b0cc564ad$var$C = $ad98c79b0cc564ad$var$d, $ad98c79b0cc564ad$var$D = $ad98c79b0cc564ad$var$p, $ad98c79b0cc564ad$var$E = $ad98c79b0cc564ad$var$n, $ad98c79b0cc564ad$var$F = $ad98c79b0cc564ad$var$c, $ad98c79b0cc564ad$var$G = $ad98c79b0cc564ad$var$f, $ad98c79b0cc564ad$var$H = $ad98c79b0cc564ad$var$e, $ad98c79b0cc564ad$var$I = $ad98c79b0cc564ad$var$l;
$ad98c79b0cc564ad$export$a7c73072b1a182ae = $ad98c79b0cc564ad$var$h;
$ad98c79b0cc564ad$export$9f27bc3417b4524d = $ad98c79b0cc564ad$var$z;
$ad98c79b0cc564ad$export$db77ccec0bb4ccac = $ad98c79b0cc564ad$var$A;
$ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = $ad98c79b0cc564ad$var$B;
$ad98c79b0cc564ad$export$ffb0004e005737fa = $ad98c79b0cc564ad$var$C;
$ad98c79b0cc564ad$export$b624eff549462981 = $ad98c79b0cc564ad$var$D;
$ad98c79b0cc564ad$export$7897aa7841a5380c = $ad98c79b0cc564ad$var$E;
$ad98c79b0cc564ad$export$602eac185826482c = $ad98c79b0cc564ad$var$F;
$ad98c79b0cc564ad$export$e2c29f18771995cb = $ad98c79b0cc564ad$var$G;
$ad98c79b0cc564ad$export$5f8d39834fd61797 = $ad98c79b0cc564ad$var$H;
$ad98c79b0cc564ad$export$74bf444e3cd11ea5 = $ad98c79b0cc564ad$var$I;
$ad98c79b0cc564ad$export$92387174baf9b227 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$b706b080d889d2c9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$h;
};
$ad98c79b0cc564ad$export$5be5a87408f70ddc = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$g;
};
$ad98c79b0cc564ad$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ad98c79b0cc564ad$var$b;
};
$ad98c79b0cc564ad$export$455c2e768291efa6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$k;
};
$ad98c79b0cc564ad$export$9522e17588c12572 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$d;
};
$ad98c79b0cc564ad$export$2110ac352bb060b9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$p;
};
$ad98c79b0cc564ad$export$56885ab8b9c456ab = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$n;
};
$ad98c79b0cc564ad$export$d927fcb6adf8f9de = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$c;
};
$ad98c79b0cc564ad$export$b82d16f27459e05a = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$f;
};
$ad98c79b0cc564ad$export$522c17b4f5e123e8 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$e;
};
$ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$l;
};
$ad98c79b0cc564ad$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ad98c79b0cc564ad$var$d || a === $ad98c79b0cc564ad$var$f || a === $ad98c79b0cc564ad$var$v || a === $ad98c79b0cc564ad$var$e || a === $ad98c79b0cc564ad$var$l || a === $ad98c79b0cc564ad$var$m || a === $ad98c79b0cc564ad$var$w || "object" === typeof a && null !== a && (a.$$typeof === $ad98c79b0cc564ad$var$p || a.$$typeof === $ad98c79b0cc564ad$var$n || a.$$typeof === $ad98c79b0cc564ad$var$g || a.$$typeof === $ad98c79b0cc564ad$var$h || a.$$typeof === $ad98c79b0cc564ad$var$k || a.$$typeof === $ad98c79b0cc564ad$var$u || a.$$typeof === $ad98c79b0cc564ad$var$q || a[0] === $ad98c79b0cc564ad$var$r) ? !0 : !1;
};
$ad98c79b0cc564ad$export$f5bbd400c2f4426f = $ad98c79b0cc564ad$var$y;

});



parcelRegister("94zHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b02ef9f183b3d3$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lwCWn = parcelRequire("lwCWn");

var $9UMSs = parcelRequire("9UMSs");

var $foygv = parcelRequire("foygv");

var $jjA10 = parcelRequire("jjA10");

var $2Spd8 = parcelRequire("2Spd8");

var $eEprf = parcelRequire("eEprf");
var $69b02ef9f183b3d3$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $69b02ef9f183b3d3$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $69b02ef9f183b3d3$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $69b02ef9f183b3d3$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $lwCWn.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $jjA10.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $foygv.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $2Spd8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $eEprf.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $69b02ef9f183b3d3$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $9UMSs.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $9UMSs.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $9UMSs.default) : _ref3$areMergedPropsE, extraOptions = (0, $6XgOP.default)(_ref3, $69b02ef9f183b3d3$var$_excluded);
        var initMapStateToProps = $69b02ef9f183b3d3$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $69b02ef9f183b3d3$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $69b02ef9f183b3d3$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $kU09D.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $69b02ef9f183b3d3$export$2e2bcd8739ae039 = /*#__PURE__*/ $69b02ef9f183b3d3$export$9f9feb656dec1fc4();

});
parcelRegister("9UMSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $737f420d78dbedc2$export$2e2bcd8739ae039);
function $737f420d78dbedc2$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $737f420d78dbedc2$export$2e2bcd8739ae039(objA, objB) {
    if ($737f420d78dbedc2$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$737f420d78dbedc2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("foygv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b353ad45ed306afd$export$2e2bcd8739ae039);

var $aGUDQ = parcelRequire("aGUDQ");

var $16dJ8 = parcelRequire("16dJ8");
function $b353ad45ed306afd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $b353ad45ed306afd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $b353ad45ed306afd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $aGUDQ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $b353ad45ed306afd$export$2e2bcd8739ae039 = [
    $b353ad45ed306afd$export$a9f27b4b187c1166,
    $b353ad45ed306afd$export$ba20d1a7aa0c4a90,
    $b353ad45ed306afd$export$94a6e55709d4d961
];

});
parcelRegister("aGUDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c89c37b8d715cdf$export$2e2bcd8739ae039);
function $7c89c37b8d715cdf$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("16dJ8", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $0cd0ffddfe5f8933$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $0cd0ffddfe5f8933$export$8d46c7f53c8c602f);
parcelRequire("32fpu");
function $0cd0ffddfe5f8933$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $0cd0ffddfe5f8933$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("32fpu", function(module, exports) {

var $lkFcE = parcelRequire("lkFcE");

var $2pJov = parcelRequire("2pJov");
function $235d832188fff043$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $lkFcE.default)(value)) (0, $2pJov.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("lkFcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87b6d4f23da449f$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f87b6d4f23da449f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("2pJov", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2120ec62b602d3$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1c2120ec62b602d3$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("jjA10", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0fbba8fd20a154b$export$2e2bcd8739ae039);

var $16dJ8 = parcelRequire("16dJ8");
function $e0fbba8fd20a154b$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $e0fbba8fd20a154b$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $e0fbba8fd20a154b$export$2e2bcd8739ae039 = [
    $e0fbba8fd20a154b$export$23fc470827b14aa,
    $e0fbba8fd20a154b$export$514bc8c1a53c1d66
];

});

parcelRegister("2Spd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $21842e43b7ea3faa$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("32fpu");
function $21842e43b7ea3faa$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $kU09D.default)({}, ownProps, stateProps, dispatchProps);
}
function $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $21842e43b7ea3faa$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) : undefined;
}
function $21842e43b7ea3faa$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $21842e43b7ea3faa$export$691c327fc30bc857;
    } : undefined;
}
var $21842e43b7ea3faa$export$2e2bcd8739ae039 = [
    $21842e43b7ea3faa$export$d61b680184bc3f00,
    $21842e43b7ea3faa$export$a13ba70ef50dda6d
];

});

parcelRegister("eEprf", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa888a6349e99a0$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
parcelRequire("dGyYX");
var $aaa888a6349e99a0$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $aaa888a6349e99a0$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $aaa888a6349e99a0$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $6XgOP.default)(_ref2, $aaa888a6349e99a0$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f : $aaa888a6349e99a0$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("dGyYX", function(module, exports) {

var $2pJov = parcelRequire("2pJov");
function $9f6a5555b7986929$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $2pJov.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $9f6a5555b7986929$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $9f6a5555b7986929$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $9f6a5555b7986929$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $9f6a5555b7986929$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("6N2vY", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4f194509acee95c5$export$8ad76b76a4c905f8);

var $iqB4h = parcelRequire("iqB4h");

var $2bGhE = parcelRequire("2bGhE");
function $4f194509acee95c5$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useStore = context === (0, $iqB4h.ReactReduxContext) ? (0, $2bGhE.useStore) : (0, $2bGhE.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4f194509acee95c5$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4f194509acee95c5$export$bc9b55530897c558();

});
parcelRegister("2bGhE", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $197d688751cead73$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $197d688751cead73$export$6ccbb43953eebf8);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");

var $bs1OA = parcelRequire("bs1OA");
function $197d688751cead73$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $197d688751cead73$export$6ccbb43953eebf8 = /*#__PURE__*/ $197d688751cead73$export$671dba69185d0304();

});
parcelRegister("bs1OA", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $8563b7a80af4c71a$export$c1275ca9a6fd3ec5);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");
function $8563b7a80af4c71a$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eUqFw.useContext)((0, $iqB4h.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("cU4FA", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $964e5656bc2edcae$export$2105062e25df4afe);

var $eUqFw = parcelRequire("eUqFw");

var $bs1OA = parcelRequire("bs1OA");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $964e5656bc2edcae$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eUqFw.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eUqFw.useMemo)(function() {
        return (0, $eOZYb.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eUqFw.useRef)();
    var latestSelector = (0, $eUqFw.useRef)();
    var latestStoreState = (0, $eUqFw.useRef)();
    var latestSelectedState = (0, $eUqFw.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $964e5656bc2edcae$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $964e5656bc2edcae$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eUqFw.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $964e5656bc2edcae$export$2105062e25df4afe = /*#__PURE__*/ $964e5656bc2edcae$export$2b53f90d2bd1cbfb();

});


parcelRegister("035eW", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("lEfVV")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $lEfVV = parcelRequire("lEfVV");

});


parcelRegister("bn5nT", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $847604ea52819b67$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $847604ea52819b67$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $847604ea52819b67$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $847604ea52819b67$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $847604ea52819b67$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $847604ea52819b67$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $847604ea52819b67$export$34928e660d2a8702);

var $8ynlC = parcelRequire("8ynlC");
var $847604ea52819b67$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $847604ea52819b67$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $847604ea52819b67$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $847604ea52819b67$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $847604ea52819b67$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $847604ea52819b67$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$padding;
    var marginBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $847604ea52819b67$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $847604ea52819b67$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8ynlC.default)(false);
    return result;
};
var $847604ea52819b67$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $847604ea52819b67$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $847604ea52819b67$var$shift(borderBox, change);
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $847604ea52819b67$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $847604ea52819b67$var$getWindowScroll();
    return $847604ea52819b67$export$cc800923e997bb8(original, scroll);
};
var $847604ea52819b67$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $847604ea52819b67$var$parse(styles.marginTop),
        right: $847604ea52819b67$var$parse(styles.marginRight),
        bottom: $847604ea52819b67$var$parse(styles.marginBottom),
        left: $847604ea52819b67$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $847604ea52819b67$var$parse(styles.paddingTop),
        right: $847604ea52819b67$var$parse(styles.paddingRight),
        bottom: $847604ea52819b67$var$parse(styles.paddingBottom),
        left: $847604ea52819b67$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $847604ea52819b67$var$parse(styles.borderTopWidth),
        right: $847604ea52819b67$var$parse(styles.borderRightWidth),
        bottom: $847604ea52819b67$var$parse(styles.borderBottomWidth),
        left: $847604ea52819b67$var$parse(styles.borderLeftWidth)
    };
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $847604ea52819b67$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $847604ea52819b67$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("dCUwp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9ebaaafca6cfcfc3$export$2e2bcd8739ae039);
var $9ebaaafca6cfcfc3$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $9ebaaafca6cfcfc3$var$isEqual(first, second) {
    if (first === second) return true;
    if ($9ebaaafca6cfcfc3$var$safeIsNaN(first) && $9ebaaafca6cfcfc3$var$safeIsNaN(second)) return true;
    return false;
}
function $9ebaaafca6cfcfc3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$9ebaaafca6cfcfc3$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $9ebaaafca6cfcfc3$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $9ebaaafca6cfcfc3$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $9ebaaafca6cfcfc3$export$2e2bcd8739ae039 = $9ebaaafca6cfcfc3$var$memoizeOne;

});

parcelRegister("3YjjI", function(module, exports) {

module.exports = (parcelRequire("2NZpQ"));

});
parcelRegister("2NZpQ", function(module, exports) {
parcelRequire("jDAxN");

module.exports = (parcelRequire("dhx8H")).Object.values;

});
parcelRegister("jDAxN", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $5wEa2 = parcelRequire("5wEa2");

var $e4be01bfca6fcf6b$var$$values = (parcelRequire("24HEe"))(false);
$5wEa2($5wEa2.S, 'Object', {
    values: function values(it) {
        return $e4be01bfca6fcf6b$var$$values(it);
    }
});

});
parcelRegister("24HEe", function(module, exports) {

var $kD5IQ = parcelRequire("kD5IQ");

var $kJc9M = parcelRequire("kJc9M");

var $6WitF = parcelRequire("6WitF");

var $4hWyV = parcelRequire("4hWyV");
var $182dd014df77b78c$require$isEnum = $4hWyV.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $6WitF(it);
        var keys = $kJc9M(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$kD5IQ || $182dd014df77b78c$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});




parcelRegister("l1Zd2", function(module, exports) {

module.exports = (parcelRequire("3eZZ2"));

});
parcelRegister("3eZZ2", function(module, exports) {
parcelRequire("cV6iX");

module.exports = (parcelRequire("dhx8H")).Object.keys;

});
parcelRegister("cV6iX", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $1kVaN = parcelRequire("1kVaN");

var $kJc9M = parcelRequire("kJc9M");

(parcelRequire("1u1Xc"))('keys', function() {
    return function keys(it) {
        return $kJc9M($1kVaN(it));
    };
});

});
parcelRegister("1u1Xc", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $5wEa2 = parcelRequire("5wEa2");

var $dhx8H = parcelRequire("dhx8H");

var $cbAAd = parcelRequire("cbAAd");
module.exports = function(KEY, exec) {
    var fn = ($dhx8H.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $5wEa2($5wEa2.S + $5wEa2.F * $cbAAd(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("gxvYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a8875644982a16$export$2e2bcd8739ae039);
var $c0a8875644982a16$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c0a8875644982a16$export$2e2bcd8739ae039 = $c0a8875644982a16$var$rafSchd;

});

parcelRegister("5JNlj", function(module, exports) {

module.exports = (parcelRequire("fpboz"));

});
parcelRegister("fpboz", function(module, exports) {
parcelRequire("1WSQk");

module.exports = (parcelRequire("dhx8H")).Date.now;

});
parcelRegister("1WSQk", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $5wEa2 = parcelRequire("5wEa2");
$5wEa2($5wEa2.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});



parcelRegister("8kUbC", function(module, exports) {

module.exports = (parcelRequire("jmbPZ"));

});
parcelRegister("jmbPZ", function(module, exports) {
parcelRequire("hSyJ0");

module.exports = (parcelRequire("dhx8H")).Number.isInteger;

});
parcelRegister("hSyJ0", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S, 'Number', {
    isInteger: (parcelRequire("cYSpV"))
});

});
parcelRegister("cYSpV", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $8T9YM = parcelRequire("8T9YM");
var $97354cb9c31bad1d$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$8T9YM(it) && isFinite(it) && $97354cb9c31bad1d$var$floor(it) === it;
};

});





parcelRegister("fWkFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42223e83f1ce9c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3da0c = parcelRequire("3da0c");

var $lPArN = parcelRequire("lPArN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b42223e83f1ce9c0$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPArN.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("lPArN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dddb8b24cbf4df$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84dddb8b24cbf4df$export$2e2bcd8739ae039 = ({ url: url })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("7CnU4", function(module, exports) {

$parcel$export(module.exports, "DeprecationBanner", () => $40036bce85ad49a2$export$35ae8bd48b5aa255);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $kEBPk = parcelRequire("kEBPk");

var $aM3C8 = parcelRequire("aM3C8");

var $bjyZK = parcelRequire("bjyZK");

var $2aR8r = parcelRequire("2aR8r");
const $40036bce85ad49a2$var$DEPRECATION_BANNERS = {
    endeavour_gadget_deprecation_banner_v1: {
        version: (0, $kEBPk.DEPRECATION_BANNER_V1),
        component: (0, $2aR8r.DeprecationBannerV1)
    }
};
const $40036bce85ad49a2$export$35ae8bd48b5aa255 = ({ gadgets: gadgets, gadgetId: gadgetId })=>{
    const { dashboardHasDeprecatedGadget: dashboardHasDeprecatedGadget } = (0, $aM3C8.useDashboardHasDeprecatedGadget)(gadgets);
    const featureGatedBannerVersion = 'endeavour_gadget_deprecation_banner_v1';
    let hasDeprecationBannerFGon = false;
    if ((0, $eI5EY.fg)('endeavour_gadget_deprecation_banner_v1')) hasDeprecationBannerFGon = true;
    const BannerComponent = $40036bce85ad49a2$var$DEPRECATION_BANNERS[featureGatedBannerVersion].component;
    const { isDeprecationBannerDismissed: isDeprecationBannerDismissed, onDeprecationBannerDismiss: onDeprecationBannerDismiss } = (0, $bjyZK.useDeprecationBannerState)($40036bce85ad49a2$var$DEPRECATION_BANNERS[featureGatedBannerVersion].version, gadgetId);
    return hasDeprecationBannerFGon && !isDeprecationBannerDismissed && dashboardHasDeprecatedGadget ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BannerComponent, {
        onDismiss: onDeprecationBannerDismiss
    }) : null;
};

});
parcelRegister("aM3C8", function(module, exports) {

$parcel$export(module.exports, "useDashboardHasDeprecatedGadget", () => $0a0cccfe00ab0cb3$export$3b0936c4a7671adc);

var $eUqFw = parcelRequire("eUqFw");

var $k6Hlo = parcelRequire("k6Hlo");
const $0a0cccfe00ab0cb3$export$3b0936c4a7671adc = (gadgets)=>{
    const [dashboardHasDeprecatedGadget, setDashboardHasDeprecatedGadget] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setDashboardHasDeprecatedGadget($0a0cccfe00ab0cb3$var$checkDashboardHasDeprecatedGadget(gadgets));
    }, [
        gadgets
    ]);
    return {
        dashboardHasDeprecatedGadget: dashboardHasDeprecatedGadget
    };
};
const $0a0cccfe00ab0cb3$var$checkDashboardHasDeprecatedGadget = (gadgets)=>{
    return gadgets.some((gadget)=>(0, $k6Hlo.isDeprecatedGadget)(gadget.amdModule));
};

});
parcelRegister("k6Hlo", function(module, exports) {

$parcel$export(module.exports, "isDeprecatedGadget", () => $8b979e4e0dc46825$export$4b6bff4e9074989);

var $kEBPk = parcelRequire("kEBPk");
const $8b979e4e0dc46825$export$4b6bff4e9074989 = (gadgetResource)=>{
    return gadgetResource !== undefined && (gadgetResource in (0, $kEBPk.DEPRECATED_GADGETS_MAP) || Object.values((0, $kEBPk.DEPRECATED_GADGETS_MAP)).includes(gadgetResource));
};

});


parcelRegister("bjyZK", function(module, exports) {

$parcel$export(module.exports, "useDeprecationBannerState", () => $f25ba015bb93ad40$export$ce2c61270a55779b);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");
const $f25ba015bb93ad40$export$ce2c61270a55779b = (dashboardBannerStorageKey, dashboardId)=>{
    const [isDeprecationBannerDismissed, setIsDeprecationBannerDismissed] = (0, $eUqFw.useState)(false);
    const store = (0, $aZaPn.createLocalStorageProvider)('jira-dashboard-deprecation-banner-state');
    (0, $eUqFw.useEffect)(()=>{
        const localDeprecatedBannersState = store.get(dashboardBannerStorageKey);
        if (localDeprecatedBannersState) {
            const bannerIsDismissed = localDeprecatedBannersState.includes(dashboardId);
            setIsDeprecationBannerDismissed(bannerIsDismissed);
        }
    }, [
        dashboardId,
        dashboardBannerStorageKey,
        store
    ]);
    const onDeprecationBannerDismiss = ()=>{
        setIsDeprecationBannerDismissed(true);
        const localDeprecatedBannersState = store.get(dashboardBannerStorageKey);
        if (localDeprecatedBannersState) {
            localDeprecatedBannersState.push(dashboardId);
            store.set(dashboardBannerStorageKey, localDeprecatedBannersState);
        } else store.set(dashboardBannerStorageKey, [
            dashboardId
        ]);
    };
    return {
        isDeprecationBannerDismissed: isDeprecationBannerDismissed,
        onDeprecationBannerDismiss: onDeprecationBannerDismiss
    };
};

});

parcelRegister("2aR8r", function(module, exports) {

$parcel$export(module.exports, "DeprecationBannerV1", () => $a84be6106f08b852$export$b10eedc6ae25381c);

var $eUqFw = parcelRequire("eUqFw");

var $lxsI7 = parcelRequire("lxsI7");
var $2EMWV = parcelRequire("2EMWV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $iyI7w = parcelRequire("iyI7w");
const $a84be6106f08b852$export$b10eedc6ae25381c = ({ onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxsI7.default), {
        appearance: "warning",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2EMWV.default), {
                key: "gadgetDeprecationBannerDimissV1",
                onClick: onDismiss
            }, formatMessage((0, $iyI7w.default).gadgetDeprecationMessageDismissV1))
        ],
        title: formatMessage((0, $iyI7w.default).gadgetDeprecationTitleV1)
    }, formatMessage((0, $iyI7w.default).gadgetDeprecationMessageV1, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
                href: "https://community.atlassian.com/t5/Jira-articles/We-re-ending-support-for-five-dashboard-gadgets-on-Dec-9-2024/ba-p/2821066"
            }, chunks),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null))
    }));
};

});
parcelRegister("2EMWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae7e9947f1766d1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $7ae7e9947f1766d1$var$SectionMessageAction = /*#__PURE__*/ (0, $eUqFw.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    // FIXME: This path doesn't make sense
    // If the intent of the design for this component is to use an action, not providing `href` or `onClick`
    // makes the use case invalid. This should be addressed.
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});
$7ae7e9947f1766d1$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $7ae7e9947f1766d1$export$2e2bcd8739ae039 = $7ae7e9947f1766d1$var$SectionMessageAction;

});

parcelRegister("iyI7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $681ec7eb72e01900$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $681ec7eb72e01900$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    gadgetDeprecationTitleV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-title.non-final",
        "defaultMessage": "We're no longer supporting five of your gadgets"
    },
    gadgetDeprecationMessageV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-message.non-final",
        "defaultMessage": "This timeline is paused. The revised timeline will be confirmed next week (the week of October 14, 2024).<br></br>Starting December 9, 2024, we're removing the functionality of the Jira Road Map, Bubble Chart, Heat Map, Projects, and Labels gadgets. If you don't delete them before then, they'll no longer work, and you won't be able to reference them for the available alternatives. <Link>More about the gadgets and alternative options</Link>"
    },
    gadgetDeprecationMessageDismissV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-message-dismiss.non-final",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("lIqKj", function(module, exports) {

$parcel$export(module.exports, "DashboardControllerContextProvider", () => $88d721fcbd4febd2$export$36eb228a17cae64d);
$parcel$export(module.exports, "DashboardControllerContextConsumer", () => $88d721fcbd4febd2$export$4ce01c0dbab5bb18);
$parcel$export(module.exports, "useDashboardRefresh", () => $88d721fcbd4febd2$export$71d14892f68b2430);
$parcel$export(module.exports, "useOnAddedGadget", () => $88d721fcbd4febd2$export$2471f3ee3e3601fe);

var $4klDo = parcelRequire("4klDo");
const { createUseContextField: $88d721fcbd4febd2$export$3fb47a2904db1f37, Provider: $88d721fcbd4febd2$export$36eb228a17cae64d, Consumer: $88d721fcbd4febd2$export$4ce01c0dbab5bb18 } = (0, $4klDo.createRendererContext)();
const $88d721fcbd4febd2$export$71d14892f68b2430 = $88d721fcbd4febd2$export$3fb47a2904db1f37('onRefresh');
const $88d721fcbd4febd2$export$2471f3ee3e3601fe = $88d721fcbd4febd2$export$3fb47a2904db1f37('onAddedGadget');

});
parcelRegister("4klDo", function(module, exports) {

$parcel$export(module.exports, "createRendererContext", () => $3433cfc1c4724813$export$ac09db0e74937f7f);

var $eUqFw = parcelRequire("eUqFw");

var $aFvYX = parcelRequire("aFvYX");
const $3433cfc1c4724813$export$ac09db0e74937f7f = ()=>{
    const _UnmemoisedContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { Provider: UnmemoisedProvider, Consumer: Consumer } = _UnmemoisedContext;
    const Provider = /*#__PURE__*/ (0, $eUqFw.memo)(UnmemoisedProvider, ({ value: valueA, ...propsA }, { value: valueB, ...propsB })=>(0, $aFvYX.default)(valueA, valueB) && (0, $aFvYX.default)(propsA, propsB));
    const createRenderFunction = (children)=>(value)=>children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Provider, {
                value: value
            }, typeof children === 'function' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Consumer, null, children) : children) : null;
    const createUseContextField = (key)=>()=>{
            const value = (0, $eUqFw.useContext)(_UnmemoisedContext);
            if (value == null) throw new Error('context not found');
            return value[key];
        };
    return {
        _UnmemoisedContext: _UnmemoisedContext,
        Provider: Provider,
        Consumer: Consumer,
        createRenderFunction: createRenderFunction,
        createUseContextField: createUseContextField
    };
};

});
parcelRegister("aFvYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24f9d4e9538bf7e$export$2e2bcd8739ae039);

var $5NVi6 = parcelRequire("5NVi6");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f24f9d4e9538bf7e$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $5NVi6.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $5NVi6.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("5NVi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4109ba822744d4$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $8e4109ba822744d4$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});




parcelRegister("jOV2f", function(module, exports) {

$parcel$export(module.exports, "DashboardController", () => $0c5cabd78de58446$export$b9771780c6ecf3f);

var $eUqFw = parcelRequire("eUqFw");

var $6ci8W = parcelRequire("6ci8W");

var $dnhZn = parcelRequire("dnhZn");

var $kEBPk = parcelRequire("kEBPk");

var $lIqKj = parcelRequire("lIqKj");
const $0c5cabd78de58446$export$d7eb50fb85f631d = ({ automaticRefreshMs: automaticRefreshMs })=>{
    const [refreshId, setRefreshId] = (0, $eUqFw.useState)(Date.now());
    const [, setMostRecentlyAddedGadgetId] = (0, $eUqFw.useState)(null);
    const onRefresh = (0, $eUqFw.useCallback)(()=>{
        (0, $6ci8W.emit)((0, $kEBPk.FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), {
            origin: 'dashboard'
        });
        (0, $dnhZn.default)((0, $kEBPk.CONNECT_GADGET_REFRESH_REQUEST_EVENT), {}, {
            origin: 'dashboard'
        });
        setRefreshId(Date.now());
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (automaticRefreshMs == null || automaticRefreshMs < 1) return ()=>undefined;
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
        const interval = setInterval(onRefresh, refreshIntervalMs);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        automaticRefreshMs,
        onRefresh
    ]);
    const onMount = (0, $eUqFw.useCallback)((gadgetId, focusCallback)=>{
        setMostRecentlyAddedGadgetId((mostRecentlyAddedGadgetId)=>{
            if (gadgetId === mostRecentlyAddedGadgetId) {
                focusCallback();
                return null;
            }
            return mostRecentlyAddedGadgetId;
        });
    }, []);
    return {
        onRefresh: onRefresh,
        refreshId: refreshId,
        onAddedGadget: setMostRecentlyAddedGadgetId,
        onMount: onMount
    };
};
const $0c5cabd78de58446$export$b9771780c6ecf3f = ({ children: children, ...props })=>{
    const value = $0c5cabd78de58446$export$d7eb50fb85f631d(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIqKj.DashboardControllerContextProvider), {
        value: value
    }, children);
};

});
parcelRegister("6ci8W", function(module, exports) {

$parcel$export(module.exports, "on", () => $efeb38c525182ee3$export$af631764ddc44097);
$parcel$export(module.exports, "emit", () => $efeb38c525182ee3$export$8f35fbd5db0f3634);
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $efeb38c525182ee3$var$EVENT_PREFIX = 'forge.bridge.';
function $efeb38c525182ee3$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$efeb38c525182ee3$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$efeb38c525182ee3$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
function $efeb38c525182ee3$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$efeb38c525182ee3$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
}

});

parcelRegister("dnhZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fad4fd9e63464a6$export$2e2bcd8739ae039);

var $4lxPQ = parcelRequire("4lxPQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8fad4fd9e63464a6$export$2e2bcd8739ae039 = (eventName, addonFilter, eventData)=>{
    (0, $4lxPQ.withConnectHost)((host)=>{
        host && host.broadcastEvent(eventName, addonFilter, eventData);
    });
};

});
parcelRegister("4lxPQ", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $74a29a4beb89f78b$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $74a29a4beb89f78b$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $74a29a4beb89f78b$export$920fb4b46d4f2eec);

var $3X4Tl = parcelRequire("3X4Tl");
const $74a29a4beb89f78b$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $3X4Tl.setupConnectJs)();
    action(connectHost);
};
const $74a29a4beb89f78b$export$186d423c00af146c = ()=>window.connectHost;
const $74a29a4beb89f78b$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("3X4Tl", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $e1d87b293e6b1fa3$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $8nDwh = parcelRequire("8nDwh");

const $e1d87b293e6b1fa3$var$installConnectJs = async ()=>{
    await (0, $8nDwh.waitForJQuery)();
    const loader = await (parcelRequire("2Dzjt"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $e1d87b293e6b1fa3$var$installConnectJsPromise = null;
const $e1d87b293e6b1fa3$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($e1d87b293e6b1fa3$var$installConnectJsPromise === null) $e1d87b293e6b1fa3$var$installConnectJsPromise = $e1d87b293e6b1fa3$var$installConnectJs();
        return $e1d87b293e6b1fa3$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $2BvS3.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("8nDwh", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $57c59c350a2284e3$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $57c59c350a2284e3$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $57c59c350a2284e3$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $57c59c350a2284e3$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $57c59c350a2284e3$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $57c59c350a2284e3$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $57c59c350a2284e3$export$d690da9bc8146677);

var $guiFP = parcelRequire("guiFP");

const $57c59c350a2284e3$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $57c59c350a2284e3$export$7232a6dc780f9887 = ()=>AJS.$;
const $57c59c350a2284e3$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $57c59c350a2284e3$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $57c59c350a2284e3$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $57c59c350a2284e3$var$FIVE_MINUTES = 300000;
const $57c59c350a2284e3$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $guiFP.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $57c59c350a2284e3$var$FIVE_MINUTES);
    });
const $57c59c350a2284e3$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $57c59c350a2284e3$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $57c59c350a2284e3$export$d690da9bc8146677 = [
    $57c59c350a2284e3$export$cb954c21735b28e4,
    $57c59c350a2284e3$export$7315c38dc71bd41f
];

});

parcelRegister("2Dzjt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dJtVb").then(()=>parcelRequire('l6TcI'));

});





parcelRegister("244wN", function(module, exports) {

$parcel$export(module.exports, "DashboardPageContainer", () => $ba93b869131c0227$export$8aeaeff803e753cd);

var $eUqFw = parcelRequire("eUqFw");

var $9EHc8 = parcelRequire("9EHc8");

var $heNSb = parcelRequire("heNSb");

var $8WuJm = parcelRequire("8WuJm");

var $fO5rB = parcelRequire("fO5rB");

var $78d1w = parcelRequire("78d1w");

var $gd0Sp = parcelRequire("gd0Sp");

var $lxLTd = parcelRequire("lxLTd");

var $gOA4E = parcelRequire("gOA4E");

var $id3p3 = parcelRequire("id3p3");
const $ba93b869131c0227$export$8aeaeff803e753cd = ({ children: children, analyticsSourceName: analyticsSourceName, analyticsExperience: analyticsExperience, unauthenticatedFallback: unauthenticatedFallback, unauthorisedFallback: unauthorisedFallback, documentTitle: documentTitle, resourceData: resourceData })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: data, loading: loading } = resourceData;
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    const ref = (0, $gOA4E.useDashboardRef)();
    if (!tenantContext) return null;
    if (!tenantContext.atlassianAccountId && !loading && !data) return unauthenticatedFallback;
    if (unauthorisedFallback != null && data && !data.writable) return unauthorisedFallback;
    /**
	 * we need to also mark this with the 'dashboardScreen' analytics source.
	 * Otherwise, the source will default to 'navigationNextScreen'.
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: analyticsSourceName,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        containerId: data?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "platform"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $id3p3.PageLayout), {
        ref: ref
    }, !isInitialRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxLTd.PrefetchLinks), {
        dashboardId: data?.id ?? 'pending'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "dashboard",
        // Need className for some of some gadgets, e.g. Filter Count
        // Please always make sure the wrapper dom id and class are in the html response
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "dashboard",
        "data-testid": "dashboard-internal-common.ui.container.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experienceId: data?.id,
        experience: analyticsExperience,
        analyticsSource: "dashboard",
        edition: null,
        application: null
    }, children))));
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("lxLTd", function(module, exports) {

$parcel$export(module.exports, "PrefetchLinks", () => $80b2dd579213799b$export$b64797ad00b7bd3c);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $829dv = parcelRequire("829dv");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");
const $80b2dd579213799b$export$b64797ad00b7bd3c = ({ dashboardId: dashboardId })=>{
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    const { data: data } = (0, $01Qi5.useDashboardResource)();
    const prefetches = (0, $eUqFw.useMemo)(()=>data ? (0, $829dv.getPrefetches)(data) : [], [
        data
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!isInitialRender && window && window[0, $kEBPk.PRELOADED_GADGET_DATA_KEY]) // cleanup preloaded data on window, which is only used on initial load
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        delete window[0, $kEBPk.PRELOADED_GADGET_DATA_KEY];
    }, [
        isInitialRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, prefetches.map((prefetch)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("link", {
            key: `${dashboardId}-${prefetch.url}`,
            rel: isInitialRender ? prefetch.priority : 'prefetch',
            as: "fetch",
            href: prefetch.url
        })));
};

});

parcelRegister("gOA4E", function(module, exports) {

$parcel$export(module.exports, "useDashboardRef", () => $a1b9be0d5aa3752e$export$a52b4118d451e93c);

var $eUqFw = parcelRequire("eUqFw");
const $a1b9be0d5aa3752e$export$a52b4118d451e93c = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const originalGetDashboard = window.AG?.DashboardManager?.getDashboard;
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.AG = {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ...window.AG,
                DashboardManager: {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    ...window.AG?.DashboardManager,
                    getDashboard: originalGetDashboard
                }
            };
        };
    }, []);
    return (0, $eUqFw.useCallback)((node)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.AG = {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            ...window.AG,
            DashboardManager: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ...window.AG?.DashboardManager,
                getDashboard: ()=>node
            }
        };
    }, []);
};

});

parcelRegister("id3p3", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d3d8d6e38ee89bc$export$6d1402fb58384e4f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $3d3d8d6e38ee89bc$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zdiv _kqswh2mm _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eeqLP", function(module, exports) {

$parcel$export(module.exports, "EngagementBanners", () => $15a176044218f05b$export$eaa8218767cf0103);

var $eUqFw = parcelRequire("eUqFw");
const $15a176044218f05b$export$eaa8218767cf0103 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);

});

parcelRegister("zdVcQ", function(module, exports) {

$parcel$export(module.exports, "ColumnPlaceholderContextConsumer", () => $c838eb7e8345db80$export$efa1c423df3eb8d9);
$parcel$export(module.exports, "ColumnLayout", () => $c838eb7e8345db80$export$c7e5bac7049eee2a);

var $eUqFw = parcelRequire("eUqFw");

var $1F29s = parcelRequire("1F29s");
var $6iuk0 = parcelRequire("6iuk0");

var $iS1RU = parcelRequire("iS1RU");

var $bYzOG = parcelRequire("bYzOG");

var $fWiDt = parcelRequire("fWiDt");

var $4klDo = parcelRequire("4klDo");

var $aIeBA = parcelRequire("aIeBA");

var $17IDF = parcelRequire("17IDF");

var $cfvbJ = parcelRequire("cfvbJ");

var $hOodT = parcelRequire("hOodT");
const { createRenderFunction: $c838eb7e8345db80$var$createPlaceholderRender, Provider: $c838eb7e8345db80$export$e3a62d26c35df0c2, Consumer: $c838eb7e8345db80$export$efa1c423df3eb8d9 } = (0, $4klDo.createRendererContext)();
const { createRenderFunction: $c838eb7e8345db80$var$createGadgetRender, Provider: $c838eb7e8345db80$export$de8f6456a7a635a7, Consumer: $c838eb7e8345db80$export$599894a5533c31ef } = (0, $4klDo.createRendererContext)();
const $c838eb7e8345db80$export$c7e5bac7049eee2a = ({ data: data, dnd: dnd, columnPlaceholder: columnPlaceholder, layoutPlaceholder: layoutPlaceholder, onLayoutReposition: onLayoutReposition, children: children })=>{
    const { layout: layout, writable: writable, gadgets: gadgets } = data;
    const { DragDropContext: DragDropContext = (0, $17IDF.DegenerateDragDropContext), Draggable: Draggable = (0, $17IDF.DegenerateDraggable), Droppable: Droppable = (0, $17IDF.DegenerateDroppable) } = dnd ?? {};
    const { getPropsByGadgetId: getPropsByGadgetId, getPropsByColumnIndex: getPropsByColumnIndex } = (0, $fWiDt.useMaximizedGadget)(gadgets);
    const [isAnyDragging, setIsAnyDragging] = (0, $eUqFw.useState)(false);
    const columns = (0, $eUqFw.useMemo)(()=>(0, $aIeBA.toColumns)(gadgets, layout), [
        gadgets,
        layout
    ]);
    const width = (0, $iS1RU.useDebouncedWindowWidth)();
    const onDragEnd = (0, $eUqFw.useCallback)((result)=>{
        if (!writable || !onLayoutReposition) return;
        const { destination: destination, source: source } = result;
        if (destination && destination.droppableId != null) {
            const moved = columns[+source.droppableId].splice(source.index, 1)[0];
            columns[+destination.droppableId].splice(destination.index, 0, moved);
            moved.column = +destination.droppableId;
        }
        onLayoutReposition(layout, columns);
        setIsAnyDragging(false);
    }, [
        columns,
        layout,
        writable,
        onLayoutReposition
    ]);
    const onDragStart = (0, $eUqFw.useCallback)(()=>{
        setIsAnyDragging(true);
    }, []);
    const renderColumnPlaceholder = $c838eb7e8345db80$var$createPlaceholderRender(columnPlaceholder);
    const renderGadget = $c838eb7e8345db80$var$createGadgetRender(children);
    if (!gadgets.length && layoutPlaceholder != null) return layoutPlaceholder;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DragDropContext, {
        onDragEnd: onDragEnd,
        onDragStart: onDragStart
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfvbJ.ContainerWrapper), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.layout.container-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bYzOG.DimensionsProvider), {
        value: `${layout}-${width}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1F29s.default), {
        layout: "fluid"
    }, columns.map((items, columnIndex)=>{
        const columnWidth = (0, $hOodT.getColumnWidth)(columnIndex, layout, getPropsByColumnIndex(columnIndex).display);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6iuk0.default), {
            key: columnIndex,
            medium: columnWidth,
            testId: "dashboard-internal-common.ui.dashboard-content.layout.column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Droppable, {
            droppableId: columnIndex.toString()
        }, ({ innerRef: columnRef, droppableProps: droppableProps, placeholder: dndPlaceholder }, { isDraggingOver: isDraggingOver })=>{
            const isNonEmptyCol = items.length > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfvbJ.ContentWrapper), {
                ...droppableProps,
                ref: columnRef,
                isDimmed: isNonEmptyCol && isDraggingOver,
                isHidden: columnWidth === 0
            }, isNonEmptyCol ? items.map((gadgetData, rowIndex)=>{
                const { isDraggable: isMaybeDraggable, ...gadgetProps } = getPropsByGadgetId(gadgetData.id);
                const isDraggable = dnd != null && isMaybeDraggable;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Draggable, {
                    key: gadgetData.id,
                    draggableId: gadgetData.id,
                    index: rowIndex,
                    isDragDisabled: !isDraggable
                }, ({ innerRef: rowRef, dragHandleProps: dragHandleProps, draggableProps: draggableProps }, { isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        ...draggableProps,
                        ref: rowRef
                    }, renderGadget({
                        data: gadgetData,
                        dragHandleProps: dragHandleProps,
                        isDraggable: isDraggable,
                        isDragging: isDragging,
                        isAnyDragging: isAnyDragging,
                        ...gadgetProps
                    })));
            }) : renderColumnPlaceholder({
                columnIndex: columnIndex,
                isDraggingOver: isDraggingOver
            }), dndPlaceholder);
        }));
    })))));
};

});
parcelRegister("1F29s", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bafd6a21e02ac44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hruHU = parcelRequire("hruHU");

var $jIG5W = parcelRequire("jIG5W");

var $6iuk0 = parcelRequire("6iuk0");

var $cRDGB = parcelRequire("cRDGB");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $1bafd6a21e02ac44$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $cRDGB.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6iuk0.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $hruHU.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $hruHU.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRDGB.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jIG5W.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $1bafd6a21e02ac44$export$2e2bcd8739ae039 = $1bafd6a21e02ac44$var$GridWrapper;

});
parcelRegister("hruHU", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $625387874402dca9$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $625387874402dca9$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $625387874402dca9$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $625387874402dca9$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $625387874402dca9$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $625387874402dca9$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $625387874402dca9$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $625387874402dca9$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $625387874402dca9$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $625387874402dca9$export$936829b4511db3e4);
const $625387874402dca9$export$3aaf3a78c909ea56 = 8;
const $625387874402dca9$export$74797698e12f8baa = 12;
const $625387874402dca9$export$b8241a1616ab1b96 = $625387874402dca9$export$3aaf3a78c909ea56 * 10;
const $625387874402dca9$export$2a89a65a43bab52d = {
    comfortable: $625387874402dca9$export$3aaf3a78c909ea56 * 5,
    cosy: $625387874402dca9$export$3aaf3a78c909ea56 * 2,
    compact: $625387874402dca9$export$3aaf3a78c909ea56 * 0.5
};
const $625387874402dca9$export$8ec7372efd74b753 = 'cosy';
const $625387874402dca9$export$d77f83c3d17a7b8a = 52;
const $625387874402dca9$export$f8725d21f81f3e01 = 0;
const $625387874402dca9$export$2303d2bd9eeff99a = 'fixed';
const $625387874402dca9$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $625387874402dca9$export$8b7e31f391e6e681 = '--ds-column-span';
const $625387874402dca9$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("jIG5W", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $1d5f602cb305a6aa$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hruHU = parcelRequire("hruHU");

var $cRDGB = parcelRequire("cRDGB");
function $1d5f602cb305a6aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1d5f602cb305a6aa$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $hruHU.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $1d5f602cb305a6aa$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $hruHU.varColumnsNum)}) * ${(0, $hruHU.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $1d5f602cb305a6aa$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $hruHU.varGridSpacing)}))`
});
const $1d5f602cb305a6aa$export$ef2184bd89960b14 = ({ layout: layout = (0, $hruHU.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $cRDGB.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $1d5f602cb305a6aa$var$gridStyles,
            $1d5f602cb305a6aa$var$gridLayoutStyles[layout],
            isNested && $1d5f602cb305a6aa$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $hruHU.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $hruHU.varGridSpacing)]: `${(0, $hruHU.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("cRDGB", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $d8e825ce6db92d08$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $hruHU = parcelRequire("hruHU");
const $d8e825ce6db92d08$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $hruHU.defaultSpacing),
    columns: (0, $hruHU.defaultGridColumns)
});

});


parcelRegister("6iuk0", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $6d861d849366cea5$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $6d861d849366cea5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hruHU = parcelRequire("hruHU");

var $cRDGB = parcelRequire("cRDGB");
var $6d861d849366cea5$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($6d861d849366cea5$var$ColumnVariant || ($6d861d849366cea5$var$ColumnVariant = {}));
const $6d861d849366cea5$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $hruHU.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $6d861d849366cea5$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6d861d849366cea5$var$singleColumnWidth = `(${$6d861d849366cea5$var$availableWidth} / var(${(0, $hruHU.varColumnsNum)}))`;
const $6d861d849366cea5$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$6d861d849366cea5$var$singleColumnWidth} - var(${(0, $hruHU.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $hruHU.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $6d861d849366cea5$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $hruHU.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$6d861d849366cea5$var$singleColumnWidth} *  var(${(0, $hruHU.varColumnSpan)}) - var(${(0, $hruHU.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $hruHU.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $6d861d849366cea5$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $hruHU.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $6d861d849366cea5$var$GridColumn = ({ medium: medium = (0, $hruHU.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $cRDGB.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $6d861d849366cea5$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($6d861d849366cea5$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $6d861d849366cea5$var$gridColumnStyles,
            $6d861d849366cea5$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $hruHU.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $6d861d849366cea5$export$2e2bcd8739ae039 = $6d861d849366cea5$var$GridColumn;

});


parcelRegister("iS1RU", function(module, exports) {

$parcel$export(module.exports, "useDebouncedWindowWidth", () => $e81db186a6309f25$export$4b69c5ad33ff59ee);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
const $e81db186a6309f25$export$4b69c5ad33ff59ee = (ms = 100)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const [width, setWidth] = (0, $eUqFw.useState)(window.innerWidth);
    const debounced = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((w)=>setWidth(w), ms));
    (0, $eUqFw.useEffect)(()=>{
        const handleResize = ()=>{
            const { innerWidth: innerWidth } = window;
            if (innerWidth !== width) debounced.current(innerWidth);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', handleResize);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', handleResize);
        };
    }, [
        width
    ]);
    return width;
};

});

parcelRegister("bYzOG", function(module, exports) {

$parcel$export(module.exports, "DimensionsProvider", () => $074bdf83395171e7$export$a31e22a91fd34dd9);
$parcel$export(module.exports, "useDimensions", () => $074bdf83395171e7$export$d04af0e501fb729f);

var $eUqFw = parcelRequire("eUqFw");
const $074bdf83395171e7$var$DimensionsContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $074bdf83395171e7$export$a31e22a91fd34dd9 = $074bdf83395171e7$var$DimensionsContext.Provider;
const $074bdf83395171e7$export$d04af0e501fb729f = ()=>(0, $eUqFw.useContext)($074bdf83395171e7$var$DimensionsContext);

});

parcelRegister("fWiDt", function(module, exports) {

$parcel$export(module.exports, "useMaximizedGadget", () => $0fd9a6dd4011c88c$export$23a0742f39986cba);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $lcJyp = parcelRequire("lcJyp");

var $lB25E = parcelRequire("lB25E");
const $0fd9a6dd4011c88c$export$23a0742f39986cba = (gadgetsData)=>{
    const [{ location: { hash: hash } }] = (0, $lB25E.useRouter)();
    const [maximizedQueryParam, setMaximizedQueryParam] = (0, $lB25E.useQueryParam)((0, $kEBPk.MAXIMIZED_PARAM));
    const [, { setAppReady: setAppReady }] = (0, $lcJyp.useSpaStateActions)();
    // The regex matches any character (except a newline character)
    // zero or more times .* followed by a '/'. The (?<id>\d+) part is a
    // named capturing group which matches one or more digits and assigns
    // the group to an id value accessible through .groups.id
    // We are using a backup hash decodedId for legacy URLs in case users have
    // bookmarked a legacy URL. Legacy URLs used '#' instead of '?maximized='
    // (e.g. https://.../jira/dashboards/{dashboardId}#{some-text}/{gadgetId})
    const decodedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const idFromHashOrQuery = maximizedQueryParam != null ? maximizedQueryParam : decodedId;
    const gadget = idFromHashOrQuery != null && gadgetsData?.find(({ id: id })=>id === idFromHashOrQuery) || null;
    const maximizedId = gadget?.isMaximizable ? idFromHashOrQuery : null;
    const getMaximisedGadgetId = (0, $eUqFw.useMemo)(()=>maximizedId, [
        maximizedId
    ]);
    const getPropsByColumnIndex = (0, $eUqFw.useCallback)((column)=>{
        const maximizedGadget = maximizedId !== null ? gadgetsData?.find(({ id: id })=>id === maximizedId) : null;
        const { column: maximizedColumn = null } = maximizedGadget ?? {};
        const display = maximizedColumn === null && (0, $kEBPk.GADGET_DISPLAY).NORMAL || maximizedColumn === column && (0, $kEBPk.GADGET_DISPLAY).MAXIMIZED || (0, $kEBPk.GADGET_DISPLAY).HIDDEN;
        return {
            display: display
        };
    }, [
        maximizedId,
        gadgetsData
    ]);
    // create curried callbacks once in the memoized scope
    const maximizedLookup = (0, $eUqFw.useMemo)(()=>Object.fromEntries(gadgetsData?.filter(({ isMaximizable: isMaximizable })=>isMaximizable).map((data)=>[
                data.id,
                (doMaximizeNotRestore)=>{
                    if (maximizedId === (doMaximizeNotRestore ? data.id : null)) return;
                    setMaximizedQueryParam(doMaximizeNotRestore ? data.id : undefined);
                    setTimeout(setAppReady);
                }
            ]) ?? []), [
        gadgetsData,
        maximizedId,
        setAppReady,
        setMaximizedQueryParam
    ]);
    const getPropsByGadgetId = (0, $eUqFw.useCallback)((id)=>{
        // Get display by gadget ID
        const display = maximizedId === null && (0, $kEBPk.GADGET_DISPLAY).NORMAL || maximizedId === id && (0, $kEBPk.GADGET_DISPLAY).MAXIMIZED || (0, $kEBPk.GADGET_DISPLAY).HIDDEN;
        // Get isDraggable by gadget ID
        const isDraggable = id !== maximizedId;
        // Get onMaximizeOrRestore by gadget ID
        const onMaximizeOrRestore = maximizedLookup[id] ?? (()=>undefined);
        return {
            display: display,
            isDraggable: isDraggable,
            onMaximizeOrRestore: onMaximizeOrRestore
        };
    }, [
        maximizedId,
        maximizedLookup
    ]);
    return {
        getMaximisedGadgetId: getMaximisedGadgetId,
        getPropsByGadgetId: getPropsByGadgetId,
        getPropsByColumnIndex: getPropsByColumnIndex
    };
};

});

parcelRegister("aIeBA", function(module, exports) {

$parcel$export(module.exports, "toColumns", () => $a3ebb36e3a8b3c10$export$755ca66aa40344da);
const $a3ebb36e3a8b3c10$export$755ca66aa40344da = (gadgets, layout)=>{
    const getGadgetsForCol = (col)=>gadgets.filter((gadget)=>gadget.column === col);
    switch(layout){
        case 'A':
            return [
                getGadgetsForCol(0)
            ];
        case 'AA':
        case 'AB':
        case 'BA':
            return [
                getGadgetsForCol(0),
                getGadgetsForCol(1)
            ];
        case 'AAA':
            return [
                getGadgetsForCol(0),
                getGadgetsForCol(1),
                getGadgetsForCol(2)
            ];
        default:
            throw new Error('Unexpected layout was provided');
    }
};

});

parcelRegister("17IDF", function(module, exports) {

$parcel$export(module.exports, "DegenerateDragDropContext", () => $7f731e7b56ff7bb2$export$cc74aca994b0ed41);
$parcel$export(module.exports, "DegenerateDraggable", () => $7f731e7b56ff7bb2$export$c114e58211833c77);
$parcel$export(module.exports, "DegenerateDroppable", () => $7f731e7b56ff7bb2$export$50925b5bb72c3049);
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
const $7f731e7b56ff7bb2$var$providedDraggable = {
    innerRef: ()=>undefined,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    draggableProps: {},
    dragHandleProps: undefined
};
const $7f731e7b56ff7bb2$var$snapshotDraggable = {
    isDragging: false,
    isDropAnimating: false,
    dropAnimation: undefined,
    draggingOver: undefined,
    combineWith: undefined,
    combineTargetFor: undefined,
    mode: undefined,
    isClone: false
};
const $7f731e7b56ff7bb2$var$providedDroppable = {
    innerRef: ()=>undefined,
    placeholder: undefined,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    droppableProps: {}
};
const $7f731e7b56ff7bb2$var$snapshotDroppable = {
    isDraggingOver: false,
    draggingOverWith: undefined,
    draggingFromThisWith: undefined,
    isUsingPlaceholder: false
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $7f731e7b56ff7bb2$var$rubricDraggable = {};
const $7f731e7b56ff7bb2$export$cc74aca994b0ed41 = ({ children: children })=>children;
const $7f731e7b56ff7bb2$export$c114e58211833c77 = ({ children: children })=>children($7f731e7b56ff7bb2$var$providedDraggable, $7f731e7b56ff7bb2$var$snapshotDraggable, $7f731e7b56ff7bb2$var$rubricDraggable);
const $7f731e7b56ff7bb2$export$50925b5bb72c3049 = ({ children: children })=>children($7f731e7b56ff7bb2$var$providedDroppable, $7f731e7b56ff7bb2$var$snapshotDroppable);

});

parcelRegister("cfvbJ", function(module, exports) {

$parcel$export(module.exports, "ContentWrapper", () => $9c9db95bacce9bf5$export$6ce170286acaa8d3);
$parcel$export(module.exports, "ContainerWrapper", () => $9c9db95bacce9bf5$export$1312e4658e616d9d);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $9c9db95bacce9bf5$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDimmed: isDimmed, isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _2rkoftgi _v564mfn2",
            __cmplp.isDimmed ? "_11q7hri9" : "_11q7vuon",
            __cmplp.isHidden && "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $9c9db95bacce9bf5$export$1312e4658e616d9d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "main", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _otyridpf _18u0mgjw _2hwxmgjw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hOodT", function(module, exports) {

$parcel$export(module.exports, "getColumnWidth", () => $d8cef97bce94b94c$export$dfa11a34ceba822);

var $kEBPk = parcelRequire("kEBPk");
const $d8cef97bce94b94c$export$dfa11a34ceba822 = (index, layout, display)=>{
    if (display === (0, $kEBPk.GADGET_DISPLAY).HIDDEN) return 0;
    if (layout === 'A' || display === (0, $kEBPk.GADGET_DISPLAY).MAXIMIZED) return 12;
    if (layout === 'AA') return 6;
    if (layout === 'AAA') return 4;
    if (layout === 'AB') return index === 0 ? 8 : 4;
    return index === 0 ? 4 : 8;
};

});


parcelRegister("3Dnr1", function(module, exports) {

$parcel$export(module.exports, "DashboardContentContainer", () => $df896dcfcfa5fd49$export$b49692a976fb3d05);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $kwMhr = parcelRequire("kwMhr");

var $gUUjF = parcelRequire("gUUjF");

var $bEZRh = parcelRequire("bEZRh");


var $01Qi5 = parcelRequire("01Qi5");

var $yhxNs = parcelRequire("yhxNs");

var $2on8Z = parcelRequire("2on8Z");

var $dYru8 = parcelRequire("dYru8");

var $6QUMT = parcelRequire("6QUMT");

var $4UDpw = parcelRequire("4UDpw");

var $9zcCd = parcelRequire("9zcCd");

var $1xFgW = parcelRequire("1xFgW");

var $kVRTc = parcelRequire("kVRTc");

var $4Jf8r = parcelRequire("4Jf8r");

var $3kpkG = parcelRequire("3kpkG");

var $35TBS = parcelRequire("35TBS");

var $b4XFG = parcelRequire("b4XFG");
const $df896dcfcfa5fd49$var$HALF_HOUR = 1800000;
const $df896dcfcfa5fd49$export$d3a4cb300c572c66 = ({ data: { id: id, gadgets: gadgets, layout: layout }, saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
    (0, $9zcCd.useSpaStatePageReady)();
    (0, $35TBS.usePageStatusLogger)($df896dcfcfa5fd49$var$HALF_HOUR);
    (0, $4UDpw.useGadgetMetricsBridge)(id, gadgets, layout);
    (0, $2on8Z.useConnectApi)({
        saveCustomGadgetTitle: saveCustomGadgetTitle
    });
    return null;
};
const $df896dcfcfa5fd49$var$AMD_RESOURCE_RETRY_LIMIT = 2;
const $df896dcfcfa5fd49$export$b49692a976fb3d05 = ({ children: children, customHeight: customHeight, analyticsExperience: analyticsExperience, saveCustomGadgetTitle: saveCustomGadgetTitle = ()=>Promise.resolve(), resourceData: resourceData, permissionErrorFallback: permissionErrorFallback })=>{
    const { data: configData, error: configError, loading: configLoading } = resourceData;
    const { loading: amdLoading, data: amdData, error: amdError, refresh: amdRefresh } = (0, $01Qi5.useDashboardAMDModulesResource)();
    const [amdResourceRetries, setAmdResourceRetries] = (0, $eUqFw.useState)(0);
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const eventSent = (0, $eUqFw.useRef)(null);
    const isAmdResourceUnhealthy = configData != null && amdData == null && amdError != null || amdData?.amdModules != null && Object.values(amdData?.amdModules).some((v)=>v == null);
    const isAmdResourceRetriesExceeded = !amdLoading && amdResourceRetries >= $df896dcfcfa5fd49$var$AMD_RESOURCE_RETRY_LIMIT;
    (0, $eUqFw.useEffect)(()=>{
        if (false || configLoading || configData == null || eventSent.current === Number(configData.id)) return;
        fireAnalytics({
            eventType: (0, $41ea3621645e2acc$export$f1d537d508d2945a),
            actionSubjectId: 'dashboard',
            actionSubject: 'dashboardScreen',
            action: 'viewed'
        });
        (0, $1xFgW.addDashboardToRecents)(configData.id);
        eventSent.current = Number(configData.id);
    }, [
        configData,
        fireAnalytics,
        configLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (false) return;
        if (amdLoading) {
            // NOTE - reset retries when resource changes
            !isAmdResourceUnhealthy && setAmdResourceRetries(0);
            return;
        }
        if (!isAmdResourceUnhealthy) (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.content-container', `AMD resource loaded, after retries [${amdResourceRetries}]`);
        else if (isAmdResourceRetriesExceeded) {
            const [failedCount, totalCount] = Object.values(amdData?.amdModules ?? []).reduce(([f], v, i, arr)=>[
                    f + (v == null ? 1 : 0),
                    arr.length
                ], [
                0,
                0
            ]);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.content-container', amdError ? `AMD resource error [${String(amdError.message)}]` : `AMD resource degraded, failed [${failedCount}] of [${totalCount}] gadgets`);
        } else {
            (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.content-container', `Retrying AMD resource, retry [${amdResourceRetries + 1}]`);
            setAmdResourceRetries((n)=>n + 1);
            amdRefresh();
        }
    }, [
        amdResourceRetries,
        amdLoading,
        amdError,
        amdData,
        isAmdResourceUnhealthy,
        isAmdResourceRetriesExceeded,
        amdRefresh
    ]);
    if (false || configLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yhxNs.GenericLoadingView), {
        customHeight: customHeight
    });
    if (configError != null || configData == null) {
        const errorCode = Number(configError?.message?.substring(configError.message.length - 3));
        if ((0, $3kpkG.DASHBOARD_PERMISSION_ERROR_CODE_LIST).includes(errorCode)) return permissionErrorFallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
            location: analyticsExperience,
            failureEventAttributes: {
                error: configError ? configError.message : 'unknown error'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.JSErrorPageAsync), null));
    }
    if (isAmdResourceRetriesExceeded && amdError != null && amdData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
        location: analyticsExperience,
        failureEventAttributes: {
            error: `AMD resource error [${String(amdError.message)}]`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.JSErrorPageAsync), null));
    return(// ThemeProvider will no longer be used in later versions of Atlaskit Grid
    // Remove when @atlaskit/page is updated
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
        theme: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: analyticsExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Jf8r.AmdGadgetMonolithOverrideStyles), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kVRTc.AboveTheFoldContainer), {
        dashboardId: configData.id,
        layout: configData.layout,
        gadgets: configData.gadgets
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6QUMT.GadgetAdditionalStateContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df896dcfcfa5fd49$export$d3a4cb300c572c66, {
        data: configData,
        saveCustomGadgetTitle: saveCustomGadgetTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b4XFG.RouteResourceValidator), null), children)))));
};

});
parcelRegister("yhxNs", function(module, exports) {

$parcel$export(module.exports, "GenericLoadingView", () => $a3f0eec4c468a3cf$export$901c7e24ef786b0f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $aYtGv = parcelRequire("aYtGv");

var $lbjCz = parcelRequire("lbjCz");
const $a3f0eec4c468a3cf$export$901c7e24ef786b0f = ({ customHeight: customHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbjCz.default), {
        name: "generic-loading-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Title, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Button, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Button, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$ContainerWrapper, {
        customHeight: customHeight
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3f0eec4c468a3cf$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1y6m _1e0c1txw _1n261g80 _p12f1osq _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});
const $a3f0eec4c468a3cf$var$ContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { customHeight: customHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6y8cer": (0, $9t7rW.default)(__cmplp.customHeight),
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71aqf _1bsb1osq _1pbyb4wl",
            __cmplp.customHeight != null ? "_4t3i1hh3" : "_4t3inb68",
            __cmplp.className
        ])
    });
});
const $a3f0eec4c468a3cf$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _18s8gx6n _1okqidpf _142fidpf _kdjlidpf _1octidpf",
            __cmplp.className
        ])
    });
});
const $a3f0eec4c468a3cf$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1wug _11q71aqf _4t3izwfg _1bsbclpc",
            __cmplp.className
        ])
    });
});
const $a3f0eec4c468a3cf$var$Button = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _11q71aqf _4t3izwfg _1bsbzwfg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2on8Z", function(module, exports) {

$parcel$export(module.exports, "useConnectApi", () => $d59eb7955bc94cbc$export$521765443e759ceb);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $kEBPk = parcelRequire("kEBPk");

var $01Qi5 = parcelRequire("01Qi5");

var $5lv3X = parcelRequire("5lv3X");

var $6QUMT = parcelRequire("6QUMT");
const $d59eb7955bc94cbc$export$521765443e759ceb = ({ saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
    const { data: data, update: update } = (0, $01Qi5.useDashboardResource)();
    const debouncedHeightRef = (0, $eUqFw.useRef)({});
    const [, { addNonRenamable: addNonRenamable, addForcedHeight: addForcedHeight }] = (0, $6QUMT.useGadgetAdditionalStateActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (!data) return;
        const setGadgetTitle = async (id, title)=>{
            if (data.gadgets.some((g)=>g.id === id)) {
                saveCustomGadgetTitle(id, title);
                addNonRenamable(id);
            }
        };
        const setGadgetHeight = (id, height)=>{
            if (debouncedHeightRef.current[id] == null) debouncedHeightRef.current[id] = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((debouncedHeight)=>{
                (0, $5lv3X.updateLocalStorageHeight)(data.id, id, debouncedHeight);
                addForcedHeight(id, debouncedHeight);
            }, (0, $kEBPk.GADGET_HEIGHT_UPDATE_WAIT_TIME));
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            debouncedHeightRef.current[id](height);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const isGadgetConfigurable = (id)=>{
            const gadget = data.gadgets.find((g)=>g.id === id);
            const { configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl } = gadget || {};
            return data.writable && (configurable || hasNonHiddenUserPrefs || Boolean(renderedGadgetUrl));
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.dashboardSpaBridge = {
            setGadgetTitle: setGadgetTitle,
            setGadgetHeight: setGadgetHeight,
            isGadgetConfigurable: isGadgetConfigurable
        };
    }, [
        data,
        addNonRenamable,
        addForcedHeight,
        saveCustomGadgetTitle,
        update
    ]);
};

});
parcelRegister("5lv3X", function(module, exports) {

$parcel$export(module.exports, "getGadgetDataFromLocalStorage", () => $e3672cf42f32f276$export$9d44840cd06e000d);
$parcel$export(module.exports, "putGadgetDataFromLocalStorage", () => $e3672cf42f32f276$export$bfbe102b0a9ddb0b);
$parcel$export(module.exports, "deleteGadgetDataFromLocalStorage", () => $e3672cf42f32f276$export$d0ed0cab2f2757a9);
$parcel$export(module.exports, "updateLocalStorageHeight", () => $e3672cf42f32f276$export$2e93c23f060e835b);
$parcel$export(module.exports, "getLocalStorageHeight", () => $e3672cf42f32f276$export$e31e30011965d5e7);
$parcel$export(module.exports, "getAllLocalStorageHeights", () => $e3672cf42f32f276$export$2590d76ae5192a56);

var $aZaPn = parcelRequire("aZaPn");

var $kEBPk = parcelRequire("kEBPk");
const $e3672cf42f32f276$export$6bac6bdc21b646b4 = (cookieData)=>{
    if (!cookieData) return {};
    const cookieInfos = cookieData.split('|').filter((cookieInfo)=>cookieInfo.trim().length);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return cookieInfos.reduce((acc, cookieInfo)=>{
        const COOKIE_INFO_PATTERN = /(?<cookieKey>.*)=(?<cookieValue>.*)/;
        const matchRes = cookieInfo.match(COOKIE_INFO_PATTERN);
        if (!matchRes) return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { cookieKey: cookieKey, cookieValue: cookieValue } = matchRes.groups;
        if (cookieKey.includes(':')) {
            const [gadgetId, gadgetAttributeName] = cookieKey.split(':');
            acc[gadgetId] = acc[gadgetId] || {};
            acc[gadgetId][gadgetAttributeName] = cookieValue;
        } else if (cookieKey.includes('-')) {
            const [, gadgetId, gadgetAttributeName] = cookieKey.split('-');
            acc[gadgetId] = acc[gadgetId] || {};
            acc[gadgetId][gadgetAttributeName] = cookieValue;
        }
        return acc;
    }, {});
};
const $e3672cf42f32f276$export$20a3a47cb251067e = (mappedCookieInfo)=>{
    let res = '';
    if (typeof mappedCookieInfo !== 'object') return res;
    Object.keys(mappedCookieInfo).forEach((id)=>{
        const attributeNames = mappedCookieInfo[id];
        if (typeof attributeNames !== 'object') return;
        Object.keys(attributeNames).forEach((attributeName)=>{
            const attributeValue = attributeNames[attributeName];
            if (!attributeValue) return;
            // If res already has contents add the separator
            if (res.length) res += '|';
            if (attributeName.includes('fh')) res += `gadget-${id}-${attributeName}=${attributeValue}`;
            else res += `${id}:${attributeName}=${attributeValue}`;
        });
    });
    return res;
};
const $e3672cf42f32f276$export$ad3e452a397f8ecc = ()=>{
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    const cookieData = localStorage.get((0, $kEBPk.GADGET_LOCAL_STORAGE_NAME));
    if (typeof cookieData !== 'string') return '';
    // TODO: Remove when monolith manipulation of gadget local storage is removed.
    // In particular around frame heights of gadgets coming from AG.Cookie.js
    // Issue is the FE local storage provider adds leading and trailing quotations
    // while the old local storage value does not have it. This causes issues when
    // the local storage is dynamically updated by the old monolith code
    // Eg. Might end up with something like '"foo=1"|bar=2'
    // To handle this for now, we remove all quotations
    return cookieData.replace(/"/g, '');
};
const $e3672cf42f32f276$export$9d44840cd06e000d = (id, gadgetDataKey)=>{
    const cleanedCookieData = $e3672cf42f32f276$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $e3672cf42f32f276$export$6bac6bdc21b646b4(cleanedCookieData);
    const gadgetInfo = mappedCookieInfo[id];
    return gadgetInfo?.[gadgetDataKey];
};
const $e3672cf42f32f276$export$bfbe102b0a9ddb0b = (id, gadgetDataKey, value)=>{
    const cleanedCookieData = $e3672cf42f32f276$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $e3672cf42f32f276$export$6bac6bdc21b646b4(cleanedCookieData);
    mappedCookieInfo[id] = mappedCookieInfo[id] ?? {};
    if (mappedCookieInfo[id]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    mappedCookieInfo[id][gadgetDataKey] = value;
    const updatedCookieData = $e3672cf42f32f276$export$20a3a47cb251067e(mappedCookieInfo);
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    localStorage.set((0, $kEBPk.GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
};
const $e3672cf42f32f276$export$d0ed0cab2f2757a9 = (id, gadgetDataKey)=>{
    const cleanedCookieData = $e3672cf42f32f276$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $e3672cf42f32f276$export$6bac6bdc21b646b4(cleanedCookieData);
    if (mappedCookieInfo[id]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    delete mappedCookieInfo[id][gadgetDataKey];
    const updatedCookieData = $e3672cf42f32f276$export$20a3a47cb251067e(mappedCookieInfo);
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    localStorage.set((0, $kEBPk.GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
};
const $e3672cf42f32f276$export$2e93c23f060e835b = (dashboardId, gadgetId, height)=>{
    if (dashboardId == null || height == null) return;
    const heightAsInt = Math.round(height);
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $kEBPk.DASHBOARD_LOCAL_STORAGE_KEY_NAME)) ?? {};
    dashboardLocalData[dashboardId] = dashboardLocalData[dashboardId] ?? {};
    const dashboardData = dashboardLocalData[dashboardId];
    dashboardData[gadgetId] = dashboardData[gadgetId] ?? {};
    const gadgetData = dashboardData[gadgetId];
    const storedHeight = gadgetData.height;
    if (storedHeight === heightAsInt) return;
    gadgetData.height = heightAsInt;
    localStorage.set((0, $kEBPk.DASHBOARD_LOCAL_STORAGE_KEY_NAME), dashboardLocalData);
};
const $e3672cf42f32f276$export$e31e30011965d5e7 = (dashboardId, gadgetId)=>{
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $kEBPk.DASHBOARD_LOCAL_STORAGE_KEY_NAME));
    const gadgetLocalHeight = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    dashboardLocalData?.[dashboardId]?.[gadgetId]?.height;
    return gadgetLocalHeight !== 0 && gadgetLocalHeight != null ? gadgetLocalHeight : (0, $kEBPk.GADGET_DEFAULT_HEIGHT);
};
const $e3672cf42f32f276$export$2590d76ae5192a56 = (dashboardId)=>{
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $kEBPk.DASHBOARD_LOCAL_STORAGE_KEY_NAME));
    return dashboardLocalData?.[dashboardId] ?? {};
};

});

parcelRegister("6QUMT", function(module, exports) {

$parcel$export(module.exports, "useIsRenamable", () => $2bf15318627074cf$export$99680f47796b1368);
$parcel$export(module.exports, "useForcedHeight", () => $2bf15318627074cf$export$6286e5c3de90c7ce);
$parcel$export(module.exports, "useGadgetAdditionalStateActions", () => $2bf15318627074cf$export$7050d853cb5c3b12);
$parcel$export(module.exports, "GadgetAdditionalStateContainer", () => $2bf15318627074cf$export$c59b94948beb035f);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ 
var $WBLbN = parcelRequire("WBLbN");
const $2bf15318627074cf$var$actions = {
    addNonRenamable: (id)=>({ setState: setState, getState: getState })=>{
            const gadgetIdToStateMap = getState().idToStateMap;
            const newIds = new Map(gadgetIdToStateMap.set(id, {
                ...gadgetIdToStateMap.get(id),
                isNonRenamable: true
            }));
            setState({
                idToStateMap: newIds
            });
        },
    addForcedHeight: (id, forcedHeight)=>({ setState: setState, getState: getState })=>{
            const gadgetIdToStateMap = getState().idToStateMap;
            const newGadgetIdToStateMap = new Map(gadgetIdToStateMap.set(id, {
                ...gadgetIdToStateMap.get(id),
                forcedHeight: forcedHeight
            }));
            setState({
                idToStateMap: newGadgetIdToStateMap
            });
        },
    remove: (id)=>({ setState: setState, getState: getState })=>{
            if (!getState().idToStateMap.has(id)) return;
            const newGadgetIdToStateMap = new Map(getState().idToStateMap);
            newGadgetIdToStateMap.delete(id);
            setState({
                idToStateMap: newGadgetIdToStateMap
            });
        }
};
const $2bf15318627074cf$var$Store = (0, $WBLbN.createStore)({
    name: 'gadget-additional-state',
    initialState: {
        idToStateMap: new Map()
    },
    actions: $2bf15318627074cf$var$actions
});
const $2bf15318627074cf$export$b8a31aa234db5dc9 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
hook)=>(args)=>{
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '[PR]' is not assignable to parameter of type 'void'.
        const [value] = hook(args);
        return value;
    };
const $2bf15318627074cf$export$99680f47796b1368 = $2bf15318627074cf$export$b8a31aa234db5dc9((0, $WBLbN.createHook)($2bf15318627074cf$var$Store, {
    selector: (state, id)=>!state.idToStateMap.get(id)?.isNonRenamable
}));
const $2bf15318627074cf$export$6286e5c3de90c7ce = $2bf15318627074cf$export$b8a31aa234db5dc9((0, $WBLbN.createHook)($2bf15318627074cf$var$Store, {
    selector: (state, id)=>state.idToStateMap.get(id)?.forcedHeight
}));
const $2bf15318627074cf$export$7050d853cb5c3b12 = (0, $WBLbN.createHook)($2bf15318627074cf$var$Store, {
    selector: null
});
const $2bf15318627074cf$export$c59b94948beb035f = (0, $WBLbN.createContainer)($2bf15318627074cf$var$Store);

});


parcelRegister("dYru8", function(module, exports) {

$parcel$export(module.exports, "useDashboardAnalytics", () => $cac1e3c84e8844b6$export$6da6d2b3a61f8861);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");
const $cac1e3c84e8844b6$export$6da6d2b3a61f8861 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(({ eventType: eventType, actionSubject: actionSubject, action: action, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
        let fireAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        // All of the events have exactly the same signature and transformations underneath.
        switch(eventType){
            case 0, $41ea3621645e2acc$export$947dac6c72b26f81:
                fireAnalytics = (0, $jMP2a.fireTrackAnalytics);
                break;
            case 0, $41ea3621645e2acc$export$12346a674644c156:
                fireAnalytics = (0, $jMP2a.fireOperationalAnalytics);
                break;
            case 0, $41ea3621645e2acc$export$a1562d08625f5d7e:
                fireAnalytics = (0, $jMP2a.fireUIAnalytics);
                break;
            case 0, $41ea3621645e2acc$export$f1d537d508d2945a:
                fireAnalytics = (0, $jMP2a.fireScreenAnalytics);
                break;
            default:
                fireAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        }
        fireAnalytics(createAnalyticsEvent({}), `${actionSubject} ${action}`, actionSubjectId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        attributes);
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("4UDpw", function(module, exports) {

$parcel$export(module.exports, "useGadgetMetricsBridge", () => $fd619abbf3898685$export$a81a90ecebb273c6);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $eI5EY = parcelRequire("eI5EY");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $78d1w = parcelRequire("78d1w");

var $aIeBA = parcelRequire("aIeBA");

var $179bk = parcelRequire("179bk");

var $fWiDt = parcelRequire("fWiDt");

var $iKzwQ = parcelRequire("iKzwQ");

var $kF6iw = parcelRequire("kF6iw");

var $e01k4 = parcelRequire("e01k4");

var $6ofMt = parcelRequire("6ofMt");
const $fd619abbf3898685$var$OVERALL_TIMEOUT = 60000;
const $fd619abbf3898685$var$buildEventKey = (event)=>{
    if (event.eventType !== (0, $kF6iw.GADGET_MARK_EVENT_PREFIX) || event.markName == null || event.markStage == null) return event.eventType;
    return `${0, $kF6iw.GADGET_MARK_EVENT_PREFIX}-${event.markName}-${event.markStage}`;
};
const $fd619abbf3898685$export$b70b6efb2347a731 = (gadgetMetricsEvents, gadgetId, event)=>{
    let recorded = gadgetMetricsEvents.get(gadgetId);
    if (recorded == null) {
        recorded = {
            contentType: 'Unspecified',
            source: event.source,
            events: new Map()
        };
        gadgetMetricsEvents.set(gadgetId, recorded);
    }
    if (recorded.contentType !== 'ErrorMessage' && event.contentType !== 'Unspecified') recorded.contentType = event.contentType;
    const record = {
        spaTime: Date.now()
    };
    if (!recorded.events.has($fd619abbf3898685$var$buildEventKey(event))) recorded.events.set($fd619abbf3898685$var$buildEventKey(event), record);
};
const $fd619abbf3898685$export$8aed66d0a3a7041d = (gadgets)=>gadgets.filter((item)=>item.amdModule != null || item.forge != null || item.reactKey != null)// Include only gadgets in the inclusion list
    .filter((item)=>// report all forge and react gadgets
        item.forge != null || item.reactKey != null || (0, $6ofMt.GADGETS_TO_REPORT).has(item.amdModule ?? '')).map((gadget)=>gadget.id);
const $fd619abbf3898685$export$b2ee8eefeb9c97ce = (gadgets)=>gadgets// Include only WRM gadget
    .filter((item)=>item.amdModule != null)// exclude connect gadgets
    .filter((item)=>!(0, $kF6iw.CONNECT_MODULE_PATTERN).test(item.amdModule || ''))// find gadgets not in either inclusion list or exclusion list
    .filter((item)=>!(0, $6ofMt.GADGETS_TO_REPORT).has(item.amdModule ?? '') && !(0, $6ofMt.GADGETS_IGNORED).has(item.amdModule ?? ''));
// Currently WRM gadget does not send render finish event in Config mode so we don't have accurate TTI for it
const $fd619abbf3898685$var$shouldSendGadgetMetrics = (event)=>!(event.source === (0, $kF6iw.WRM_GADGET_METRICS) && event.contentType === 'Config');
const $fd619abbf3898685$export$a81a90ecebb273c6 = (dashboardId, gadgets, layout)=>{
    const currentDashboardId = (0, $eUqFw.useRef)(null);
    // Metrics context in the a dashboard lifecycle.
    const dashboardMetricsContext = (0, $eUqFw.useRef)(null);
    const [, { registerListener: registerMessageListener, unregisterListener: unregisterMessageListener, broadcastMessage: broadcastMessageListener }] = (0, $iKzwQ.useMessageBus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { sendGadgetMetrics: sendGadgetMetrics, sendOverallGadgetMetrics: sendOverallGadgetMetrics, onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender, resetScrollStartMetrics: resetScrollStartMetrics } = (0, $e01k4.useGadgetMetricsAnalytics)(dashboardId);
    const [, { onGadgetRender: onGadgetRender }] = (0, $179bk.useRenderAboveTheFold)();
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const { name: routeName } = (0, $10fdS.useCurrentRoute)();
    const { getMaximisedGadgetId: getMaximisedGadgetId } = (0, $fWiDt.useMaximizedGadget)(gadgets);
    const maximizedId = getMaximisedGadgetId;
    if (currentDashboardId.current == null || currentDashboardId.current !== dashboardId) {
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'dashboardMetricsContext renewed', {
            dashboardId: dashboardId,
            previousDashboardId: currentDashboardId.current,
            currentPageId: currentPageId
        });
        resetScrollStartMetrics();
        // Dashboard reinitialised or changed
        currentDashboardId.current = dashboardId;
        if (dashboardMetricsContext.current?.metricsTimeout != null) clearTimeout(dashboardMetricsContext.current.metricsTimeout);
        const extractedGadgets = $fd619abbf3898685$export$8aed66d0a3a7041d(maximizedId && (0, $eI5EY.fg)('endeavour_dashboard_only_maximised_gadget_returned') ? gadgets.filter((gadget)=>gadget.id === maximizedId) : gadgets);
        const allAboveTheFoldGadgets = (0, $179bk.getAboveTheFoldGadgets)((0, $aIeBA.toColumns)(gadgets, layout), dashboardId);
        dashboardMetricsContext.current = {
            gadgetMetricsEvents: new Map(),
            gadgetIdsInOverallAnalytics: extractedGadgets,
            gadgetIdsInTti: extractedGadgets.filter((gadgetId)=>allAboveTheFoldGadgets.has(gadgetId)),
            allGadgetIds: gadgets.map((item)=>item.id),
            overallMetricsSent: false,
            atfMetricsSent: false,
            implicitlyIgnoredGadgetLogged: false,
            gadgetRenderStartTime: Date.now(),
            metricsTimeout: setTimeout(()=>{
                broadcastMessageListener((0, $kEBPk.GADGET_METRICS_TYPE).TIMEOUT, {}, {});
            }, $fd619abbf3898685$var$OVERALL_TIMEOUT),
            timestamps: {
                created: Date.now(),
                pnow: performance?.now(),
                currentPageId: currentPageId,
                lastTransitionStartTime: lastTransitionStartTime,
                navigationStart: navigationStart,
                navStart: (0, $e01k4.getNavStart)(isInitialRender, lastTransitionStartTime, navigationStart)
            }
        };
    }
    const gadgetMetricsTimeout = (0, $eUqFw.useCallback)(()=>{
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        if (context.overallMetricsSent) return;
        context.metricsTimeout = undefined;
        // Set up the overall flag so that gadgetMetricsListener will stop handling gadget events
        context.overallMetricsSent = true;
        // Send metrics for timed out gadget that sent at least one event.
        context.gadgetMetricsEvents.forEach((item, id)=>{
            if (item.allEventHandled !== true) {
                // eslint-disable-next-line no-param-reassign
                item.timedOut = true;
                sendGadgetMetrics(id, item);
            }
        });
        // Send metrics for idle gadgets that haven't sent any event
        context.gadgetIdsInOverallAnalytics.filter((id)=>!context.gadgetMetricsEvents.has(id)).forEach((id)=>{
            sendGadgetMetrics(id, {
                source: (0, $kF6iw.IDLE_GADGET_SOURCE),
                timedOut: true,
                events: new Map()
            });
        });
        onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, true);
        sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, true);
    }, [
        sendGadgetMetrics,
        sendOverallGadgetMetrics,
        onAboveTheFoldGadgetsRender
    ]);
    const onAllGadgetHandled = (0, $eUqFw.useCallback)(()=>{
        // Set up the overall flag so that gadgetMetricsListener will stop handling gadget events
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        context.overallMetricsSent = true;
        if (context.metricsTimeout != null) {
            clearTimeout(context.metricsTimeout);
            context.metricsTimeout = undefined;
        }
        sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, false);
    }, [
        sendOverallGadgetMetrics
    ]);
    const onAboveTheFoldGadgetsHandled = (0, $eUqFw.useCallback)(()=>{
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, false);
        context.atfMetricsSent = true;
    }, [
        onAboveTheFoldGadgetsRender
    ]);
    const gadgetMetricsListener = (0, $eUqFw.useCallback)((gid, command, ...args)=>{
        if (command !== 'metrics_event' || !args[0]) return;
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        if (context.overallMetricsSent) return;
        const eventData = args[0];
        const eventsPerGadget = (0, $e01k4.getAllEventHandlers)(eventData.source, eventData.contentType);
        const { pageId: pageIdInEvent } = eventData;
        // If the gadget id for the event is not in the current gadgetIds list, it is from a stale gadget of the previous dashboard
        if (currentPageId !== pageIdInEvent || context.allGadgetIds.every((id)=>id !== gid)) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `Page [${currentPageId ?? ''}] recieved staled gadget metrics event [${eventData.eventType}] from gadget [${gid}] in page [${pageIdInEvent ?? ''}]`);
            return;
        }
        // Check if all expected events for a gadget are triggered and handled
        const isAllGadgetEventsHandled = (gadgetEvents)=>gadgetEvents?.allEventHandled === true || gadgetEvents?.timedOut === true || eventsPerGadget.every((e)=>gadgetEvents?.events.has(e));
        // Check if all gadgets has been handled
        const isAllGadgetHandled = (gadgetIds)=>gadgetIds.every((id)=>context.gadgetMetricsEvents.get(id)?.allEventHandled);
        if (context.gadgetMetricsEvents.has(gid)) {
            if (isAllGadgetEventsHandled(context.gadgetMetricsEvents.get(gid))) // gadget has been handled
            return;
            if (context.gadgetMetricsEvents.get(gid)?.events.has($fd619abbf3898685$var$buildEventKey(eventData))) // event has been handled
            return;
        }
        $fd619abbf3898685$export$b70b6efb2347a731(context.gadgetMetricsEvents, gid, eventData);
        const event = context.gadgetMetricsEvents.get(gid);
        if (event != null && isAllGadgetEventsHandled(event)) {
            event.allEventHandled = true;
            if ($fd619abbf3898685$var$shouldSendGadgetMetrics(event)) {
                onGadgetRender(gid);
                sendGadgetMetrics(gid, event);
            }
            // if all above the fold gadgets are handled,  send gadgets metrics
            if (context.atfMetricsSent === false) {
                if (isAllGadgetHandled(context.gadgetIdsInTti)) onAboveTheFoldGadgetsHandled();
            }
            // if all gadgets are handled, send overall metrics
            if (isAllGadgetHandled(context.gadgetIdsInOverallAnalytics)) {
                onAllGadgetHandled();
                if (context.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
            }
        }
    }, [
        currentPageId,
        onAboveTheFoldGadgetsHandled,
        onAllGadgetHandled,
        sendGadgetMetrics,
        onGadgetRender
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // NOTE - This is temporary until we fix metrics for wallboard
            if (routeName === 'dashboard-wallboard') return;
            if (dashboardMetricsContext.current?.metricsTimeout != null) {
                clearTimeout(dashboardMetricsContext.current.metricsTimeout);
                dashboardMetricsContext.current.metricsTimeout = undefined;
            }
        }, [
        routeName
    ]);
    const gadgetMetricsMessageBusListenerAdaptor = (0, $eUqFw.useCallback)((type, message, context)=>{
        if (type !== (0, $kEBPk.GADGET_METRICS_TYPE).REPORT) return;
        const { gadgetId: gid, pageId: pageId } = context;
        if (gid == null) return;
        gadgetMetricsListener(gid, 'metrics_event', {
            ...message,
            pageId: pageId
        });
    }, [
        gadgetMetricsListener
    ]);
    const timeoutMessageBusListenerAdaptor = (0, $eUqFw.useCallback)((type)=>{
        if (type !== (0, $kEBPk.GADGET_METRICS_TYPE).TIMEOUT) return;
        gadgetMetricsTimeout();
    }, [
        gadgetMetricsTimeout
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // NOTE - This is temporary until we fix metrics for wallboard
        if (routeName === 'dashboard-wallboard') // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        registerMessageListener(gadgetMetricsMessageBusListenerAdaptor);
        registerMessageListener(timeoutMessageBusListenerAdaptor);
        return ()=>{
            unregisterMessageListener(gadgetMetricsMessageBusListenerAdaptor);
            unregisterMessageListener(timeoutMessageBusListenerAdaptor);
        };
    }, [
        gadgetMetricsMessageBusListenerAdaptor,
        gadgetMetricsListener,
        registerMessageListener,
        timeoutMessageBusListenerAdaptor,
        unregisterMessageListener,
        routeName
    ]);
    // NOTE - This is temporary until we fix metrics for wallboard
    if (routeName === 'dashboard-wallboard') return;
    if (dashboardMetricsContext.current == null || dashboardMetricsContext.current.overallMetricsSent === true) return;
    // Send overall event immediately for empty dashboard
    if (dashboardMetricsContext.current?.gadgetIdsInOverallAnalytics.length === 0) {
        onAboveTheFoldGadgetsHandled();
        onAllGadgetHandled();
    } else if (dashboardMetricsContext.current?.gadgetIdsInTti.length === 0 && dashboardMetricsContext.current?.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
    if (dashboardMetricsContext.current != null && !dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged) {
        dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged = true;
        $fd619abbf3898685$export$b2ee8eefeb9c97ce(gadgets).forEach((item)=>{
            (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics for gadget [${item.amdModule ?? 'unknown'}] is ignored implicitly.`);
        });
    }
};

});
parcelRegister("179bk", function(module, exports) {

$parcel$export(module.exports, "getAboveTheFoldGadgets", () => $e3df20c67c77a5d1$export$e12eddecf5e86fe5);
$parcel$export(module.exports, "useRenderAboveTheFold", () => $e3df20c67c77a5d1$export$16f58cfd4c8ccf70);
$parcel$export(module.exports, "RenderAboveTheFoldContainer", () => $e3df20c67c77a5d1$export$9710049f7f21917b);
$parcel$export(module.exports, "useOnGadgetRender", () => $e3df20c67c77a5d1$export$c127791d148e941c);
$parcel$export(module.exports, "useOnGadgetRenderEffect", () => $e3df20c67c77a5d1$export$1f28971b410f9e3);
$parcel$export(module.exports, "useShouldRenderGadget", () => $e3df20c67c77a5d1$export$428a5d740650db3e);
$parcel$export(module.exports, "useLocalStorageGadgetHeight", () => $e3df20c67c77a5d1$export$94d0a966fb813ab7);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ 
var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $eI5EY = parcelRequire("eI5EY");

var $WBLbN = parcelRequire("WBLbN");

var $5lv3X = parcelRequire("5lv3X");
const $e3df20c67c77a5d1$var$TOP_NAVIGATION_HEIGHT = 56;
const $e3df20c67c77a5d1$var$DASHBOARD_HEADER_HEIGHT = 80;
const $e3df20c67c77a5d1$var$GADGET_HEADER_AND_FOOTER_HEIGHT = 84;
const $e3df20c67c77a5d1$var$PRIORITISED_RENDERING_TIMEOUT = 7000;
const $e3df20c67c77a5d1$export$e12eddecf5e86fe5 = (columns, dashboardId)=>{
    const aboveTheFoldGadgets = new Set();
    const availableViewportHeight = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.innerHeight - $e3df20c67c77a5d1$var$TOP_NAVIGATION_HEIGHT - $e3df20c67c77a5d1$var$DASHBOARD_HEADER_HEIGHT;
    columns.forEach((column)=>{
        let occupiedViewportHeight = 0;
        column.some((gadget)=>{
            if (occupiedViewportHeight < availableViewportHeight) {
                const gadgetHeight = (0, $5lv3X.getLocalStorageHeight)(dashboardId, gadget.id) + $e3df20c67c77a5d1$var$GADGET_HEADER_AND_FOOTER_HEIGHT;
                aboveTheFoldGadgets.add(gadget.id);
                occupiedViewportHeight += gadgetHeight;
                return false;
            }
            // if we have enough height, we terminate the loop
            return true;
        });
    });
    return aboveTheFoldGadgets;
};
const $e3df20c67c77a5d1$export$e324594224ef24da = {
    onGadgetRender: (gadgetId, height)=>({ setState: setState, getState: getState })=>{
            const { dashboardId: dashboardId, loadingAboveTheFold: hasAboveTheFold, timeoutId: timeoutLast } = getState();
            // Always return default for wallboard, where dashboardId is null
            if (dashboardId === null) return;
            // we want this to always happen whenever onGadgetRender is called
            if (height != null) {
                (0, $5lv3X.updateLocalStorageHeight)(dashboardId, gadgetId, height);
                setState({
                    localStorageGadgetHeights: {
                        // we can't use this from the state as it might be stale due to other gadgets
                        // possibly updating their heights directly in localStorage
                        ...(0, $5lv3X.getAllLocalStorageHeights)(dashboardId),
                        [gadgetId]: {
                            height: height
                        }
                    }
                });
            }
            if (!hasAboveTheFold) return;
            const remainingAboveTheFoldGadgets = new Set(getState().remainingAboveTheFoldGadgets);
            remainingAboveTheFoldGadgets.delete(gadgetId);
            const loadingAboveTheFold = Boolean(remainingAboveTheFoldGadgets.size);
            const timeoutId = loadingAboveTheFold ? timeoutLast : null;
            if (timeoutLast && !timeoutId) clearTimeout(timeoutLast);
            setState({
                remainingAboveTheFoldGadgets: remainingAboveTheFoldGadgets,
                loadingAboveTheFold: loadingAboveTheFold,
                timeoutId: timeoutId
            });
        }
};
const $e3df20c67c77a5d1$var$Store = (0, $WBLbN.createStore)({
    name: 'RenderAboveTheFold',
    initialState: {
        dashboardId: null,
        loadingAboveTheFold: true,
        aboveTheFoldGadgets: new Set(),
        remainingAboveTheFoldGadgets: new Set(),
        timeoutId: null,
        timeout: false,
        localStorageGadgetHeights: {}
    },
    actions: $e3df20c67c77a5d1$export$e324594224ef24da
});
const $e3df20c67c77a5d1$export$16f58cfd4c8ccf70 = (0, $WBLbN.createHook)($e3df20c67c77a5d1$var$Store);
const $e3df20c67c77a5d1$export$f0ff1fd44503e803 = (0, $WBLbN.createHook)($e3df20c67c77a5d1$var$Store, {
    selector: null
});
const $e3df20c67c77a5d1$export$9710049f7f21917b = (0, $WBLbN.createContainer)($e3df20c67c77a5d1$var$Store, {
    onInit: ()=>({ setState: setState, getState: getState }, { columns: columns, dashboardId: dashboardId, maximizedGadgetId: maximizedGadgetId })=>{
            if (getState().dashboardId !== dashboardId && dashboardId != null) {
                const loadingAboveTheFoldTimeout = ()=>{
                    setState({
                        remainingAboveTheFoldGadgets: new Set(),
                        loadingAboveTheFold: false,
                        timeout: true
                    });
                };
                const aboveTheFoldGadgets = maximizedGadgetId && (0, $eI5EY.fg)('endeavour_dashboard_only_maximised_gadget_returned') ? new Set([
                    maximizedGadgetId
                ]) : $e3df20c67c77a5d1$export$e12eddecf5e86fe5(columns, dashboardId);
                // calculate gadgets
                setState({
                    dashboardId: dashboardId,
                    aboveTheFoldGadgets: aboveTheFoldGadgets,
                    remainingAboveTheFoldGadgets: new Set(aboveTheFoldGadgets),
                    loadingAboveTheFold: Boolean(aboveTheFoldGadgets.size),
                    timeoutId: setTimeout(loadingAboveTheFoldTimeout, $e3df20c67c77a5d1$var$PRIORITISED_RENDERING_TIMEOUT),
                    timeout: false,
                    localStorageGadgetHeights: (0, $5lv3X.getAllLocalStorageHeights)(dashboardId)
                });
            }
        }
});
const $e3df20c67c77a5d1$export$c127791d148e941c = (id)=>{
    const [, { onGadgetRender: onGadgetRender }] = $e3df20c67c77a5d1$export$f0ff1fd44503e803();
    return (0, $eUqFw.useCallback)((height)=>onGadgetRender(id, height), [
        id,
        onGadgetRender
    ]);
};
const $e3df20c67c77a5d1$export$1f28971b410f9e3 = (id, gadgetRef)=>{
    const onGadgetRender = $e3df20c67c77a5d1$export$c127791d148e941c(id);
    (0, $eUqFw.useEffect)(()=>{
        onGadgetRender(gadgetRef?.getBoundingClientRect().height);
    }, [
        onGadgetRender,
        gadgetRef
    ]);
};
const $e3df20c67c77a5d1$export$b8a31aa234db5dc9 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
hook)=>(args)=>{
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '[PR]' is not assignable to parameter of type 'void'.
        const [value] = hook(args);
        return value;
    };
const $e3df20c67c77a5d1$export$428a5d740650db3e = $e3df20c67c77a5d1$export$b8a31aa234db5dc9((0, $WBLbN.createHook)($e3df20c67c77a5d1$var$Store, {
    selector: ({ loadingAboveTheFold: loadingAboveTheFold, aboveTheFoldGadgets: aboveTheFoldGadgets, dashboardId: dashboardId }, gadgetId)=>{
        // Always return true for wallboard, where the dashboardId isn't defined as it uses query parameters instead
        if (dashboardId === null) return true;
        return !loadingAboveTheFold || aboveTheFoldGadgets.has(gadgetId);
    }
}));
const $e3df20c67c77a5d1$export$94d0a966fb813ab7 = $e3df20c67c77a5d1$export$b8a31aa234db5dc9((0, $WBLbN.createHook)($e3df20c67c77a5d1$var$Store, {
    selector: ({ localStorageGadgetHeights: localStorageGadgetHeights }, gadgetId)=>localStorageGadgetHeights[gadgetId]?.height ?? (0, $kEBPk.GADGET_DEFAULT_HEIGHT)
}));

});

parcelRegister("iKzwQ", function(module, exports) {

$parcel$export(module.exports, "useMessageBus", () => $5724c607f8adc142$export$69241ffa7d4e8d8d);

var $WBLbN = parcelRequire("WBLbN");
const $5724c607f8adc142$var$actions = {
    registerListener: (listener)=>({ setState: setState, getState: getState })=>{
            const { listeners: listeners } = getState();
            setState({
                listeners: [
                    ...listeners,
                    listener
                ]
            });
        },
    unregisterListener: (listener)=>({ setState: setState, getState: getState })=>{
            const { listeners: listeners } = getState();
            setState({
                listeners: listeners.filter((cb)=>cb !== listener)
            });
        },
    broadcastMessage: (type, message, context)=>({ getState: getState })=>{
            getState().listeners.forEach((listener)=>listener(type, message, context));
        }
};
const $5724c607f8adc142$var$Store = (0, $WBLbN.createStore)({
    name: 'dashboard-message-bus',
    initialState: {
        listeners: []
    },
    actions: $5724c607f8adc142$var$actions
});
const $5724c607f8adc142$export$69241ffa7d4e8d8d = (0, $WBLbN.createHook)($5724c607f8adc142$var$Store);

});

parcelRegister("kF6iw", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_GADGET_TYPE", () => $3fbc7688877dfc38$export$4db4c2521224b627);
$parcel$export(module.exports, "CONNECT_MODULE_PATTERN", () => $3fbc7688877dfc38$export$c1ee01d79441a123);
$parcel$export(module.exports, "FORGE_MODULE_PATTERN", () => $3fbc7688877dfc38$export$216b1f7517647987);
$parcel$export(module.exports, "WRM_GADGET_METRICS", () => $3fbc7688877dfc38$export$747c046b02db553e);
$parcel$export(module.exports, "FORGE_GADGET_METRICS", () => $3fbc7688877dfc38$export$fd11359c208e3b3d);
$parcel$export(module.exports, "REACT_GADGET_METRICS", () => $3fbc7688877dfc38$export$e6e5910bcc3a541f);
$parcel$export(module.exports, "FALLBACK_GADGET_SOURCE", () => $3fbc7688877dfc38$export$b17b847ae2e73914);
$parcel$export(module.exports, "IDLE_GADGET_SOURCE", () => $3fbc7688877dfc38$export$8e7a356fc2e45e1);
$parcel$export(module.exports, "GADGET_MARK_EVENT_PREFIX", () => $3fbc7688877dfc38$export$deb23548f6bb4aa6);
$parcel$export(module.exports, "GADGET_MARK_EVENT_PATTERN", () => $3fbc7688877dfc38$export$dc82d3f06c18522e);
$parcel$export(module.exports, "GADGET_RENDER_CONTAINER_EVENT", () => $3fbc7688877dfc38$export$479474c5d2f30a0a);
$parcel$export(module.exports, "GADGET_START_EVENT", () => $3fbc7688877dfc38$export$76b0ea781056f8d3);
$parcel$export(module.exports, "GADGET_RENDERING_FINISHED_EVENT", () => $3fbc7688877dfc38$export$b9c9f3ffa9290059);
$parcel$export(module.exports, "DEFAULT_WRM_GADGET_EVENTS", () => $3fbc7688877dfc38$export$f34d5b0533833e95);
const $3fbc7688877dfc38$export$4db4c2521224b627 = 'unknown';
const $3fbc7688877dfc38$export$c1ee01d79441a123 = /^atlassian-connect\/.*/;
const $3fbc7688877dfc38$export$216b1f7517647987 = /^ari:cloud:ecosystem::extension\/.*/;
const $3fbc7688877dfc38$export$747c046b02db553e = 'wrm_gadget_metrics';
const $3fbc7688877dfc38$export$fd11359c208e3b3d = 'forge_gadget_metrics';
const $3fbc7688877dfc38$export$e6e5910bcc3a541f = 'react_gadget_metrics';
const $3fbc7688877dfc38$export$b17b847ae2e73914 = 'fallback_gadget';
const $3fbc7688877dfc38$export$8e7a356fc2e45e1 = 'idle_gadget';
const $3fbc7688877dfc38$export$deb23548f6bb4aa6 = 'gadget-mark';
const $3fbc7688877dfc38$export$dc82d3f06c18522e = new RegExp(`^${$3fbc7688877dfc38$export$deb23548f6bb4aa6}-(.+)-(start|end)$`);
const $3fbc7688877dfc38$export$479474c5d2f30a0a = 'gadget-render-container';
const $3fbc7688877dfc38$export$593632c36804eee0 = 'gadget-dom-ready';
const $3fbc7688877dfc38$export$c10c3db63be202d5 = 'gadget-loaded';
const $3fbc7688877dfc38$export$76b0ea781056f8d3 = 'gadget-start';
const $3fbc7688877dfc38$export$b9c9f3ffa9290059 = 'gadget-rendering-finished';
const $3fbc7688877dfc38$export$eebee3f00d7d097d = 'gadget-sync-rendering-finished';
const $3fbc7688877dfc38$export$f34d5b0533833e95 = [
    $3fbc7688877dfc38$export$479474c5d2f30a0a,
    $3fbc7688877dfc38$export$76b0ea781056f8d3,
    $3fbc7688877dfc38$export$b9c9f3ffa9290059
];

});

parcelRegister("e01k4", function(module, exports) {

$parcel$export(module.exports, "getAllEventHandlers", () => $9d91f5788035531f$export$835bb833cb903f59);
$parcel$export(module.exports, "getNavStart", () => $9d91f5788035531f$export$f409d0aa399347ac);
$parcel$export(module.exports, "useGadgetMetricsAnalytics", () => $9d91f5788035531f$export$ea517a7cfce02895);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $k6Hlo = parcelRequire("k6Hlo");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $lMwBY = parcelRequire("lMwBY");

var $45wsB = parcelRequire("45wsB");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");

var $aD5FN = parcelRequire("aD5FN");

var $F4xHF = parcelRequire("F4xHF");

var $ces19 = parcelRequire("ces19");

var $dQeje = parcelRequire("dQeje");

var $dFjTU = parcelRequire("dFjTU");

var $rekMK = parcelRequire("rekMK");

var $179bk = parcelRequire("179bk");

var $kF6iw = parcelRequire("kF6iw");
// At time of writing BM3 doesn't support ssrFeatureFlags unless your page performs initial-paint
// in ssr (not just skeleton content), which Dashboard does not.
// We are forced to recreate here based on "@atlassian/jira-browser-metrics".
// We cannot reference code from BM directly since it gets removed in storybook, causing errors.
const $9d91f5788035531f$var$getSSRFeatureFlags = (0, $5iWql.default)(()=>{
    try {
        const metaTagValue = (0, $6rW04.default)('spa-service-flags');
        return metaTagValue != null && JSON.parse(metaTagValue) || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
const $9d91f5788035531f$var$expAttributes = {
    analyticsSource: 'dashboard',
    application: null,
    edition: null,
    additionalAttributes: {},
    wasExperienceSuccesful: true
};
// All expected metrics events from a WRM gadget in Config mode
const $9d91f5788035531f$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS = [
    (0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT)
];
// Expected metrics events from immediately finished gadgets e.g. fallbacks
const $9d91f5788035531f$var$IMMEDIATE_FINISH_GADGET_EVENTS = [
    (0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT)
];
// Events send by the gadget container, which should not be counted to determine idle gadget
const $9d91f5788035531f$var$GADGET_CONTAINER_EVENTS = new Set([
    (0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT)
]);
const $9d91f5788035531f$export$835bb833cb903f59 = (eventSource, contentType = 'View')=>{
    if (eventSource === (0, $kF6iw.WRM_GADGET_METRICS) || eventSource === (0, $kF6iw.FORGE_GADGET_METRICS) || eventSource === (0, $kF6iw.REACT_GADGET_METRICS)) return contentType === 'Config' ? $9d91f5788035531f$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS : (0, $kF6iw.DEFAULT_WRM_GADGET_EVENTS);
    return $9d91f5788035531f$var$IMMEDIATE_FINISH_GADGET_EVENTS;
};
const $9d91f5788035531f$var$isIdle = (gadgetEventRecord)=>{
    if (gadgetEventRecord == null) return false;
    if (gadgetEventRecord.source === (0, $kF6iw.IDLE_GADGET_SOURCE)) return true;
    const eventEntries = Array.from(gadgetEventRecord.events.entries());
    return eventEntries.length === $9d91f5788035531f$var$GADGET_CONTAINER_EVENTS.size && eventEntries.every((entry)=>$9d91f5788035531f$var$GADGET_CONTAINER_EVENTS.has(entry[0]));
};
const $9d91f5788035531f$export$b1f29dd0b70f467b = (events)=>{
    const customMarksMap = {};
    const customMarksList = [];
    events.forEach((event, eventKey)=>{
        const parts = (0, $kF6iw.GADGET_MARK_EVENT_PATTERN).exec(eventKey);
        if (parts == null) return;
        const key = parts[1];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const stage = parts[2];
        const customMark = customMarksMap[key];
        if (customMark == null) {
            const newCustomMark = {
                name: `gadgetMark_${key}`,
                [stage]: event.spaTime
            };
            customMarksMap[key] = newCustomMark;
            customMarksList.push(newCustomMark);
        } else customMark[stage] = event.spaTime;
    });
    return customMarksList;
};
const $9d91f5788035531f$var$getInitialMarks = (context)=>({
        TTI: Date.now() - Number(context.navStart),
        isInitialRender: context.isInitialRender,
        isWritable: context.isWritable,
        isRouteReplaced: context.isRouteReplaced,
        currentPageId: context.currentPageId,
        // TODO should be removed in favour of BM3 pageVisible property
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        pageVisible: !window?.document?.hidden,
        ssrFeatureFlags: $9d91f5788035531f$var$getSSRFeatureFlags(),
        featureFlags: (0, $ces19.getDashboardFeatureFlags)(),
        featureGates: (0, $dQeje.getDashboardFeatureGates)(),
        centralised: true
    });
const $9d91f5788035531f$export$f409d0aa399347ac = (isInitialRender, lastTransitionStartTime, navigationStart)=>{
    const sessionStart = navigationStart != null ? new Date(navigationStart).getTime() : 0;
    return !isInitialRender && lastTransitionStartTime != null ? lastTransitionStartTime : sessionStart;
};
const $9d91f5788035531f$var$isInvalidContextState = (metricsContextTimeStamp, currentNavStart, currentPageId)=>{
    if (metricsContextTimeStamp.currentPageId !== currentPageId) return true;
    if (metricsContextTimeStamp.created < metricsContextTimeStamp.navStart) return true;
    const now = Date.now();
    if (now < metricsContextTimeStamp.navStart) return true;
    if (now < Number(currentNavStart)) return true;
    return false;
};
const $9d91f5788035531f$export$ea517a7cfce02895 = (dashboardId)=>{
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId = 'unknown' }] = (0, $78d1w.useSpaStateTransition)();
    const [{ aboveTheFoldGadgets: aboveTheFoldGadgets }] = (0, $179bk.useRenderAboveTheFold)();
    const [routerState] = (0, $lB25E.useRouter)();
    const navStart = $9d91f5788035531f$export$f409d0aa399347ac(isInitialRender, lastTransitionStartTime, navigationStart);
    const dashboardData = (0, $01Qi5.useDashboardResource)().data;
    const { scrollStartTimestamp: scrollStartTimestamp, resetScrollStartTime: resetScrollStartTime } = (0, $rekMK.useDashboardScrollAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const newContext = {
        dashboardId: dashboardId,
        isInitialRender: isInitialRender,
        isRouteReplaced: routerState.action === 'REPLACE',
        lastTransitionStartTime: lastTransitionStartTime,
        navigationStart: navigationStart,
        currentPageId: currentPageId,
        navStart: navStart,
        gadgets: dashboardData?.gadgets,
        isWritable: dashboardData?.writable ?? false,
        scrollStartTimestamp: scrollStartTimestamp,
        aboveTheFoldGadgets: aboveTheFoldGadgets,
        resetScrollStartTime: resetScrollStartTime
    };
    const context = (0, $eUqFw.useRef)(newContext);
    context.current = newContext;
    const sendGadgetMetrics = (0, $eUqFw.useCallback)((gadgetId, gadgetEventRecord)=>{
        if (context.current.navigationStart == null) return;
        const gadgetModel = context.current.gadgets?.find((item)=>item.id === gadgetId) || null;
        // Setup common marks first
        const customMarks = {
            ...$9d91f5788035531f$var$getInitialMarks(context.current),
            timeout: gadgetEventRecord.timedOut === true,
            gadgetContentType: gadgetEventRecord.contentType,
            isAboveTheFold: context.current.aboveTheFoldGadgets.has(gadgetId)
        };
        // Timeout Marks
        if (gadgetEventRecord.timedOut === true) {
            if ($9d91f5788035531f$var$isIdle(gadgetEventRecord)) customMarks.timeout_idle = true;
            else $9d91f5788035531f$export$835bb833cb903f59(gadgetEventRecord.source, gadgetEventRecord.contentType).filter((event)=>!$9d91f5788035531f$var$GADGET_CONTAINER_EVENTS.has(event)).filter((event)=>!gadgetEventRecord.events.has(event)).forEach((event)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                customMarks[`timeout_${event}`] = true;
            });
        }
        if (gadgetEventRecord.source === (0, $kF6iw.WRM_GADGET_METRICS) || gadgetEventRecord.source === (0, $kF6iw.FORGE_GADGET_METRICS) || gadgetEventRecord.source === (0, $kF6iw.REACT_GADGET_METRICS)) {
            customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || gadgetModel?.reactKey || (0, $kF6iw.UNKNOWN_GADGET_TYPE);
            const renderContainer = gadgetEventRecord.events.get((0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT));
            const start = gadgetEventRecord.events.get((0, $kF6iw.GADGET_START_EVENT));
            if (renderContainer != null) customMarks.gadgetRenderContainer = renderContainer.spaTime - Number(context.current.navStart);
            if (start != null) {
                customMarks.gadgetStartTime = start.spaTime - Number(context.current.navStart);
                customMarks.gadgetDuration = Date.now() - start.spaTime;
            }
        } else if (gadgetEventRecord.source === (0, $kF6iw.IDLE_GADGET_SOURCE) || gadgetEventRecord.source === (0, $kF6iw.FALLBACK_GADGET_SOURCE)) // The gadget doesn't send any event till timed out
        customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || (0, $kF6iw.UNKNOWN_GADGET_TYPE);
        $9d91f5788035531f$export$b1f29dd0b70f467b(gadgetEventRecord.events).forEach((gadgetMark)=>{
            if (gadgetMark.start != null) customMarks[`${gadgetMark.name}-start`] = gadgetMark.start - Number(context.current.navStart);
            if (gadgetMark.start != null && gadgetMark.end != null) customMarks[`${gadgetMark.name}-duration`] = gadgetMark.end - gadgetMark.start;
        });
        const gadgetLoadIdentifier = `gadget-${context.current.dashboardId ?? 'no-dashboard-id'}-${gadgetId}`;
        (0, $dFjTU.gadgetLoad)(gadgetLoadIdentifier).start({
            startTime: context.current.navStart
        });
        (0, $dFjTU.gadgetLoad)(gadgetLoadIdentifier).stop({
            customData: customMarks,
            stopTime: Date.now()
        });
        if (gadgetEventRecord.source === (0, $kF6iw.WRM_GADGET_METRICS) && gadgetEventRecord.contentType !== 'View' && gadgetEventRecord.contentType !== 'Config') (0, $9lmTX.default)({
            ...$9d91f5788035531f$var$expAttributes,
            experience: (0, $kEBPk.VIEW_WRM_GADGET_EXPERIENCE),
            wasExperienceSuccesful: false
        });
    }, []);
    const sendOverallGadgetMetrics = (0, $eUqFw.useCallback)((gadgetIds, gadgetMetricsEvents, timeout)=>{
        const metricToReport = {
            timeout: timeout,
            fullDashboardTTI: Date.now() - Number(context.current.navStart),
            dashboardScrollStartTime: context.current.scrollStartTimestamp.current != null ? context.current.scrollStartTimestamp.current - Number(context.current.navStart) : 'unknown',
            belowTheFoldTTI: Date.now() - (context.current.scrollStartTimestamp.current != null && (context.current.gadgets?.length || 0) - context.current.aboveTheFoldGadgets.size > 0 ? context.current.scrollStartTimestamp.current : Date.now())
        };
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fullDashboard loaded', metricToReport);
    }, [
        createAnalyticsEvent
    ]);
    const onAboveTheFoldGadgetsRender = (0, $eUqFw.useCallback)((gadgetIds, gadgetMetricsEvents, gadgetRenderStartTime, contextTimeStamps, timeout)=>{
        // count connect gadgets
        const connectGadgetCount = context.current.gadgets?.filter((item)=>(0, $kF6iw.CONNECT_MODULE_PATTERN).test(item.amdModule || '')).length || 0;
        // count forge gadgets
        const forgeGadgetCount = context.current.gadgets?.filter((item)=>(0, $kF6iw.FORGE_MODULE_PATTERN).test(item.forge?.key || '')).length || 0;
        // count untracked gadgets (including connect)
        const untrackedGadgetCount = context.current.gadgets?.filter((item)=>gadgetIds.every((id)=>id !== item.id)).length || 0;
        // count the deprecated gadgets
        const deprecatedGadgetsCount = context.current.gadgets ? context.current.gadgets.filter((gadget)=>(0, $k6Hlo.isDeprecatedGadget)(gadget.amdModule)).length : 0;
        const initialMarks = $9d91f5788035531f$var$getInitialMarks(context.current);
        const gadgetRenderStart = gadgetRenderStartTime - Number(context.current.navStart);
        // Validate metrics context
        const invalidContextState = $9d91f5788035531f$var$isInvalidContextState(contextTimeStamps, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        context.current.navStart, context.current.currentPageId) || initialMarks.TTI < 0 || gadgetRenderStart < 0;
        if (invalidContextState) // Report abnormal status
        (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics context state is invalid for dashboard [${context.current.currentPageId ?? 'null'}]: { contextTimestamps: ${JSON?.stringify(contextTimeStamps)}, now:${Date.now()}, pnow:${performance?.now()}, navStart:${context.current.navStart} }`);
        const customData = {
            ...initialMarks,
            gadgetRenderStart: gadgetRenderStart,
            // counts
            gadgetCount_Total: context.current.gadgets?.length ?? 0,
            gadgetCount_Connect: connectGadgetCount,
            gadgetCount_Forge: forgeGadgetCount,
            gadgetCount_Unknown: untrackedGadgetCount - connectGadgetCount,
            timeout: timeout,
            gadgetCount_AboveTheFold: context.current.aboveTheFoldGadgets.size,
            gadgetCount_Deprecated: deprecatedGadgetsCount,
            isStaled: invalidContextState
        };
        (0, $aD5FN.addUFOCustomData)(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $45wsB.trackBM3FeatureFlagsAccessed)((0, $dFjTU.dashboardLoad));
        (0, $F4xHF.addApdexToAll)({
            key: (0, $dFjTU.dashboardLoad).key,
            stopTime: performance.now()
        });
        if ((0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences')) (0, $lMwBY.afterPaintEmit)((stopTime)=>{
            (0, $dFjTU.dashboardLoad).stop({
                stopTime: stopTime,
                customData: // @ts-expect-error - feature flags may technically be null which BM3 doesn't like
                customData
            });
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $dFjTU.dashboardLoad));
        else (0, $dFjTU.dashboardLoad).stop({
            customData: // @ts-expect-error - feature flags may technically be null which BM3 doesn't like
            customData
        });
    }, []);
    const resetScrollStartMetrics = (0, $eUqFw.useCallback)(()=>{
        context.current.resetScrollStartTime();
    }, []);
    const sendDebuggingAnalytics = (0, $eUqFw.useCallback)((contextTimeStamps)=>{
        const attributes = {
            isStale: $9d91f5788035531f$var$isInvalidContextState(contextTimeStamps, context.current.navStart, context.current.currentPageId),
            tti: Date.now() - Number(context.current.navStart),
            currentPageId: context.current.currentPageId
        };
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'tti sent', attributes);
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendGadgetMetrics: sendGadgetMetrics,
        sendOverallGadgetMetrics: sendOverallGadgetMetrics,
        onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender,
        resetScrollStartMetrics: resetScrollStartMetrics,
        sendDebuggingAnalytics: sendDebuggingAnalytics
    };
};

});
parcelRegister("lMwBY", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $6a5d9a384a9292d0$export$dc4c3408669b8f4e);

var $6iz4v = parcelRequire("6iz4v");

const $6a5d9a384a9292d0$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $5cZda = parcelRequire("5cZda");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $5cZda.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});

parcelRegister("ces19", function(module, exports) {

$parcel$export(module.exports, "getDashboardFeatureFlags", () => $641759a5eceae85c$export$5f260d38da0c0462);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $5iWql = parcelRequire("5iWql");

var $aWbzA = parcelRequire("aWbzA");
// IMPORTANT - endeavour dashboard flags should match schema, this is primarily for other teams FFs
const $641759a5eceae85c$var$DASHBOARD_ADDITIONAL_FLAGS = [];
const $641759a5eceae85c$var$DASHBOARD_FEATURE_FLAG_SCHEMA = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
const $641759a5eceae85c$export$5f260d38da0c0462 = (0, $5iWql.default)(()=>{
    // at time of writing getFeatureFlags() will throw for badly formed feature flag JSON
    try {
        const allFFs = (0, $aWbzA.default)() || {};
        return Object.fromEntries(Object.keys(allFFs).filter((key)=>$641759a5eceae85c$var$DASHBOARD_FEATURE_FLAG_SCHEMA.test(key) || $641759a5eceae85c$var$DASHBOARD_ADDITIONAL_FLAGS.includes(key)).sort((a, b)=>a.localeCompare(b, undefined, {
                ignorePunctuation: true
            })).map((key)=>[
                key,
                allFFs[key].value
            ]));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});

});

parcelRegister("dQeje", function(module, exports) {

$parcel$export(module.exports, "getDashboardFeatureGates", () => $0eba7d00f4713076$export$7cf9f66e85966b7);

var $5iWql = parcelRequire("5iWql");

var $eI5EY = parcelRequire("eI5EY");
const $0eba7d00f4713076$export$7cf9f66e85966b7 = (0, $5iWql.default)(()=>({
        endeavour_nin_assigned_to_me_gadget: (0, $eI5EY.fg)('endeavour_nin_assigned_to_me_gadget'),
        endeavour_nin_issues_in_progress_gadget: (0, $eI5EY.fg)('endeavour_nin_issues_in_progress_gadget'),
        endeavour_nin_filter_results_gadget: (0, $eI5EY.fg)('endeavour_nin_filter_results_gadget'),
        endeavour_nin_watched_issues_gadget: (0, $eI5EY.fg)('endeavour_nin_watched_issues_gadget'),
        endeavour_nin_voted_issues_gadget: (0, $eI5EY.fg)('endeavour_nin_voted_issues_gadget'),
        endeavour_gadget_deprecation_banner_v1: (0, $eI5EY.fg)('endeavour_gadget_deprecation_banner_v1')
    }));

});

parcelRegister("dFjTU", function(module, exports) {

$parcel$export(module.exports, "gadgetLoad", () => $0bf04dd1209b86cc$export$4de73f6aec94634c);
$parcel$export(module.exports, "dashboardLoad", () => $0bf04dd1209b86cc$export$2b2c4cbb9844d8cb);

var $cFpT4 = parcelRequire("cFpT4");
const $0bf04dd1209b86cc$export$4de73f6aec94634c = (0, $cFpT4.metrics).concurrent.custom({
    key: 'dashboard.gadget',
    featureFlags: []
});
const $0bf04dd1209b86cc$export$2b2c4cbb9844d8cb = (0, $cFpT4.metrics).pageLoad({
    key: 'dashboard',
    featureFlags: []
});

});

parcelRegister("rekMK", function(module, exports) {

$parcel$export(module.exports, "useDashboardScrollAnalytics", () => $d0f187c09c826dfa$export$83af525d5e7538fa);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8WKBq = parcelRequire("8WKBq");

var $78d1w = parcelRequire("78d1w");
const $d0f187c09c826dfa$export$83af525d5e7538fa = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const currentPage = (0, $8WKBq.useCurrentPage)();
    const [{ isInitialRender: isInitialRender, currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const { startTime: startTime } = currentPage;
    const scrollStartTimestamp = (0, $eUqFw.useRef)(null);
    const debounceSendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((_scrollStartTimestamp)=>{
        if (scrollStartTimestamp.current != null) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const percentageOfPageScrolled = window.scrollY / window.innerHeight;
        if (percentageOfPageScrolled < 0.2) return;
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'scrolled',
            actionSubject: 'page'
        }), 'dashboardScroll', {
            isInitialRender: isInitialRender,
            scrollStartTimeFromPageLoad: _scrollStartTimestamp - startTime,
            percentageOfPageScrolled: percentageOfPageScrolled,
            currentPageId: currentPageId
        });
        scrollStartTimestamp.current = _scrollStartTimestamp;
    }, 500);
    (0, $eUqFw.useEffect)(()=>{
        const fireScrollAnalytics = ()=>{
            debounceSendAnalytics(Date.now());
        };
        const resetScrollPosition = ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.scrollTo(0, 0);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('scroll', fireScrollAnalytics);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('unload', resetScrollPosition);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('scroll', fireScrollAnalytics);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('unload', resetScrollPosition);
        };
    }, [
        debounceSendAnalytics
    ]);
    const resetScrollStartTime = (0, $eUqFw.useCallback)(()=>{
        scrollStartTimestamp.current = null;
    }, []);
    return {
        scrollStartTimestamp: scrollStartTimestamp,
        resetScrollStartTime: resetScrollStartTime
    };
};

});
parcelRegister("8WKBq", function(module, exports) {

$parcel$export(module.exports, "useCurrentPage", () => $319deecc32e62352$export$6faff8ed5e305ed3);

var $WBLbN = parcelRequire("WBLbN");

var $cfLkw = parcelRequire("cfLkw");
const $319deecc32e62352$var$useSweetStateCurrentPage = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: (state)=>state.currentPage
});
const $319deecc32e62352$export$6faff8ed5e305ed3 = ()=>{
    const [currentPage] = $319deecc32e62352$var$useSweetStateCurrentPage();
    return currentPage;
};

});



parcelRegister("6ofMt", function(module, exports) {

$parcel$export(module.exports, "GADGETS_TO_REPORT", () => $7c2aafc47116614f$export$2c28b0760818db72);
$parcel$export(module.exports, "GADGETS_IGNORED", () => $7c2aafc47116614f$export$c1d730ac3dcf5785);
// A list of gadgets (gadgetType) should contribute to the overall dashboard TTI.
// Some gadgets not in this list may not send metrics event to the dashboard and potentially hold up the dashboard
// metrics until 60 second timeout.
const $7c2aafc47116614f$export$2c28b0760818db72 = new Set([
    // WRM gadgets
    'jira-dashboard-items/assigned-to-me',
    'jira-dashboard-items/bubble-chart-dashboard-item',
    'jira-dashboard-items/createdvsresolved',
    'jira-dashboard-items/favourite-filters',
    'jira-dashboard-items/filter-results',
    'jira-dashboard-items/in-progress',
    'jira-dashboard-items/labels',
    'jira-dashboard-items/piechart',
    'jira-dashboard-items/stats',
    'jira-dashboard-items/two-dimensional-stats',
    'jira-dashboard-items/voted',
    'jira-dashboard-items/watched',
    'jira-dashboard-items/issuescalendar',
    'jira-dashboard-items/projects',
    'jira-dashboard-items/activitystream',
    'jira-dashboard-items/recently-created',
    'jira-dashboard-items/workload-pie-chart',
    'jira-dashboard-items/roadmap',
    'jira-dashboard-items/average-age-chart',
    'jira-dashboard-items/average-time-in-status-chart',
    'jira-dashboard-items/average-number-of-times-in-status-chart',
    'jira-dashboard-items/heat-map',
    'jira-dashboard-items/time-to-first-response',
    'jira-dashboard-items/sprint-burndown',
    'jira-dashboard-items/resolution-time',
    'jira-dashboard-items/timesince',
    'jira-dashboard-items/spacer',
    'jira-dashboard-items/rapid-view',
    'jira-dashboard-items/version-report',
    // simple iframe gadgets
    'rest/gadgets/1.0/g/com.atlassian.bonfire.plugin:bonfire-test-sessions-gadget/gadget/bonfire-sessions-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.calendar:issuescalendar-gadget/templates/plugins/jira/portlets/calendar/gadget/calendar-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:firstresponse-gadget/com/atlassian/jira/ext/charting/gadget/firstresponse-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:numberoftimesinstatus-gadget/com/atlassian/jira/ext/charting/gadget/numberoftimesinstatus-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:timeinstatus-gadget/com/atlassian/jira/ext/charting/gadget/timeinstatus-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:workloadpie-gadget/com/atlassian/jira/ext/charting/gadget/workloadpie-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:average-age-chart-gadget/gadgets/average-age-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:recently-created-chart-gadget/gadgets/recently-created-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:resolution-time-gadget/gadgets/resolution-time-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:time-since-chart-gadget/gadgets/timesince-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:crucible-charting-gadget/gadgets/crucible-charting-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-charting-gadget/gadgets/fisheye-charting-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-recent-commits-gadget/gadgets/fisheye-recent-commits-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirawallboard.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.streams.streams-jira-plugin:activitystream-gadget/gadgets/activitystream-gadget.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-rapid-view/gadgets/greenhopper-rapid-view.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-sprint-burndown/gadgets/greenhopper-sprint-burndown.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-version-report/gadgets/greenhopper-version-report.xml'
]);
const $7c2aafc47116614f$export$c1d730ac3dcf5785 = new Set([
    'jira-dashboard-items/sprint-days-remaining',
    'jira-dashboard-items/sprint-health',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item'
]);

});


parcelRegister("9zcCd", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $a256b88f7680f175$export$ea2491906b753456);

var $eUqFw = parcelRequire("eUqFw");

var $6iz4v = parcelRequire("6iz4v");

var $kEBPk = parcelRequire("kEBPk");

var $01Qi5 = parcelRequire("01Qi5");

var $lcJyp = parcelRequire("lcJyp");

var $iKzwQ = parcelRequire("iKzwQ");
const $a256b88f7680f175$var$isAmdGadget = (gadget)=>gadget.amdModule != null && gadget.amdModule !== (0, $kEBPk.CONNECT_ITEM_AMD_MODULE);
const $a256b88f7680f175$var$isWaitableGadget = (gadget)=>$a256b88f7680f175$var$isAmdGadget(gadget);
const $a256b88f7680f175$var$getWaitableGadgetSet = (gadgets)=>new Set(gadgets.filter($a256b88f7680f175$var$isWaitableGadget).map(({ id: id })=>id));
const $a256b88f7680f175$export$ea2491906b753456 = ()=>{
    const { data: data, loading: loading } = (0, $01Qi5.useDashboardResource)();
    const [, { registerListener: registerListener, unregisterListener: unregisterListener }] = (0, $iKzwQ.useMessageBus)();
    const lastDashboardId = (0, $eUqFw.useRef)();
    const pendingGadgetSet = (0, $eUqFw.useRef)(new Set());
    const [, { setAppReady: setAppReady }] = (0, $lcJyp.useSpaStateActions)();
    const callback = (0, $eUqFw.useCallback)((type, _, { gadgetId: gadgetId })=>{
        if (type !== (0, $kEBPk.GADGET_METRICS_TYPE).REPORT) return;
        if (!pendingGadgetSet.current.has(gadgetId)) return;
        pendingGadgetSet.current.delete(gadgetId);
        if (pendingGadgetSet.current.size > 0) return;
        unregisterListener(callback);
        (0, $6iz4v.setMark)((0, $kEBPk.PAGE_READY_METRIC_KEY));
        setAppReady();
    }, [
        setAppReady,
        unregisterListener
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (loading || data == null || data.id === lastDashboardId.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        lastDashboardId.current = data.id;
        pendingGadgetSet.current = $a256b88f7680f175$var$getWaitableGadgetSet(data.gadgets);
        if (pendingGadgetSet.current.size === 0) {
            (0, $6iz4v.setMark)((0, $kEBPk.PAGE_READY_METRIC_KEY));
            setAppReady();
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        registerListener(callback);
        return ()=>{
            unregisterListener(callback);
        };
    }, [
        callback,
        data,
        loading,
        registerListener,
        setAppReady,
        unregisterListener
    ]);
};

});

parcelRegister("1xFgW", function(module, exports) {

$parcel$export(module.exports, "addDashboardToRecents", () => $55631ac2a21d6cbc$export$9f034829a82f8a11);
const $55631ac2a21d6cbc$export$9f034829a82f8a11 = (dashboardId)=>fetch(`/rest/internal/latest/dashboards/history/${dashboardId}`, {
        method: 'POST'
    });

});

parcelRegister("kVRTc", function(module, exports) {

$parcel$export(module.exports, "AboveTheFoldContainer", () => $2209e0d5e3e20178$export$60c1d52f3e30a1cd);

var $eUqFw = parcelRequire("eUqFw");

var $179bk = parcelRequire("179bk");

var $fWiDt = parcelRequire("fWiDt");

var $aIeBA = parcelRequire("aIeBA");
const $2209e0d5e3e20178$export$60c1d52f3e30a1cd = ({ gadgets: gadgets, dashboardId: dashboardId, layout: layout, children: children })=>{
    const { getMaximisedGadgetId: getMaximisedGadgetId } = (0, $fWiDt.useMaximizedGadget)(gadgets);
    const columns = (0, $eUqFw.useMemo)(()=>(0, $aIeBA.toColumns)(gadgets, layout), [
        gadgets,
        layout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $179bk.RenderAboveTheFoldContainer), {
        columns: columns,
        dashboardId: dashboardId,
        scope: dashboardId,
        maximizedGadgetId: getMaximisedGadgetId
    }, children);
};

});

parcelRegister("4Jf8r", function(module, exports) {

$parcel$export(module.exports, "AmdGadgetMonolithOverrideStyles", () => $c8f679d6c3022720$export$17921465e6f60e58);

var $eUqFw = parcelRequire("eUqFw");
const $c8f679d6c3022720$var$styles = `.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #5e6c84)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #0049b0)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #ebecf0)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #172b4d)"};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #5e6c84)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0049b0)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: 400;
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
const $c8f679d6c3022720$export$17921465e6f60e58 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, $c8f679d6c3022720$var$styles);

});

parcelRegister("3kpkG", function(module, exports) {

$parcel$export(module.exports, "DASHBOARD_PERMISSION_ERROR_CODE_LIST", () => $8c42a2e3550fad75$export$f33202be19a062b9);
// NOTE: Avoid modifying code `401` as this is used by wallboard and permission error pages (search DASHBOARD_PERMISSION_ERROR_CODE_LIST for usages).
// Wallboard does not reference this list directly because there are import issues, so it uses `401` as a string.
const $8c42a2e3550fad75$export$f33202be19a062b9 = [
    401,
    403,
    404
];

});

parcelRegister("35TBS", function(module, exports) {

$parcel$export(module.exports, "usePageStatusLogger", () => $0a94d34d8f3d0493$export$8b3b053e4f10e669);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");


var $78d1w = parcelRequire("78d1w");

var $dYru8 = parcelRequire("dYru8");

var $ces19 = parcelRequire("ces19");
const $0a94d34d8f3d0493$var$TEN_MIN = 600000;
// We need to replace '.' in FF keys with '_' to match BM3 and avoid confusion in Splunk
const $0a94d34d8f3d0493$var$sanitiseKeys = (featureFlags)=>Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(featureFlags || {}).map(([key, value])=>[
            key.replace(/\./g, '_'),
            value
        ]));
const $0a94d34d8f3d0493$export$8b3b053e4f10e669 = (interval)=>{
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const [{ isInitialRender: isInitialRender, currentPageId: currentPageId, lastTransition: lastTransition }] = (0, $78d1w.useSpaStateTransition)();
    (0, $eUqFw.useEffect)(()=>{
        const logFeatureFlags = ()=>{
            const featureFlags = JSON.stringify($0a94d34d8f3d0493$var$sanitiseKeys((0, $ces19.getDashboardFeatureFlags)()));
            const attributes = {
                isInitialRender: isInitialRender,
                lastTransition: lastTransition,
                currentPageId: currentPageId,
                featureFlags: featureFlags
            };
            (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.page-status', Object.entries(attributes) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([k, v])=>`${k} [${String(v ?? null)}]`).join(' '));
            fireAnalytics({
                eventType: (0, $41ea3621645e2acc$export$12346a674644c156),
                actionSubject: 'dashboard.page-status',
                actionSubjectId: 'featureFlags',
                action: 'logged',
                attributes: attributes
            });
        };
        logFeatureFlags();
        const logInterval = setInterval(logFeatureFlags, Math.max($0a94d34d8f3d0493$var$TEN_MIN, interval) || $0a94d34d8f3d0493$var$TEN_MIN);
        return ()=>clearInterval(logInterval);
    }, [
        interval,
        fireAnalytics,
        isInitialRender,
        currentPageId,
        lastTransition
    ]);
};

});

parcelRegister("b4XFG", function(module, exports) {

$parcel$export(module.exports, "RouteResourceValidator", () => $e62eebd9982c76c8$export$1d8835c03b47dfbd);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");
const $e62eebd9982c76c8$export$1d8835c03b47dfbd = ()=>{
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    const { promise: promise, loading: loading, data: data, error: error } = (0, $01Qi5.useDashboardAMDModulesResource)();
    const [hasRendered, setHasRendered] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!loading) setHasRendered(true);
    }, [
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (false) return;
        const prefix = `Resource validation [${isInitialRender ? 'initial' : 'transition'}][${hasRendered ? 'rerender' : 'original'}]`;
        if (!promise) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource may be missing`);
        else if (loading) (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} loading`);
        else if (data) {
            const { amdModules: amdModules, sharedValue: sharedValue } = data;
            if (sharedValue == null || sharedValue instanceof Error) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource shared value [${String(sharedValue)}]`);
            else if (!sharedValue?.isPreloaded && isInitialRender && !hasRendered) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, config+wrm resource did not run in SSR`);
            else if (amdModules === null) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, WRM resources failed to load`);
            else {
                const [failedCount, totalCount] = Object.values(amdModules).reduce(([f], v, i, arr)=>[
                        f + (v == null ? 1 : 0),
                        arr.length
                    ], [
                    0,
                    0
                ]);
                if (failedCount > 0) {
                    const failedNames = Object.entries(amdModules).filter(([, v])=>v == null).map(([k])=>k).join(',');
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD evaluation failed [${failedCount}] of [${totalCount}], failed modules [${failedNames}]`);
                } else (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} success`);
            }
        } else if (error) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed with AMD resource error [${error instanceof Error ? error.message : String(error)}]`, error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promise,
        loading,
        data,
        error
    ]);
    return null;
};

});


parcelRegister("f9MgH", function(module, exports) {

$parcel$export(module.exports, "useGadgetTitle", () => $f47ce2e2be077c91$export$dba832fc7432cba1);
$parcel$export(module.exports, "useConnectGadgetTitles", () => $f47ce2e2be077c91$export$66e677fcbdac9c95);

var $eUqFw = parcelRequire("eUqFw");
function $f47ce2e2be077c91$export$dba832fc7432cba1({ defaultTitle: initialDefaultTitle, title: title, onSave: onSave }) {
    const [defaultTitle, setDefaultTitle] = (0, $eUqFw.useState)(initialDefaultTitle);
    const [userTitle, setUserTitle] = (0, $eUqFw.useState)(title);
    const setTitle = (0, $eUqFw.useCallback)(async (newTitle)=>{
        const previousTitle = userTitle;
        setUserTitle(newTitle);
        onSave?.(newTitle).catch(()=>{
            setUserTitle(previousTitle);
        });
    }, [
        userTitle,
        onSave
    ]);
    const setDefaultTitleWithInitialTitle = (0, $eUqFw.useCallback)((defaultTitleUpdaterOrValue)=>{
        setDefaultTitle(typeof defaultTitleUpdaterOrValue === 'function' ? defaultTitleUpdaterOrValue(initialDefaultTitle) : defaultTitleUpdaterOrValue);
    }, [
        initialDefaultTitle
    ]);
    return {
        title: userTitle || defaultTitle,
        setDefaultTitle: setDefaultTitleWithInitialTitle,
        setTitle: setTitle
    };
}
const $f47ce2e2be077c91$export$66e677fcbdac9c95 = ()=>{
    const [connectGadgets, setConnectGadgets] = (0, $eUqFw.useState)({});
    const registerConnectGadget = (0, $eUqFw.useCallback)((id, setTitle)=>{
        setConnectGadgets((gadgets)=>({
                ...gadgets,
                [id]: setTitle
            }));
    }, []);
    const unregisterConnectGadget = (0, $eUqFw.useCallback)((id)=>{
        setConnectGadgets((gadgets)=>{
            const { [id]: _, ...rest } = gadgets;
            return rest;
        });
    }, []);
    const setCustomTitle = (0, $eUqFw.useCallback)((id, title)=>{
        const setTitle = connectGadgets[id];
        if (!setTitle) throw new Error(`Unable to set custom title on Connect gadget. No gadget with id ${id} found. Available ids: ${Object.keys(connectGadgets).join(', ')}`);
        return setTitle(title);
    }, [
        connectGadgets
    ]);
    return {
        registerConnectGadget: registerConnectGadget,
        setCustomTitle: setCustomTitle,
        unregisterConnectGadget: unregisterConnectGadget
    };
};

});

parcelRegister("cQdeb", function(module, exports) {

$parcel$export(module.exports, "RightPanelLayoutContainer", () => $d0a392c5b7aaf746$export$b0b99b1b479c37c2);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $lvsk4 = parcelRequire("lvsk4");
var $8Vv3m = parcelRequire("8Vv3m");

var $aYtGv = parcelRequire("aYtGv");

var $c9TLT = parcelRequire("c9TLT");

var $8Dzk5 = parcelRequire("8Dzk5");
const $d0a392c5b7aaf746$var$RIGHT_PANEL_WIDTH = (0, $c9TLT.gridSize) * 46;
const $d0a392c5b7aaf746$export$b0b99b1b479c37c2 = ({ isOpenByDefault: isOpenByDefault = false, defaultPanelId: defaultPanelId, rightContent: rightContent, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Dzk5.RightPanelContainer), {
        isOpenByDefault: isOpenByDefault,
        defaultPanelId: defaultPanelId,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0a392c5b7aaf746$var$Panels, {
        rightContent: rightContent
    }, children));
// `useRightPanelState` needs to be called from inside `RightPanelContainer` to ensure the value of isOpen is
// set correctly on initial render (otherwise it defaults to false), so we need a separate component here.
const $d0a392c5b7aaf746$var$Panels = ({ rightContent: rightContent, children: children })=>{
    const { isOpen: isRightPanelOpen } = (0, $8Dzk5.useRightPanelState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvsk4.default), {
        templateColumns: isRightPanelOpen ? `1fr ${$d0a392c5b7aaf746$var$RIGHT_PANEL_WIDTH}px` : '1fr 0',
        gap: isRightPanelOpen ? 'space.500' : 'space.0',
        xcss: $d0a392c5b7aaf746$var$gridStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $d0a392c5b7aaf746$var$leftPanelStyles
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        as: "aside",
        xcss: $d0a392c5b7aaf746$var$rightPanelStyles
    }, rightContent));
};
const $d0a392c5b7aaf746$var$rightPanelStyles = (0, $8Vv3m.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: `calc(${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)})`,
    alignSelf: 'start',
    marginRight: 'space.negative.400'
});
const $d0a392c5b7aaf746$var$leftPanelStyles = (0, $8Vv3m.xcss)({
    minWidth: '0'
});
const $d0a392c5b7aaf746$var$gridStyles = (0, $8Vv3m.xcss)({
    transition: 'grid-template-columns 300ms cubic-bezier(0.2, 0, 0, 1) 0s'
});

});
parcelRegister("8Dzk5", function(module, exports) {

$parcel$export(module.exports, "useRightPanelToggle", () => $b0ea5829ee465b66$export$898b0b9e6647aa1a);
$parcel$export(module.exports, "useRightPanelState", () => $b0ea5829ee465b66$export$44f374c6fe8a17ef);
$parcel$export(module.exports, "RightPanelContainer", () => $b0ea5829ee465b66$export$e37cfb5282d612c2);

var $WBLbN = parcelRequire("WBLbN");
const $b0ea5829ee465b66$var$initialState = {
    isOpen: false,
    focusKey: 0,
    panelId: null,
    isTriggerFocused: false
};
const $b0ea5829ee465b66$var$openPanel = (panelId)=>({ setState: setState, getState: getState })=>{
        if (getState().isOpen === false) setState({
            isOpen: true,
            focusKey: getState().focusKey + 1,
            panelId: panelId,
            isTriggerFocused: false
        });
        else setState({
            // if the panel is already open, we only want to focus it
            // this scenario occurs when the panel is open by default
            // and the user clicks on the add gadget button
            // update key to trigger re-focusing of the side panel
            focusKey: getState().focusKey + 1
        });
    };
const $b0ea5829ee465b66$var$closePanel = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isOpen === true) setState({
            ...$b0ea5829ee465b66$var$initialState,
            isTriggerFocused: true
        });
    };
const $b0ea5829ee465b66$var$focusTrigger = (focusTriggerCallback)=>({ setState: setState, getState: getState })=>{
        if (getState().isTriggerFocused) focusTriggerCallback();
        setState({
            isTriggerFocused: false
        });
    };
const $b0ea5829ee465b66$var$focusPanel = (focusPanelCallback)=>({ getState: getState })=>{
        if (getState().focusKey > 0) focusPanelCallback();
    };
const $b0ea5829ee465b66$var$Store = (0, $WBLbN.createStore)({
    initialState: $b0ea5829ee465b66$var$initialState,
    actions: {
        openPanel: $b0ea5829ee465b66$var$openPanel,
        closePanel: $b0ea5829ee465b66$var$closePanel,
        focusTrigger: $b0ea5829ee465b66$var$focusTrigger,
        focusPanel: $b0ea5829ee465b66$var$focusPanel
    },
    name: 'right-side-panel'
});
const $b0ea5829ee465b66$var$useRightPanel = (0, $WBLbN.createHook)($b0ea5829ee465b66$var$Store);
const $b0ea5829ee465b66$var$useRightPanelActions = (0, $WBLbN.createHook)($b0ea5829ee465b66$var$Store, {
    selector: null
});
const $b0ea5829ee465b66$export$898b0b9e6647aa1a = ()=>{
    const [, actions] = $b0ea5829ee465b66$var$useRightPanelActions();
    return {
        onCloseRightPanel: actions.closePanel,
        onOpenRightPanel: actions.openPanel,
        onFocusTrigger: actions.focusTrigger,
        onFocusPanel: actions.focusPanel
    };
};
const $b0ea5829ee465b66$export$44f374c6fe8a17ef = ()=>$b0ea5829ee465b66$var$useRightPanel()[0];
const $b0ea5829ee465b66$export$e37cfb5282d612c2 = (0, $WBLbN.createContainer)($b0ea5829ee465b66$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpenByDefault: isOpenByDefault, defaultPanelId: defaultPanelId })=>{
            if (isOpenByDefault === true && defaultPanelId != null) setState({
                isOpen: true,
                panelId: defaultPanelId
            });
        }
});

});


parcelRegister("i5UyB", function(module, exports) {

$parcel$export(module.exports, "useLayoutChange", () => $91f900f36685c6b4$export$13f16b0ff83cf772);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");

var $kEBPk = parcelRequire("kEBPk");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $01Qi5 = parcelRequire("01Qi5");
const $91f900f36685c6b4$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.CHANGE_LAYOUT_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $91f900f36685c6b4$export$755ca66aa40344da = (gadgets)=>[
        gadgets.filter((gadget)=>gadget.column === 0),
        gadgets.filter((gadget)=>gadget.column === 1),
        gadgets.filter((gadget)=>gadget.column === 2)
    ];
const $91f900f36685c6b4$export$3ef0a75b350ea007 = (currentColumns, currentLayout, newLayout)=>{
    // if adding a column or no change in column count
    if (currentLayout.length <= newLayout.length) return currentColumns;
    if (currentLayout.length > newLayout.length) {
        const newColumns = currentColumns.slice(0, newLayout.length);
        const leftOver = currentColumns.slice(newLayout.length).flat().map((gadget)=>({
                ...gadget,
                column: newColumns.length - 1
            }));
        // append the leftover to last column
        newColumns[newColumns.length - 1] = newColumns[newColumns.length - 1].concat(leftOver);
        return newColumns;
    }
    return currentColumns;
};
const $91f900f36685c6b4$export$13f16b0ff83cf772 = ()=>{
    const { data: data, update: update } = (0, $01Qi5.useDashboardResource)();
    return (0, $eUqFw.useCallback)(async (layout, explicitColumns)=>{
        if (!data) return;
        const columns = explicitColumns ?? $91f900f36685c6b4$export$3ef0a75b350ea007($91f900f36685c6b4$export$755ca66aa40344da(data.gadgets), data.layout, layout);
        const payload = columns.map((column)=>column.map((gadget)=>gadget.id));
        const url = `${data.resourceUrl}/layout`;
        try {
            await (0, $lRmyA.performPutRequest)(url, {
                body: JSON.stringify({
                    '0': payload[0],
                    '1': payload[1],
                    '2': payload[2],
                    layout: layout
                })
            });
            update((currentData)=>currentData && {
                    ...currentData,
                    gadgets: columns.flat(),
                    layout: layout
                });
            (0, $9lmTX.default)({
                ...$91f900f36685c6b4$var$expAttributes,
                wasExperienceSuccesful: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9lmTX.default)({
                ...$91f900f36685c6b4$var$expAttributes,
                wasExperienceSuccesful: false
            });
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: (0, $kEBPk.CHANGE_LAYOUT_EXPERIENCE),
                    packageName: 'jiraDashboardEdit'
                }
            });
            throw error;
        }
    }, [
        data,
        update
    ]);
};

});

parcelRegister("aaVtE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf3bf39bb8e6f2b0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bf3bf39bb8e6f2b0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageTitleFallback: {
        "id": "dashboard-edit.page-title-fallback",
        "defaultMessage": "Edit dashboard"
    },
    pageTitle: {
        "id": "dashboard-edit.page-title",
        "defaultMessage": "Edit - {dashboardName}"
    },
    editingInfo: {
        "id": "dashboard-edit.editing-info",
        "defaultMessage": "You are currently editing your dashboard. Changes will be saved automatically."
    }
});

});

parcelRegister("6Ltiq", function(module, exports) {

$parcel$export(module.exports, "GadgetEditable", () => $cddfbf92096215b4$export$9ea8e07be9334eb3);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $iBeSy = parcelRequire("iBeSy");
var $8Vv3m = parcelRequire("8Vv3m");

var $kEBPk = parcelRequire("kEBPk");

var $7puJ8 = parcelRequire("7puJ8");

var $k6Hlo = parcelRequire("k6Hlo");

var $1KK5n = parcelRequire("1KK5n");

var $6QUMT = parcelRequire("6QUMT");

var $7G1NC = parcelRequire("7G1NC");

var $gnGe3 = parcelRequire("gnGe3");

var $f9d6c = parcelRequire("f9d6c");

var $1SsGr = parcelRequire("1SsGr");

var $4dOeX = parcelRequire("4dOeX");

var $ipYDU = parcelRequire("ipYDU");

var $fH0Fe = parcelRequire("fH0Fe");

var $kCCta = parcelRequire("kCCta");

var $bMzUB = parcelRequire("bMzUB");

var $5VGkZ = parcelRequire("5VGkZ");

var $5IxAc = parcelRequire("5IxAc");

var $12Fqt = parcelRequire("12Fqt");

var $5H4uC = parcelRequire("5H4uC");

var $crAWe = parcelRequire("crAWe");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $01Qi5 = parcelRequire("01Qi5");

var $hx4rB = parcelRequire("hx4rB");

var $fkagI = parcelRequire("fkagI");

var $hea51 = parcelRequire("hea51");

var $jVjSy = parcelRequire("jVjSy");

var $axCzi = parcelRequire("axCzi");

var $2B0LU = parcelRequire("2B0LU");

var $hDBf1 = parcelRequire("hDBf1");

var $dX4P5 = parcelRequire("dX4P5");

var $7Vjhj = parcelRequire("7Vjhj");
const $cddfbf92096215b4$export$c52d8ff08351976f = ({ data: { id: id, userPrefs: userPrefs, reactKey: reactKey, configurable: configurable, refreshable: isRefreshableByJira, connect: connect, forge: forge, ...data }, display: display, isConnectDisabled: isConnectDisabled, dashboardRefreshId: dashboardRefreshId, children: children })=>{
    const isRenamable = (0, $6QUMT.useIsRenamable)(id);
    const saveTitleById = (0, $jVjSy.useSaveCustomGadgetTitleById)(id);
    const showSaveTitleFlag = (0, $7Vjhj.useGadgetTitleChangeErrorFlag)();
    const localStorageService = (0, $1SsGr.useLocalStorageService)(id);
    const { update: update } = (0, $01Qi5.useDashboardResource)();
    const userPreferencesService = (0, $4dOeX.useUserPreferencesService)(id, update);
    const { reinitialise: onGadgetKeyChange, isEditable: isReactEditable, isLoading: isReactLoading } = (0, $f9d6c.useReactGadget)(id, reactKey);
    const automaticRefreshMs = (0, $eUqFw.useMemo)(()=>{
        const { refresh: refresh } = (0, $crAWe.decodeUserPreferences)(userPrefs?.fields);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return parseInt(refresh, 10) * 60000 || null;
    }, [
        userPrefs?.fields
    ]);
    const saveTitle = (0, $eUqFw.useCallback)((...args)=>saveTitleById(...args).catch((error)=>{
            showSaveTitleFlag();
            throw error;
        }), [
        saveTitleById,
        showSaveTitleFlag
    ]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const { isInEditMode: isInEditMode, ...editable } = (0, $hx4rB.useGadgetEditableController)({
        id: id,
        userPrefs: userPrefs,
        configurable: isReactEditable ?? configurable,
        reactKey: reactKey,
        isRenamable: isRenamable,
        isConnectDisabled: isConnectDisabled,
        saveTitle: saveTitle,
        userPreferencesAction: userPrefs?.action,
        userPreferencesService: userPreferencesService,
        ...data
    });
    // Ecosystem gadgets are not supposed to re-render if they are opting out refreshing
    const ignoreGlobalDashboardRefresh = !isRefreshableByJira;
    const { onRefresh: onRefresh, ...common } = (0, $gnGe3.useGadgetCommonController)({
        id: id,
        display: display,
        automaticRefreshMs: isInEditMode ? null : automaticRefreshMs,
        localStorageService: // disable auto refresh in edit mode
        localStorageService,
        dashboardRefreshId: ignoreGlobalDashboardRefresh ? null : dashboardRefreshId,
        onGadgetKeyChange: onGadgetKeyChange
    });
    const ecosystemRefresh = (0, $5H4uC.useEcosystemRefresh)({
        id: id,
        connect: connect,
        forge: forge
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7G1NC.GadgetControllerContextProvider), {
        value: {
            ...common,
            ...editable,
            isLoading: isReactLoading ?? isLoading,
            setIsLoading: reactKey ? ()=>undefined : setIsLoading,
            isInEditMode: isInEditMode,
            isRenamable: isRenamable,
            onRefresh: isRefreshableByJira ? onRefresh : ecosystemRefresh.onRefresh ?? onRefresh
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ecosystemRefresh.wrapperRef
    }, children));
};
const $cddfbf92096215b4$export$9ea8e07be9334eb3 = ({ dashboardId: dashboardId, data: data, display: display, isDraggable: isDraggable = false, isDragging: isDragging = false, isConnectDisabled: isConnectDisabled = false, dragHandleProps: dragHandleProps, refreshId: refreshId, onMaximizeOrRestore: onMaximizeOrRestore, onMount: onMount, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget })=>{
    const { id: id, isMaximizable: isMaximizable, color: color, forge: forge, customisedTitle: customisedTitle, title: defaultTitle } = data;
    const saveColor = (0, $axCzi.useSaveGadgetColor)(id);
    const deleteGadget = (0, $fkagI.useDeleteGadget)(id, customisedTitle || defaultTitle);
    const duplicateGadget = (0, $hea51.useDuplicateGadget)(id);
    const gadgetHeaderRef = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isFirstPartyGadget = !(0, $12Fqt.isConnectGadget)(data) && !forge;
    const isDeprecated = (0, $k6Hlo.isDeprecatedGadget)(data.amdModule);
    // this onMount function is idempotent so we don't need to ensure that it is
    // called at most one time use an additional ref. The controller will already
    // handle duplicate calls to ensure that the focus callback is only called once.
    (0, $eUqFw.useEffect)(()=>onMount?.(id, ()=>gadgetHeaderRef.current?.focus()), [
        onMount,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cddfbf92096215b4$export$c52d8ff08351976f, {
        data: data,
        display: display,
        isConnectDisabled: isConnectDisabled,
        dashboardRefreshId: refreshId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7G1NC.GadgetControllerContextConsumer), null, ({ isDisplayed: isDisplayed, isMaximized: isMaximized, isMinimized: isMinimized, onMinimizeOrRestore: onMinimizeOrRestore, shouldUseCache: shouldUseCache, isLoading: isLoading, setIsLoading: setIsLoading, lastRefreshed: lastRefreshed, isUnconfigured: isUnconfigured, isEditModeEnabled: isEditModeEnabled, isEditButtonDisabled: isEditButtonDisabled, isInEditMode: isInEditMode, onEditModeTrigger: onEditModeTrigger, onEditModeCancel: onEditModeCancel, title: title, isRenamable: isRenamable, isRenaming: isRenaming, setDefaultTitle: setDefaultTitle, onRenameTrigger: onRenameTrigger, onRenameSave: onRenameSave, onRenameCancel: onRenameCancel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fH0Fe.GadgetLayoutWithAnalytics), {
            gadgetData: data,
            isDisplayed: isDisplayed,
            isContentHidden: isMinimized,
            customWrapperStyles: [
                isDraggable && isDragging && $cddfbf92096215b4$var$gadgetDraggingStyles
            ],
            customPlaceholder: isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), {
                customHeight: `${(0, $kEBPk.GADGET_DEFAULT_HEIGHT)}px`,
                isPulsing: false
            }),
            header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", dragHandleProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
                alignItems: "center",
                xcss: [
                    isDraggable && $cddfbf92096215b4$var$draggableHeaderStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCCta.GadgetTitleWrapper), {
                isRenaming: isRenaming,
                id: `gadget-title-${id}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dX4P5.TitleEditor), {
                isRenamable: isRenamable,
                isRenaming: isRenaming,
                title: title,
                onEdit: onRenameTrigger,
                editButtonLabel: formatMessage((0, $hDBf1.default).rename, {
                    gadgetName: title
                }),
                onConfirmEdit: onRenameSave,
                onCancelEdit: onRenameCancel
            }, isDeprecated && (0, $eI5EY.fg)('endeavour_gadget_deprecation_banner_v1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                xcss: $cddfbf92096215b4$var$titleStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMzUB.TitleReadOnly), {
                title: title,
                // We don't want to render a link in edit mode
                titleUrl: undefined,
                forgeEnvironment: forge?.environment,
                forgeEnvironmentKey: forge?.environmentKey
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                xcss: $cddfbf92096215b4$var$tooltipStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7puJ8.DeprecationTooltip), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMzUB.TitleReadOnly), {
                title: title,
                // We don't want to render a link in edit mode
                titleUrl: undefined,
                forgeEnvironment: forge?.environment,
                forgeEnvironmentKey: forge?.environmentKey
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5VGkZ.GadgetToolbar), {
                gadgetId: id,
                title: title,
                onMinimizeOrRestore: onMinimizeOrRestore,
                isMinimized: isMinimized,
                isMaximizable: isMaximizable,
                onMaximizeOrRestore: onMaximizeOrRestore,
                isMaximized: isMaximized,
                additionalToolbarItems: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2B0LU.ConfigDropdown), {
                    isEditable: isEditModeEnabled,
                    isEditDisabled: isLoading || isEditButtonDisabled,
                    gadgetId: id,
                    gadgetTitle: title,
                    gadgetColor: color,
                    onSaveColor: saveColor,
                    onEditModeClick: onEditModeTrigger,
                    onDeleteGadget: deleteGadget,
                    onDuplicateGadget: duplicateGadget
                })
            }))),
            footer: isFirstPartyGadget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IxAc.LastRefreshed), {
                lastRefreshed: lastRefreshed,
                updateInterval: (0, $kEBPk.REFRESH_LABEL_UPDATE_INTERVAL)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "dashboard-edit.ui.gadget-editable.gadget-editable"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ipYDU.GadgetInner), {
            dashboardId: dashboardId,
            data: data,
            isUnconfigured: isUnconfigured,
            isEditModeEnabled: isEditModeEnabled,
            isLoading: isLoading,
            isInEditMode: isInEditMode,
            shouldUseCache: shouldUseCache,
            setIsLoading: setIsLoading,
            setDefaultTitle: setDefaultTitle,
            setTitle: onRenameSave,
            onEditModeCancel: onEditModeCancel,
            isMaximized: isMaximized,
            onRegisterConnectGadget: onRegisterConnectGadget,
            onUnregisterConnectGadget: onUnregisterConnectGadget
        })))));
};
const $cddfbf92096215b4$var$draggableHeaderStyles = (0, $8Vv3m.xcss)({
    cursor: 'grab'
});
const $cddfbf92096215b4$var$gadgetDraggingStyles = (0, $8Vv3m.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $kEBPk.GADGET_DRAG_CONTAINER_HEIGHT)}px !important`
});
const $cddfbf92096215b4$var$titleStyles = (0, $8Vv3m.xcss)({
    display: 'flex',
    flexDirection: 'row'
});
const $cddfbf92096215b4$var$tooltipStyles = (0, $8Vv3m.xcss)({
    marginTop: 'space.025'
});

});
parcelRegister("7puJ8", function(module, exports) {

$parcel$export(module.exports, "DeprecationTooltip", () => $7183cb6efbd83df1$export$3afd8bd60d8bcdb8);

var $eUqFw = parcelRequire("eUqFw");

var $h9KeX = parcelRequire("h9KeX");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $9rKWs = parcelRequire("9rKWs");
const $7183cb6efbd83df1$export$3afd8bd60d8bcdb8 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $7183cb6efbd83df1$var$tooltipStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h9KeX.default), {
        appearance: "warning"
    }, formatMessage((0, $9rKWs.default).gadgetDeprecationTooltip, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
                href: "https://community.atlassian.com/t5/Jira-articles/We-re-ending-support-for-five-dashboard-gadgets-on-Dec-9-2024/ba-p/2821066"
            }, chunks),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null))
    })));
};
const $7183cb6efbd83df1$var$tooltipStyles = (0, $8Vv3m.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("h9KeX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1fb1ac323afb749$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUg8E = parcelRequire("lUg8E");

var $jIR8w = parcelRequire("jIR8w");

var $45qbL = parcelRequire("45qbL");
var $1JJay = parcelRequire("1JJay");


var $5djSH = parcelRequire("5djSH");
function $d1fb1ac323afb749$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d1fb1ac323afb749$var$rootStyles = {
    name: "ssyr0c",
    styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
};
const $d1fb1ac323afb749$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $1b343b038f6c23ec$export$e62e8919cca44969})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $1b343b038f6c23ec$export$747d86715d4175de})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $1b343b038f6c23ec$export$a7175d4e9206bc80})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $1b343b038f6c23ec$export$5aae31392d72caaa})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $1b343b038f6c23ec$export$4a7404f376229999})`;
    }
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $d1fb1ac323afb749$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $d1fb1ac323afb749$var$rootStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--icon-accent-color': $d1fb1ac323afb749$var$iconColor(appearance)
        },
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jIR8w.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lUg8E.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $45qbL.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5djSH.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $45qbL.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1JJay.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1JJay.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText))))));
};
var $d1fb1ac323afb749$export$2e2bcd8739ae039 = $d1fb1ac323afb749$var$InlineMessage;

});
var $1b343b038f6c23ec$exports = {};

$parcel$export($1b343b038f6c23ec$exports, "R50", () => $1b343b038f6c23ec$export$4b84fd0e2c617bd);
$parcel$export($1b343b038f6c23ec$exports, "R75", () => $1b343b038f6c23ec$export$b34b069eff244586);
$parcel$export($1b343b038f6c23ec$exports, "R100", () => $1b343b038f6c23ec$export$be802dd0d8b57f35);
$parcel$export($1b343b038f6c23ec$exports, "R200", () => $1b343b038f6c23ec$export$60847d42f9da92a6);
$parcel$export($1b343b038f6c23ec$exports, "R300", () => $1b343b038f6c23ec$export$4a7404f376229999);
$parcel$export($1b343b038f6c23ec$exports, "R400", () => $1b343b038f6c23ec$export$2010d0fb4295b346);
$parcel$export($1b343b038f6c23ec$exports, "R500", () => $1b343b038f6c23ec$export$2837b5a1a71d5c02);
$parcel$export($1b343b038f6c23ec$exports, "Y50", () => $1b343b038f6c23ec$export$8d9596b529bbb9cf);
$parcel$export($1b343b038f6c23ec$exports, "Y75", () => $1b343b038f6c23ec$export$41060a744ab0b7ae);
$parcel$export($1b343b038f6c23ec$exports, "Y100", () => $1b343b038f6c23ec$export$1cc05bbbf340e559);
$parcel$export($1b343b038f6c23ec$exports, "Y200", () => $1b343b038f6c23ec$export$5aae31392d72caaa);
$parcel$export($1b343b038f6c23ec$exports, "Y300", () => $1b343b038f6c23ec$export$c6930421db9fa514);
$parcel$export($1b343b038f6c23ec$exports, "Y400", () => $1b343b038f6c23ec$export$59619663aa6500fb);
$parcel$export($1b343b038f6c23ec$exports, "Y500", () => $1b343b038f6c23ec$export$874739ea9e379ab6);
$parcel$export($1b343b038f6c23ec$exports, "G50", () => $1b343b038f6c23ec$export$8a6341c32b6a3ee6);
$parcel$export($1b343b038f6c23ec$exports, "G75", () => $1b343b038f6c23ec$export$69a3bf21b9686c2b);
$parcel$export($1b343b038f6c23ec$exports, "G100", () => $1b343b038f6c23ec$export$afbce1382ec95f73);
$parcel$export($1b343b038f6c23ec$exports, "G200", () => $1b343b038f6c23ec$export$747d86715d4175de);
$parcel$export($1b343b038f6c23ec$exports, "G300", () => $1b343b038f6c23ec$export$940e1f69e873f202);
$parcel$export($1b343b038f6c23ec$exports, "G400", () => $1b343b038f6c23ec$export$a49394138f7b8e85);
$parcel$export($1b343b038f6c23ec$exports, "G500", () => $1b343b038f6c23ec$export$6fa04827ac68a4fb);
$parcel$export($1b343b038f6c23ec$exports, "B50", () => $1b343b038f6c23ec$export$226de0355ed012f8);
$parcel$export($1b343b038f6c23ec$exports, "B75", () => $1b343b038f6c23ec$export$8c13c2ee36917869);
$parcel$export($1b343b038f6c23ec$exports, "B100", () => $1b343b038f6c23ec$export$ecfc1dff386a3e7a);
$parcel$export($1b343b038f6c23ec$exports, "B200", () => $1b343b038f6c23ec$export$215b7063051591f1);
$parcel$export($1b343b038f6c23ec$exports, "B300", () => $1b343b038f6c23ec$export$e62e8919cca44969);
$parcel$export($1b343b038f6c23ec$exports, "B400", () => $1b343b038f6c23ec$export$b3de0ae08da2ce64);
$parcel$export($1b343b038f6c23ec$exports, "B500", () => $1b343b038f6c23ec$export$a6ee3d71bc067634);
$parcel$export($1b343b038f6c23ec$exports, "B600", () => $1b343b038f6c23ec$export$67f15409e87642a1);
$parcel$export($1b343b038f6c23ec$exports, "B700", () => $1b343b038f6c23ec$export$f0539dbc42dbb067);
$parcel$export($1b343b038f6c23ec$exports, "P50", () => $1b343b038f6c23ec$export$363e4475840015bb);
$parcel$export($1b343b038f6c23ec$exports, "P75", () => $1b343b038f6c23ec$export$4b0a4417ed59760f);
$parcel$export($1b343b038f6c23ec$exports, "P100", () => $1b343b038f6c23ec$export$6011520a64d9a187);
$parcel$export($1b343b038f6c23ec$exports, "P200", () => $1b343b038f6c23ec$export$a7175d4e9206bc80);
$parcel$export($1b343b038f6c23ec$exports, "P300", () => $1b343b038f6c23ec$export$b48405b95304b5a1);
$parcel$export($1b343b038f6c23ec$exports, "P400", () => $1b343b038f6c23ec$export$c71e4279dd54a18d);
$parcel$export($1b343b038f6c23ec$exports, "P500", () => $1b343b038f6c23ec$export$147899de772240ec);
$parcel$export($1b343b038f6c23ec$exports, "T50", () => $1b343b038f6c23ec$export$2cf711fe14c66f06);
$parcel$export($1b343b038f6c23ec$exports, "T75", () => $1b343b038f6c23ec$export$7a8f4d33f6f9772c);
$parcel$export($1b343b038f6c23ec$exports, "T100", () => $1b343b038f6c23ec$export$776c9c497ef08533);
$parcel$export($1b343b038f6c23ec$exports, "T200", () => $1b343b038f6c23ec$export$69cb3ca10c1e330e);
$parcel$export($1b343b038f6c23ec$exports, "T300", () => $1b343b038f6c23ec$export$9dc1ef0f3f48059b);
$parcel$export($1b343b038f6c23ec$exports, "T400", () => $1b343b038f6c23ec$export$7c835c78b6fcdef8);
$parcel$export($1b343b038f6c23ec$exports, "T500", () => $1b343b038f6c23ec$export$6036577f95c3877e);
$parcel$export($1b343b038f6c23ec$exports, "N0", () => $1b343b038f6c23ec$export$29a4f05edc054374);
$parcel$export($1b343b038f6c23ec$exports, "N10", () => $1b343b038f6c23ec$export$e655ef011c4aa1a2);
$parcel$export($1b343b038f6c23ec$exports, "N20", () => $1b343b038f6c23ec$export$9fdfb749e33cdf97);
$parcel$export($1b343b038f6c23ec$exports, "N30", () => $1b343b038f6c23ec$export$3e51e8f1440314ba);
$parcel$export($1b343b038f6c23ec$exports, "N40", () => $1b343b038f6c23ec$export$1ce2d1575d444ceb);
$parcel$export($1b343b038f6c23ec$exports, "N50", () => $1b343b038f6c23ec$export$8754fc7e6d8b3000);
$parcel$export($1b343b038f6c23ec$exports, "N60", () => $1b343b038f6c23ec$export$c2e91cbeada39b8b);
$parcel$export($1b343b038f6c23ec$exports, "N70", () => $1b343b038f6c23ec$export$5f71e19f3a7ad9de);
$parcel$export($1b343b038f6c23ec$exports, "N80", () => $1b343b038f6c23ec$export$eaa8c8a70ac22806);
$parcel$export($1b343b038f6c23ec$exports, "N90", () => $1b343b038f6c23ec$export$7c87d337fb91a97d);
$parcel$export($1b343b038f6c23ec$exports, "N100", () => $1b343b038f6c23ec$export$d6447c357493214f);
$parcel$export($1b343b038f6c23ec$exports, "N200", () => $1b343b038f6c23ec$export$f563ee71e9ee74cd);
$parcel$export($1b343b038f6c23ec$exports, "N300", () => $1b343b038f6c23ec$export$e2ef2124cf4024b1);
$parcel$export($1b343b038f6c23ec$exports, "N400", () => $1b343b038f6c23ec$export$eece5f492e429f08);
$parcel$export($1b343b038f6c23ec$exports, "N500", () => $1b343b038f6c23ec$export$c39c0fe0f26207ae);
$parcel$export($1b343b038f6c23ec$exports, "N600", () => $1b343b038f6c23ec$export$7090862dc3038a9f);
$parcel$export($1b343b038f6c23ec$exports, "N700", () => $1b343b038f6c23ec$export$ad0bacf983b7ddaa);
$parcel$export($1b343b038f6c23ec$exports, "N800", () => $1b343b038f6c23ec$export$7d61b15e0da132af);
$parcel$export($1b343b038f6c23ec$exports, "N900", () => $1b343b038f6c23ec$export$fbda843f0a27fe96);
$parcel$export($1b343b038f6c23ec$exports, "N10A", () => $1b343b038f6c23ec$export$791e57b27ca738ef);
$parcel$export($1b343b038f6c23ec$exports, "N20A", () => $1b343b038f6c23ec$export$8d43898f60b96a82);
$parcel$export($1b343b038f6c23ec$exports, "N30A", () => $1b343b038f6c23ec$export$920c0d5c49070351);
$parcel$export($1b343b038f6c23ec$exports, "N40A", () => $1b343b038f6c23ec$export$46987b49aab6d1a8);
$parcel$export($1b343b038f6c23ec$exports, "N50A", () => $1b343b038f6c23ec$export$7d3359664e8bb0e5);
$parcel$export($1b343b038f6c23ec$exports, "N60A", () => $1b343b038f6c23ec$export$d2d3bedfb276cac0);
$parcel$export($1b343b038f6c23ec$exports, "N70A", () => $1b343b038f6c23ec$export$6e5e7499ff054f6d);
$parcel$export($1b343b038f6c23ec$exports, "N80A", () => $1b343b038f6c23ec$export$59264b346c877fa7);
$parcel$export($1b343b038f6c23ec$exports, "N90A", () => $1b343b038f6c23ec$export$d092757d7c64925c);
$parcel$export($1b343b038f6c23ec$exports, "N100A", () => $1b343b038f6c23ec$export$486ab785e4bac3c6);
$parcel$export($1b343b038f6c23ec$exports, "N200A", () => $1b343b038f6c23ec$export$fba592bbc6419fea);
$parcel$export($1b343b038f6c23ec$exports, "N300A", () => $1b343b038f6c23ec$export$13609db0e6812ab8);
$parcel$export($1b343b038f6c23ec$exports, "N400A", () => $1b343b038f6c23ec$export$fbae4efaa892d883);
$parcel$export($1b343b038f6c23ec$exports, "N500A", () => $1b343b038f6c23ec$export$f13946d26f440ce6);
$parcel$export($1b343b038f6c23ec$exports, "N600A", () => $1b343b038f6c23ec$export$19f58225ac52a306);
$parcel$export($1b343b038f6c23ec$exports, "N700A", () => $1b343b038f6c23ec$export$6384f09da70e7b62);
$parcel$export($1b343b038f6c23ec$exports, "N800A", () => $1b343b038f6c23ec$export$d0dccc730683edc2);
$parcel$export($1b343b038f6c23ec$exports, "DN900", () => $1b343b038f6c23ec$export$2f6319cf7d736c2a);
$parcel$export($1b343b038f6c23ec$exports, "DN800", () => $1b343b038f6c23ec$export$95126bc8884d6634);
$parcel$export($1b343b038f6c23ec$exports, "DN700", () => $1b343b038f6c23ec$export$8338d8c35d44ff1);
$parcel$export($1b343b038f6c23ec$exports, "DN600", () => $1b343b038f6c23ec$export$5368d76ae4fbbda7);
$parcel$export($1b343b038f6c23ec$exports, "DN500", () => $1b343b038f6c23ec$export$9f0a771d16ec8d36);
$parcel$export($1b343b038f6c23ec$exports, "DN400", () => $1b343b038f6c23ec$export$abcf8c38338b4aa5);
$parcel$export($1b343b038f6c23ec$exports, "DN300", () => $1b343b038f6c23ec$export$97e81faa16a182c7);
$parcel$export($1b343b038f6c23ec$exports, "DN200", () => $1b343b038f6c23ec$export$bfe21c59123ecf33);
$parcel$export($1b343b038f6c23ec$exports, "DN100", () => $1b343b038f6c23ec$export$ee82aa2ea6a1558);
$parcel$export($1b343b038f6c23ec$exports, "DN90", () => $1b343b038f6c23ec$export$682927c6ed76be02);
$parcel$export($1b343b038f6c23ec$exports, "DN80", () => $1b343b038f6c23ec$export$91fd9994c5be9757);
$parcel$export($1b343b038f6c23ec$exports, "DN70", () => $1b343b038f6c23ec$export$d281fbfe3cff2df6);
$parcel$export($1b343b038f6c23ec$exports, "DN60", () => $1b343b038f6c23ec$export$3902c91d8b98a753);
$parcel$export($1b343b038f6c23ec$exports, "DN50", () => $1b343b038f6c23ec$export$8e8133c1ba5845b5);
$parcel$export($1b343b038f6c23ec$exports, "DN40", () => $1b343b038f6c23ec$export$33ff357f6620b39);
$parcel$export($1b343b038f6c23ec$exports, "DN30", () => $1b343b038f6c23ec$export$633847cf062b69e0);
$parcel$export($1b343b038f6c23ec$exports, "DN20", () => $1b343b038f6c23ec$export$9776a6e503bdbf76);
$parcel$export($1b343b038f6c23ec$exports, "DN10", () => $1b343b038f6c23ec$export$6c813d5160dff5db);
$parcel$export($1b343b038f6c23ec$exports, "DN0", () => $1b343b038f6c23ec$export$3d4f271a500072a);
$parcel$export($1b343b038f6c23ec$exports, "DN800A", () => $1b343b038f6c23ec$export$fe151285c22759ec);
$parcel$export($1b343b038f6c23ec$exports, "DN700A", () => $1b343b038f6c23ec$export$a101c6190d0da34);
$parcel$export($1b343b038f6c23ec$exports, "DN600A", () => $1b343b038f6c23ec$export$4b16f52932fda51);
$parcel$export($1b343b038f6c23ec$exports, "DN500A", () => $1b343b038f6c23ec$export$a74bcd7b9845b0d8);
$parcel$export($1b343b038f6c23ec$exports, "DN400A", () => $1b343b038f6c23ec$export$9209c179316d1751);
$parcel$export($1b343b038f6c23ec$exports, "DN300A", () => $1b343b038f6c23ec$export$88f55133f636c8dd);
$parcel$export($1b343b038f6c23ec$exports, "DN200A", () => $1b343b038f6c23ec$export$51126f85d1009512);
$parcel$export($1b343b038f6c23ec$exports, "DN100A", () => $1b343b038f6c23ec$export$a069b547bd23af78);
$parcel$export($1b343b038f6c23ec$exports, "DN90A", () => $1b343b038f6c23ec$export$40cce05af3b2600a);
$parcel$export($1b343b038f6c23ec$exports, "DN80A", () => $1b343b038f6c23ec$export$b78942185925a0d);
$parcel$export($1b343b038f6c23ec$exports, "DN70A", () => $1b343b038f6c23ec$export$e058fb44b8eaafca);
$parcel$export($1b343b038f6c23ec$exports, "DN60A", () => $1b343b038f6c23ec$export$92b0b8de26920c18);
$parcel$export($1b343b038f6c23ec$exports, "DN50A", () => $1b343b038f6c23ec$export$67564f7459d3fc9e);
$parcel$export($1b343b038f6c23ec$exports, "DN40A", () => $1b343b038f6c23ec$export$77868e1ca884ffa3);
$parcel$export($1b343b038f6c23ec$exports, "DN30A", () => $1b343b038f6c23ec$export$2afd71d7d3ea2cd5);
$parcel$export($1b343b038f6c23ec$exports, "DN20A", () => $1b343b038f6c23ec$export$f2a0acaab9972c70);
$parcel$export($1b343b038f6c23ec$exports, "DN10A", () => $1b343b038f6c23ec$export$9ab70e67d6475361);
$parcel$export($1b343b038f6c23ec$exports, "T30", () => $1b343b038f6c23ec$export$d2adc5dedf09fced);
$parcel$export($1b343b038f6c23ec$exports, "L50", () => $1b343b038f6c23ec$export$f51762073d2bb381);
$parcel$export($1b343b038f6c23ec$exports, "L75", () => $1b343b038f6c23ec$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $1b343b038f6c23ec$export$4b84fd0e2c617bd = '#FFEBE6';
const $1b343b038f6c23ec$export$b34b069eff244586 = '#FFBDAD';
const $1b343b038f6c23ec$export$be802dd0d8b57f35 = '#FF8F73';
const $1b343b038f6c23ec$export$60847d42f9da92a6 = '#FF7452';
const $1b343b038f6c23ec$export$4a7404f376229999 = '#FF5630';
const $1b343b038f6c23ec$export$2010d0fb4295b346 = '#DE350B';
const $1b343b038f6c23ec$export$2837b5a1a71d5c02 = '#BF2600';
const $1b343b038f6c23ec$export$8d9596b529bbb9cf = '#FFFAE6';
const $1b343b038f6c23ec$export$41060a744ab0b7ae = '#FFF0B3';
const $1b343b038f6c23ec$export$1cc05bbbf340e559 = '#FFE380';
const $1b343b038f6c23ec$export$5aae31392d72caaa = '#FFC400';
const $1b343b038f6c23ec$export$c6930421db9fa514 = '#FFAB00';
const $1b343b038f6c23ec$export$59619663aa6500fb = '#FF991F';
const $1b343b038f6c23ec$export$874739ea9e379ab6 = '#FF8B00';
const $1b343b038f6c23ec$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $1b343b038f6c23ec$export$69a3bf21b9686c2b = '#ABF5D1';
const $1b343b038f6c23ec$export$afbce1382ec95f73 = '#79F2C0';
const $1b343b038f6c23ec$export$747d86715d4175de = '#57D9A3';
const $1b343b038f6c23ec$export$940e1f69e873f202 = '#36B37E';
const $1b343b038f6c23ec$export$a49394138f7b8e85 = '#00875A';
const $1b343b038f6c23ec$export$6fa04827ac68a4fb = '#006644';
const $1b343b038f6c23ec$export$226de0355ed012f8 = '#DEEBFF';
const $1b343b038f6c23ec$export$8c13c2ee36917869 = '#B3D4FF';
const $1b343b038f6c23ec$export$ecfc1dff386a3e7a = '#4C9AFF';
const $1b343b038f6c23ec$export$215b7063051591f1 = '#2684FF';
const $1b343b038f6c23ec$export$e62e8919cca44969 = '#0065FF';
const $1b343b038f6c23ec$export$b3de0ae08da2ce64 = '#0052CC';
const $1b343b038f6c23ec$export$a6ee3d71bc067634 = '#0747A6';
const $1b343b038f6c23ec$export$67f15409e87642a1 = '#669DF1';
const $1b343b038f6c23ec$export$f0539dbc42dbb067 = '#8FB8F6';
const $1b343b038f6c23ec$export$363e4475840015bb = '#EAE6FF';
const $1b343b038f6c23ec$export$4b0a4417ed59760f = '#C0B6F2';
const $1b343b038f6c23ec$export$6011520a64d9a187 = '#998DD9';
const $1b343b038f6c23ec$export$a7175d4e9206bc80 = '#8777D9';
const $1b343b038f6c23ec$export$b48405b95304b5a1 = '#6554C0';
const $1b343b038f6c23ec$export$c71e4279dd54a18d = '#5243AA';
const $1b343b038f6c23ec$export$147899de772240ec = '#403294';
const $1b343b038f6c23ec$export$2cf711fe14c66f06 = '#E6FCFF';
const $1b343b038f6c23ec$export$7a8f4d33f6f9772c = '#B3F5FF';
const $1b343b038f6c23ec$export$776c9c497ef08533 = '#79E2F2';
const $1b343b038f6c23ec$export$69cb3ca10c1e330e = '#00C7E6';
const $1b343b038f6c23ec$export$9dc1ef0f3f48059b = '#00B8D9';
const $1b343b038f6c23ec$export$7c835c78b6fcdef8 = '#00A3BF';
const $1b343b038f6c23ec$export$6036577f95c3877e = '#008DA6';
const $1b343b038f6c23ec$export$29a4f05edc054374 = '#FFFFFF';
const $1b343b038f6c23ec$export$e655ef011c4aa1a2 = '#FAFBFC';
const $1b343b038f6c23ec$export$9fdfb749e33cdf97 = '#F4F5F7';
const $1b343b038f6c23ec$export$3e51e8f1440314ba = '#EBECF0';
const $1b343b038f6c23ec$export$1ce2d1575d444ceb = '#DFE1E6';
const $1b343b038f6c23ec$export$8754fc7e6d8b3000 = '#C1C7D0';
const $1b343b038f6c23ec$export$c2e91cbeada39b8b = '#B3BAC5';
const $1b343b038f6c23ec$export$5f71e19f3a7ad9de = '#A5ADBA';
const $1b343b038f6c23ec$export$eaa8c8a70ac22806 = '#97A0AF';
const $1b343b038f6c23ec$export$7c87d337fb91a97d = '#8993A4';
const $1b343b038f6c23ec$export$d6447c357493214f = '#7A869A';
const $1b343b038f6c23ec$export$f563ee71e9ee74cd = '#6B778C';
const $1b343b038f6c23ec$export$e2ef2124cf4024b1 = '#5E6C84';
const $1b343b038f6c23ec$export$eece5f492e429f08 = '#505F79';
const $1b343b038f6c23ec$export$c39c0fe0f26207ae = '#42526E';
const $1b343b038f6c23ec$export$7090862dc3038a9f = '#344563';
const $1b343b038f6c23ec$export$ad0bacf983b7ddaa = '#253858';
const $1b343b038f6c23ec$export$7d61b15e0da132af = '#172B4D';
const $1b343b038f6c23ec$export$fbda843f0a27fe96 = '#091E42';
const $1b343b038f6c23ec$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $1b343b038f6c23ec$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $1b343b038f6c23ec$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $1b343b038f6c23ec$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $1b343b038f6c23ec$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $1b343b038f6c23ec$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $1b343b038f6c23ec$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $1b343b038f6c23ec$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $1b343b038f6c23ec$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $1b343b038f6c23ec$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $1b343b038f6c23ec$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $1b343b038f6c23ec$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $1b343b038f6c23ec$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $1b343b038f6c23ec$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $1b343b038f6c23ec$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $1b343b038f6c23ec$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $1b343b038f6c23ec$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $1b343b038f6c23ec$export$2f6319cf7d736c2a = '#E6EDFA';
const $1b343b038f6c23ec$export$95126bc8884d6634 = '#DCE5F5';
const $1b343b038f6c23ec$export$8338d8c35d44ff1 = '#CED9EB';
const $1b343b038f6c23ec$export$5368d76ae4fbbda7 = '#B8C7E0';
const $1b343b038f6c23ec$export$9f0a771d16ec8d36 = '#ABBBD6';
const $1b343b038f6c23ec$export$abcf8c38338b4aa5 = '#9FB0CC';
const $1b343b038f6c23ec$export$97e81faa16a182c7 = '#8C9CB8';
const $1b343b038f6c23ec$export$bfe21c59123ecf33 = '#7988A3';
const $1b343b038f6c23ec$export$ee82aa2ea6a1558 = '#67758F';
const $1b343b038f6c23ec$export$682927c6ed76be02 = '#56637A';
const $1b343b038f6c23ec$export$91fd9994c5be9757 = '#455166';
const $1b343b038f6c23ec$export$d281fbfe3cff2df6 = '#3B475C';
const $1b343b038f6c23ec$export$3902c91d8b98a753 = '#313D52';
const $1b343b038f6c23ec$export$8e8133c1ba5845b5 = '#283447';
const $1b343b038f6c23ec$export$33ff357f6620b39 = '#202B3D';
const $1b343b038f6c23ec$export$633847cf062b69e0 = '#1B2638';
const $1b343b038f6c23ec$export$9776a6e503bdbf76 = '#121A29';
const $1b343b038f6c23ec$export$6c813d5160dff5db = '#0E1624';
const $1b343b038f6c23ec$export$3d4f271a500072a = '#0D1424';
const $1b343b038f6c23ec$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $1b343b038f6c23ec$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $1b343b038f6c23ec$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $1b343b038f6c23ec$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $1b343b038f6c23ec$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $1b343b038f6c23ec$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $1b343b038f6c23ec$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $1b343b038f6c23ec$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $1b343b038f6c23ec$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $1b343b038f6c23ec$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $1b343b038f6c23ec$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $1b343b038f6c23ec$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $1b343b038f6c23ec$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $1b343b038f6c23ec$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $1b343b038f6c23ec$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $1b343b038f6c23ec$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $1b343b038f6c23ec$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $1b343b038f6c23ec$export$d2adc5dedf09fced = '#292A2E';
const $1b343b038f6c23ec$export$f51762073d2bb381 = '#94C748';
const $1b343b038f6c23ec$export$95e26d54def96891 = '#B3DF72';

parcelRegister("5djSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b092de0044a1385$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");


var $lffDx = parcelRequire("lffDx");
function $2b092de0044a1385$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b092de0044a1385$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $1b343b038f6c23ec$export$b3de0ae08da2ce64})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $1b343b038f6c23ec$export$940e1f69e873f202})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $1b343b038f6c23ec$export$b48405b95304b5a1})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $1b343b038f6c23ec$export$c6930421db9fa514})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`;
    }
};
const $2b092de0044a1385$var$iconWrapperStyles = {
    name: "kw6wgo",
    styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
};
const $2b092de0044a1385$var$iconColorStyles = {
    name: "1iy94md",
    styles: "color:var(--icon-accent-color)"
};
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $2b092de0044a1385$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $lffDx.typesMapping);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-ds--inline-message--icon": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--icon-color': $2b092de0044a1385$var$iconColor(appearance)
        },
        css: [
            $2b092de0044a1385$var$iconWrapperStyles,
            isOpen && $2b092de0044a1385$var$iconColorStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious"
    }));
};
var $2b092de0044a1385$export$2e2bcd8739ae039 = $2b092de0044a1385$var$SelectedIcon;

});
parcelRegister("lffDx", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $88c91e96f0d99692$export$4d111645c0b39d5d);

var $bpk0U = parcelRequire("bpk0U");

var $kfXvt = parcelRequire("kfXvt");

var $os4bU = parcelRequire("os4bU");

var $9r2Te = parcelRequire("9r2Te");
const $88c91e96f0d99692$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9r2Te))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($os4bU))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kfXvt))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9r2Te))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bpk0U))),
        defaultLabel: 'error inline message'
    }
};

});
parcelRegister("kfXvt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebf35e246a02b71d$var$_react = $ebf35e246a02b71d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ebf35e246a02b71d$var$_information = $ebf35e246a02b71d$var$_interopRequireDefault((parcelRequire("jgkb5")));

var $ebf35e246a02b71d$var$_info = $ebf35e246a02b71d$var$_interopRequireDefault((parcelRequire("2RI87")));
function $ebf35e246a02b71d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ebf35e246a02b71d$var$InformationIcon = (props)=>/*#__PURE__*/ $ebf35e246a02b71d$var$_react.default.createElement($ebf35e246a02b71d$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $ebf35e246a02b71d$var$_info.default
    }, props));
$ebf35e246a02b71d$var$InformationIcon.Name = 'InformationIconMigration';
var $ebf35e246a02b71d$var$_default = module.exports.default = $ebf35e246a02b71d$var$InformationIcon;

});

parcelRegister("os4bU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04980372a0b4c9eb$var$_react = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $04980372a0b4c9eb$var$_success = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("dwLyV")));

var $04980372a0b4c9eb$var$_checkCircle = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("gghOv")));
function $04980372a0b4c9eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04980372a0b4c9eb$var$SuccessIcon = (props)=>/*#__PURE__*/ $04980372a0b4c9eb$var$_react.default.createElement($04980372a0b4c9eb$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $04980372a0b4c9eb$var$_checkCircle.default
    }, props));
$04980372a0b4c9eb$var$SuccessIcon.Name = 'SuccessIconMigration';
var $04980372a0b4c9eb$var$_default = module.exports.default = $04980372a0b4c9eb$var$SuccessIcon;

});




parcelRegister("9rKWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb620a752400bbbc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $eb620a752400bbbc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    gadgetDeprecationTooltip: {
        "id": "dashboard-internal-common.common.gadget.deprecation-tooltip.gadget-deprecation-tooltip.non-final",
        "defaultMessage": "This timeline is paused. The revised timeline will be confirmed next week (the week of October 14, 2024).<br></br>Starting December 9th, we're no longer supporting this gadget. Delete it before then to reference its data in the available alternatives.<br></br><Link>More about the gadget alternatives</Link>"
    }
});

});


parcelRegister("1KK5n", function(module, exports) {

$parcel$export(module.exports, "SkeletonGadgetContent", () => $95ec7e6a3cd0d458$export$8609a145e570faa1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $v88A3 = parcelRequire("v88A3");

var $aYtGv = parcelRequire("aYtGv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lbjCz = parcelRequire("lbjCz");

var $5lv3X = parcelRequire("5lv3X");

var $i5ZMe = parcelRequire("i5ZMe");
const $95ec7e6a3cd0d458$export$8609a145e570faa1 = ({ dashboardId: dashboardId, gadgetId: gadgetId, customHeight: customHeight, isPulsing: isPulsing = true, isLimitedToScreenHeight: isLimitedToScreenHeight = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const gadgetLocalHeight = customHeight ?? `${(0, $5lv3X.getLocalStorageHeight)(dashboardId, gadgetId)}px`;
    const heightIsZero = gadgetLocalHeight.match(/^0[^.0-9]*$/);
    // will match 0px,0%,etc but not 0.1px
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbjCz.default), {
        name: "skeleton-gadget-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95ec7e6a3cd0d458$var$SkeletonContent, {
        height: gadgetLocalHeight,
        isLimitedToScreenHeight: isLimitedToScreenHeight,
        isPulsing: isPulsing,
        "data-testid": "dashboard-internal-common.common.gadget.gadget-skeleton.skeleton-content",
        role: "status",
        "aria-label": "Loading"
    }, !heightIsZero && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($v88A3))), {
        LEGACY_size: "large",
        label: formatMessage((0, $i5ZMe.default).genericPlaceholderIcon),
        color: "currentColor"
    })));
};
const $95ec7e6a3cd0d458$var$PulseAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95ec7e6a3cd0d458$var$SkeletonContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLimitedToScreenHeight: isLimitedToScreenHeight, isPulsing: isPulsing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kmmpls": (0, $9t7rW.default)(__cmplp.height ?? '100%'),
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i101j _bfhk1s4m _2rko1y44 _1e0c1txw _4cvr1h6o _1bah1h6o _1nj11i4r _v4q31yy8 _nhwa12c5 _1qzz10vm _8em7p3kn",
            __cmplp.isLimitedToScreenHeight && "_c71lve9e",
            __cmplp.isPulsing ? "_h82i9cwz" : "_h82iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("v88A3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b76701fdeded2ed2baf8d7b2cda2dab9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d9354839f80fc1$var$_react = $05d9354839f80fc1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $05d9354839f80fc1$var$_chartBar = $05d9354839f80fc1$var$_interopRequireDefault((parcelRequire("esi9c")));

var $05d9354839f80fc1$var$_presentation = $05d9354839f80fc1$var$_interopRequireDefault((parcelRequire("fxGsH")));
function $05d9354839f80fc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChartBarIcon.
 * This component is ChartBarIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesPresentationIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05d9354839f80fc1$var$ChartBarIcon = (props)=>/*#__PURE__*/ $05d9354839f80fc1$var$_react.default.createElement($05d9354839f80fc1$var$_chartBar.default, Object.assign({
        LEGACY_fallbackIcon: $05d9354839f80fc1$var$_presentation.default
    }, props));
$05d9354839f80fc1$var$ChartBarIcon.Name = 'ChartBarIconMigration';
var $05d9354839f80fc1$var$_default = module.exports.default = $05d9354839f80fc1$var$ChartBarIcon;

});
parcelRegister("esi9c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43e1267245ec627d6ff95c89014f3fb2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a861c1e1bf5cf4c2$var$_react = $a861c1e1bf5cf4c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a861c1e1bf5cf4c2$var$_UNSAFE_baseNew = $a861c1e1bf5cf4c2$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $a861c1e1bf5cf4c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a861c1e1bf5cf4c2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $a861c1e1bf5cf4c2$var$_react.default.createElement($a861c1e1bf5cf4c2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.917 9.75H1.75V13c0 .69.56 1.25 1.25 1.25h2.917m0-4.5v4.5m0-4.5v-4h4.166m-4.166 8.5h4.166m0-8.5v-4h4.167V13c0 .69-.56 1.25-1.25 1.25h-2.917m0-8.5v8.5"/>`
    }, props));
$a861c1e1bf5cf4c2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $a861c1e1bf5cf4c2$var$_default = module.exports.default = $a861c1e1bf5cf4c2$var$ChartBarIcon;

});

parcelRegister("fxGsH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b50ae01bfe204003$var$_react = $b50ae01bfe204003$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $b50ae01bfe204003$var$_chartBar = $b50ae01bfe204003$var$_interopRequireDefault((parcelRequire("esi9c")));
function $b50ae01bfe204003$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b50ae01bfe204003$var$MediaServicesPresentationIcon = (props)=>/*#__PURE__*/ $b50ae01bfe204003$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><rect width="2" height="3" x="8" y="12" fill="inherit" rx="1"/><rect width="2" height="5" x="11" y="10" fill="inherit" rx="1"/><rect width="2" height="7" x="14" y="8" fill="inherit" rx="1"/></g></svg>`
    }, props, {
        newIcon: $b50ae01bfe204003$var$_chartBar.default
    }));
$b50ae01bfe204003$var$MediaServicesPresentationIcon.displayName = 'MediaServicesPresentationIcon';
var $b50ae01bfe204003$var$_default = module.exports.default = $b50ae01bfe204003$var$MediaServicesPresentationIcon;

});


parcelRegister("i5ZMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3622f593cb3455$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cb3622f593cb3455$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    genericPlaceholderIcon: {
        "id": "dashboard-internal-common.common.gadget.gadget-skeleton.generic-placeholder-icon",
        "defaultMessage": "Placeholder icon"
    }
});

});


parcelRegister("7G1NC", function(module, exports) {

$parcel$export(module.exports, "GadgetControllerContextProvider", () => $e9a64807d919c35f$export$4de1bad6b03d7763);
$parcel$export(module.exports, "GadgetControllerContextConsumer", () => $e9a64807d919c35f$export$4d4eb85e0f24da5c);
$parcel$export(module.exports, "useGadgetRefresh", () => $e9a64807d919c35f$export$9e5c8ef16417c38e);
$parcel$export(module.exports, "useGadgetRenderKey", () => $e9a64807d919c35f$export$b4c09774e3d2cd2d);
$parcel$export(module.exports, "useIsConnectDisabled", () => $e9a64807d919c35f$export$2afbda65cda4cd52);
$parcel$export(module.exports, "useGadgetSetPreferences", () => $e9a64807d919c35f$export$263d54a76be27f46);

var $4klDo = parcelRequire("4klDo");
const { createUseContextField: $e9a64807d919c35f$export$56fb4dd71461f98e, Provider: $e9a64807d919c35f$export$4de1bad6b03d7763, Consumer: $e9a64807d919c35f$export$4d4eb85e0f24da5c } = (0, $4klDo.createRendererContext)();
const $e9a64807d919c35f$export$9e5c8ef16417c38e = $e9a64807d919c35f$export$56fb4dd71461f98e('onRefresh');
const $e9a64807d919c35f$export$b4c09774e3d2cd2d = $e9a64807d919c35f$export$56fb4dd71461f98e('renderKey');
const $e9a64807d919c35f$export$2afbda65cda4cd52 = $e9a64807d919c35f$export$56fb4dd71461f98e('isConnectDisabled');
const $e9a64807d919c35f$export$263d54a76be27f46 = $e9a64807d919c35f$export$56fb4dd71461f98e('setPreferences');

});

parcelRegister("gnGe3", function(module, exports) {

$parcel$export(module.exports, "useGadgetCommonController", () => $d34a301803596a04$export$3db154a5767b2bd0);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");
const $d34a301803596a04$export$3db154a5767b2bd0 = ({ id: id, display: display, automaticRefreshMs: automaticRefreshMs, localStorageService: { get: localStorageServiceGet, put: localStorageServicePut, del: localStorageServiceDel }, dashboardRefreshId: dashboardRefreshId, onGadgetKeyChange: onGadgetKeyChange })=>{
    const isDisplayed = display !== (0, $kEBPk.GADGET_DISPLAY).HIDDEN;
    const isMaximized = display === (0, $kEBPk.GADGET_DISPLAY).MAXIMIZED;
    const [isMinimized, setIsMinimized] = (0, $eUqFw.useState)(()=>localStorageServiceGet('minimized') === 'true');
    const onMinimizeOrRestore = (0, $eUqFw.useCallback)((doMinimize)=>{
        if (doMinimize !== isMinimized) {
            if (doMinimize) localStorageServicePut('minimized', 'true');
            else localStorageServiceDel('minimized');
            setIsMinimized(doMinimize);
        }
    }, [
        isMinimized,
        setIsMinimized,
        localStorageServicePut,
        localStorageServiceDel
    ]);
    const [shouldUseCache, setShouldUseCache] = (0, $eUqFw.useState)(true);
    const [refreshId, setRefreshId] = (0, $eUqFw.useState)(Date.now());
    const renderKey = `${id}-${refreshId}-${dashboardRefreshId}-${isMaximized ? 'canvas' : 'default'}`;
    const prevRenderKey = (0, $eUqFw.useRef)(renderKey);
    const onRefresh = (0, $eUqFw.useCallback)(()=>{
        setShouldUseCache(false);
        setRefreshId(Date.now());
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (automaticRefreshMs == null || automaticRefreshMs <= 0) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
        const interval = setInterval(onRefresh, refreshIntervalMs);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        automaticRefreshMs,
        onRefresh
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (prevRenderKey.current !== renderKey) {
            prevRenderKey.current = renderKey;
            onGadgetKeyChange();
        }
    }, [
        renderKey,
        onGadgetKeyChange
    ]);
    // id is a timestamp
    const lastRefreshed = Math.max(Number(dashboardRefreshId), refreshId);
    return {
        isDisplayed: isDisplayed,
        isMaximized: isMaximized,
        isMinimized: isMinimized,
        onMinimizeOrRestore: onMinimizeOrRestore,
        renderKey: renderKey,
        shouldUseCache: shouldUseCache,
        onRefresh: onRefresh,
        lastRefreshed: lastRefreshed
    };
};

});

parcelRegister("f9d6c", function(module, exports) {

$parcel$export(module.exports, "useReactGadget", () => $d61a6b4d1ba2c171$export$a821269bdacf74ba);

var $eUqFw = parcelRequire("eUqFw");

var $iFHrw = parcelRequire("iFHrw");

var $01Qi5 = parcelRequire("01Qi5");

var $aNC1f = parcelRequire("aNC1f");
const $d61a6b4d1ba2c171$export$a821269bdacf74ba = (gadgetId, reactKey)=>{
    const { update: update, refresh: refresh, loading: loading } = (0, $01Qi5.useDashboardReactGadgetsResource)();
    const [resetId, setResetId] = (0, $eUqFw.useState)(null);
    const [namedState, setNamedState] = (0, $eUqFw.useState)('idle');
    const isReactGadget = (0, $iFHrw.isReactKey)(reactKey);
    const reinitialise = (0, $eUqFw.useCallback)(()=>{
        if (namedState === 'idle') {
            // IMPORTANT - Mutations to resource while loading will be lost
            if (loading) {
                setResetId(gadgetId);
                setNamedState('update');
            } else {
                // IMPORTANT - Set null in the resource and then refresh to remove the nulls
                update((0, $aNC1f.lensReactGadget)(gadgetId, null));
                setNamedState('refresh');
            }
        }
    }, [
        gadgetId,
        loading,
        update,
        namedState
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!loading && resetId != null && namedState === 'update') {
            setResetId(null);
            // IMPORTANT - Set null in the resource and then refresh to remove the nulls
            update((0, $aNC1f.lensReactGadget)(resetId, null));
            setNamedState('refresh');
        }
    }, [
        loading,
        update,
        resetId,
        namedState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // IMPORTANT - We need to arrive here asynchronously in case multiple gadgets are reset at once
        if (namedState === 'refresh') {
            setNamedState('loading');
            refresh();
        }
    }, [
        refresh,
        namedState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && namedState === 'loading') setNamedState('idle');
    }, [
        loading,
        namedState
    ]);
    if (!isReactGadget) return {
        reinitialise: ()=>undefined,
        isEditable: null,
        isLoading: null
    };
    const { componentEdit: componentEdit } = (0, $iFHrw.default)[reactKey];
    return {
        reinitialise: reinitialise,
        isEditable: Boolean(componentEdit),
        isLoading: namedState === 'loading' || loading && namedState === 'idle'
    };
};

});
parcelRegister("aNC1f", function(module, exports) {

$parcel$export(module.exports, "lensReactGadget", () => $628c79ad0e024b67$export$703ae6d6d75e47f1);
const $628c79ad0e024b67$export$bada82ca295a26d5 = (updateGadgets)=>(resource)=>resource && {
            ...resource,
            reactGadgetsState: updateGadgets(resource.reactGadgetsState)
        };
const $628c79ad0e024b67$export$703ae6d6d75e47f1 = (id, setterOrValue)=>{
    const setter = typeof setterOrValue === 'function' ? setterOrValue : ()=>setterOrValue;
    return $628c79ad0e024b67$export$bada82ca295a26d5((reactGadgetsState)=>{
        if (!reactGadgetsState || !(id in reactGadgetsState)) return reactGadgetsState;
        const prevStateOrError = reactGadgetsState[id];
        const newState = setter(prevStateOrError);
        const prevState = prevStateOrError === null || prevStateOrError instanceof Error ? {} : prevStateOrError;
        return {
            ...reactGadgetsState,
            [id]: newState === null ? null : {
                ...prevState,
                ...newState
            }
        };
    });
};

});


parcelRegister("1SsGr", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageService", () => $835ff7a2933fed43$export$aae02958650bede0);

var $eUqFw = parcelRequire("eUqFw");

var $5lv3X = parcelRequire("5lv3X");
const $835ff7a2933fed43$export$d4655e9fae202a89 = (id)=>(0, $eUqFw.useCallback)((...args)=>(0, $5lv3X.getGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $835ff7a2933fed43$export$3bf5aef0d5c5f925 = (id)=>(0, $eUqFw.useCallback)((...args)=>(0, $5lv3X.putGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $835ff7a2933fed43$export$84a14851141ef231 = (id)=>(0, $eUqFw.useCallback)((...args)=>(0, $5lv3X.deleteGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $835ff7a2933fed43$export$aae02958650bede0 = (id)=>{
    const get = $835ff7a2933fed43$export$d4655e9fae202a89(id);
    const put = $835ff7a2933fed43$export$3bf5aef0d5c5f925(id);
    const del = $835ff7a2933fed43$export$84a14851141ef231(id);
    return {
        get: get,
        put: put,
        del: del
    };
};

});

parcelRegister("4dOeX", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesService", () => $9b15ea344c1f6fec$export$f1180a44ef60f9a2);

var $eUqFw = parcelRequire("eUqFw");

var $crAWe = parcelRequire("crAWe");

var $drSGD = parcelRequire("drSGD");

var $WBLbN = parcelRequire("WBLbN");

var $gjx45 = parcelRequire("gjx45");
const $9b15ea344c1f6fec$export$f1180a44ef60f9a2 = (id, update)=>{
    const refresh = (0, $eUqFw.useCallback)((action, onUpdate)=>(0, $crAWe.getUserPreferences)(action).then((userPrefs)=>new Promise((resolve)=>{
                // IMPORTANT
                //  some consumers need batch react state updates with route resource updates
                //  to avoid render race-conditions
                (0, $WBLbN.batch)(()=>{
                    update((0, $gjx45.lensGadget)(id, {
                        userPrefs: userPrefs
                    }));
                    onUpdate && onUpdate();
                    resolve(userPrefs);
                });
            })), [
        id,
        update
    ]);
    return {
        get: (0, $crAWe.getUserPreferences),
        put: (0, $drSGD.putUserPreferences),
        refresh: refresh
    };
};

});
parcelRegister("drSGD", function(module, exports) {

$parcel$export(module.exports, "putUserPreferences", () => $cf607aef99f1902e$export$4af73e9957d3b620);

var $lRmyA = parcelRequire("lRmyA");
const $cf607aef99f1902e$export$46db0cded8c5f9ba = (preferences)=>{
    const userPreferences = {
        up_isConfigured: true
    };
    if (preferences) Object.keys(preferences).forEach((key)=>{
        userPreferences[`up_${key}`] = preferences[key];
    });
    return userPreferences;
};
const $cf607aef99f1902e$export$4af73e9957d3b620 = (action, preferences)=>{
    if (Object.entries(preferences).length === 0) return null;
    const body = JSON.stringify($cf607aef99f1902e$export$46db0cded8c5f9ba(preferences));
    return (0, $lRmyA.performPutRequest)(action, {
        body: body
    });
};

});

parcelRegister("gjx45", function(module, exports) {

$parcel$export(module.exports, "lensGadgetsList", () => $b391365f2fc7b3a8$export$20e5dac1cf24abd6);
$parcel$export(module.exports, "lensGadget", () => $b391365f2fc7b3a8$export$fd99d53e8db9addf);
const $b391365f2fc7b3a8$export$20e5dac1cf24abd6 = (updateGadgets)=>(config)=>config && {
            ...config,
            gadgets: updateGadgets(config.gadgets)
        };
const $b391365f2fc7b3a8$export$fd99d53e8db9addf = (id, setterOrValue)=>{
    const setter = typeof setterOrValue === 'function' ? setterOrValue : ()=>setterOrValue;
    return $b391365f2fc7b3a8$export$20e5dac1cf24abd6((gadgets)=>gadgets.map((item)=>item.id === id ? {
                ...item,
                ...setter(item)
            } : item));
};

});


parcelRegister("ipYDU", function(module, exports) {

$parcel$export(module.exports, "GadgetInner", () => $53cfe0ee600dd1ae$export$9bb8ef6d23720658);

var $eUqFw = parcelRequire("eUqFw");

var $iFHrw = parcelRequire("iFHrw");

var $179bk = parcelRequire("179bk");

var $cKLT4 = parcelRequire("cKLT4");

var $12Fqt = parcelRequire("12Fqt");

var $97R6n = parcelRequire("97R6n");

var $4CV7l = parcelRequire("4CV7l");

var $5McEu = parcelRequire("5McEu");

var $hBMAw = parcelRequire("hBMAw");

var $8Xm0B = parcelRequire("8Xm0B");
const $53cfe0ee600dd1ae$export$9bb8ef6d23720658 = ({ dashboardId: dashboardId, data: data, isUnconfigured: isUnconfigured, isEditModeEnabled: isEditModeEnabled, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, setTitle: setTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel, unconfiguredFallback: unconfiguredFallback, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget })=>{
    const enhancedContext = (0, $cKLT4.useGadgetDataContextEnhancer)(data.context);
    const onGadgetRender = (0, $179bk.useOnGadgetRender)(data.id);
    const unconfiguredModernGadgetInViewMode = !isInEditMode && isUnconfigured && !(0, $12Fqt.isConnectGadget)(data);
    const localStorageHeight = (0, $179bk.useLocalStorageGadgetHeight)(data.id);
    if (unconfiguredFallback != null && unconfiguredModernGadgetInViewMode) return unconfiguredFallback;
    if ((0, $12Fqt.isConnectGadget)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4CV7l.Connect), {
        dashboardId: dashboardId,
        gadgetId: data.id,
        inlineHtml: data.inlineHtml,
        isLoading: isLoading,
        isInEditMode: isInEditMode,
        setIsLoading: setIsLoading,
        onEditModeCancel: onEditModeCancel,
        onRegister: onRegisterConnectGadget,
        onUnregister: onUnregisterConnectGadget,
        setTitle: setTitle
    });
    if (data.amdModule != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $97R6n.Amd), {
        dashboardId: dashboardId,
        gadgetId: data.id,
        amdModule: data.amdModule,
        context: enhancedContext,
        defaultTitle: data.title,
        userPrefs: data.userPrefs,
        inlineHtml: data.inlineHtml,
        isEditable: isEditModeEnabled,
        isLoading: isLoading,
        isInEditMode: isInEditMode,
        setIsLoading: setIsLoading,
        setDefaultTitle: setDefaultTitle,
        shouldUseCache: shouldUseCache,
        isMaximized: isMaximized,
        onEditModeCancel: onEditModeCancel
    });
    if (data.inlineHtml != null && data.renderedGadgetUrl == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hBMAw.InlineHtml), {
        id: data.id,
        inlineHtml: data.inlineHtml,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    });
    if (data.forge != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5McEu.Forge), {
        forgeKey: data.forge.key,
        gadgetData: data,
        isInEditMode: isInEditMode,
        onEditModeCancel: onEditModeCancel,
        setIsLoading: setIsLoading
    });
    if ((0, $iFHrw.isReactKey)(data.reactKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Xm0B.ReactGadget), {
        id: data.id,
        reactKey: data.reactKey,
        onEditModeCancel: onEditModeCancel,
        isInEditMode: isInEditMode,
        userPrefs: data.userPrefs,
        onRenderComplete: onGadgetRender,
        setDefaultTitle: setDefaultTitle,
        customSkeletonHeightInPx: localStorageHeight
    });
    throw new Error(`Unrecognised gadget type [${data.title}, ${data?.gadgetSpecUrl}]`);
};

});
parcelRegister("cKLT4", function(module, exports) {

$parcel$export(module.exports, "useGadgetDataContextEnhancer", () => $b00ae424e1a02e9e$export$c9b763726c221f0f);

var $eUqFw = parcelRequire("eUqFw");

var $dxcfv = parcelRequire("dxcfv");

var $7MyOX = parcelRequire("7MyOX");
const $b00ae424e1a02e9e$export$191677f0ab656833 = ({ user: user, ...context }, enhancedUser)=>({
        ...context,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        user: {
            ...user,
            ...enhancedUser
        }
    });
const $b00ae424e1a02e9e$export$c9b763726c221f0f = (data)=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const languageTag = (0, $7MyOX.useLanguageTag)();
    return (0, $eUqFw.useMemo)(()=>$b00ae424e1a02e9e$export$191677f0ab656833(data, {
            accountId: accountId,
            languageTag: languageTag
        }), [
        accountId,
        data,
        languageTag
    ]);
};

});
parcelRegister("7MyOX", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LANGUAGE_TAG", () => $7b26ee60dfecfd20$export$271af7ea6b55125e);
$parcel$export(module.exports, "useLanguageTag", () => $7b26ee60dfecfd20$export$dbb9c2c3f6b09f02);

var $gd0Sp = parcelRequire("gd0Sp");
const $7b26ee60dfecfd20$export$271af7ea6b55125e = 'en-US';
const $7b26ee60dfecfd20$export$dbb9c2c3f6b09f02 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.languageTag || $7b26ee60dfecfd20$export$271af7ea6b55125e;
};

});


parcelRegister("12Fqt", function(module, exports) {

$parcel$export(module.exports, "isConnectGadget", () => $8fd6c3e19b737ed1$export$d4464474d72c938d);

var $kEBPk = parcelRequire("kEBPk");
const $8fd6c3e19b737ed1$export$d4464474d72c938d = ({ amdModule: amdModule })=>amdModule === (0, $kEBPk.CONNECT_ITEM_AMD_MODULE);

});

parcelRegister("97R6n", function(module, exports) {

$parcel$export(module.exports, "Amd", () => $5db1bb2b57d8ad42$export$f7e1ea694836dc0c);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $crAWe = parcelRequire("crAWe");

var $guiFP = parcelRequire("guiFP");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");

var $7dAFN = parcelRequire("7dAFN");

var $1KK5n = parcelRequire("1KK5n");

var $3R3Dp = parcelRequire("3R3Dp");

var $7G1NC = parcelRequire("7G1NC");

var $dudVJ = parcelRequire("dudVJ");

var $4rWxC = parcelRequire("4rWxC");

var $iKzwQ = parcelRequire("iKzwQ");

var $kF6iw = parcelRequire("kF6iw");

var $7pi21 = parcelRequire("7pi21");

var $26jnP = parcelRequire("26jnP");
const $5db1bb2b57d8ad42$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.VIEW_WRM_GADGET_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $5db1bb2b57d8ad42$var$reportError = (gadgetId, reportGadgetMetrics, error)=>{
    reportGadgetMetrics(gadgetId, (0, $kF6iw.GADGET_START_EVENT), 'ErrorMessage');
    reportGadgetMetrics(gadgetId, (0, $kF6iw.GADGET_RENDERING_FINISHED_EVENT), 'ErrorMessage');
    (0, $9lmTX.default)({
        ...$5db1bb2b57d8ad42$var$expAttributes,
        wasExperienceSuccesful: false
    });
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: (0, $kEBPk.VIEW_WRM_GADGET_EXPERIENCE),
            packageName: 'jiraDashboardInternalCommon'
        }
    });
};
const $5db1bb2b57d8ad42$export$f7e1ea694836dc0c = ({ dashboardId: dashboardId, gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, userPrefs: userPrefs, inlineHtml: inlineHtml, isEditable: isEditable, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel })=>{
    const [{ currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const { loading: loadingB, data: data } = (0, $01Qi5.useDashboardAMDModulesResource)();
    const { amdModules: amdModules = null } = data ?? {};
    const setPreferences = (0, $7G1NC.useGadgetSetPreferences)();
    const preference = (0, $eUqFw.useMemo)(()=>(0, $crAWe.decodeUserPreferences)(userPrefs?.fields), [
        userPrefs?.fields
    ]);
    const module = (0, $eUqFw.useRef)(null);
    const divRef = (0, $eUqFw.useRef)(null);
    const { addEventHandler: addEventHandler, triggerEvent: triggerEvent, removeEventHandlers: removeEventHandlers } = (0, $3R3Dp.useEventPublisher)();
    const isGlobalsReady = (0, $dudVJ.useIsGlobalsReady)();
    const isRenderable = isGlobalsReady && !loadingB && amdModules?.[amdModule ?? ''] != null || module.current != null;
    const isSkeleton = isLoading && !isInEditMode;
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $iKzwQ.useMessageBus)();
    const [gadgetError, setGadgetError] = (0, $eUqFw.useState)(null);
    (0, $4rWxC.useLinkInterceptor)(divRef.current, isLoading);
    const reportGadgetMetrics = (0, $eUqFw.useCallback)((gid, eventType, contentType, markName, markStage)=>{
        broadcastMessageBusListener((0, $kEBPk.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: contentType,
            markName: markName,
            markStage: markStage,
            source: (0, $kF6iw.WRM_GADGET_METRICS)
        }, {
            gadgetId: gid,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        currentPageId
    ]);
    const gadgetApi = (0, $eUqFw.useMemo)(()=>(0, $7pi21.getInlineGadgetApi)({
            gadgetId: gadgetId,
            amdModule: amdModule ?? '',
            context: context,
            defaultTitle: defaultTitle,
            isEditable: isEditable,
            closeEdit: onEditModeCancel,
            setIsLoading: setIsLoading,
            ref: divRef,
            setDefaultTitle: setDefaultTitle,
            reportGadgetMetrics: reportGadgetMetrics,
            dashboardId: dashboardId,
            addEventHandler: addEventHandler,
            removeEventHandlers: removeEventHandlers,
            triggerEvent: triggerEvent,
            setPreferences: setPreferences,
            shouldUseCache: shouldUseCache,
            view: isMaximized ? 'canvas' : 'default',
            setError: setGadgetError
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // IMPORTANT - this effect must come before AMD initialisation effect
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (inlineHtml == null || divRef.current == null) return;
        divRef.current.innerHTML = '';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        divRef.current.appendChild(document.createRange().createContextualFragment(inlineHtml));
    }, [
        inlineHtml
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (async ()=>{
            // TODO - amdModule missing should be a hard error not a type refinement
            if (!isRenderable || amdModule == null) return;
            // first time initialisation
            if (module.current == null) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const Module = amdModules[amdModule];
                try {
                    module.current = new Module(gadgetApi);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    $5db1bb2b57d8ad42$var$reportError(gadgetId, reportGadgetMetrics, error);
                    setGadgetError((0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR);
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Failed to instantiate AMD module [${amdModule}]`, error);
                }
            }
            // re-render on edit-mode config/view change
            if (module.current != null) {
                (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] in ${isInEditMode ? 'Edit' : 'View'} mode`);
                reportGadgetMetrics(gadgetId, (0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT), isInEditMode ? 'Config' : 'View', undefined, undefined);
                const render = isInEditMode && module.current?.renderEdit || preference.isConfigured && module.current?.render || null;
                if (render == null) {
                    $5db1bb2b57d8ad42$var$reportError(gadgetId, reportGadgetMetrics, new Error('gadget render is null'));
                    setGadgetError((0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR);
                    // NOTE - this is not a plausible case but log it anyway, ideally we'd want type guarantees
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method missing`);
                } else {
                    try {
                        render.call(module.current, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        window.jQuery(divRef.current), preference);
                        setGadgetError(null);
                        (0, $9lmTX.default)({
                            ...$5db1bb2b57d8ad42$var$expAttributes,
                            wasExperienceSuccesful: true
                        });
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        $5db1bb2b57d8ad42$var$reportError(gadgetId, reportGadgetMetrics, error);
                        setGadgetError((0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR);
                        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method throws error`, error);
                    }
                    triggerEvent('afterRender');
                }
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInEditMode,
        preference,
        isRenderable
    ]);
    (0, $eUqFw.useEffect)(// clean up, in separate hook because we only want it called once on unmount
    ()=>()=>{
            if (module.current) module.current = null;
        }, []);
    return gadgetError != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
        errorType: gadgetError,
        id: gadgetId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26jnP.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26jnP.GadgetContainer), {
        id: `gadget-${gadgetId}`,
        ref: divRef,
        isHidden: isSkeleton
    }), isSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26jnP.SkeletonWrapper), {
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.amd.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), {
        dashboardId: dashboardId,
        gadgetId: gadgetId
    })));
};

});
parcelRegister("7dAFN", function(module, exports) {

$parcel$export(module.exports, "GadgetErrorFallbackBase", () => $e782b2f063635ee6$export$f9edce43cd0e391a);
$parcel$export(module.exports, "GadgetErrorFallback", () => $e782b2f063635ee6$export$6de1d4202af2589f);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $93tHo = parcelRequire("93tHo");


var $5JgJ2 = parcelRequire("5JgJ2");

var $7G1NC = parcelRequire("7G1NC");

var $9ocry = parcelRequire("9ocry");

var $9awI2 = parcelRequire("9awI2");

var $fg8Mt = parcelRequire("fg8Mt");
const $e782b2f063635ee6$export$f9edce43cd0e391a = ({ id: id, message: message, isRefresh: isRefresh = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onRefreshClick = (0, $7G1NC.useGadgetRefresh)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ocry.GadgetFallback), {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93tHo))), {
            label: formatMessage((0, $9awI2.default).errorTitle),
            primaryColor: `var(--ds-text-warning, ${(0, $1b343b038f6c23ec$exports).Y300})`
        }),
        action: isRefresh && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: "default",
            spacing: "default",
            onClick: onRefreshClick
        }, formatMessage((0, $9awI2.default).refreshButtonText))
    }, message);
};
const $e782b2f063635ee6$export$6de1d4202af2589f = ({ id: id, errorType: errorType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e782b2f063635ee6$export$f9edce43cd0e391a, {
        message: formatMessage((0, $fg8Mt.MESSAGES_BY_ERROR)[errorType]),
        isRefresh: (0, $fg8Mt.IS_REFRESH_BY_ERROR)[errorType],
        id: id
    });
};

});
parcelRegister("9ocry", function(module, exports) {

$parcel$export(module.exports, "GadgetFallback", () => $c07bff5687e4288b$export$5c6c3d588eda4d74);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $179bk = parcelRequire("179bk");
const $c07bff5687e4288b$export$5c6c3d588eda4d74 = ({ icon: icon, action: action, id: id, children: children })=>{
    const ref = (0, $eUqFw.useRef)(null);
    const onGadgetRender = (0, $179bk.useOnGadgetRender)(id);
    (0, $eUqFw.useEffect)(()=>{
        const measuredHeight = ref.current?.getBoundingClientRect().height;
        onGadgetRender(measuredHeight === 0 ? undefined : measuredHeight);
    }, [
        onGadgetRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c07bff5687e4288b$var$GadgetFallbackWrapper, {
        ref: ref
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $c07bff5687e4288b$var$contentStyles
    }, children), action);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c07bff5687e4288b$var$GadgetFallbackWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41ejb _bfhk11bn _2rkoiti9 _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _syaz1dyx _vchhusvi _y3gn1h6o _4t3i1kw7",
            __cmplp.className
        ])
    });
});
const $c07bff5687e4288b$var$contentStyles = (0, $8Vv3m.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    margin: 'space.100'
});

});

parcelRegister("9awI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9551435eebfcd333$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9551435eebfcd333$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-message",
        "defaultMessage": "We're having some trouble displaying this gadget. It's probably a temporary problem. Try refreshing the gadget."
    },
    errorTitle: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-title",
        "defaultMessage": "Warning"
    },
    configErrorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.config-error-message",
        "defaultMessage": "Something went wrong. We could not save your gadget configuration. Refresh this gadget to update its configuration and try again."
    },
    refreshButtonText: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.refresh-button-text",
        "defaultMessage": "Refresh"
    },
    notSupportedErrorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.not-supported-error-message",
        "defaultMessage": "This gadget is no longer supported by Jira."
    }
});

});

parcelRegister("fg8Mt", function(module, exports) {

$parcel$export(module.exports, "MESSAGES_BY_ERROR", () => $e6393f5567278778$export$8c49a4613a61ecc1);
$parcel$export(module.exports, "IS_REFRESH_BY_ERROR", () => $e6393f5567278778$export$1b18ce488a22b856);

var $kEBPk = parcelRequire("kEBPk");

var $9awI2 = parcelRequire("9awI2");
const $e6393f5567278778$export$8c49a4613a61ecc1 = {
    [(0, $kEBPk.GADGET_ERROR_TYPE).CONFIG_ERROR]: (0, $9awI2.default).configErrorMessage,
    [(0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR]: (0, $9awI2.default).errorMessage,
    [(0, $kEBPk.GADGET_ERROR_TYPE).EDIT_ERROR]: (0, $9awI2.default).errorMessage,
    [(0, $kEBPk.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: (0, $9awI2.default).notSupportedErrorMessage
};
const $e6393f5567278778$export$1b18ce488a22b856 = {
    [(0, $kEBPk.GADGET_ERROR_TYPE).CONFIG_ERROR]: true,
    [(0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR]: true,
    [(0, $kEBPk.GADGET_ERROR_TYPE).EDIT_ERROR]: true,
    [(0, $kEBPk.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: false
};

});


parcelRegister("3R3Dp", function(module, exports) {

$parcel$export(module.exports, "useEventPublisher", () => $0b8612fce7c28e08$export$15f587a36eadd076);

var $eUqFw = parcelRequire("eUqFw");
const $0b8612fce7c28e08$export$15f587a36eadd076 = ()=>{
    // Do not reassign current, as this change will not be seen by useCallback dependency list.  Mutate object instead.
    const eventHandlers = (0, $eUqFw.useRef)(new Map()).current;
    const singleUseEventHandlers = (0, $eUqFw.useRef)(new Map()).current;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const addEventHandler = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName, handler, isSingleUse = false)=>{
        const handlers = isSingleUse ? singleUseEventHandlers : eventHandlers;
        handlers.has(eventName) ? handlers.get(eventName)?.add(handler) : handlers.set(eventName, new Set([
            handler
        ]));
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const removeEventHandlers = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName, handler)=>{
        if (eventName == null) {
            eventHandlers.clear();
            singleUseEventHandlers.clear();
            return;
        }
        if (!handler) {
            eventHandlers.delete(eventName);
            singleUseEventHandlers.delete(eventName);
            return;
        }
        eventHandlers.get(eventName)?.delete(handler);
        singleUseEventHandlers.get(eventName)?.delete(handler);
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const triggerEvent = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName)=>{
        eventHandlers.get(eventName)?.forEach((handler)=>{
            handler();
        });
        singleUseEventHandlers.get(eventName)?.forEach((handler)=>{
            handler();
        });
        singleUseEventHandlers.delete(eventName);
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    return {
        addEventHandler: addEventHandler,
        removeEventHandlers: removeEventHandlers,
        triggerEvent: triggerEvent
    };
};

});

parcelRegister("dudVJ", function(module, exports) {

$parcel$export(module.exports, "useIsGlobalsReady", () => $16f47c2f72910861$export$676419e1d49cf911);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $fTc01 = parcelRequire("fTc01");

var $8Rnv5 = parcelRequire("8Rnv5");
let $16f47c2f72910861$var$pollingSingleton = null;
const $16f47c2f72910861$export$ef596e2a3bce12f6 = ()=>{
    $16f47c2f72910861$var$pollingSingleton = null;
};
class $16f47c2f72910861$var$PollingTimedOutError extends Error {
    constructor(){
        super('Timed out polling for globals');
        this.skipSentry = true;
    }
}
const $16f47c2f72910861$export$676419e1d49cf911 = ()=>{
    try {
        $16f47c2f72910861$var$pollingSingleton = $16f47c2f72910861$var$pollingSingleton ?? new (0, $fTc01.default)(100, (0, $8Rnv5.POLLING_TIMEOUT_MS), (0, $gUUjF.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.common', 'error creating globals polling singleton', error);
    }
    // IMPORTANT - must evaluate readiness synchronously on the first call to avoid async delay
    const [isGlobalsReady, setIsGlobalsReady] = (0, $eUqFw.useState)(()=>$16f47c2f72910861$var$pollingSingleton?.isReady ?? false);
    const [isTimedOut, setIsTimedOut] = (0, $eUqFw.useState)(()=>$16f47c2f72910861$var$pollingSingleton?.isTimedOut ?? false);
    (0, $eUqFw.useEffect)(()=>{
        const setGlobalsReady = ()=>{
            setIsGlobalsReady(true);
        };
        const setTimedOut = ()=>{
            setIsTimedOut(true);
        };
        $16f47c2f72910861$var$pollingSingleton?.addEventListener('onReady', setGlobalsReady);
        $16f47c2f72910861$var$pollingSingleton?.addEventListener('onTimeout', setTimedOut);
        return ()=>{
            $16f47c2f72910861$var$pollingSingleton?.removeEventListener('onReady', setGlobalsReady);
            $16f47c2f72910861$var$pollingSingleton?.removeEventListener('onTimeout', setTimedOut);
        };
    }, []);
    // NOTE - additional state and effect is needed for error to trigger react ErrorBoundary
    (0, $eUqFw.useEffect)(()=>{
        if (isTimedOut) throw new $16f47c2f72910861$var$PollingTimedOutError();
    }, [
        isTimedOut
    ]);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $16f47c2f72910861$var$pollingSingleton !== null ? isGlobalsReady : (0, $8Rnv5.DEPENDENCIES).every((dep)=>window[dep]);
};

});
parcelRegister("fTc01", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b6a9c79541ad9f$export$2e2bcd8739ae039);

var $8Rnv5 = parcelRequire("8Rnv5");

var $kpe7r = parcelRequire("kpe7r");
const $12b6a9c79541ad9f$var$formatGlobals = (deps)=>deps.map((dep)=>`window.${dep}`).join(', ');
// IMPORTANT - EventTarget does not exist in SSR so a degenerate version is required so that it doesn't fail SSR.
// This class should not be run on SSR as it will fall back to the degenerate version.
const $12b6a9c79541ad9f$var$EventTargetUniversal = typeof EventTarget === 'undefined' ? (0, $kpe7r.default) : EventTarget;
class $12b6a9c79541ad9f$export$2e2bcd8739ae039 extends $12b6a9c79541ad9f$var$EventTargetUniversal {
    #intervalID;
    #timeoutID;
    #startTime;
    constructor(pollingMs, timeoutMs, logger){
        super();
        this.isReady = false;
        this.isTimedOut = false;
        this.missingDeps = [];
        this.#intervalID = null;
        this.#timeoutID = null;
        this.#startTime = Date.now();
        this.#constructPolling = (pollingMs, timeoutMs, logger)=>{
            this.#intervalID = setInterval(()=>{
                const newReadyDeps = (0, $8Rnv5.DEPENDENCIES).filter(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                (dep)=>window[dep] && this.missingDeps.includes(dep));
                if (newReadyDeps.length !== 0) {
                    this.missingDeps = this.missingDeps.filter((dep)=>!newReadyDeps.includes(dep));
                    logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `globals [${$12b6a9c79541ad9f$var$formatGlobals(newReadyDeps)}] ready after ${(Date.now() - this.#startTime) / 1000}s, missing globals [${$12b6a9c79541ad9f$var$formatGlobals(this.missingDeps)}]`);
                }
                if (this.missingDeps.length === 0) {
                    this.isReady = true;
                    this.destroy();
                    this.dispatchEvent(new CustomEvent('onReady'));
                    logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$12b6a9c79541ad9f$var$formatGlobals((0, $8Rnv5.DEPENDENCIES))}] ready after ${(Date.now() - this.#startTime) / 1000}s`);
                }
            }, pollingMs);
            this.#timeoutID = setTimeout(()=>{
                this.destroy();
                if (!this.isReady) {
                    this.isTimedOut = true;
                    this.dispatchEvent(new CustomEvent('onTimeout'));
                    logger.safeErrorWithoutCustomerData('spa-apps.dashboard.common', `timed out polling globals, missing globals [${$12b6a9c79541ad9f$var$formatGlobals(this.missingDeps)}]`);
                }
            }, timeoutMs);
        };
        this.destroy = ()=>{
            if (this.#intervalID != null) {
                clearInterval(this.#intervalID);
                this.#intervalID = null;
            }
            if (this.#timeoutID != null) {
                clearTimeout(this.#timeoutID);
                this.#timeoutID = null;
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.missingDeps = (0, $8Rnv5.DEPENDENCIES).filter((dep)=>!window[dep]);
        if (this.missingDeps.length === 0) {
            logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$12b6a9c79541ad9f$var$formatGlobals((0, $8Rnv5.DEPENDENCIES))}] ready on initialisation`);
            this.isReady = true;
        } else {
            logger.safeWarnWithoutCustomerData('spa-apps.dashboard.common', `missing globals [${$12b6a9c79541ad9f$var$formatGlobals(this.missingDeps)}]`);
            this.#constructPolling(pollingMs, timeoutMs, logger);
        }
    }
    #constructPolling;
}

});
parcelRegister("8Rnv5", function(module, exports) {

$parcel$export(module.exports, "DEPENDENCIES", () => $8b56a12ae8449b80$export$db362e2d293fe52e);
$parcel$export(module.exports, "POLLING_TIMEOUT_MS", () => $8b56a12ae8449b80$export$560b5415aba6175);
const $8b56a12ae8449b80$export$db362e2d293fe52e = [
    'require',
    'jQuery'
];
const $8b56a12ae8449b80$export$560b5415aba6175 = 60000;

});

parcelRegister("kpe7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $252284ee98806f92$export$2e2bcd8739ae039);
class $252284ee98806f92$export$2e2bcd8739ae039 {
    constructor(){
        throw new Error('EventTarget is not defined');
    }
}

});



parcelRegister("4rWxC", function(module, exports) {

$parcel$export(module.exports, "useLinkInterceptor", () => $2f5fc4620bf8cbb9$export$d6b75f959ce086c3);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $lB25E = parcelRequire("lB25E");

var $aoqW4 = parcelRequire("aoqW4");

var $kMGge = parcelRequire("kMGge");
const $2f5fc4620bf8cbb9$export$ad8ccaa587ef5e2e = 3984;
// Absolutely exclude any paths that contain the following regex
const $2f5fc4620bf8cbb9$var$EXCLUDED_PATHS = [
    /^\/rest\/(?:gadget|api)\/1\.0\//,
    /^\/plugins\/servlet\/gadgets\/ifr/
];
const $2f5fc4620bf8cbb9$var$isExcludedPath = (path)=>$2f5fc4620bf8cbb9$var$EXCLUDED_PATHS.some((regex)=>regex.test(path));
const $2f5fc4620bf8cbb9$export$d6b75f959ce086c3 = (element, isLoading)=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    (0, $eUqFw.useEffect)(()=>{
        if (isLoading) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const linkClickHandler = (event)=>{
            const anchor = event.target instanceof HTMLAnchorElement ? event.target : event.target.closest?.('a');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (anchor == null || window.location.hostname !== anchor.hostname) // skip if it is not an anchor or to external link
            return;
            if (anchor.href && anchor.href.length > $2f5fc4620bf8cbb9$export$ad8ccaa587ef5e2e) {
                event.preventDefault();
                const flagConfig = {
                    key: (0, $eo17r.toFlagId)('urlTooLongWarning'),
                    type: 'error',
                    title: (0, $kMGge.default).linkInterceptorUrlTooLongTitle,
                    description: (0, $kMGge.default).linkInterceptorUrlTooLongDescription
                };
                showFlag(flagConfig);
            } else if (anchor.pathname && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            !(0, $aoqW4.clickedWithShortcutKeys)(event) && // some links from the monolith code are invalid and calls
            // event.preventDefault (e.g. popups), so we filter those out
            !event.defaultPrevented && !$2f5fc4620bf8cbb9$var$isExcludedPath(anchor.pathname)) {
                event.preventDefault();
                push(anchor.href);
            }
        };
        element?.addEventListener('click', linkClickHandler);
        return ()=>{
            element?.removeEventListener('click', linkClickHandler);
        };
    }, [
        element,
        isLoading,
        push,
        showFlag
    ]);
};

});
parcelRegister("aoqW4", function(module, exports) {

$parcel$export(module.exports, "clickedWithShortcutKeys", () => $7b45ac25e57fd492$export$141f1be6ae7df96b);
const $7b45ac25e57fd492$export$141f1be6ae7df96b = (e)=>{
    if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return true;
    return false;
};

});

parcelRegister("kMGge", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c87c7e280c79f2a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5c87c7e280c79f2a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    linkInterceptorUrlTooLongTitle: {
        "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-title",
        "defaultMessage": "Requested URL too large"
    },
    linkInterceptorUrlTooLongDescription: {
        "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-description",
        "defaultMessage": "Try shortening the JQL of your saved filter."
    }
});

});


parcelRegister("7pi21", function(module, exports) {

$parcel$export(module.exports, "getInlineGadgetApi", () => $1a76c735cfb7acab$export$a7c3539038fb2c0);

var $jG2Eu = parcelRequire("jG2Eu");

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $guiFP = parcelRequire("guiFP");

var $5lv3X = parcelRequire("5lv3X");
const $1a76c735cfb7acab$export$a7c3539038fb2c0 = ({ gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, isEditable: isEditable, closeEdit: closeEdit, ref: ref, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, reportGadgetMetrics: reportGadgetMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), dashboardId: dashboardId, setPreferences: setPreferences, addEventHandler: addEventHandler, removeEventHandlers: removeEventHandlers, triggerEvent: triggerEvent, shouldUseCache: shouldUseCache, view: view, setError: setError })=>{
    const resize = ()=>{
        if (!dashboardId || !gadgetId) return;
        // Store current height of gadget in local storage
        const height = ref.current?.getBoundingClientRect().height;
        (0, $5lv3X.updateLocalStorageHeight)(dashboardId, gadgetId, height);
    };
    const moduleAPI = {
        on: (id, handler)=>addEventHandler(id, handler),
        once: (id, handler)=>addEventHandler(id, handler, true),
        off: (id, handler)=>removeEventHandlers(id, handler),
        trigger: (id)=>triggerEvent(id)
    };
    const expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, $kEBPk.SAVE_AMD_GADGET_CONFIG_PREFERENCES),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    return {
        gadget: {
            amdModule: amdModule,
            context: context,
            moduleAPI: moduleAPI
        },
        showLoadingBar: ()=>{
            setIsLoading(true);
        },
        resize: resize,
        isEditable: ()=>isEditable,
        savePreferences: async (preferences)=>{
            // IMPORTANT
            //  per JDAG-413 we need to batch react state updates with route resource update
            const maybePromise = setPreferences(preferences, ()=>{
                setError(null);
                closeEdit();
            });
            if (!maybePromise) return;
            try {
                await maybePromise;
                (0, $9lmTX.default)({
                    ...expAttributes,
                    wasExperienceSuccesful: true
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd.api', `${e.message} [${defaultTitle}]`);
                setError((0, $kEBPk.GADGET_ERROR_TYPE).CONFIG_ERROR);
                (0, $9lmTX.default)({
                    ...expAttributes,
                    wasExperienceSuccesful: false
                });
                (0, $guiFP.default)({
                    error: e,
                    meta: {
                        id: (0, $kEBPk.SAVE_AMD_GADGET_CONFIG_PREFERENCES),
                        packageName: 'jiraDashboardInternalCommon'
                    }
                });
            }
        },
        setTitle: setDefaultTitle,
        hideLoadingBar: ()=>setIsLoading(false),
        initRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        getRefreshFieldValue: (fieldName)=>{
            const input = ref.current?.querySelector(`input[name=${fieldName || 'refresh'}]`);
            if (input == null || !(input instanceof HTMLInputElement) || !input.checked) return 'false';
            return input.value;
        },
        getGadgetId: ()=>gadgetId,
        closeEdit: closeEdit,
        // deprecated
        forceLayoutRefresh: ()=>{
            (0, $gUUjF.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'deprecated forceLayoutRefresh() is called');
            resize();
        },
        publicInstace: ()=>(0, $gUUjF.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'Unexpected public instance called'),
        _preparePreferencesToBeSaved: (preference)=>{
            let preferenceStr = '';
            try {
                preferenceStr = JSON.stringify(preference);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                preferenceStr = 'non-stringifiable type';
            }
            (0, $gUUjF.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', `Unexpected prepare preferences called with ${preferenceStr} for ${defaultTitle}`);
        },
        getContext: ()=>context,
        // deprecated, replaced by react life cycle
        ...moduleAPI,
        listenTo: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        stopListening: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        listenToOnce: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        reportGadgetMetrics: reportGadgetMetrics,
        shouldUseCache: shouldUseCache,
        view: view
    };
};

});

parcelRegister("26jnP", function(module, exports) {

$parcel$export(module.exports, "styleOverrideFromMonolith", () => $fc0d182b030fb28e$export$a135452a315aaac8);
$parcel$export(module.exports, "editModeStyleOverrideFromMonolith", () => $fc0d182b030fb28e$export$5dd19c8cd0b42775);
$parcel$export(module.exports, "Container", () => $fc0d182b030fb28e$export$42a852a2b6b56249);
$parcel$export(module.exports, "SkeletonWrapper", () => $fc0d182b030fb28e$export$6069cbe61f690103);
$parcel$export(module.exports, "GadgetContainer", () => $fc0d182b030fb28e$export$3f9afbcf9557b0b4);
$parcel$export(module.exports, "ConfigureButton", () => $fc0d182b030fb28e$export$b95d78b6ea7efb0b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");
const $fc0d182b030fb28e$export$a135452a315aaac8 = `
.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #5e6c84)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #0049b0)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #ebecf0)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #172b4d)"};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #5e6c84)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0049b0)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: 400;
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
const $fc0d182b030fb28e$export$5dd19c8cd0b42775 = `
form.aui .buttons-container .buttons, form.aui .submit-cancel-controls {
    text-align: end;
}
.piechart-gadget .dashboard-item-preferences-config {
    margin: -20px
}
`;
const $fc0d182b030fb28e$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $fc0d182b030fb28e$export$6069cbe61f690103 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _11q7vuon",
            __cmplp.className
        ])
    });
});
const $fc0d182b030fb28e$export$3f9afbcf9557b0b4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHidden && "_3um015vq _kqsw7079",
            __cmplp.className
        ])
    });
});
const $fc0d182b030fb28e$export$b95d78b6ea7efb0b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lUg8E.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4CV7l", function(module, exports) {

$parcel$export(module.exports, "Connect", () => $84c3d044e912aae6$export$59e6910693f047c2);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $3X4Tl = parcelRequire("3X4Tl");

var $1KK5n = parcelRequire("1KK5n");

var $179bk = parcelRequire("179bk");

var $6QUMT = parcelRequire("6QUMT");

var $7G1NC = parcelRequire("7G1NC");

var $dudVJ = parcelRequire("dudVJ");

var $5lv3X = parcelRequire("5lv3X");

var $bxyRs = parcelRequire("bxyRs");
const $84c3d044e912aae6$export$59e6910693f047c2 = ({ dashboardId: dashboardId, gadgetId: gadgetId, inlineHtml: inlineHtml, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, onEditModeCancel: onEditModeCancel, onRegister: onRegister, onUnregister: onUnregister, setTitle: setTitle })=>{
    const divRef = (0, $eUqFw.useRef)(null);
    const isGlobalsReady = (0, $dudVJ.useIsGlobalsReady)();
    const isDisabled = (0, $7G1NC.useIsConnectDisabled)();
    const forcedHeightFromState = (0, $6QUMT.useForcedHeight)(gadgetId);
    const forcedHeight = (0, $eUqFw.useMemo)(()=>forcedHeightFromState ?? (0, $5lv3X.getLocalStorageHeight)(dashboardId, gadgetId), [
        forcedHeightFromState,
        dashboardId,
        gadgetId
    ]);
    const onGadgetRender = (0, $179bk.useOnGadgetRender)(gadgetId);
    const onRefresh = (0, $7G1NC.useGadgetRefresh)();
    const showSkeleton = isLoading && !isInEditMode;
    (0, $eUqFw.useEffect)(()=>{
        // TODO - inlineHtml missing should be a hard error not a type refinement
        if (!isGlobalsReady || inlineHtml == null) return;
        (0, $3X4Tl.setupConnectJs)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const slotHtml = document.createRange().createContextualFragment(inlineHtml);
            if (divRef.current) {
                divRef.current.innerHTML = '';
                divRef.current.appendChild(slotHtml);
                setIsLoading(false);
                onGadgetRender();
            }
        }).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.connect', 'Failed to render Connect gadget', error);
        // TODO - where is setError here, where is reportError here?? (compare with amd gadget)
        });
    }, [
        isGlobalsReady,
        inlineHtml,
        onGadgetRender,
        setIsLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onRegister(gadgetId, setTitle);
        return ()=>{
            onUnregister(gadgetId);
        };
    }, [
        gadgetId,
        setTitle,
        onRegister,
        onUnregister
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const target = divRef.current?.getElementsByTagName('iframe')[0];
        if (!target || !isInEditMode || isLoading) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.connectHost?.broadcastEvent('jira_dashboard_item_edit', {
            id: target.getAttribute('id')
        });
    }, [
        isInEditMode,
        isLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const connectEventHandler = (event)=>{
            const eventData = event.data;
            const target = divRef.current?.getElementsByTagName('iframe')[0];
            if (target == null || eventData == null || eventData.eid !== target.getAttribute('id')) return;
            if (eventData.type === 'unload') onRefresh();
            else onEditModeCancel();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('message', connectEventHandler, false);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('message', connectEventHandler);
        };
    }, [
        dashboardId,
        gadgetId,
        inlineHtml,
        isGlobalsReady,
        onRefresh,
        onEditModeCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bxyRs.Container), {
        minHeight: forcedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bxyRs.GadgetContainer), {
        id: `gadget-${gadgetId}`,
        "data-gadget-id": gadgetId,
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.connect",
        ref: divRef,
        isHidden: showSkeleton,
        isDisabled: isDisabled
    }), showSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bxyRs.SkeletonWrapper), {
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), {
        dashboardId: dashboardId,
        gadgetId: gadgetId
    })));
};

});
parcelRegister("bxyRs", function(module, exports) {

$parcel$export(module.exports, "Container", () => $b8da857cf1d6c8ed$export$42a852a2b6b56249);
$parcel$export(module.exports, "SkeletonWrapper", () => $b8da857cf1d6c8ed$export$6069cbe61f690103);
$parcel$export(module.exports, "GadgetContainer", () => $b8da857cf1d6c8ed$export$3f9afbcf9557b0b4);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");
const $b8da857cf1d6c8ed$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minHeight: minHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1l1bpbj": (0, $9t7rW.default)(`${__cmplp.minHeight}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1tkemu0a",
            __cmplp.className
        ])
    });
});
const $b8da857cf1d6c8ed$export$6069cbe61f690103 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _154iidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1sen",
            __cmplp.className
        ])
    });
});
const $b8da857cf1d6c8ed$var$GadgetContainerComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHidden ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.isDisabled ? "_lcxvglyw" : "_lcxv1kw7",
            __cmplp.className
        ])
    });
});
const $b8da857cf1d6c8ed$export$3f9afbcf9557b0b4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// for monolith to identify gadget
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8da857cf1d6c8ed$var$GadgetContainerComponent, {
        className: "connect-gadget",
        ...props,
        ref: ref
    }));

});


parcelRegister("5McEu", function(module, exports) {

$parcel$export(module.exports, "Forge", () => $ab523a797b5fb20d$export$4b9c9e62f20bbcd0);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $eciFw = parcelRequire("eciFw");

var $7AHA4 = parcelRequire("7AHA4");

var $cY2Xs = parcelRequire("cY2Xs");

var $70ON1 = parcelRequire("70ON1");

var $gGtKh = parcelRequire("gGtKh");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");

var $7dAFN = parcelRequire("7dAFN");

var $1KK5n = parcelRequire("1KK5n");

var $7G1NC = parcelRequire("7G1NC");

var $iKzwQ = parcelRequire("iKzwQ");

var $kF6iw = parcelRequire("kF6iw");

var $9496v = parcelRequire("9496v");
const $ab523a797b5fb20d$export$4b36646b2dadb9ee = ({ gadgetData: gadgetData, forgeKey: forgeKey, isInEditMode: isInEditMode, onEditModeCancel: onEditModeCancel, setIsLoading: setIsLoading })=>{
    const [{ currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const { data: dashboardData } = (0, $01Qi5.useDashboardResource)();
    const { data: forgeResourceData, loading: isDashboardForgeResourceLoading, error: resourceError } = (0, $01Qi5.useDashboardForgeResource)();
    const setPreferences = (0, $7G1NC.useGadgetSetPreferences)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $iKzwQ.useMessageBus)();
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [isUpdatePending, setIsUpdatePending] = (0, $eUqFw.useState)(false);
    const reportGadgetMetrics = (0, $eUqFw.useCallback)((eventType, contentType, markName, markStage)=>{
        broadcastMessageBusListener((0, $kEBPk.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: contentType,
            markName: markName,
            markStage: markStage,
            source: (0, $kF6iw.FORGE_GADGET_METRICS)
        }, {
            gadgetId: gadgetData.id,
            pageId: currentPageId
        });
    }, [
        gadgetData.id,
        broadcastMessageBusListener,
        currentPageId
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // gadget container mounted event
        reportGadgetMetrics((0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT), 'View');
    }, [
        reportGadgetMetrics
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isDashboardForgeResourceLoading) setIsLoading(false);
    }, [
        isDashboardForgeResourceLoading,
        setIsLoading
    ]);
    const onConfigurationSave = (0, $eUqFw.useCallback)((dataToSave)=>{
        (0, $eciFw.fireUiTriggerClickEvent)('dashboardGadgetEdit');
        setIsUpdatePending(true);
        return (0, $9496v.savePreferences)(gadgetData, dataToSave, setPreferences, setError, ()=>{
            setIsUpdatePending(false);
        });
    }, [
        gadgetData,
        setPreferences,
        setError,
        setIsUpdatePending
    ]);
    const dashboardId = dashboardData?.id || '';
    const extensionData = (0, $eUqFw.useMemo)(()=>({
            gadgetConfiguration: (0, $9496v.transformUserPrefsForForgeAppConsumption)(gadgetData.userPrefs?.fields),
            dashboard: {
                id: dashboardId
            },
            gadget: {
                id: gadgetData.id
            }
        }), [
        gadgetData.userPrefs?.fields,
        dashboardId,
        gadgetData.id
    ]);
    if (isDashboardForgeResourceLoading || isUpdatePending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), null);
    const forgeGadget = forgeResourceData?.gadgets.find((gadget)=>gadget.id === forgeKey);
    if (resourceError || error || !forgeGadget || !dashboardId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
        errorType: error ?? (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR,
        id: gadgetData.id
    });
    return(// have to use Suspense here because AsyncDashboardGadget is lazy loaded using React.lazy()
    // which requires a Suspense further up the tree to work
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-dashboard-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), null)
    }, isInEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cY2Xs.AsyncDashboardGadgetEdit), {
        extension: forgeGadget,
        extensionData: extensionData,
        onReportGadgetMetrics: reportGadgetMetrics,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), null),
        onEditModeCancel: onEditModeCancel,
        onConfigurationSave: onConfigurationSave
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cY2Xs.AsyncDashboardGadgetView), {
        extension: forgeGadget,
        extensionData: extensionData,
        onReportGadgetMetrics: reportGadgetMetrics,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), null)
    })));
};
const $ab523a797b5fb20d$export$4b9c9e62f20bbcd0 = (props)=>{
    const { gadgetData: { id: id }, isInEditMode: isInEditMode } = props;
    const envType = props.gadgetData.forge?.environment;
    const forgeKey = props.gadgetData.forge?.key;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7AHA4.AnalyticsWrapper), {
        attributes: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            envType: envType,
            ...forgeKey ? (0, $70ON1.parseExtensionId)(forgeKey) : {}
        },
        key: `${id}__${isInEditMode}`,
        isInEditMode: isInEditMode,
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
                errorType: (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR,
                id: id
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab523a797b5fb20d$export$4b36646b2dadb9ee, props));
};

});
parcelRegister("eciFw", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $514bc3269fa006a8$export$1798d320c6527c08);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $514bc3269fa006a8$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $514bc3269fa006a8$export$cfefb608fbbf02c9);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $hRcYT = parcelRequire("hRcYT");
const $514bc3269fa006a8$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $514bc3269fa006a8$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $514bc3269fa006a8$export$1798d320c6527c08 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).EDITED, {
        id: $514bc3269fa006a8$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $514bc3269fa006a8$export$762dee9e981de3e1 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: $514bc3269fa006a8$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $514bc3269fa006a8$export$cfefb608fbbf02c9 = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $514bc3269fa006a8$var$triggerEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("7AHA4", function(module, exports) {

$parcel$export(module.exports, "AnalyticsWrapper", () => $f61e3bf2225ec876$export$63b55d605f8a2340);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $f61e3bf2225ec876$export$63b55d605f8a2340 = (props)=>{
    const { isInEditMode: isInEditMode, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        ...restProps,
        module: (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
        entryPoint: isInEditMode ? (0, $2Rqjr.ENTRY_POINT_EDIT) : undefined,
        shouldFireInitializedEvent: true
    });
};

});

parcelRegister("cY2Xs", function(module, exports) {

$parcel$export(module.exports, "AsyncDashboardGadgetView", () => $0b5eaac4436593a5$export$8f8b884c8f9b7f99);
$parcel$export(module.exports, "AsyncDashboardGadgetEdit", () => $0b5eaac4436593a5$export$11802f9302dce8a3);
// eslint-disable-next-line jira/restricted/react-lazy

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $1boRu = parcelRequire("1boRu");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");
const $0b5eaac4436593a5$var$GADGET_START_EVENT = 'gadget-start';
const $0b5eaac4436593a5$var$GADGET_FINISH_EVENT = 'gadget-rendering-finished';

// We are using React.lazy() instead of react-loosley-lazy here because DashboardGadget
// renders RendererNext from the forge-ui package which uses Suspense
// and you can't mix React.Suspense with RLL
const $0b5eaac4436593a5$var$getUiKitModule = ()=>(parcelRequire("aDcmA"));
const $0b5eaac4436593a5$export$d53932a75c2ba294 = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getUiKitModule().then((module)=>({
            default: module.DashboardGadgetView
        }))));
const $0b5eaac4436593a5$export$e388a2aaf41cd524 = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getUiKitModule().then((module)=>({
            default: module.DashboardGadgetEdit
        }))));

const $0b5eaac4436593a5$var$getIframeModule = ()=>(parcelRequire("b1INm"));
const $0b5eaac4436593a5$export$6e328a6d6807e3ef = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getIframeModule().then((module)=>({
            default: module.DashboardGadgetViewRenderer
        }))));
const $0b5eaac4436593a5$export$6618f34be2146a7d = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getIframeModule().then((module)=>({
            default: module.DashboardGadgetEditRenderer
        }))));

const $0b5eaac4436593a5$var$getForgeExtensionModule = ()=>(parcelRequire("fN4iA"));
const $0b5eaac4436593a5$export$90dc543486d6f150 = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getForgeExtensionModule().then((module)=>({
            default: module.DashboardGadgetViewExtension
        }))));
const $0b5eaac4436593a5$export$8a87cc350601aff5 = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getForgeExtensionModule().then((module)=>({
            default: module.DashboardGadgetEditExtension
        }))));
const $0b5eaac4436593a5$var$useDashboardGadget = (onReportGadgetMetrics, extensionData, entryPoint)=>{
    const onInitialRender = (0, $eUqFw.useCallback)((payload)=>{
        if (payload !== undefined && payload.error == null) onReportGadgetMetrics($0b5eaac4436593a5$var$GADGET_FINISH_EVENT, 'View');
        else onReportGadgetMetrics($0b5eaac4436593a5$var$GADGET_FINISH_EVENT, 'ErrorMessage');
    }, [
        onReportGadgetMetrics
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        onReportGadgetMetrics($0b5eaac4436593a5$var$GADGET_START_EVENT, 'View');
    }, [
        onReportGadgetMetrics
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        const extraPropsUiCommon = {
            module: (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
            entryPoint: entryPoint,
            extensionData: {
                ...extensionData,
                entryPoint: entryPoint,
                type: (0, $2Rqjr.DASHBOARD_GADGET_MODULE)
            }
        };
        return {
            onInitialRender: onInitialRender,
            extraPropsUiCommon: extraPropsUiCommon
        };
    }, [
        entryPoint,
        extensionData,
        onInitialRender
    ]);
};
const $0b5eaac4436593a5$export$8f8b884c8f9b7f99 = (props)=>{
    const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
    const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $0b5eaac4436593a5$var$useDashboardGadget(onReportGadgetMetrics, extensionData);
    const extraPropsUiKit = {
        ...extraPropsUiCommon,
        onInitialRender: onInitialRender
    };
    const extraPropsCustomUi = {
        ...extraPropsUiCommon,
        onLoad: onInitialRender
    };
    if (((0, $2vJHJ.isNativeUiExtension)(props.extension) || (0, $2vJHJ.isCustomUIExtension)(props.extension)) && // https://switcheroo.atlassian.com/ui/gates/cd39682c-bc5b-4f4b-af87-f25672cfc326
    (0, $eI5EY.fg)('jira_new_ui_kit_renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$90dc543486d6f150, {
        ...restProps,
        ...extraPropsCustomUi
    });
    return (0, $2vJHJ.isCustomUIExtension)(props.extension) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$6e328a6d6807e3ef, {
        ...restProps,
        ...extraPropsCustomUi
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$d53932a75c2ba294, {
        ...restProps,
        ...extraPropsUiKit
    });
};
const $0b5eaac4436593a5$export$11802f9302dce8a3 = (props)=>{
    const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
    const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $0b5eaac4436593a5$var$useDashboardGadget(onReportGadgetMetrics, extensionData, (0, $2Rqjr.ENTRY_POINT_EDIT));
    const extraPropsUiKitEdit = {
        ...extraPropsUiCommon,
        onInitialRender: onInitialRender
    };
    const extraPropsCustomUiEdit = {
        ...extraPropsUiCommon,
        onLoad: onInitialRender
    };
    if (((0, $2vJHJ.isNativeUiExtension)(props.extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) || (0, $2vJHJ.isCustomUIExtension)(props.extension, (0, $2Rqjr.ENTRY_POINT_EDIT))) && // https://switcheroo.atlassian.com/ui/gates/cd39682c-bc5b-4f4b-af87-f25672cfc326
    (0, $eI5EY.fg)('jira_new_ui_kit_renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$8a87cc350601aff5, {
        ...restProps,
        ...extraPropsCustomUiEdit
    });
    return (0, $2vJHJ.isCustomUIExtension)(props.extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$6618f34be2146a7d, {
        ...restProps,
        ...extraPropsCustomUiEdit
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$e388a2aaf41cd524, {
        ...restProps,
        ...extraPropsUiKitEdit
    });
};

});
parcelRegister("aDcmA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("l1vWP")
]).then(()=>parcelRequire('eLTtE'));

});

parcelRegister("b1INm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bEZw0")
]).then(()=>parcelRequire('llDsp'));

});

parcelRegister("fN4iA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("5ulkh")
]).then(()=>parcelRequire('5Upee'));

});


parcelRegister("9496v", function(module, exports) {

$parcel$export(module.exports, "savePreferences", () => $eca177cb92a8b8c7$export$f1786e2fa4419c16);
$parcel$export(module.exports, "transformUserPrefsForForgeAppConsumption", () => $eca177cb92a8b8c7$export$b5d9bfce42b49862);

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $guiFP = parcelRequire("guiFP");

var $eciFw = parcelRequire("eciFw");
const $eca177cb92a8b8c7$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $eca177cb92a8b8c7$export$f1786e2fa4419c16 = async (data, preferences, setPreferences, setError, onComplete)=>{
    const { title: defaultTitle } = data;
    // the backend checks that each user pref value is valid json
    // so we need to stringify string values eg ""value""
    // this is done inside the gadget for other gadget types but
    // we need to do it here for forge
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newUserPrefs = {};
    Object.entries(preferences).forEach(([key, value])=>{
        newUserPrefs[key] = typeof value === 'string' ? JSON.stringify(value) : value;
    });
    const maybePromise = setPreferences(newUserPrefs, onComplete);
    if (!maybePromise) return;
    try {
        await maybePromise;
        setError(null);
        (0, $9lmTX.default)({
            ...$eca177cb92a8b8c7$var$expAttributes,
            wasExperienceSuccesful: true
        });
        (0, $eciFw.fireTrackEditedEvent)('dashboardGadgetEdit');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.forge', `${e.message} [${defaultTitle}]`);
        setError((0, $kEBPk.GADGET_ERROR_TYPE).CONFIG_ERROR);
        (0, $9lmTX.default)({
            ...$eca177cb92a8b8c7$var$expAttributes,
            wasExperienceSuccesful: false
        });
        (0, $guiFP.default)({
            error: e,
            meta: {
                id: (0, $kEBPk.SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
                packageName: 'jiraDashboardInternalCommon'
            }
        });
        (0, $eciFw.fireOperationalEditFailedEvent)('dashboardGadgetEdit', {
            error: e
        });
    }
};
// user prefs with a string value are encoded like "&quot;value&quot;" so we need to
// decode them for forge gadgets
const $eca177cb92a8b8c7$var$decodeQuotes = (value)=>value.replace(/(?:&quot;)/gm, '"');
const $eca177cb92a8b8c7$export$b5d9bfce42b49862 = (userPrefsFields)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedUserPrefs = {};
    if (userPrefsFields !== undefined) userPrefsFields.forEach((field)=>{
        if (field.name !== 'isConfigured') // the backend stringifies all configuration values,
        // we need to parse them here for forge gadgets
        transformedUserPrefs[field.name] = JSON.parse($eca177cb92a8b8c7$var$decodeQuotes(field.value));
    });
    return transformedUserPrefs;
};

});


parcelRegister("hBMAw", function(module, exports) {

$parcel$export(module.exports, "InlineHtml", () => $5cf2ed0011b76313$export$109427fbef437c1e);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $1cMWl = parcelRequire("1cMWl");

var $lbjCz = parcelRequire("lbjCz");

var $179bk = parcelRequire("179bk");

var $4rWxC = parcelRequire("4rWxC");
const $5cf2ed0011b76313$export$109427fbef437c1e = ({ id: id, inlineHtml: inlineHtml, isLoading: isLoading, setIsLoading: setIsLoading })=>{
    const inlineHtmlRef = (0, $eUqFw.useRef)(null);
    const [hasIntroLogo, setHasIntroLogo] = (0, $eUqFw.useState)(false);
    (0, $4rWxC.useLinkInterceptor)(inlineHtmlRef.current, isLoading);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const slotHtml = document.createRange().createContextualFragment(inlineHtml);
        if (inlineHtmlRef.current) {
            inlineHtmlRef.current.innerHTML = '';
            inlineHtmlRef.current.appendChild(slotHtml);
            const introLogoElement = inlineHtmlRef.current.querySelector('.intro-logo');
            if (introLogoElement) setHasIntroLogo(true);
        }
        setIsLoading(false);
    }, [
        inlineHtml,
        setIsLoading
    ]);
    (0, $179bk.useOnGadgetRenderEffect)(id, inlineHtmlRef.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbjCz.default), {
        name: "inline-html-gadget",
        hold: isLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: hasIntroLogo && $5cf2ed0011b76313$var$introStyles
    }, hasIntroLogo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cMWl.default), {
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: `gadget-${id}`,
        ref: inlineHtmlRef
    })));
};
const $5cf2ed0011b76313$var$introStyles = (0, $8Vv3m.xcss)({
    overflow: 'auto',
    height: '160px',
    display: 'flex',
    justifyContent: 'space-around',
    padding: 'space.200',
    gap: 'space.200'
});

});
parcelRegister("1cMWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f396f88c4fb6c77$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $9TZf5 = parcelRequire("9TZf5");

var $kzU2s = parcelRequire("kzU2s");
const $8f396f88c4fb6c77$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($kzU2s)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kzU2s))
});
var $8f396f88c4fb6c77$export$2e2bcd8739ae039 = $8f396f88c4fb6c77$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $8f396f88c4fb6c77$export$a179c88182cb9d56 = [
    0,
    0,
    431,
    406
];

});
parcelRegister("kzU2s", function(module, exports) {
module.exports = new URL("graph-go-up-with-people.4705ad58.svg", import.meta.url).toString();

});



parcelRegister("8Xm0B", function(module, exports) {

$parcel$export(module.exports, "ReactGadget", () => $109f8595095265b5$export$561f0f8350aca3ee);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $78d1w = parcelRequire("78d1w");

var $7dAFN = parcelRequire("7dAFN");

var $7G1NC = parcelRequire("7G1NC");

var $iKzwQ = parcelRequire("iKzwQ");

var $kF6iw = parcelRequire("kF6iw");

var $rEZ85 = parcelRequire("rEZ85");
const $109f8595095265b5$var$expAttributes = {
    analyticsSource: 'dashboard',
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $109f8595095265b5$export$561f0f8350aca3ee = ({ id: id, userPrefs: userPrefs, isInEditMode: isInEditMode, reactKey: reactKey, onEditModeCancel: onEditModeCancel, onRenderComplete: onRenderComplete, setDefaultTitle: setDefaultTitle, customSkeletonHeightInPx: customSkeletonHeightInPx })=>{
    const [{ currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $iKzwQ.useMessageBus)();
    const setPreferences = (0, $7G1NC.useGadgetSetPreferences)();
    const ref = (0, $eUqFw.useRef)(null);
    const isExperienceCompletedRef = (0, $eUqFw.useRef)(false);
    const { state: state, componentView: ComponentView, componentEdit: ComponentEdit, setState: setState } = (0, $rEZ85.useReactGadgetState)(id, reactKey);
    const experienceKey = `${(0, $kEBPk.VIEW_REACT_GADGET_EXPERIENCE)}-${reactKey.split('/')[1]}`; // e.g. view-react-gadget-filter-results
    const reportGadgetMetrics = (0, $eUqFw.useCallback)((eventType)=>{
        broadcastMessageBusListener((0, $kEBPk.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: isInEditMode ? 'Config' : 'View',
            source: (0, $kF6iw.REACT_GADGET_METRICS)
        }, {
            gadgetId: id,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        isInEditMode,
        id,
        currentPageId
    ]);
    const reportGadgetStart = (0, $eUqFw.useCallback)(()=>{
        reportGadgetMetrics((0, $kF6iw.GADGET_START_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    const onGadgetFinish = (0, $eUqFw.useCallback)(// this API is not ideal, but a temporary solution to allow gadget to not save height to localStorage
    (shouldPersistHeight = true)=>{
        if (shouldPersistHeight) {
            const height = ref.current?.getBoundingClientRect().height;
            onRenderComplete(height);
        }
        reportGadgetMetrics((0, $kF6iw.GADGET_RENDERING_FINISHED_EVENT));
        if (!isExperienceCompletedRef.current) {
            (0, $9lmTX.default)({
                ...$109f8595095265b5$var$expAttributes,
                experience: experienceKey,
                wasExperienceSuccesful: true
            });
            isExperienceCompletedRef.current = true;
        }
    }, [
        reportGadgetMetrics,
        onRenderComplete,
        experienceKey
    ]);
    const errorFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
            id: id,
            errorType: (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR
        }), [
        id
    ]);
    const sendFailExperience = (0, $eUqFw.useCallback)(()=>{
        if (!isExperienceCompletedRef.current) {
            (0, $9lmTX.default)({
                ...$109f8595095265b5$var$expAttributes,
                experience: experienceKey,
                wasExperienceSuccesful: false
            });
            isExperienceCompletedRef.current = true;
        }
    }, [
        experienceKey
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // gadget container mounted event
        reportGadgetMetrics((0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    const setGadgetContentTitle = (0, $eUqFw.useCallback)((contentTitle)=>{
        setDefaultTitle((initialDefaultTitle)=>contentTitle ? `${initialDefaultTitle}: ${contentTitle}` : initialDefaultTitle);
    }, [
        setDefaultTitle
    ]);
    const Component = isInEditMode ? ComponentEdit : ComponentView;
    if (state instanceof Error) {
        sendFailExperience();
        throw state;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: errorFallback,
        packageName: "jiraDashboardInternalCommon",
        id: reactKey,
        teamName: "endeavour",
        onError: sendFailExperience,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref
    }, Component && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        setPreferences: setPreferences,
        state: state,
        onGadgetStart: reportGadgetStart,
        onGadgetFinish: onGadgetFinish,
        userPrefs: userPrefs,
        onEditModeCancel: onEditModeCancel,
        setState: setState,
        setGadgetContentTitle: setGadgetContentTitle,
        customSkeletonHeightInPx: customSkeletonHeightInPx
    })));
};

});
parcelRegister("rEZ85", function(module, exports) {

$parcel$export(module.exports, "useReactGadgetState", () => $5289625847d5b5e4$export$8e5d1b52830d94a5);

var $eUqFw = parcelRequire("eUqFw");

var $iFHrw = parcelRequire("iFHrw");

var $01Qi5 = parcelRequire("01Qi5");

var $aNC1f = parcelRequire("aNC1f");
const $5289625847d5b5e4$export$8e5d1b52830d94a5 = (id, reactKey)=>{
    const { data: data, update: update, loading: loading, error: error } = (0, $01Qi5.useDashboardReactGadgetsResource)();
    const reactGadgetsState = data?.reactGadgetsState ?? null;
    const state = (()=>{
        if (reactGadgetsState != null && id in reactGadgetsState) return reactGadgetsState[id];
        if (loading) return null;
        if (reactGadgetsState == null) return error ?? new Error('Gadget resource not initialised');
        return new Error(`Gadget state not found in initialised resource for gadget with reactKey: "${reactKey}" and ID: "${id}"`);
    })();
    const { componentView: componentView, componentEdit: componentEdit } = (0, $iFHrw.default)[reactKey];
    const setState = (0, $eUqFw.useCallback)((setterOrValue)=>{
        if (reactGadgetsState && id in reactGadgetsState) update((0, $aNC1f.lensReactGadget)(id, setterOrValue));
    }, [
        update,
        reactGadgetsState,
        id
    ]);
    return {
        state: state,
        componentView: componentView,
        componentEdit: componentEdit,
        setState: setState
    };
};

});



parcelRegister("fH0Fe", function(module, exports) {

$parcel$export(module.exports, "GadgetLayoutWithAnalytics", () => $10be697bfa64aa92$export$fbd1c75042cfdd67);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");


var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $dnJL9 = parcelRequire("dnJL9");

var $8WuJm = parcelRequire("8WuJm");

var $7dAFN = parcelRequire("7dAFN");

var $1Z7MZ = parcelRequire("1Z7MZ");

var $dpbXU = parcelRequire("dpbXU");
function $10be697bfa64aa92$export$89ffb18af4090c15({ gadgetData: gadgetData, isDisplayed: isDisplayed, header: header, isContentHidden: isContentHidden, customWrapperStyles: customWrapperStyles, children: children, footer: footer, customPlaceholder: customPlaceholder }) {
    const { id: id, color: color, title: title, errorMessage: errorMessage } = gadgetData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "gadget",
        objectId: gadgetData.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "gadget",
        packageName: "jiraDashboardInternalCommon",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            isDisplayed ? $10be697bfa64aa92$var$wrapperStyles : $10be697bfa64aa92$var$gadgetNotDisplayedStyles,
            ...Array.isArray(customWrapperStyles) ? customWrapperStyles : [
                customWrapperStyles
            ],
            color && $10be697bfa64aa92$var$colorsMap[color]
        ],
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: `gadget-title-${id}`
    }, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        "aria-labelledby": `gadget-title-${id}`,
        id: `gadget-content-${id}`,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpbXU.GadgetBoundary), {
        data: gadgetData,
        isError: !title,
        errorFallback: errorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallbackBase), {
            id: id,
            message: errorMessage
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
            id: id,
            errorType: !title ? (0, $kEBPk.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR : (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR
        }),
        customPlaceholder: customPlaceholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            isContentHidden ? $10be697bfa64aa92$var$contentHiddenStyles : $10be697bfa64aa92$var$contentStylesOld
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Z7MZ.GadgetAnalyticsContainer), {
        data: gadgetData
    }, children), footer))))));
}
function $10be697bfa64aa92$export$a6ebed15ee391e49({ gadgetData: gadgetData, isDisplayed: isDisplayed, header: header, isContentHidden: isContentHidden, customWrapperStyles: customWrapperStyles, children: children, footer: footer, customPlaceholder: customPlaceholder }) {
    const { id: id, color: color, title: title, errorMessage: errorMessage } = gadgetData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "gadget",
        objectId: gadgetData.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "gadget",
        packageName: "jiraDashboardInternalCommon",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            isDisplayed ? $10be697bfa64aa92$var$wrapperStyles : $10be697bfa64aa92$var$gadgetNotDisplayedStyles,
            ...Array.isArray(customWrapperStyles) ? customWrapperStyles : [
                customWrapperStyles
            ],
            color && $10be697bfa64aa92$var$colorsMap[color]
        ],
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: `gadget-title-${id}`
    }, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        "aria-labelledby": `gadget-title-${id}`,
        id: `gadget-content-${id}`,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpbXU.GadgetBoundary), {
        data: gadgetData,
        isError: !title,
        errorFallback: errorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallbackBase), {
            id: id,
            message: errorMessage
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
            id: id,
            errorType: !title ? (0, $kEBPk.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR : (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR
        }),
        customPlaceholder: customPlaceholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            isContentHidden ? $10be697bfa64aa92$var$contentHiddenStyles : $10be697bfa64aa92$var$contentStylesNew
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Z7MZ.GadgetAnalyticsContainer), {
        data: gadgetData
    }, children), footer))))));
}
const $10be697bfa64aa92$var$wrapperStyles = (0, $8Vv3m.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderTopWidth: '4px',
    borderTopStyle: 'solid',
    borderRadius: 'border.radius.100',
    marginBottom: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-surface-raised, ${(0, $1b343b038f6c23ec$exports).N0})`,
    paddingInline: 'space.200',
    paddingBottom: 'space.200',
    position: 'relative',
    borderColor: 'color.border.brand'
});
const $10be697bfa64aa92$var$gadgetNotDisplayedStyles = (0, $8Vv3m.xcss)({
    display: 'none'
});
const $10be697bfa64aa92$var$colorsMap = Object.fromEntries(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore-next-line The borderColor value isn't a valid token
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
Object.entries((0, $kEBPk.COLOR_MAP)).map(([key, value])=>[
        key,
        (0, $8Vv3m.xcss)({
            borderColor: value
        })
    ]));
const $10be697bfa64aa92$var$contentStylesNew = (0, $8Vv3m.xcss)({
    overflowWrap: 'anywhere'
});
const $10be697bfa64aa92$var$contentStylesOld = (0, $8Vv3m.xcss)({
    overflow: 'hidden'
});
const $10be697bfa64aa92$var$contentHiddenStyles = (0, $8Vv3m.xcss)({
    display: 'none'
});
const $10be697bfa64aa92$export$fbd1c75042cfdd67 = (0, $dnJL9.componentWithFG)('endeavour_gadget_layout_style_overflow', $10be697bfa64aa92$export$a6ebed15ee391e49, $10be697bfa64aa92$export$89ffb18af4090c15);

});
parcelRegister("1Z7MZ", function(module, exports) {

$parcel$export(module.exports, "GadgetAnalyticsContainer", () => $1984d96c6049397e$export$33d5cbc3e6507749);

var $eUqFw = parcelRequire("eUqFw");

var $dYru8 = parcelRequire("dYru8");

var $QPCBp = parcelRequire("QPCBp");
const $1984d96c6049397e$export$33250e472f9e12c2 = 4840;
const $1984d96c6049397e$export$33d5cbc3e6507749 = ({ data: data, children: children })=>{
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const eventSent = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (data !== null && eventSent.current === false) {
            fireAnalytics({
                ...(0, $QPCBp.getGadgetAnalyticsProps)(data),
                action: 'viewed'
            });
            eventSent.current = true;
        }
    }, [
        data,
        fireAnalytics
    ]);
    if (!data) return null;
    if (data.renderedGadgetUrl != null && data.renderedGadgetUrl.length > $1984d96c6049397e$export$33250e472f9e12c2) {
        if (eventSent.current === false) {
            fireAnalytics({
                ...(0, $QPCBp.getGadgetAnalyticsProps)(data),
                action: 'viewedFailed'
            });
            eventSent.current = true;
        }
        throw new Error('Request header is too large');
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});
parcelRegister("QPCBp", function(module, exports) {

$parcel$export(module.exports, "getGadgetAnalyticsProps", () => $46850f109fd87be9$export$42d88d3ece4aff0);


var $iFHrw = parcelRequire("iFHrw");
const $46850f109fd87be9$export$42d88d3ece4aff0 = (data)=>{
    let gadgetType = 'UNKNOWN_GADGET';
    if (data.amdModule != null) gadgetType = data.amdModule;
    else if (data.forge != null) gadgetType = data.forge.key;
    else if ((0, $iFHrw.isReactKey)(data.reactKey)) gadgetType = data.reactKey;
    return {
        eventType: (0, $41ea3621645e2acc$export$947dac6c72b26f81),
        actionSubjectId: 'gadget',
        actionSubject: 'gadget',
        attributes: {
            gadgetTitle: data.title,
            gadgetType: gadgetType
        }
    };
};

});


parcelRegister("dpbXU", function(module, exports) {

$parcel$export(module.exports, "GadgetBoundary", () => $dc6a18a2aa7ca723$export$9327e9e817f0323d);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $1KK5n = parcelRequire("1KK5n");

var $179bk = parcelRequire("179bk");

var $7G1NC = parcelRequire("7G1NC");
const $dc6a18a2aa7ca723$export$9327e9e817f0323d = ({ data: data, errorFallback: errorFallback, customPlaceholder: customPlaceholder, isError: isError, children: children })=>{
    const { id: id } = data;
    const renderKey = (0, $7G1NC.useGadgetRenderKey)();
    const shouldRender = (0, $179bk.useShouldRenderGadget)(id);
    const renderFallback = (0, $eUqFw.useCallback)(()=>errorFallback, [
        errorFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "gadget-content",
        packageName: "jiraDashboardInternalCommon",
        fallback: renderFallback
    }, (()=>{
        if (isError) return errorFallback;
        if (customPlaceholder) return customPlaceholder;
        if (!shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), {
            customHeight: `${(0, $kEBPk.GADGET_DEFAULT_HEIGHT)}px`,
            isPulsing: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: renderKey
        }, children);
    })());
};

});


parcelRegister("kCCta", function(module, exports) {

$parcel$export(module.exports, "GadgetTitleWrapper", () => $5e6b6db2c797bdb6$export$88d654f5e42c4cf);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");
function $5e6b6db2c797bdb6$export$88d654f5e42c4cf({ isRenaming: isRenaming, children: children, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            $5e6b6db2c797bdb6$var$titleStyles,
            isRenaming && $5e6b6db2c797bdb6$var$titleRenamingStyles
        ],
        id: id
    }, children);
}
const $5e6b6db2c797bdb6$var$titleStyles = (0, $8Vv3m.xcss)({
    minHeight: "var(--ds-space-250, 20px)",
    flexGrow: 1,
    minWidth: '0',
    paddingBlock: 'space.200',
    paddingRight: 'space.100',
    wordBreak: 'break-word',
    marginRight: 'space.200'
});
const $5e6b6db2c797bdb6$var$titleRenamingStyles = (0, $8Vv3m.xcss)({
    cursor: 'text'
});

});

parcelRegister("bMzUB", function(module, exports) {

$parcel$export(module.exports, "TitleReadOnly", () => $5f0e6c5b82708ddf$export$10ece9f949c62d6e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hA2nt = parcelRequire("hA2nt");

var $jl1we = parcelRequire("jl1we");

var $fT83w = parcelRequire("fT83w");

var $lB25E = parcelRequire("lB25E");

var $bYzOG = parcelRequire("bYzOG");
const $5f0e6c5b82708ddf$var$TitleInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ title: title, titleUrl: titleUrl, forgeEnvironment: forgeEnvironment, forgeEnvironmentKey: forgeEnvironmentKey }, ref)=>{
    const displayTitle = forgeEnvironment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
        extensionEnvType: forgeEnvironment,
        extensionEnvKey: forgeEnvironmentKey,
        extensionName: title
    }) : title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hA2nt.default), {
        size: "small",
        as: "h2",
        testId: "dashboard-internal-common.ui.gadget.title-readonly.title-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f0e6c5b82708ddf$var$HeaderTextWrapper, {
        ref: ref
    }, titleUrl !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        href: titleUrl
    }, displayTitle) : displayTitle));
});
const $5f0e6c5b82708ddf$export$10ece9f949c62d6e = ({ title: title, titleUrl: titleUrl, forgeEnvironment: forgeEnvironment, forgeEnvironmentKey: forgeEnvironmentKey })=>{
    const dimensions = (0, $bYzOG.useDimensions)();
    const ref = (0, $eUqFw.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (ref.current == null) return;
        const { offsetWidth: offsetWidth, scrollWidth: scrollWidth } = ref.current;
        const shouldShowTooltip = offsetWidth < scrollWidth;
        if (showTooltip !== shouldShowTooltip) setShowTooltip(shouldShowTooltip);
    }, [
        dimensions,
        showTooltip
    ]);
    const tooltipContent = (0, $eUqFw.useMemo)(()=>{
        if (showTooltip) return forgeEnvironment ? `${title} (${forgeEnvironment})` : title;
        return null;
    }, [
        showTooltip,
        forgeEnvironment,
        title
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f0e6c5b82708ddf$var$TooltipWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f0e6c5b82708ddf$var$TitleInner, {
        title: title,
        ref: ref,
        titleUrl: titleUrl,
        forgeEnvironment: forgeEnvironment,
        forgeEnvironmentKey: forgeEnvironmentKey
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0e6c5b82708ddf$var$TooltipWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
});
const $5f0e6c5b82708ddf$var$HeaderTextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fT83w", function(module, exports) {

$parcel$export(module.exports, "ExtensionTitle", () => $3a6007e5947da50f$export$3aa4a75e461c581c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2Rqjr = parcelRequire("2Rqjr");

var $7eMp1 = parcelRequire("7eMp1");
const $3a6007e5947da50f$var$shouldShowEnv = (extensionEnvType)=>[
        (0, $2Rqjr.STAGING_ENVIRONMENT),
        (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT)
    ].includes(extensionEnvType);
const $3a6007e5947da50f$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName })=>{
    if (!$3a6007e5947da50f$var$shouldShowEnv(extensionEnvType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, extensionName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a6007e5947da50f$var$ExtensionTitleWrapper, null, (0, $7eMp1.nameWithCustomEnvironment)(extensionName, extensionEnvType, extensionEnvKey), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
        environmentType: extensionEnvType
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a6007e5947da50f$var$ExtensionTitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5VGkZ", function(module, exports) {

$parcel$export(module.exports, "GadgetToolbar", () => $d23825cfa500b2b1$export$bef5bd636ffcc29c);

var $eUqFw = parcelRequire("eUqFw");

var $kRXDJ = parcelRequire("kRXDJ");

var $hl6gT = parcelRequire("hl6gT");

var $c0Idf = parcelRequire("c0Idf");

var $aTISQ = parcelRequire("aTISQ");

var $3ipdN = parcelRequire("3ipdN");

var $2V5rS = parcelRequire("2V5rS");

var $iBeSy = parcelRequire("iBeSy");

var $jl1we = parcelRequire("jl1we");

var $5JgJ2 = parcelRequire("5JgJ2");


var $dYru8 = parcelRequire("dYru8");

var $7G1NC = parcelRequire("7G1NC");

var $fhnP2 = parcelRequire("fhnP2");
function $d23825cfa500b2b1$export$bef5bd636ffcc29c({ gadgetId: gadgetId, title: title, onMinimizeOrRestore: onMinimizeOrRestore, isMinimized: isMinimized, isMaximizable: isMaximizable, onMaximizeOrRestore: onMaximizeOrRestore, isMaximized: isMaximized, additionalToolbarItems: additionalToolbarItems }) {
    const onRefresh = (0, $7G1NC.useGadgetRefresh)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d23825cfa500b2b1$export$266a769812832828, {
        onClick: ()=>onMinimizeOrRestore(!isMinimized),
        action: "minimize-restore-button",
        tooltipMessageKey: (0, $fhnP2.default)[isMinimized ? 'expand' : 'minimize'],
        ariaLabelMessageKey: (0, $fhnP2.default)[isMinimized ? 'expandAriaLabel' : 'minimizeAriaLabel'],
        gadgetName: title,
        gadgetId: gadgetId,
        icon: isMinimized ? (0, (/*@__PURE__*/$parcel$interopDefault($aTISQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($2V5rS)))
    }), isMaximizable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d23825cfa500b2b1$export$266a769812832828, {
        onClick: ()=>onMaximizeOrRestore(!isMaximized),
        action: "maximize-restore-button",
        tooltipMessageKey: (0, $fhnP2.default)[isMaximized ? 'singleColumn' : 'maximize'],
        ariaLabelMessageKey: (0, $fhnP2.default)[isMaximized ? 'singleColumn' : 'maximizeAriaLabel'],
        gadgetId: gadgetId,
        gadgetName: title,
        icon: isMaximized ? (0, (/*@__PURE__*/$parcel$interopDefault($c0Idf))) : (0, (/*@__PURE__*/$parcel$interopDefault($hl6gT)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d23825cfa500b2b1$export$266a769812832828, {
        gadgetId: gadgetId,
        onClick: onRefresh,
        action: "refresh-button",
        tooltipMessageKey: (0, $fhnP2.default).refresh,
        ariaLabelMessageKey: (0, $fhnP2.default).refreshAriaLabel,
        gadgetName: title,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3ipdN)))
    }), additionalToolbarItems);
}
const $d23825cfa500b2b1$export$266a769812832828 = ({ gadgetId: gadgetId, onClick: onClick, action: action, tooltipMessageKey: tooltipMessageKey, ariaLabelMessageKey: ariaLabelMessageKey, gadgetName: gadgetName, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const onClickHandler = ()=>{
        fireAnalytics({
            eventType: (0, $41ea3621645e2acc$export$a1562d08625f5d7e),
            actionSubject: `gadget.${action}`,
            action: 'clicked',
            actionSubjectId: 'gadget'
        });
        onClick();
    };
    const tooltipContent = formatMessage(tooltipMessageKey);
    const ariaLabel = formatMessage(ariaLabelMessageKey, {
        gadgetName: gadgetName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
        appearance: "subtle",
        spacing: "default",
        label: ariaLabel,
        onClick: onClickHandler,
        icon: icon,
        testId: `dashboard-internal-common.ui.gadget.toolbar.${action}`,
        "aria-controls": `gadget-content-${gadgetId}`
    }));
};

});
parcelRegister("hl6gT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c924d7aa97536feacf0cc0682b2e7ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9f9433c287f2dd2$var$_react = $c9f9433c287f2dd2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c9f9433c287f2dd2$var$_fullscreenEnter = $c9f9433c287f2dd2$var$_interopRequireDefault((parcelRequire("oMKUA")));

var $c9f9433c287f2dd2$var$_vidFullScreenOn = $c9f9433c287f2dd2$var$_interopRequireDefault((parcelRequire("geljO")));
function $c9f9433c287f2dd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FullscreenEnterIcon.
 * This component is FullscreenEnterIcon, with `UNSAFE_fallbackIcon` set to "VidFullScreenOnIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9f9433c287f2dd2$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $c9f9433c287f2dd2$var$_react.default.createElement($c9f9433c287f2dd2$var$_fullscreenEnter.default, Object.assign({
        LEGACY_fallbackIcon: $c9f9433c287f2dd2$var$_vidFullScreenOn.default
    }, props));
$c9f9433c287f2dd2$var$FullscreenEnterIcon.Name = 'FullscreenEnterIconMigration';
var $c9f9433c287f2dd2$var$_default = module.exports.default = $c9f9433c287f2dd2$var$FullscreenEnterIcon;

});
parcelRegister("oMKUA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c721c617fdca0955d1ccf38be0723428>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04a80fdc20e4d02f$var$_react = $04a80fdc20e4d02f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $04a80fdc20e4d02f$var$_UNSAFE_baseNew = $04a80fdc20e4d02f$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $04a80fdc20e4d02f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04a80fdc20e4d02f$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $04a80fdc20e4d02f$var$_react.default.createElement($04a80fdc20e4d02f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 6V3c0-.69.56-1.25 1.25-1.25h3M14.25 10v3c0 .69-.56 1.25-1.25 1.25h-3m0-12.5h3c.69 0 1.25.56 1.25 1.25v3M6 14.25H3c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$04a80fdc20e4d02f$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $04a80fdc20e4d02f$var$_default = module.exports.default = $04a80fdc20e4d02f$var$FullscreenEnterIcon;

});

parcelRegister("geljO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd0e7d940b6da07f$var$_react = $bd0e7d940b6da07f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $bd0e7d940b6da07f$var$_fullscreenEnter = $bd0e7d940b6da07f$var$_interopRequireDefault((parcelRequire("oMKUA")));
function $bd0e7d940b6da07f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bd0e7d940b6da07f$var$VidFullScreenOnIcon = (props)=>/*#__PURE__*/ $bd0e7d940b6da07f$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 18h3a1 1 0 0 1 0 2H6a2 2 0 0 1-2-2v-3a1 1 0 0 1 2 0zm12 2h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2M6 4h3a1 1 0 1 1 0 2H6v3a1 1 0 1 1-2 0V6a2 2 0 0 1 2-2m12 2h-3a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z"/></svg>`
    }, props, {
        newIcon: $bd0e7d940b6da07f$var$_fullscreenEnter.default
    }));
$bd0e7d940b6da07f$var$VidFullScreenOnIcon.displayName = 'VidFullScreenOnIcon';
var $bd0e7d940b6da07f$var$_default = module.exports.default = $bd0e7d940b6da07f$var$VidFullScreenOnIcon;

});


parcelRegister("c0Idf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e159e576acb01648bbd8ed46b8160907>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8be7c7d1d9ff979d$var$_react = $8be7c7d1d9ff979d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8be7c7d1d9ff979d$var$_fullscreenExit = $8be7c7d1d9ff979d$var$_interopRequireDefault((parcelRequire("20Z0z")));

var $8be7c7d1d9ff979d$var$_fullScreen = $8be7c7d1d9ff979d$var$_interopRequireDefault((parcelRequire("5UL5j")));
function $8be7c7d1d9ff979d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FullscreenExitIcon.
 * This component is FullscreenExitIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFullScreenIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for return screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8be7c7d1d9ff979d$var$FullscreenExitIcon = (props)=>/*#__PURE__*/ $8be7c7d1d9ff979d$var$_react.default.createElement($8be7c7d1d9ff979d$var$_fullscreenExit.default, Object.assign({
        LEGACY_fallbackIcon: $8be7c7d1d9ff979d$var$_fullScreen.default
    }, props));
$8be7c7d1d9ff979d$var$FullscreenExitIcon.Name = 'FullscreenExitIconMigration';
var $8be7c7d1d9ff979d$var$_default = module.exports.default = $8be7c7d1d9ff979d$var$FullscreenExitIcon;

});
parcelRegister("20Z0z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::65fe63e1d54b02ee7495bc54d9d6933b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $177ae7d5a33fcaf5$var$_react = $177ae7d5a33fcaf5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $177ae7d5a33fcaf5$var$_UNSAFE_baseNew = $177ae7d5a33fcaf5$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $177ae7d5a33fcaf5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FullscreenExit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for return screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $177ae7d5a33fcaf5$var$FullscreenExitIcon = (props)=>/*#__PURE__*/ $177ae7d5a33fcaf5$var$_react.default.createElement($177ae7d5a33fcaf5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.25 1v3c0 .69-.56 1.25-1.25 1.25H1M10.75 15v-3c0-.69.56-1.25 1.25-1.25h3m0-5.5h-3c-.69 0-1.25-.56-1.25-1.25V1M1 10.75h3c.69 0 1.25.56 1.25 1.25v3"/>`
    }, props));
$177ae7d5a33fcaf5$var$FullscreenExitIcon.displayName = 'FullscreenExitIcon';
var $177ae7d5a33fcaf5$var$_default = module.exports.default = $177ae7d5a33fcaf5$var$FullscreenExitIcon;

});

parcelRegister("5UL5j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44e6b4c1d171cd0e$var$_react = $44e6b4c1d171cd0e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $44e6b4c1d171cd0e$var$_fullscreenExit = $44e6b4c1d171cd0e$var$_interopRequireDefault((parcelRequire("20Z0z")));
function $44e6b4c1d171cd0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $44e6b4c1d171cd0e$var$MediaServicesFullScreenIcon = (props)=>/*#__PURE__*/ $44e6b4c1d171cd0e$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 8h3a1 1 0 0 1 0 2h-3a2 2 0 0 1-2-2V5a1 1 0 0 1 2 0zm-8 2H5a1 1 0 1 1 0-2h3V5a1 1 0 1 1 2 0v3a2 2 0 0 1-2 2m8 4h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3a2 2 0 0 1 2-2m-8 2H5a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z"/></svg>`
    }, props, {
        newIcon: $44e6b4c1d171cd0e$var$_fullscreenExit.default
    }));
$44e6b4c1d171cd0e$var$MediaServicesFullScreenIcon.displayName = 'MediaServicesFullScreenIcon';
var $44e6b4c1d171cd0e$var$_default = module.exports.default = $44e6b4c1d171cd0e$var$MediaServicesFullScreenIcon;

});


parcelRegister("aTISQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a044223350e041031a35374685e9a4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ef1db5fdde15ff3$var$_react = $7ef1db5fdde15ff3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7ef1db5fdde15ff3$var$_growDiagonal = $7ef1db5fdde15ff3$var$_interopRequireDefault((parcelRequire("a1wP0")));

var $7ef1db5fdde15ff3$var$_actualSize = $7ef1db5fdde15ff3$var$_interopRequireDefault((parcelRequire("a8yyp")));
function $7ef1db5fdde15ff3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ef1db5fdde15ff3$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $7ef1db5fdde15ff3$var$_react.default.createElement($7ef1db5fdde15ff3$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $7ef1db5fdde15ff3$var$_actualSize.default
    }, props));
$7ef1db5fdde15ff3$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $7ef1db5fdde15ff3$var$_default = module.exports.default = $7ef1db5fdde15ff3$var$GrowDiagonalIcon;

});
parcelRegister("a1wP0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f990ef7feacad13ce09338893186ed73>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74c375149b138e1b$var$_react = $74c375149b138e1b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $74c375149b138e1b$var$_UNSAFE_baseNew = $74c375149b138e1b$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $74c375149b138e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74c375149b138e1b$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $74c375149b138e1b$var$_react.default.createElement($74c375149b138e1b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
    }, props));
$74c375149b138e1b$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $74c375149b138e1b$var$_default = module.exports.default = $74c375149b138e1b$var$GrowDiagonalIcon;

});

parcelRegister("a8yyp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76157476a4ea3fa7$var$_react = $76157476a4ea3fa7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $76157476a4ea3fa7$var$_growDiagonal = $76157476a4ea3fa7$var$_interopRequireDefault((parcelRequire("a1wP0")));
function $76157476a4ea3fa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $76157476a4ea3fa7$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $76157476a4ea3fa7$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $76157476a4ea3fa7$var$_growDiagonal.default
    }));
$76157476a4ea3fa7$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $76157476a4ea3fa7$var$_default = module.exports.default = $76157476a4ea3fa7$var$MediaServicesActualSizeIcon;

});


parcelRegister("3ipdN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e77e094a0aa1d7ca1d4c9b1f496feee5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26669e0642da4dde$var$_react = $26669e0642da4dde$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26669e0642da4dde$var$_refresh = $26669e0642da4dde$var$_interopRequireDefault((parcelRequire("11PZK")));

var $26669e0642da4dde$var$_refresh2 = $26669e0642da4dde$var$_interopRequireDefault((parcelRequire("6MHi8")));
function $26669e0642da4dde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26669e0642da4dde$var$RefreshIcon = (props)=>/*#__PURE__*/ $26669e0642da4dde$var$_react.default.createElement($26669e0642da4dde$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $26669e0642da4dde$var$_refresh2.default
    }, props));
$26669e0642da4dde$var$RefreshIcon.Name = 'RefreshIconMigration';
var $26669e0642da4dde$var$_default = module.exports.default = $26669e0642da4dde$var$RefreshIcon;

});
parcelRegister("11PZK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bfe378c6b5d90c8$var$_react = $0bfe378c6b5d90c8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0bfe378c6b5d90c8$var$_UNSAFE_baseNew = $0bfe378c6b5d90c8$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $0bfe378c6b5d90c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0bfe378c6b5d90c8$var$RefreshIcon = (props)=>/*#__PURE__*/ $0bfe378c6b5d90c8$var$_react.default.createElement($0bfe378c6b5d90c8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$0bfe378c6b5d90c8$var$RefreshIcon.displayName = 'RefreshIcon';
var $0bfe378c6b5d90c8$var$_default = module.exports.default = $0bfe378c6b5d90c8$var$RefreshIcon;

});

parcelRegister("6MHi8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f08ce899a518e5a$var$_react = $4f08ce899a518e5a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $4f08ce899a518e5a$var$_refresh = $4f08ce899a518e5a$var$_interopRequireDefault((parcelRequire("11PZK")));
function $4f08ce899a518e5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f08ce899a518e5a$var$RefreshIcon = (props)=>/*#__PURE__*/ $4f08ce899a518e5a$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $4f08ce899a518e5a$var$_refresh.default
    }));
$4f08ce899a518e5a$var$RefreshIcon.displayName = 'RefreshIcon';
var $4f08ce899a518e5a$var$_default = module.exports.default = $4f08ce899a518e5a$var$RefreshIcon;

});


parcelRegister("2V5rS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b2e8bb6e01e7e0a7a6c4696ef5279cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22052199be756b7d$var$_react = $22052199be756b7d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $22052199be756b7d$var$_shrinkDiagonal = $22052199be756b7d$var$_interopRequireDefault((parcelRequire("aYUun")));

var $22052199be756b7d$var$_fitToPage = $22052199be756b7d$var$_interopRequireDefault((parcelRequire("kGxU5")));
function $22052199be756b7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22052199be756b7d$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $22052199be756b7d$var$_react.default.createElement($22052199be756b7d$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $22052199be756b7d$var$_fitToPage.default
    }, props));
$22052199be756b7d$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $22052199be756b7d$var$_default = module.exports.default = $22052199be756b7d$var$ShrinkDiagonalIcon;

});
parcelRegister("aYUun", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::093b1e9b17ed5e0dd45627fbe3b0508b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7feb53864f441b05$var$_react = $7feb53864f441b05$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7feb53864f441b05$var$_UNSAFE_baseNew = $7feb53864f441b05$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $7feb53864f441b05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7feb53864f441b05$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $7feb53864f441b05$var$_react.default.createElement($7feb53864f441b05$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
    }, props));
$7feb53864f441b05$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $7feb53864f441b05$var$_default = module.exports.default = $7feb53864f441b05$var$ShrinkDiagonalIcon;

});

parcelRegister("kGxU5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0f2076e74ce3988$var$_react = $f0f2076e74ce3988$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $f0f2076e74ce3988$var$_shrinkDiagonal = $f0f2076e74ce3988$var$_interopRequireDefault((parcelRequire("aYUun")));
function $f0f2076e74ce3988$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f0f2076e74ce3988$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $f0f2076e74ce3988$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $f0f2076e74ce3988$var$_shrinkDiagonal.default
    }));
$f0f2076e74ce3988$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $f0f2076e74ce3988$var$_default = module.exports.default = $f0f2076e74ce3988$var$MediaServicesFitToPageIcon;

});


parcelRegister("fhnP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f70a30dd662264e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f70a30dd662264e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    minimize: {
        "id": "dashboard-internal-common.gadget.toolbar.minimize",
        "defaultMessage": "Minimize"
    },
    minimizeAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.minimize-aria-label",
        "defaultMessage": "Minimize {gadgetName}"
    },
    expand: {
        "id": "dashboard-internal-common.gadget.toolbar.expand",
        "defaultMessage": "Expand"
    },
    expandAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.expand-aria-label",
        "defaultMessage": "Expand {gadgetName}"
    },
    maximize: {
        "id": "dashboard-internal-common.gadget.toolbar.maximize",
        "defaultMessage": "Maximize"
    },
    maximizeAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.maximize-aria-label",
        "defaultMessage": "Maximize {gadgetName}"
    },
    refresh: {
        "id": "dashboard-internal-common.gadget.toolbar.refresh",
        "defaultMessage": "Refresh"
    },
    refreshAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.refresh-aria-label",
        "defaultMessage": "Refresh {gadgetName}"
    },
    singleColumn: {
        "id": "dashboard-internal-common.gadget.toolbar.single-column",
        "defaultMessage": "Single column"
    }
});

});


parcelRegister("5IxAc", function(module, exports) {

$parcel$export(module.exports, "LastRefreshed", () => $5d216c870d120ae1$export$66aab1cf9cd737cc);

var $eUqFw = parcelRequire("eUqFw");

var $6MHi8 = parcelRequire("6MHi8");

var $iBeSy = parcelRequire("iBeSy");
var $1JJay = parcelRequire("1JJay");
var $8Vv3m = parcelRequire("8Vv3m");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8K9kM = parcelRequire("8K9kM");

var $gd0Sp = parcelRequire("gd0Sp");

var $eqEfz = parcelRequire("eqEfz");
const $5d216c870d120ae1$export$66aab1cf9cd737cc = ({ lastRefreshed: lastRefreshed, updateInterval: updateInterval })=>{
    const [lastRefreshedTimeAgo, setLastRefreshedTimeAgo] = (0, $eUqFw.useState)('');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { locale: locale } = (0, $gd0Sp.useTenantContext)();
    (0, $eUqFw.useEffect)(()=>{
        setLastRefreshedTimeAgo(formatMessage((0, $eqEfz.default).justNow));
        const refreshInterval = setInterval(()=>lastRefreshed != null && setLastRefreshedTimeAgo(formatMessage((0, $eqEfz.default).timeAgo, {
                timeAgo: (0, $8K9kM.formatDistanceStrictWithLocale)(lastRefreshed, new Date(), locale)
            })), updateInterval);
        return ()=>clearInterval(refreshInterval);
    }, [
        formatMessage,
        lastRefreshed,
        locale,
        updateInterval
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
        direction: "row",
        alignItems: "center",
        xcss: $5d216c870d120ae1$var$lastRefreshedWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6MHi8))), {
        size: "small",
        label: formatMessage((0, $eqEfz.default).lastRefreshedIcon)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        size: "UNSAFE_small",
        color: "color.text.subtle"
    }, lastRefreshedTimeAgo));
};
const $5d216c870d120ae1$var$lastRefreshedWrapperStyles = (0, $8Vv3m.xcss)({
    paddingTop: 'space.200',
    color: 'color.text.subtle',
    gap: 'space.050'
});

});
parcelRegister("eqEfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c18d063e0c09f948$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c18d063e0c09f948$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    justNow: {
        "id": "dashboard-internal-common.last-refreshed.just-now",
        "defaultMessage": "Just now"
    },
    timeAgo: {
        "id": "dashboard-internal-common.last-refreshed.time-ago",
        "defaultMessage": "{timeAgo} ago"
    },
    lastRefreshedIcon: {
        "id": "dashboard-internal-common.last-refreshed.last-refreshed-icon",
        "defaultMessage": "Last refreshed"
    }
});

});


parcelRegister("5H4uC", function(module, exports) {

$parcel$export(module.exports, "useEcosystemRefresh", () => $616bd816ac62015a$export$a96edb2d9dc3e9bf);

var $eUqFw = parcelRequire("eUqFw");

var $6ci8W = parcelRequire("6ci8W");

var $kEBPk = parcelRequire("kEBPk");
const $616bd816ac62015a$export$1da99641cec7fdf3 = (payload, id)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.connectHost?.broadcastEvent((0, $kEBPk.CONNECT_GADGET_REFRESH_REQUEST_EVENT), {
        id: id
    }, payload);
const $616bd816ac62015a$export$a96edb2d9dc3e9bf = ({ id: id, connect: connect, forge: forge })=>{
    const isConnect = Boolean(connect?.addonKey);
    const isForge = Boolean(forge?.key);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const ecosystemOnRefresh = (0, $eUqFw.useCallback)(()=>{
        const payload = {
            origin: 'gadget',
            gadgetId: id
        };
        if (isConnect) $616bd816ac62015a$export$1da99641cec7fdf3(payload, wrapperRef.current?.querySelector('iframe')?.id);
        else if (isForge) (0, $6ci8W.emit)((0, $kEBPk.FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), payload);
    }, [
        id,
        isConnect,
        isForge
    ]);
    return {
        wrapperRef: wrapperRef,
        onRefresh: isConnect || isForge ? ecosystemOnRefresh : undefined
    };
};

});

parcelRegister("hx4rB", function(module, exports) {

$parcel$export(module.exports, "useGadgetEditableController", () => $1c0b7d08945f82af$export$bcc758b734cee1d1);

var $eUqFw = parcelRequire("eUqFw");

var $5RHEV = parcelRequire("5RHEV");

var $12Fqt = parcelRequire("12Fqt");

var $aNC1f = parcelRequire("aNC1f");

var $f9MgH = parcelRequire("f9MgH");

var $01Qi5 = parcelRequire("01Qi5");
const $1c0b7d08945f82af$export$bcc758b734cee1d1 = ({ id: id, title: defaultTitle, customisedTitle: customisedTitle, configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs, amdModule: amdModule, reactKey: reactKey, isRenamable: isRenamable, isConnectDisabled: isConnectDisabled, saveTitle: saveTitle, userPreferencesAction: userPreferencesAction, userPreferencesService: userPreferencesService, instrumentation: instrumentation })=>{
    const { put: userPreferencesServicePut, refresh: userPreferencesServiceRefresh } = userPreferencesService;
    const { isConfigurable: isEditModeEnabled, isUnconfigured: isUnconfigured } = (0, $5RHEV.useConfigurationStatus)({
        configurable: configurable,
        hasNonHiddenUserPrefs: hasNonHiddenUserPrefs,
        renderedGadgetUrl: renderedGadgetUrl,
        userPrefs: userPrefs
    });
    const [isInEditMode, setIsInEditMode] = (0, $eUqFw.useState)(isEditModeEnabled && isUnconfigured);
    const isEditButtonDisabled = isInEditMode && !(0, $12Fqt.isConnectGadget)({
        amdModule: amdModule
    });
    const onEditModeTrigger = (0, $eUqFw.useCallback)(()=>{
        instrumentation?.onEditModeEnter?.();
        setIsInEditMode(true);
    }, [
        setIsInEditMode,
        instrumentation
    ]);
    const onEditModeCancel = (0, $eUqFw.useCallback)(()=>setIsInEditMode(false), [
        setIsInEditMode
    ]);
    const [isRenaming, setIsRenaming] = (0, $eUqFw.useState)(false);
    const onRenameSave = (0, $eUqFw.useCallback)(async (newTitle)=>{
        if (isRenamable) await saveTitle(newTitle);
        setIsRenaming(false);
    }, [
        isRenamable,
        saveTitle
    ]);
    const { title: title, setDefaultTitle: setDefaultTitle, setTitle: setTitle } = (0, $f9MgH.useGadgetTitle)({
        defaultTitle: defaultTitle,
        title: customisedTitle,
        onSave: onRenameSave
    });
    const onRenameTrigger = (0, $eUqFw.useCallback)(()=>{
        setIsRenaming(true);
    }, [
        setIsRenaming
    ]);
    const onRenameCancel = (0, $eUqFw.useCallback)(()=>{
        setIsRenaming(false);
    }, [
        setIsRenaming
    ]);
    const { update: update } = (0, $01Qi5.useDashboardReactGadgetsResource)();
    const setPreferences = (0, $eUqFw.useCallback)((preferences, onUpdate)=>{
        if (userPreferencesAction == null) throw new Error('gadget attempted to save preference without existing preferences');
        const maybePromise = userPreferencesServicePut(userPreferencesAction, preferences);
        if (!maybePromise) return null;
        return (async ()=>{
            try {
                await maybePromise;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                throw new Error(`failed to put gadget preference: ${e.message}`);
            }
            if (reactKey) // refresh react gadget
            update((0, $aNC1f.lensReactGadget)(id, null));
            const userPrefsFromService = await userPreferencesServiceRefresh(userPreferencesAction, onUpdate);
            if (userPrefsFromService == null) throw new Error('failed to get preferences after put preferences');
        })();
    }, [
        userPreferencesAction,
        userPreferencesServicePut,
        userPreferencesServiceRefresh,
        update,
        id,
        reactKey
    ]);
    return {
        isUnconfigured: isUnconfigured,
        isEditModeEnabled: isEditModeEnabled,
        isEditButtonDisabled: isEditButtonDisabled,
        isInEditMode: isInEditMode,
        isConnectDisabled: isConnectDisabled,
        onEditModeTrigger: onEditModeTrigger,
        onEditModeCancel: onEditModeCancel,
        title: title,
        isRenaming: isRenaming,
        setDefaultTitle: setDefaultTitle,
        onRenameTrigger: onRenameTrigger,
        onRenameSave: setTitle,
        onRenameCancel: onRenameCancel,
        setPreferences: setPreferences
    };
};

});
parcelRegister("5RHEV", function(module, exports) {

$parcel$export(module.exports, "useConfigurationStatus", () => $6ef60b3a4371683b$export$416bc2c29f65a3f8);

var $eUqFw = parcelRequire("eUqFw");

var $9hXa4 = parcelRequire("9hXa4");
const $6ef60b3a4371683b$export$416bc2c29f65a3f8 = ({ configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs })=>{
    const isConfigurable = Boolean(configurable || hasNonHiddenUserPrefs || renderedGadgetUrl);
    const isUnconfigured = (0, $eUqFw.useMemo)(()=>isConfigurable && !(0, $9hXa4.isGadgetConfigured)(userPrefs), [
        isConfigurable,
        userPrefs
    ]);
    return {
        isConfigurable: isConfigurable,
        isUnconfigured: isUnconfigured
    };
};

});


parcelRegister("fkagI", function(module, exports) {

$parcel$export(module.exports, "useDeleteGadget", () => $856be3141cfe617f$export$fddaf21479a00190);

var $eUqFw = parcelRequire("eUqFw");

var $6QUMT = parcelRequire("6QUMT");

var $gjx45 = parcelRequire("gjx45");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $01Qi5 = parcelRequire("01Qi5");

var $4bfJ0 = parcelRequire("4bfJ0");
const $856be3141cfe617f$var$deleteSuccessFlag = (name)=>({
        type: 'success',
        title: (0, $4bfJ0.messages).successTitle,
        description: [
            (0, $4bfJ0.messages).successDescription,
            {
                name: name
            }
        ],
        isAutoDismiss: false,
        delayAnnouncement: 1500
    });
const $856be3141cfe617f$var$deleteFailureFlag = {
    type: 'error',
    title: (0, $4bfJ0.messages).failureTitle,
    description: (0, $4bfJ0.messages).failureDescription,
    isAutoDismiss: false,
    delayAnnouncement: 1500
};
const $856be3141cfe617f$export$fddaf21479a00190 = (id, name)=>{
    const { data: data, update: update } = (0, $01Qi5.useDashboardResource)();
    const [, { remove: remove }] = (0, $6QUMT.useGadgetAdditionalStateActions)();
    const flagService = (0, $k8Qyf.useFlagService)();
    return (0, $eUqFw.useCallback)(async ()=>{
        if (!data) return;
        const gadgetUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}`;
        try {
            await (0, $lRmyA.performDeleteRequest)(gadgetUrl);
            update((0, $gjx45.lensGadgetsList)((gadgets)=>gadgets.filter((element)=>element.id !== id)));
            remove(id);
            flagService.showFlag($856be3141cfe617f$var$deleteSuccessFlag(name));
        } catch (_) {
            flagService.showFlag($856be3141cfe617f$var$deleteFailureFlag);
        }
    }, [
        data,
        id,
        update,
        remove,
        flagService,
        name
    ]);
};

});
parcelRegister("4bfJ0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $175fbac182c0069b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $175fbac182c0069b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    successTitle: {
        "id": "dashboard-edit.services.success-title",
        "defaultMessage": "Gadget has been removed"
    },
    successDescription: {
        "id": "dashboard-edit.services.success-description",
        "defaultMessage": "You've successfully removed the \"{name}\" gadget."
    },
    failureTitle: {
        "id": "dashboard-edit.services.failure-title",
        "defaultMessage": "We couldn't delete the gadget"
    },
    failureDescription: {
        "id": "dashboard-edit.services.failure-description",
        "defaultMessage": "Give it a couple of minutes, then try again."
    }
});

});


parcelRegister("hea51", function(module, exports) {

$parcel$export(module.exports, "useDuplicateGadget", () => $28c89d5556a22b67$export$f1865177002d12dd);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");

var $kEBPk = parcelRequire("kEBPk");

var $b32xd = parcelRequire("b32xd");

var $lIqKj = parcelRequire("lIqKj");

var $gjx45 = parcelRequire("gjx45");

var $gNJNY = parcelRequire("gNJNY");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $01Qi5 = parcelRequire("01Qi5");

var $ePdsY = parcelRequire("ePdsY");

var $5AGXO = parcelRequire("5AGXO");

var $lSj46 = parcelRequire("lSj46");
const $28c89d5556a22b67$export$6fb6758aa812bdfb = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.DUPLICATE_GADGET_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $28c89d5556a22b67$var$errorFlagAttributes = {
    key: (0, $eo17r.toFlagId)('gadgetDuplicateError'),
    type: 'error',
    title: (0, $lSj46.default).errorFlagTitle,
    description: (0, $lSj46.default).errorFlagDescription,
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    actions: [
        {
            content: (0, $lSj46.default).errorFlagAction,
            onClick: ()=>window.location.reload()
        }
    ]
};
const $28c89d5556a22b67$var$successFlagAttributes = (name)=>({
        key: (0, $eo17r.toFlagId)('gadgetDuplicateSuccess'),
        type: 'success',
        title: (0, $lSj46.default).successFlagTitle,
        description: [
            (0, $lSj46.default).successFlagDescription,
            {
                name: name
            }
        ]
    });
const $28c89d5556a22b67$export$f1865177002d12dd = (id)=>{
    const { data: data, update: update } = (0, $01Qi5.useDashboardResource)();
    const { canAddGadgetWithinLimit: canAddGadgetWithinLimit, showGadgetLimitFlag: showGadgetLimitFlag } = (0, $5AGXO.useAddGadgetWithinLimit)((0, $ePdsY.MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS), (0, $ePdsY.MAX_ALLOWED_GADGETS_COUNT));
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const onBeforeGadgetAdded = (0, $lIqKj.useOnAddedGadget)();
    return (0, $eUqFw.useCallback)(async ()=>{
        if (!data) return;
        const originalGadget = data.gadgets.find((gadget)=>gadget.id === id);
        if (!originalGadget) {
            showFlag($28c89d5556a22b67$var$errorFlagAttributes);
            return;
        }
        const isGadgetIgnored = !!originalGadget?.amdModule && Object.values((0, $ePdsY.IGNORED_GADGETS_FROM_COUNT_MAP)).includes(originalGadget.amdModule);
        if (!canAddGadgetWithinLimit(data.gadgets, isGadgetIgnored)) {
            showGadgetLimitFlag();
            return;
        }
        const duplicateGadgetUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/duplicate`;
        (0, $lRmyA.performPostRequest)(duplicateGadgetUrl).then((gadgetData)=>{
            onBeforeGadgetAdded(gadgetData.id);
            update((0, $gjx45.lensGadgetsList)((gadgets)=>[
                    ...(0, $b32xd.mapToReactGadgets)([
                        gadgetData
                    ]),
                    ...gadgets
                ]));
            showFlag($28c89d5556a22b67$var$successFlagAttributes(originalGadget.title));
            (0, $9lmTX.default)({
                ...$28c89d5556a22b67$export$6fb6758aa812bdfb,
                wasExperienceSuccesful: true
            });
        }).catch((error)=>{
            showFlag($28c89d5556a22b67$var$errorFlagAttributes);
            (0, $gNJNY.handleFetchErrorAsExperience)({
                error: error,
                sendSuccessExperience: ()=>{
                    (0, $9lmTX.default)({
                        ...$28c89d5556a22b67$export$6fb6758aa812bdfb,
                        wasExperienceSuccesful: true
                    });
                },
                sendFailedExperience: ()=>{
                    (0, $9lmTX.default)({
                        ...$28c89d5556a22b67$export$6fb6758aa812bdfb,
                        wasExperienceSuccesful: false
                    });
                },
                logErrorEvent: (reason)=>{
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: (0, $kEBPk.DUPLICATE_GADGET_EXPERIENCE),
                            packageName: (0, $ePdsY.PACKAGE_NAME)
                        },
                        attributes: {
                            reason: reason,
                            endpoint: 'duplicateGadget'
                        }
                    });
                }
            });
        });
    }, [
        data,
        canAddGadgetWithinLimit,
        id,
        showFlag,
        showGadgetLimitFlag,
        onBeforeGadgetAdded,
        update
    ]);
};

});
parcelRegister("gNJNY", function(module, exports) {

$parcel$export(module.exports, "handleFetchErrorAsExperience", () => $daf69c61aef3b9ba$export$8b2399c5090eddc3);

var $7byHA = parcelRequire("7byHA");

var $JRB5w = parcelRequire("JRB5w");
const $daf69c61aef3b9ba$export$65e55894e6e38a89 = 'client network error';
const $daf69c61aef3b9ba$export$796b9e0e5da90309 = 'unauthenticated (401)';
const $daf69c61aef3b9ba$export$8b2399c5090eddc3 = ({ error: error, sendSuccessExperience: sendSuccessExperience, sendFailedExperience: sendFailedExperience, logErrorEvent: logErrorEvent })=>{
    if ((0, $JRB5w.isClientFetchError)(error)) {
        sendSuccessExperience();
        logErrorEvent($daf69c61aef3b9ba$export$65e55894e6e38a89);
    } else if (error instanceof (0, $7byHA.default) && error.constructor === (0, $7byHA.default)) {
        const errorCode = Number(error.message.substring(error.message.length - 3));
        if (errorCode === 304) // 304 response cached
        sendSuccessExperience();
        else if (errorCode === 401) // 401 user unauthenticated, neither success nor fail
        logErrorEvent($daf69c61aef3b9ba$export$796b9e0e5da90309);
        else {
            sendFailedExperience();
            logErrorEvent(`${errorCode} status code response`);
        }
    } else {
        // in the case of Error, SyntaxError and ValidationError(400);
        sendFailedExperience();
        logErrorEvent();
    }
};

});

parcelRegister("ePdsY", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $9d8858082222eaef$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "MAX_ALLOWED_GADGETS_COUNT", () => $9d8858082222eaef$export$e11360046219e002);
$parcel$export(module.exports, "MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS", () => $9d8858082222eaef$export$2ea683536c2351db);
$parcel$export(module.exports, "IGNORED_GADGETS_FROM_COUNT_MAP", () => $9d8858082222eaef$export$7f4c0fee173151d3);
const $9d8858082222eaef$export$b8b9d90f9e5bd72b = 'jiraDashboardEdit';
const $9d8858082222eaef$export$93b482f0f653203d = [
    {
        pattern: /React does not recognize/,
        ignoredBecause: 'Warning from `createAnalyticsEvent` prop being forwarded to Atlaskit DropdownMenu.',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /The above error occurred in the (.+?) component/,
        ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /jira.frontend.common.error-boundary/,
        ignoredBecause: 'Unhandled error caught by error boundary',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /jira.frontend.experience-tracker.missing-provider/,
        ignoredBecause: 'Unhandled error caught by error boundary',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /Failed to load resource: the server responded with a status of 404/,
        ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /rest\/internal\/2\/log\/safe\/error/,
        ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /Encountered two children with the same key/,
        ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /Unrecognised gadget type/,
        ignoredBecause: 'exception thrown: Unrecognised gadget type',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /FetchError: Error server response/,
        ignoredBecause: 'exception thrown: Error server response',
        jiraIssueId: 'DAG-688'
    }
];
const $9d8858082222eaef$export$e11360046219e002 = 20;
const $9d8858082222eaef$export$2ea683536c2351db = 50;
const $9d8858082222eaef$export$7f4c0fee173151d3 = {
    'rest/gadgets/1.0/g/com.atlassian.jira.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml': 'jira-dashboard-items/spacer'
};

});

parcelRegister("5AGXO", function(module, exports) {

$parcel$export(module.exports, "useAddGadgetWithinLimit", () => $9117d2952bb3d5aa$export$c536a8bb380238f8);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $ePdsY = parcelRequire("ePdsY");

var $3SWdF = parcelRequire("3SWdF");
const $9117d2952bb3d5aa$export$b9cafb79af2372cd = {
    key: (0, $eo17r.toFlagId)('gadgetAddWithinLimitError'),
    type: 'error',
    title: (0, $3SWdF.default).gadgetLimitFlagTitle,
    description: (0, $3SWdF.default).gadgetLimitFlagDescription
};
const $9117d2952bb3d5aa$export$c536a8bb380238f8 = (limitIncludeIgnoredGadgets, limitExcludeIgnoredGadgets)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const canAddGadgetWithinLimit = (0, $eUqFw.useCallback)((gadgets, isGadgetIgnored)=>isGadgetIgnored ? gadgets.length < limitIncludeIgnoredGadgets : gadgets.length < limitIncludeIgnoredGadgets && gadgets.filter((e)=>typeof e.amdModule !== 'undefined' ? !Object.values((0, $ePdsY.IGNORED_GADGETS_FROM_COUNT_MAP)).includes(e.amdModule) : true).length < limitExcludeIgnoredGadgets, [
        limitIncludeIgnoredGadgets,
        limitExcludeIgnoredGadgets
    ]);
    const showGadgetLimitFlag = (0, $eUqFw.useCallback)(()=>{
        showFlag($9117d2952bb3d5aa$export$b9cafb79af2372cd);
    }, [
        showFlag
    ]);
    return {
        canAddGadgetWithinLimit: canAddGadgetWithinLimit,
        showGadgetLimitFlag: showGadgetLimitFlag
    };
};

});
parcelRegister("3SWdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5ba2d1816f14e26$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e5ba2d1816f14e26$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    gadgetLimitFlagTitle: {
        "id": "dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-title",
        "defaultMessage": "Error."
    },
    gadgetLimitFlagDescription: {
        "id": "dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-description",
        "defaultMessage": "Sorry, you have exceeded the maximum number of gadgets supported by your dashboard.  You must remove some gadgets before proceeding."
    }
});

});


parcelRegister("lSj46", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9f871a13d2690eb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e9f871a13d2690eb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "dashboard-edit.services.duplicate-gadget.error-flag-title",
        "defaultMessage": "Error"
    },
    errorFlagDescription: {
        "id": "dashboard-edit.services.duplicate-gadget.error-flag-description",
        "defaultMessage": "We cannot duplicate that gadget at the moment"
    },
    errorFlagAction: {
        "id": "dashboard-edit.services.duplicate-gadget.error-flag-action",
        "defaultMessage": "Refresh"
    },
    successFlagTitle: {
        "id": "dashboard-edit.services.duplicate-gadget.success-flag-title",
        "defaultMessage": "Gadget has been duplicated"
    },
    successFlagDescription: {
        "id": "dashboard-edit.services.duplicate-gadget.success-flag-description",
        "defaultMessage": "You've successfully duplicated the \"{name}\" gadget."
    }
});

});


parcelRegister("jVjSy", function(module, exports) {

$parcel$export(module.exports, "useSaveCustomGadgetTitleById", () => $b1b5bd80e9727410$export$4156ac3cf466d45d);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $gjx45 = parcelRequire("gjx45");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $01Qi5 = parcelRequire("01Qi5");
const $b1b5bd80e9727410$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.SAVE_CUSTOM_GADGET_TITLE_PREFERENCES),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $b1b5bd80e9727410$export$5b8abdff51d766d5 = ()=>{
    const { data: data, update: update } = (0, $01Qi5.useDashboardResource)();
    return (0, $eUqFw.useCallback)(async (id, title)=>{
        const gadget = data?.gadgets.find((g)=>g.id === id);
        if (!gadget || title === gadget.customisedTitle || !data) return;
        const changeTitleUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/title`;
        try {
            await (0, $lRmyA.performPutRequest)(changeTitleUrl, {
                body: JSON.stringify({
                    title: title
                })
            });
            update((0, $gjx45.lensGadget)(id, {
                customisedTitle: title
            }));
            (0, $9lmTX.default)({
                ...$b1b5bd80e9727410$var$expAttributes,
                wasExperienceSuccesful: true
            });
            (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard', 'Set gadget title');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9lmTX.default)({
                ...$b1b5bd80e9727410$var$expAttributes,
                wasExperienceSuccesful: false
            });
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: (0, $kEBPk.SAVE_CUSTOM_GADGET_TITLE_PREFERENCES),
                    packageName: 'jiraDashboardEdit'
                }
            });
            throw error;
        }
    }, // update should be in this list, but it changes every render and breaks everything
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        data
    ]);
};
const $b1b5bd80e9727410$export$4156ac3cf466d45d = (id)=>{
    const saveCustomTitle = $b1b5bd80e9727410$export$5b8abdff51d766d5();
    return (0, $eUqFw.useCallback)((title)=>saveCustomTitle(id, title), [
        id,
        saveCustomTitle
    ]);
};

});

parcelRegister("axCzi", function(module, exports) {

$parcel$export(module.exports, "useSaveGadgetColor", () => $ab9661d072a981a5$export$13794d1743e6e544);

var $eUqFw = parcelRequire("eUqFw");

var $gjx45 = parcelRequire("gjx45");

var $lRmyA = parcelRequire("lRmyA");

var $01Qi5 = parcelRequire("01Qi5");
const $ab9661d072a981a5$export$13794d1743e6e544 = (id)=>{
    const { data: data, update: update } = (0, $01Qi5.useDashboardResource)();
    return (0, $eUqFw.useCallback)(async (newColorId)=>{
        if (!data) return;
        const colorUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/color`;
        await (0, $lRmyA.performPutRequest)(colorUrl, {
            body: JSON.stringify({
                color: newColorId
            })
        });
        update((0, $gjx45.lensGadget)(id, {
            color: newColorId
        }));
    }, [
        data,
        id,
        update
    ]);
};

});

parcelRegister("2B0LU", function(module, exports) {

$parcel$export(module.exports, "ConfigDropdown", () => $1195d1eb2e1af172$export$47c9dde399e23070);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");
parcelRequire("hFK4X");
var $lXXwI = parcelRequire("lXXwI");
var $hFK4X = parcelRequire("hFK4X");

var $f5xzw = parcelRequire("f5xzw");
var $5E6sS = parcelRequire("5E6sS");
var $e0IEe = parcelRequire("e0IEe");

var $5vJDH = parcelRequire("5vJDH");

var $kEBPk = parcelRequire("kEBPk");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4HwSc = parcelRequire("4HwSc");

var $2phqk = parcelRequire("2phqk");

var $5Xtlh = parcelRequire("5Xtlh");
const $1195d1eb2e1af172$export$47c9dde399e23070 = ({ isEditable: isEditable, isEditDisabled: isEditDisabled, gadgetColor: gadgetColor, gadgetId: gadgetId, gadgetTitle: gadgetTitle, onSaveColor: onSaveColor, onEditModeClick: onEditModeClick, onDeleteGadget: onDeleteGadget, onDuplicateGadget: onDuplicateGadget })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eUqFw.useState)(false);
    const [shouldFocusModalTrigger, setShouldFocusModalTrigger] = (0, $eUqFw.useState)(false);
    const [, { on: gadgetDeleteOpen }] = (0, $4HwSc.useSwitchModals)(gadgetId);
    const modalTriggerRef = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    const colorPalette = (0, $eUqFw.useMemo)(()=>Object.values((0, $kEBPk.COLOR_MAP)).map((code)=>{
            const colorName = (0, $kEBPk.COLOR_NAME_MAP)[code];
            return {
                label: colorName ? formatMessage(colorName) : code,
                value: code
            };
        }), [
        formatMessage
    ]);
    const handleDropdownOpenChange = (0, $eUqFw.useCallback)(({ isOpen: isOpen })=>setIsDropdownOpen(isOpen), []);
    const handleModalClose = (0, $eUqFw.useCallback)(()=>{
        setTimeout(()=>{
            // prevent unwanted state update if component is unmounted
            if (isMounted.current) {
                // Added 1ms delay to allow for the modal onClose event to finish
                // This is because closing the modal via the `ESC` key will trigger
                // the dropdown menu to close simultaneously, so we must dispatch this
                // after the keypress event has finished
                setIsDropdownOpen(true);
                setShouldFocusModalTrigger(true);
            }
        }, 1);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldFocusModalTrigger && isDropdownOpen) {
            // DropdownMenu component uses useFocusManager hook to focus the first
            // dropdown menu item when the menu is opened, so we need to wait roughly
            // 50ms for the menu to open and focus the first item before then focusing
            // the modal trigger.
            setTimeout(()=>{
                modalTriggerRef.current?.focus();
            }, 50);
            setShouldFocusModalTrigger(false);
        }
    }, [
        isDropdownOpen,
        shouldFocusModalTrigger
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            isMounted.current = false;
        }, []);
    const onColourChangeOld = (0, $eUqFw.useCallback)((newColor)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const colorId = Object.keys((0, $kEBPk.COLOR_MAP)).find((key)=>(0, $kEBPk.COLOR_MAP)[key] === newColor);
        if (colorId) onSaveColor(colorId);
    }, [
        onSaveColor
    ]);
    const onColourChange = (0, $eUqFw.useCallback)((_, newColor)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const colorId = Object.keys((0, $kEBPk.COLOR_MAP)).find((key)=>(0, $kEBPk.COLOR_MAP)[key] === newColor);
        if (colorId) onSaveColor(colorId);
    }, [
        onSaveColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1195d1eb2e1af172$var$DropdownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
        isOpen: isDropdownOpen,
        onOpenChange: handleDropdownOpenChange,
        isLoading: false,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "default",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5vJDH))), {
                    label: formatMessage((0, $5Xtlh.default).moreActions, {
                        gadgetTitle: gadgetTitle
                    }),
                    size: "medium"
                }),
                testId: "dashboard-edit.ui.gadget-editable.config-dropdown.dropdown-button",
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        appearance: "tall",
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e0IEe.default), {
        title: formatMessage((0, $5Xtlh.default).colorHeading)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1195d1eb2e1af172$var$ColorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXXwI.default), {
        label: formatMessage((0, $5Xtlh.default).colorHeading),
        palette: colorPalette,
        selectedColor: (0, $kEBPk.COLOR_MAP)[gadgetColor],
        checkMarkColor: (0, $kEBPk.COLOR_CHECKMARK_MAP)[gadgetColor],
        mode: (0, $hFK4X.Compact),
        cols: Object.keys((0, $kEBPk.COLOR_MAP)).length,
        ...(0, $eI5EY.fg)('platform_color_palette-expose-event') ? {
            onChange: onColourChange
        } : {
            onChangeOld: onColourChangeOld
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e0IEe.default), null, isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.edit",
        isDisabled: isEditDisabled,
        onClick: onEditModeClick
    }, formatMessage((0, $5Xtlh.default).configure)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.duplicate",
        onClick: onDuplicateGadget
    }, formatMessage((0, $5Xtlh.default).duplicate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.delete",
        ref: modalTriggerRef,
        onClick: gadgetDeleteOpen
    }, formatMessage((0, $5Xtlh.default).delete))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2phqk.DeleteGadgetModal), {
        id: gadgetId,
        onDeleteGadget: onDeleteGadget,
        gadgetName: gadgetTitle,
        onClose: handleModalClose
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1195d1eb2e1af172$var$DropdownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1195d1eb2e1af172$var$ColorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4sd53 _n7zlfa5n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFK4X", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $1f2347a7bcc07937$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $1f2347a7bcc07937$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ColorPaletteMenu", () => (parcelRequire("lXXwI")).default);

var $73Pk9 = parcelRequire("73Pk9");

var $lL6MX = parcelRequire("lL6MX");

var $lXXwI = parcelRequire("lXXwI");
const { Compact: $1f2347a7bcc07937$export$6479582a9c9e50ce, Standard: $1f2347a7bcc07937$export$d5a1f56087d42b19 } = (0, $lL6MX.Mode);
var $1f2347a7bcc07937$export$2e2bcd8739ae039 = (0, $73Pk9.default);

});
parcelRegister("73Pk9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0c24f7b2a59d3d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $5IfN7 = parcelRequire("5IfN7");

var $kKVap = parcelRequire("kKVap");

var $3WxM1 = parcelRequire("3WxM1");


var $j8gJ1 = parcelRequire("j8gJ1");
var $8LRlt = parcelRequire("8LRlt");
var $f3klQ = parcelRequire("f3klQ");

var $mbR6d = parcelRequire("mbR6d");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $gCqfn = parcelRequire("gCqfn");
function $2c0c24f7b2a59d3d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2c0c24f7b2a59d3d$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $2c0c24f7b2a59d3d$var$packageName = "platform-pkg";
const $2c0c24f7b2a59d3d$var$packageVersion = "0.0.0-use.local";
class $2c0c24f7b2a59d3d$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $2c0c24f7b2a59d3d$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl } = this.props;
        const { options: options, value: value } = (0, $mbR6d.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $5IfN7.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: $2c0c24f7b2a59d3d$var$colorCardWrapperStyles,
                    ref: ref
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kKVap.default), {
                    ...value,
                    label: fullLabel,
                    expanded: isOpen,
                    swatchSize: selectedColourSwatchSize,
                    isDisabled: isDisabledSelectedSwatch,
                    id: triggerId
                })),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            "aria-label": fullLabel,
            value: value,
            components: $3WxM1,
            onChange: this.onChangeSelect,
            // never show search input
            searchThreshold: Number.MAX_VALUE,
            // palette props
            //@ts-ignore react-select unsupported props
            cols: cols,
            checkMarkColor: checkMarkColor,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown
        });
    }
    constructor(...args){
        super(...args);
        this.createAndFireEventOnAtlaskit = (0, $j8gJ1.default)('atlaskit');
        this.state = {
            isTabbing: false
        };
        this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $2c0c24f7b2a59d3d$var$packageName,
                    packageVersion: $2c0c24f7b2a59d3d$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        };
        this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        };
        this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        };
        this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $df82270178fd50e6$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $df82270178fd50e6$export$b34c7ae3fd8138d2) || key === (0, $df82270178fd50e6$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === (0, $df82270178fd50e6$export$929c2026f4dd54a2)) e.stopPropagation();
        };
        this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $gCqfn.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $2c0c24f7b2a59d3d$export$2fcf66ed38ff3cf5 = (0, $2qhQi.default)($2c0c24f7b2a59d3d$var$ColorPickerWithoutAnalyticsBase);
var $2c0c24f7b2a59d3d$export$2e2bcd8739ae039 = (0, $8LRlt.default)({
    componentName: 'color-picker',
    packageName: $2c0c24f7b2a59d3d$var$packageName,
    packageVersion: $2c0c24f7b2a59d3d$var$packageVersion
})((0, $f3klQ.default)()($2c0c24f7b2a59d3d$export$2fcf66ed38ff3cf5));
const $2c0c24f7b2a59d3d$var$colorCardWrapperStyles = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};

});
parcelRegister("5IfN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf75109f1a322fd4$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $lbDTY = parcelRequire("lbDTY");

var $kQSBm = parcelRequire("kQSBm");
var $5bdEm = parcelRequire("5bdEm");
var $dmg8t = parcelRequire("dmg8t");

var $asNSH = parcelRequire("asNSH");

var $2Pede = parcelRequire("2Pede");

var $gYrJM = parcelRequire("gYrJM");

var $8r9C9 = parcelRequire("8r9C9");


var $aJuqz = parcelRequire("aJuqz");

var $a3o6L = parcelRequire("a3o6L");

var $NHgCB = parcelRequire("NHgCB");

var $2FrYX = parcelRequire("2FrYX");
/**
 * Are we rendering on the client or server?
 */ const $bf75109f1a322fd4$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $bf75109f1a322fd4$var$FocusLock = (0, $gYrJM.fg)('platform_dst_select-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
const $bf75109f1a322fd4$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $bf75109f1a322fd4$var$defaultPopperProps = {
    modifiers: $bf75109f1a322fd4$var$modifiers,
    placement: 'bottom-start'
};
const $bf75109f1a322fd4$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $bf75109f1a322fd4$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$bf75109f1a322fd4$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $2FrYX.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$bf75109f1a322fd4$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQSBm.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Pede.IdProvider), {
            postfix: "-popup-select"
        }, ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dmg8t.Reference), null, ({ ref: ref })=>target && target({
                    isOpen: isOpen,
                    onKeyDown: this.handleTargetKeyDown,
                    ref: this.resolveTargetRef(ref),
                    'aria-haspopup': 'true',
                    'aria-expanded': isOpen,
                    'aria-controls': isOpen ? id : undefined
                })), this.renderSelect(id))));
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $8r9C9.mergeStyles)((0, $a3o6L.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $2FrYX.defaultComponents),
            mergedPopperProps: $bf75109f1a322fd4$var$defaultPopperProps
        };
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            if ((0, $gYrJM.fg)('tab-event-should-close-popupSelect')) {
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            }
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $gYrJM.fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $gYrJM.fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $bf75109f1a322fd4$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $2FrYX.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $NHgCB.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $NHgCB.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $NHgCB.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bdEm.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform_design_system_team_select_node_resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf75109f1a322fd4$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2FrYX.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: id,
                    testId: testId,
                    ref: !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf75109f1a322fd4$var$FocusLock, {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aJuqz.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $8r9C9.mergeStyles)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $bf75109f1a322fd4$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("kQSBm", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $f2e304bb02006a02$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $f2e304bb02006a02$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $f2e304bb02006a02$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $f2e304bb02006a02$export$3dbd3405086fec7b = $eUqFw.createContext();
var $f2e304bb02006a02$export$cbabb21c2529b130 = $eUqFw.createContext();
function $f2e304bb02006a02$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($f2e304bb02006a02$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($f2e304bb02006a02$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("5bdEm", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $3c589169ddd94ce2$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $kQSBm = parcelRequire("kQSBm");

var $2Leve = parcelRequire("2Leve");

var $efr5v = parcelRequire("efr5v");
var $3c589169ddd94ce2$var$NOOP = function NOOP() {
    return void 0;
};
var $3c589169ddd94ce2$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $3c589169ddd94ce2$var$EMPTY_MODIFIERS = [];
function $3c589169ddd94ce2$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $3c589169ddd94ce2$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $kQSBm.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $2Leve.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $efr5v.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $3c589169ddd94ce2$var$NOOP,
            update: update || $3c589169ddd94ce2$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $2Leve.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("2Leve", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $202b3879e180f9e1$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $202b3879e180f9e1$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $202b3879e180f9e1$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $202b3879e180f9e1$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $202b3879e180f9e1$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $202b3879e180f9e1$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $202b3879e180f9e1$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $202b3879e180f9e1$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $202b3879e180f9e1$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $202b3879e180f9e1$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $202b3879e180f9e1$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("efr5v", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $a5f77a7e238a9101$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $ap33P = parcelRequire("ap33P");

var $an8Qp = parcelRequire("an8Qp");

var $2Leve = parcelRequire("2Leve");
var $a5f77a7e238a9101$var$EMPTY_MODIFIERS = [];
var $a5f77a7e238a9101$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $a5f77a7e238a9101$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $2Leve.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $2Leve.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $2Leve.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $2Leve.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $ap33P.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("ap33P", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $792e9cfbd261b473$export$8f7491d57c8f97a9);

var $lYrVW = parcelRequire("lYrVW");

var $anyZr = parcelRequire("anyZr");

var $3QpMQ = parcelRequire("3QpMQ");

var $bbqbM = parcelRequire("bbqbM");

var $lro9d = parcelRequire("lro9d");

var $6qkVe = parcelRequire("6qkVe");

var $8rAdb = parcelRequire("8rAdb");

var $gFjel = parcelRequire("gFjel");

var $hiKPe = parcelRequire("hiKPe");

var $izul8 = parcelRequire("izul8");


var $792e9cfbd261b473$export$d34966752335dd47 = [
    (0, $anyZr.default),
    (0, $3QpMQ.default),
    (0, $bbqbM.default),
    (0, $lro9d.default),
    (0, $6qkVe.default),
    (0, $8rAdb.default),
    (0, $gFjel.default),
    (0, $hiKPe.default),
    (0, $izul8.default)
];
var $792e9cfbd261b473$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $lYrVW.popperGenerator)({
    defaultModifiers: $792e9cfbd261b473$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("lYrVW", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $fff4de9b669adeeb$export$ed5e13716264f202);

var $ag20p = parcelRequire("ag20p");

var $QrBqo = parcelRequire("QrBqo");

var $ePkdB = parcelRequire("ePkdB");

var $dNrcD = parcelRequire("dNrcD");

var $67G0M = parcelRequire("67G0M");

var $fb5CK = parcelRequire("fb5CK");

var $dFfUS = parcelRequire("dFfUS");


var $edBYZ = parcelRequire("edBYZ");
var $fff4de9b669adeeb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $fff4de9b669adeeb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $fff4de9b669adeeb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $fff4de9b669adeeb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $fff4de9b669adeeb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $edBYZ.isElement)(reference) ? (0, $ePkdB.default)(reference) : reference.contextElement ? (0, $ePkdB.default)(reference.contextElement) : [],
                    popper: (0, $ePkdB.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $67G0M.default)((0, $dFfUS.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$fff4de9b669adeeb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ag20p.default)(reference, (0, $dNrcD.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $QrBqo.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $fb5CK.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$fff4de9b669adeeb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $fff4de9b669adeeb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $fff4de9b669adeeb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("ag20p", function(module, exports) {

$parcel$export(module.exports, "default", () => $777cf448ef0803dd$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");

var $9xSYk = parcelRequire("9xSYk");

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");

var $5l3cx = parcelRequire("5l3cx");

var $80xbK = parcelRequire("80xbK");

var $lB8uB = parcelRequire("lB8uB");

var $lCnHF = parcelRequire("lCnHF");
function $777cf448ef0803dd$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $lCnHF.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $lCnHF.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $777cf448ef0803dd$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $edBYZ.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $edBYZ.isHTMLElement)(offsetParent) && $777cf448ef0803dd$var$isElementScaled(offsetParent);
    var documentElement = (0, $80xbK.default)(offsetParent);
    var rect = (0, $1a1A9.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $k9tfz.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lB8uB.default)(documentElement)) scroll = (0, $9xSYk.default)(offsetParent);
        if ((0, $edBYZ.isHTMLElement)(offsetParent)) {
            offsets = (0, $1a1A9.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $5l3cx.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("1a1A9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d87f3ca928fe9a2$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");

var $lCnHF = parcelRequire("lCnHF");

var $3xJ5v = parcelRequire("3xJ5v");

var $920uN = parcelRequire("920uN");
function $0d87f3ca928fe9a2$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $edBYZ.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $lCnHF.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $lCnHF.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $edBYZ.isElement)(element) ? (0, $3xJ5v.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $920uN.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("edBYZ", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $a59fbe293893fdf9$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $a59fbe293893fdf9$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $a59fbe293893fdf9$export$af51f0f06c0f328a);

var $3xJ5v = parcelRequire("3xJ5v");
function $a59fbe293893fdf9$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $3xJ5v.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $a59fbe293893fdf9$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $3xJ5v.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $a59fbe293893fdf9$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $3xJ5v.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("3xJ5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $29476dadb45dea2c$export$2e2bcd8739ae039);
function $29476dadb45dea2c$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("lCnHF", function(module, exports) {

$parcel$export(module.exports, "max", () => $fbcf889019494e36$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $fbcf889019494e36$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $fbcf889019494e36$export$2077e0241d6afd3c);
var $fbcf889019494e36$export$8960430cfd85939f = Math.max;
var $fbcf889019494e36$export$96ec731ed4dcb222 = Math.min;
var $fbcf889019494e36$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("920uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6934af65acd9e478$export$2e2bcd8739ae039);

var $72LZU = parcelRequire("72LZU");
function $6934af65acd9e478$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $72LZU.default)());
}

});
parcelRegister("72LZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $520df39ba6a9a4ac$export$2e2bcd8739ae039);
function $520df39ba6a9a4ac$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9xSYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f31d66ead222a8d$export$2e2bcd8739ae039);

var $ac1Wl = parcelRequire("ac1Wl");

var $3xJ5v = parcelRequire("3xJ5v");

var $edBYZ = parcelRequire("edBYZ");

var $hdS5H = parcelRequire("hdS5H");
function $6f31d66ead222a8d$export$2e2bcd8739ae039(node) {
    if (node === (0, $3xJ5v.default)(node) || !(0, $edBYZ.isHTMLElement)(node)) return (0, $ac1Wl.default)(node);
    else return (0, $hdS5H.default)(node);
}

});
parcelRegister("ac1Wl", function(module, exports) {

$parcel$export(module.exports, "default", () => $76bc879f580a47a7$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
function $76bc879f580a47a7$export$2e2bcd8739ae039(node) {
    var win = (0, $3xJ5v.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("hdS5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89d9be7ec372ac1$export$2e2bcd8739ae039);
function $c89d9be7ec372ac1$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("k9tfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eabb5662a7f5257f$export$2e2bcd8739ae039);
function $eabb5662a7f5257f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("5l3cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e31659f48c6f7d6$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");

var $80xbK = parcelRequire("80xbK");

var $ac1Wl = parcelRequire("ac1Wl");
function $3e31659f48c6f7d6$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1a1A9.default)((0, $80xbK.default)(element)).left + (0, $ac1Wl.default)(element).scrollLeft;
}

});
parcelRegister("80xbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d481159709e436d$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");
function $5d481159709e436d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $edBYZ.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lB8uB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb93a41cc2fd2e28$export$2e2bcd8739ae039);

var $aPsIR = parcelRequire("aPsIR");
function $fb93a41cc2fd2e28$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $aPsIR.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("aPsIR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e24f28110b44487$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
function $7e24f28110b44487$export$2e2bcd8739ae039(element) {
    return (0, $3xJ5v.default)(element).getComputedStyle(element);
}

});



parcelRegister("QrBqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $09da44bfd33a27e6$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");
function $09da44bfd33a27e6$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1a1A9.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("ePkdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb58313ecb6072d$export$2e2bcd8739ae039);

var $fJHhD = parcelRequire("fJHhD");

var $hoKF3 = parcelRequire("hoKF3");

var $3xJ5v = parcelRequire("3xJ5v");

var $lB8uB = parcelRequire("lB8uB");
function $acb58313ecb6072d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fJHhD.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $3xJ5v.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lB8uB.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($acb58313ecb6072d$export$2e2bcd8739ae039((0, $hoKF3.default)(target)));
}

});
parcelRegister("fJHhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b74ca229b5aac469$export$2e2bcd8739ae039);

var $hoKF3 = parcelRequire("hoKF3");

var $lB8uB = parcelRequire("lB8uB");

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");
function $b74ca229b5aac469$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $k9tfz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $edBYZ.isHTMLElement)(node) && (0, $lB8uB.default)(node)) return node;
    return $b74ca229b5aac469$export$2e2bcd8739ae039((0, $hoKF3.default)(node));
}

});
parcelRegister("hoKF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caa8df7de2e956b1$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");

var $80xbK = parcelRequire("80xbK");

var $edBYZ = parcelRequire("edBYZ");
function $caa8df7de2e956b1$export$2e2bcd8739ae039(element) {
    if ((0, $k9tfz.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $edBYZ.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $80xbK.default)(element) // fallback
    );
}

});



parcelRegister("dNrcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b4f3d95d479f23$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");

var $k9tfz = parcelRequire("k9tfz");

var $aPsIR = parcelRequire("aPsIR");

var $edBYZ = parcelRequire("edBYZ");

var $kqjk2 = parcelRequire("kqjk2");

var $hoKF3 = parcelRequire("hoKF3");

var $72LZU = parcelRequire("72LZU");
function $a0b4f3d95d479f23$var$getTrueOffsetParent(element) {
    if (!(0, $edBYZ.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $aPsIR.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a0b4f3d95d479f23$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $72LZU.default)());
    var isIE = /Trident/i.test((0, $72LZU.default)());
    if (isIE && (0, $edBYZ.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $aPsIR.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $hoKF3.default)(element);
    if ((0, $edBYZ.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $edBYZ.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $k9tfz.default)(currentNode)) < 0){
        var css = (0, $aPsIR.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a0b4f3d95d479f23$export$2e2bcd8739ae039(element) {
    var window = (0, $3xJ5v.default)(element);
    var offsetParent = $a0b4f3d95d479f23$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $kqjk2.default)(offsetParent) && (0, $aPsIR.default)(offsetParent).position === 'static')offsetParent = $a0b4f3d95d479f23$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $k9tfz.default)(offsetParent) === 'html' || (0, $k9tfz.default)(offsetParent) === 'body' && (0, $aPsIR.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $a0b4f3d95d479f23$var$getContainingBlock(element) || window;
}

});
parcelRegister("kqjk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede5395aec84864a$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");
function $ede5395aec84864a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $k9tfz.default)(element)) >= 0;
}

});


parcelRegister("67G0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4753fc241c56a947$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");
function $4753fc241c56a947$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $4753fc241c56a947$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $4753fc241c56a947$var$order(modifiers); // order based on phase
    return (0, $8CWSq.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("8CWSq", function(module, exports) {

$parcel$export(module.exports, "top", () => $647f8b13194227d9$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $647f8b13194227d9$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $647f8b13194227d9$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $647f8b13194227d9$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $647f8b13194227d9$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $647f8b13194227d9$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $647f8b13194227d9$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $647f8b13194227d9$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $647f8b13194227d9$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $647f8b13194227d9$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $647f8b13194227d9$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $647f8b13194227d9$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $647f8b13194227d9$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $647f8b13194227d9$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $647f8b13194227d9$export$d087d3878fdf71d5);
var $647f8b13194227d9$export$1e95b668f3b82d = 'top';
var $647f8b13194227d9$export$40e543e69a8b3fbb = 'bottom';
var $647f8b13194227d9$export$79ffe56a765070d2 = 'right';
var $647f8b13194227d9$export$eabcd2c8791e7bf4 = 'left';
var $647f8b13194227d9$export$dfb5619354ba860 = 'auto';
var $647f8b13194227d9$export$aec2ce47c367b8c3 = [
    $647f8b13194227d9$export$1e95b668f3b82d,
    $647f8b13194227d9$export$40e543e69a8b3fbb,
    $647f8b13194227d9$export$79ffe56a765070d2,
    $647f8b13194227d9$export$eabcd2c8791e7bf4
];
var $647f8b13194227d9$export$b3571188c770cc5a = 'start';
var $647f8b13194227d9$export$bd5df0f255a350f8 = 'end';
var $647f8b13194227d9$export$390fd549c5303b4d = 'clippingParents';
var $647f8b13194227d9$export$d7b7311ec04a3e8f = 'viewport';
var $647f8b13194227d9$export$ae5ab1c730825774 = 'popper';
var $647f8b13194227d9$export$ca50aac9f3ba507f = 'reference';
var $647f8b13194227d9$export$368f9a87e87fa4e1 = /*#__PURE__*/ $647f8b13194227d9$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $647f8b13194227d9$export$b3571188c770cc5a,
        placement + "-" + $647f8b13194227d9$export$bd5df0f255a350f8
    ]);
}, []);
var $647f8b13194227d9$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($647f8b13194227d9$export$aec2ce47c367b8c3, [
    $647f8b13194227d9$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $647f8b13194227d9$export$b3571188c770cc5a,
        placement + "-" + $647f8b13194227d9$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $647f8b13194227d9$export$421679a7c3d56e = 'beforeRead';
var $647f8b13194227d9$export$aafa59e2e03f2942 = 'read';
var $647f8b13194227d9$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $647f8b13194227d9$export$c65e99957a05207c = 'beforeMain';
var $647f8b13194227d9$export$f22da7240b7add18 = 'main';
var $647f8b13194227d9$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $647f8b13194227d9$export$8d4d2d70e7d46032 = 'beforeWrite';
var $647f8b13194227d9$export$68d8715fc104d294 = 'write';
var $647f8b13194227d9$export$70a6e5159acce2e6 = 'afterWrite';
var $647f8b13194227d9$export$d087d3878fdf71d5 = [
    $647f8b13194227d9$export$421679a7c3d56e,
    $647f8b13194227d9$export$aafa59e2e03f2942,
    $647f8b13194227d9$export$6964f6c886723980,
    $647f8b13194227d9$export$c65e99957a05207c,
    $647f8b13194227d9$export$f22da7240b7add18,
    $647f8b13194227d9$export$bab79516f2d662fe,
    $647f8b13194227d9$export$8d4d2d70e7d46032,
    $647f8b13194227d9$export$68d8715fc104d294,
    $647f8b13194227d9$export$70a6e5159acce2e6
];

});


parcelRegister("fb5CK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cc3ee5e6caa807$export$2e2bcd8739ae039);
function $b0cc3ee5e6caa807$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("dFfUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f2b735bd29d87f1$export$2e2bcd8739ae039);
function $9f2b735bd29d87f1$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("anyZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e731ac5ccd6edc$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
var $78e731ac5ccd6edc$var$passive = {
    passive: true
};
function $78e731ac5ccd6edc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $3xJ5v.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $78e731ac5ccd6edc$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $78e731ac5ccd6edc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $78e731ac5ccd6edc$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $78e731ac5ccd6edc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $78e731ac5ccd6edc$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $78e731ac5ccd6edc$var$effect,
    data: {}
};

});

parcelRegister("3QpMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cca3b2cec3a358e$export$2e2bcd8739ae039);

var $5HHLS = parcelRequire("5HHLS");
function $2cca3b2cec3a358e$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5HHLS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2cca3b2cec3a358e$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $2cca3b2cec3a358e$var$popperOffsets,
    data: {}
};

});
parcelRegister("5HHLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4272ebf28a8b18f9$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $iR1vh = parcelRequire("iR1vh");

var $fOHu6 = parcelRequire("fOHu6");

var $8CWSq = parcelRequire("8CWSq");
function $4272ebf28a8b18f9$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $aXPSi.default)(placement) : null;
    var variation = placement ? (0, $iR1vh.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8CWSq.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8CWSq.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8CWSq.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8CWSq.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fOHu6.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $8CWSq.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8CWSq.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("aXPSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb7a75361164827$export$2e2bcd8739ae039);

function $7fb7a75361164827$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("iR1vh", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9e57cb08416451$export$2e2bcd8739ae039);
function $db9e57cb08416451$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("fOHu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b83d41a8913a6625$export$2e2bcd8739ae039);
function $b83d41a8913a6625$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("bbqbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8245095d444bc6ab$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $dNrcD = parcelRequire("dNrcD");

var $3xJ5v = parcelRequire("3xJ5v");

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $aXPSi = parcelRequire("aXPSi");

var $iR1vh = parcelRequire("iR1vh");

var $lCnHF = parcelRequire("lCnHF");
var $8245095d444bc6ab$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8245095d444bc6ab$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $lCnHF.round)(x * dpr) / dpr || 0,
        y: (0, $lCnHF.round)(y * dpr) / dpr || 0
    };
}
function $8245095d444bc6ab$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $8CWSq.left);
    var sideY = (0, $8CWSq.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $dNrcD.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $3xJ5v.default)(popper)) {
            offsetParent = (0, $80xbK.default)(popper);
            if ((0, $aPsIR.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8CWSq.top) || (placement === (0, $8CWSq.left) || placement === (0, $8CWSq.right)) && variation === (0, $8CWSq.end)) {
            sideY = (0, $8CWSq.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8CWSq.left) || (placement === (0, $8CWSq.top) || placement === (0, $8CWSq.bottom)) && variation === (0, $8CWSq.end)) {
            sideX = (0, $8CWSq.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8245095d444bc6ab$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8245095d444bc6ab$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $3xJ5v.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $8245095d444bc6ab$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $aXPSi.default)(state.placement),
        variation: (0, $iR1vh.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8245095d444bc6ab$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8245095d444bc6ab$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8245095d444bc6ab$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $8245095d444bc6ab$var$computeStyles,
    data: {}
};

});

parcelRegister("lro9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9bed9cb68105387$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");
// and applies them to the HTMLElements such as popper and arrow
function $f9bed9cb68105387$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $edBYZ.isHTMLElement)(element) || !(0, $k9tfz.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $f9bed9cb68105387$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $edBYZ.isHTMLElement)(element) || !(0, $k9tfz.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $f9bed9cb68105387$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $f9bed9cb68105387$var$applyStyles,
    effect: $f9bed9cb68105387$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("6qkVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad56675e809f390$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $8CWSq = parcelRequire("8CWSq");
function $4ad56675e809f390$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $aXPSi.default)(placement);
    var invertDistance = [
        (0, $8CWSq.left),
        (0, $8CWSq.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8CWSq.left),
        (0, $8CWSq.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $4ad56675e809f390$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8CWSq.placements).reduce(function(acc, placement) {
        acc[placement] = $4ad56675e809f390$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4ad56675e809f390$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $4ad56675e809f390$var$offset
};

});

parcelRegister("8rAdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $625cef3e22a64921$export$2e2bcd8739ae039);

var $60Kh8 = parcelRequire("60Kh8");

var $aXPSi = parcelRequire("aXPSi");

var $ib8Lm = parcelRequire("ib8Lm");

var $ecS3L = parcelRequire("ecS3L");

var $gUvF5 = parcelRequire("gUvF5");

var $8CWSq = parcelRequire("8CWSq");

var $iR1vh = parcelRequire("iR1vh");
function $625cef3e22a64921$var$getExpandedFallbackPlacements(placement) {
    if ((0, $aXPSi.default)(placement) === (0, $8CWSq.auto)) return [];
    var oppositePlacement = (0, $60Kh8.default)(placement);
    return [
        (0, $ib8Lm.default)(placement),
        oppositePlacement,
        (0, $ib8Lm.default)(oppositePlacement)
    ];
}
function $625cef3e22a64921$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $aXPSi.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $60Kh8.default)(preferredPlacement)
    ] : $625cef3e22a64921$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $aXPSi.default)(placement) === (0, $8CWSq.auto) ? (0, $gUvF5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $aXPSi.default)(placement);
        var isStartVariation = (0, $iR1vh.default)(placement) === (0, $8CWSq.start);
        var isVertical = [
            (0, $8CWSq.top),
            (0, $8CWSq.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $ecS3L.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8CWSq.right) : (0, $8CWSq.left) : isStartVariation ? (0, $8CWSq.bottom) : (0, $8CWSq.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $60Kh8.default)(mainVariationSide);
        var altVariationSide = (0, $60Kh8.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $625cef3e22a64921$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $625cef3e22a64921$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("60Kh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4606a37f7c1f292f$export$2e2bcd8739ae039);
var $4606a37f7c1f292f$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $4606a37f7c1f292f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $4606a37f7c1f292f$var$hash[matched];
    });
}

});

parcelRegister("ib8Lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c00d3590b14ae0$export$2e2bcd8739ae039);
var $d3c00d3590b14ae0$var$hash = {
    start: 'end',
    end: 'start'
};
function $d3c00d3590b14ae0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $d3c00d3590b14ae0$var$hash[matched];
    });
}

});

parcelRegister("ecS3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57c1ec8d520bc76$export$2e2bcd8739ae039);

var $gY30K = parcelRequire("gY30K");

var $80xbK = parcelRequire("80xbK");

var $1a1A9 = parcelRequire("1a1A9");

var $5HHLS = parcelRequire("5HHLS");

var $hRFeC = parcelRequire("hRFeC");

var $8CWSq = parcelRequire("8CWSq");

var $edBYZ = parcelRequire("edBYZ");

var $5HivB = parcelRequire("5HivB");

var $gafWf = parcelRequire("gafWf");
function $a57c1ec8d520bc76$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8CWSq.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8CWSq.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8CWSq.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5HivB.default)(typeof padding !== 'number' ? padding : (0, $gafWf.default)(padding, (0, $8CWSq.basePlacements)));
    var altContext = elementContext === (0, $8CWSq.popper) ? (0, $8CWSq.reference) : (0, $8CWSq.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $gY30K.default)((0, $edBYZ.isElement)(element) ? element : element.contextElement || (0, $80xbK.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1a1A9.default)(state.elements.reference);
    var popperOffsets = (0, $5HHLS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $hRFeC.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8CWSq.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8CWSq.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8CWSq.right),
                (0, $8CWSq.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8CWSq.top),
                (0, $8CWSq.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("gY30K", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a495e161fa24d3$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $3GhRd = parcelRequire("3GhRd");

var $Z1xa3 = parcelRequire("Z1xa3");

var $ePkdB = parcelRequire("ePkdB");

var $dNrcD = parcelRequire("dNrcD");

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $edBYZ = parcelRequire("edBYZ");

var $1a1A9 = parcelRequire("1a1A9");

var $hoKF3 = parcelRequire("hoKF3");

var $4W0o9 = parcelRequire("4W0o9");

var $k9tfz = parcelRequire("k9tfz");

var $hRFeC = parcelRequire("hRFeC");

var $lCnHF = parcelRequire("lCnHF");
function $c5a495e161fa24d3$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1a1A9.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $c5a495e161fa24d3$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8CWSq.viewport) ? (0, $hRFeC.default)((0, $3GhRd.default)(element, strategy)) : (0, $edBYZ.isElement)(clippingParent) ? $c5a495e161fa24d3$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $hRFeC.default)((0, $Z1xa3.default)((0, $80xbK.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $c5a495e161fa24d3$var$getClippingParents(element) {
    var clippingParents = (0, $ePkdB.default)((0, $hoKF3.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $aPsIR.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $edBYZ.isHTMLElement)(element) ? (0, $dNrcD.default)(element) : element;
    if (!(0, $edBYZ.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $edBYZ.isElement)(clippingParent) && (0, $4W0o9.default)(clippingParent, clipperElement) && (0, $k9tfz.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $c5a495e161fa24d3$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $c5a495e161fa24d3$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $c5a495e161fa24d3$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $lCnHF.max)(rect.top, accRect.top);
        accRect.right = (0, $lCnHF.min)(rect.right, accRect.right);
        accRect.bottom = (0, $lCnHF.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $lCnHF.max)(rect.left, accRect.left);
        return accRect;
    }, $c5a495e161fa24d3$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3GhRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae3256cd0a63b6c$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");

var $80xbK = parcelRequire("80xbK");

var $5l3cx = parcelRequire("5l3cx");

var $920uN = parcelRequire("920uN");
function $2ae3256cd0a63b6c$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $3xJ5v.default)(element);
    var html = (0, $80xbK.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $920uN.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $5l3cx.default)(element),
        y: y
    };
}

});

parcelRegister("Z1xa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b76e33639bec5b0$export$2e2bcd8739ae039);

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $5l3cx = parcelRequire("5l3cx");

var $ac1Wl = parcelRequire("ac1Wl");

var $lCnHF = parcelRequire("lCnHF");
function $0b76e33639bec5b0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $80xbK.default)(element);
    var winScroll = (0, $ac1Wl.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $lCnHF.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $lCnHF.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $5l3cx.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $aPsIR.default)(body || html).direction === 'rtl') x += (0, $lCnHF.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("4W0o9", function(module, exports) {

$parcel$export(module.exports, "default", () => $397ce160bfc587fd$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");
function $397ce160bfc587fd$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $edBYZ.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("hRFeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0175f4a07c21ab5$export$2e2bcd8739ae039);
function $d0175f4a07c21ab5$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("5HivB", function(module, exports) {

$parcel$export(module.exports, "default", () => $425f53560a1fdf3c$export$2e2bcd8739ae039);

var $1ZKmd = parcelRequire("1ZKmd");
function $425f53560a1fdf3c$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1ZKmd.default)(), paddingObject);
}

});
parcelRegister("1ZKmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $173f728cc6ee2a3b$export$2e2bcd8739ae039);
function $173f728cc6ee2a3b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("gafWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc49f189f7bd576d$export$2e2bcd8739ae039);
function $bc49f189f7bd576d$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("gUvF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4fa6fa3ea07a9a4$export$2e2bcd8739ae039);

var $iR1vh = parcelRequire("iR1vh");

var $8CWSq = parcelRequire("8CWSq");

var $ecS3L = parcelRequire("ecS3L");

var $aXPSi = parcelRequire("aXPSi");
function $c4fa6fa3ea07a9a4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8CWSq.placements) : _options$allowedAutoP;
    var variation = (0, $iR1vh.default)(placement);
    var placements = variation ? flipVariations ? (0, $8CWSq.variationPlacements) : (0, $8CWSq.variationPlacements).filter(function(placement) {
        return (0, $iR1vh.default)(placement) === variation;
    }) : (0, $8CWSq.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $ecS3L.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $aXPSi.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("gFjel", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21f64720698273b$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $aXPSi = parcelRequire("aXPSi");

var $fOHu6 = parcelRequire("fOHu6");

var $hAEuy = parcelRequire("hAEuy");

var $bnZ7G = parcelRequire("bnZ7G");

var $QrBqo = parcelRequire("QrBqo");

var $dNrcD = parcelRequire("dNrcD");

var $ecS3L = parcelRequire("ecS3L");

var $iR1vh = parcelRequire("iR1vh");

var $1ZKmd = parcelRequire("1ZKmd");

var $lCnHF = parcelRequire("lCnHF");
function $c21f64720698273b$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $ecS3L.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $aXPSi.default)(state.placement);
    var variation = (0, $iR1vh.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fOHu6.default)(basePlacement);
    var altAxis = (0, $hAEuy.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $8CWSq.top) : (0, $8CWSq.left);
        var altSide = mainAxis === 'y' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8CWSq.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8CWSq.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $QrBqo.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1ZKmd.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $bnZ7G.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $dNrcD.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $bnZ7G.within)(tether ? (0, $lCnHF.min)(min, tetherMin) : min, offset, tether ? (0, $lCnHF.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $8CWSq.top) : (0, $8CWSq.left);
        var _altSide = mainAxis === 'x' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8CWSq.top),
            (0, $8CWSq.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $bnZ7G.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $bnZ7G.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c21f64720698273b$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $c21f64720698273b$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("hAEuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce5354b6e28e32b$export$2e2bcd8739ae039);
function $cce5354b6e28e32b$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("bnZ7G", function(module, exports) {

$parcel$export(module.exports, "within", () => $84a14174e88d0bc0$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $84a14174e88d0bc0$export$86c8af6d3ef0b4a);

var $lCnHF = parcelRequire("lCnHF");
function $84a14174e88d0bc0$export$f28d906d67a997f3(min, value, max) {
    return (0, $lCnHF.max)(min, (0, $lCnHF.min)(value, max));
}
function $84a14174e88d0bc0$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $84a14174e88d0bc0$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("hiKPe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c988709f87b64d9b$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $QrBqo = parcelRequire("QrBqo");

var $4W0o9 = parcelRequire("4W0o9");

var $dNrcD = parcelRequire("dNrcD");

var $fOHu6 = parcelRequire("fOHu6");

var $bnZ7G = parcelRequire("bnZ7G");

var $5HivB = parcelRequire("5HivB");

var $gafWf = parcelRequire("gafWf");

var $8CWSq = parcelRequire("8CWSq");
var $c988709f87b64d9b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5HivB.default)(typeof padding !== 'number' ? padding : (0, $gafWf.default)(padding, (0, $8CWSq.basePlacements)));
};
function $c988709f87b64d9b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $aXPSi.default)(state.placement);
    var axis = (0, $fOHu6.default)(basePlacement);
    var isVertical = [
        (0, $8CWSq.left),
        (0, $8CWSq.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c988709f87b64d9b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $QrBqo.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $8CWSq.top) : (0, $8CWSq.left);
    var maxProp = axis === 'y' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $dNrcD.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $bnZ7G.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c988709f87b64d9b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4W0o9.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c988709f87b64d9b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c988709f87b64d9b$var$arrow,
    effect: $c988709f87b64d9b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("izul8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85307bf73b62e8b$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $ecS3L = parcelRequire("ecS3L");
function $d85307bf73b62e8b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d85307bf73b62e8b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8CWSq.top),
        (0, $8CWSq.right),
        (0, $8CWSq.bottom),
        (0, $8CWSq.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d85307bf73b62e8b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $ecS3L.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $ecS3L.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d85307bf73b62e8b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d85307bf73b62e8b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d85307bf73b62e8b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d85307bf73b62e8b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d85307bf73b62e8b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d85307bf73b62e8b$var$hide
};

});




parcelRegister("dmg8t", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $9b99d8a8ad795e92$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $kQSBm = parcelRequire("kQSBm");

var $2Leve = parcelRequire("2Leve");
function $9b99d8a8ad795e92$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $kQSBm.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $2Leve.setRef)(innerRef, node);
        (0, $2Leve.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $2Leve.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $2Leve.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("8r9C9", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $890d25d6ddbbb5af$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $890d25d6ddbbb5af$export$e618dc39ac9ad607);

var $kfs3D = parcelRequire("kfs3D");

var $5eRrO = parcelRequire("5eRrO");

var $ngqpF = parcelRequire("ngqpF");

var $8YZfj = parcelRequire("8YZfj");

var $fG8ma = parcelRequire("fG8ma");

var $6t2wI = parcelRequire("6t2wI");

var $i0VNY = parcelRequire("i0VNY");

var $35wVQ = parcelRequire("35wVQ");

var $akzU3 = parcelRequire("akzU3");

var $7VMaH = parcelRequire("7VMaH");
const $890d25d6ddbbb5af$export$214b055320e0bf32 = {
    clearIndicator: (0, $8YZfj.clearIndicatorCSS),
    container: (0, $kfs3D.containerCSS),
    control: (0, $5eRrO.css),
    dropdownIndicator: (0, $8YZfj.dropdownIndicatorCSS),
    group: (0, $ngqpF.groupCSS),
    groupHeading: (0, $ngqpF.groupHeadingCSS),
    indicatorsContainer: (0, $kfs3D.indicatorsContainerCSS),
    indicatorSeparator: (0, $8YZfj.indicatorSeparatorCSS),
    input: (0, $fG8ma.inputCSS),
    loadingIndicator: (0, $8YZfj.loadingIndicatorCSS),
    loadingMessage: (0, $6t2wI.loadingMessageCSS),
    menu: (0, $6t2wI.menuCSS),
    menuList: (0, $6t2wI.menuListCSS),
    menuPortal: (0, $6t2wI.menuPortalCSS),
    multiValue: (0, $i0VNY.multiValueCSS),
    multiValueLabel: (0, $i0VNY.multiValueLabelCSS),
    multiValueRemove: (0, $i0VNY.multiValueRemoveCSS),
    noOptionsMessage: (0, $6t2wI.noOptionsMessageCSS),
    option: (0, $35wVQ.optionCSS),
    placeholder: (0, $akzU3.placeholderCSS),
    singleValue: (0, $7VMaH.css),
    valueContainer: (0, $kfs3D.valueContainerCSS)
};
function $890d25d6ddbbb5af$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});
parcelRegister("kfs3D", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $9bc2a331068e3f37$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $9bc2a331068e3f37$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $9bc2a331068e3f37$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $9bc2a331068e3f37$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $9bc2a331068e3f37$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $9bc2a331068e3f37$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $9bc2a331068e3f37$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    });
const $9bc2a331068e3f37$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $9bc2a331068e3f37$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        ...unstyled ? {} : {
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        }
    });
const $9bc2a331068e3f37$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $DomJ2.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $9bc2a331068e3f37$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    });
const $9bc2a331068e3f37$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("DomJ2", function(module, exports) {

$parcel$export(module.exports, "noop", () => $a7fa863fc859695d$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $a7fa863fc859695d$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $a7fa863fc859695d$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $a7fa863fc859695d$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $a7fa863fc859695d$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $a7fa863fc859695d$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $a7fa863fc859695d$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $a7fa863fc859695d$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $a7fa863fc859695d$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $a7fa863fc859695d$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $a7fa863fc859695d$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $a7fa863fc859695d$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $a7fa863fc859695d$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $a7fa863fc859695d$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $a7fa863fc859695d$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $a7fa863fc859695d$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $a7fa863fc859695d$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $a7fa863fc859695d$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $a7fa863fc859695d$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $a7fa863fc859695d$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $a7fa863fc859695d$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $a7fa863fc859695d$export$4213b25a1c4e877);
const $a7fa863fc859695d$export$8793edee2d425525 = ()=>{};
const $a7fa863fc859695d$export$1643ccb46f49255c = ()=>'';
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $a7fa863fc859695d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $a7fa863fc859695d$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$a7fa863fc859695d$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $a7fa863fc859695d$export$33f062f47f21a01 = (value)=>{
    if ($a7fa863fc859695d$export$43bee75e5e14138e(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $a7fa863fc859695d$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $a7fa863fc859695d$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $a7fa863fc859695d$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $a7fa863fc859695d$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $a7fa863fc859695d$export$2e0654fad740d2e4(el) {
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $a7fa863fc859695d$export$c4a223a8ba9e4ea5(el) {
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a7fa863fc859695d$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $a7fa863fc859695d$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $a7fa863fc859695d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a7fa863fc859695d$export$858c30343199f3af(element, to, duration = 200, callback = $a7fa863fc859695d$export$8793edee2d425525) {
    const start = $a7fa863fc859695d$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $a7fa863fc859695d$var$easeOutCubic(currentTime, start, change, duration);
        $a7fa863fc859695d$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $a7fa863fc859695d$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a7fa863fc859695d$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a7fa863fc859695d$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $a7fa863fc859695d$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $a7fa863fc859695d$export$c0d0115e766e14c3(str) {
    return str.replace(/\W/g, '-');
}
function $a7fa863fc859695d$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $a7fa863fc859695d$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $a7fa863fc859695d$var$passiveOptionAccessed = false;
const $a7fa863fc859695d$var$options = {
    get passive () {
        return $a7fa863fc859695d$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $a7fa863fc859695d$var$w = typeof window !== 'undefined' ? window : {};
if ($a7fa863fc859695d$var$w.addEventListener && $a7fa863fc859695d$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $a7fa863fc859695d$var$w.addEventListener('p', $a7fa863fc859695d$export$8793edee2d425525, $a7fa863fc859695d$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $a7fa863fc859695d$var$w.removeEventListener('p', $a7fa863fc859695d$export$8793edee2d425525, false);
}
const $a7fa863fc859695d$export$b0622a6911dbeaf5 = $a7fa863fc859695d$var$passiveOptionAccessed;
function $a7fa863fc859695d$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $a7fa863fc859695d$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $a7fa863fc859695d$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a7fa863fc859695d$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $a7fa863fc859695d$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $a7fa863fc859695d$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("5eRrO", function(module, exports) {

$parcel$export(module.exports, "css", () => $6c9f9c8f28b24213$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $6c9f9c8f28b24213$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $6c9f9c8f28b24213$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        }
    });
const $6c9f9c8f28b24213$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        ...(0, $DomJ2.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6c9f9c8f28b24213$export$2e2bcd8739ae039 = $6c9f9c8f28b24213$var$Control;

});

parcelRegister("ngqpF", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $aad1e47212eaaeb7$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $aad1e47212eaaeb7$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $aad1e47212eaaeb7$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $aad1e47212eaaeb7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $aad1e47212eaaeb7$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
const $aad1e47212eaaeb7$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $byn9U.jsx)("div", null, children));
};
const $aad1e47212eaaeb7$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        ...unstyled ? {} : {
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        }
    });
const $aad1e47212eaaeb7$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $DomJ2.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aad1e47212eaaeb7$export$2e2bcd8739ae039 = $aad1e47212eaaeb7$var$Group;

});

parcelRegister("8YZfj", function(module, exports) {

$parcel$export(module.exports, "CrossIcon", () => $17a6994453780832$export$3b621d86b1566b2);
$parcel$export(module.exports, "DownChevron", () => $17a6994453780832$export$c5cbe1656ba71e6c);
$parcel$export(module.exports, "dropdownIndicatorCSS", () => $17a6994453780832$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $17a6994453780832$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $17a6994453780832$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $17a6994453780832$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "indicatorSeparatorCSS", () => $17a6994453780832$export$ec39646155d07fdd);
$parcel$export(module.exports, "IndicatorSeparator", () => $17a6994453780832$export$bd638c2ba7915668);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $17a6994453780832$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $17a6994453780832$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
function $17a6994453780832$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
const $17a6994453780832$var$styles = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
const $17a6994453780832$var$Svg = ({ size: size, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $17a6994453780832$var$styles,
        ...props
    });
const $17a6994453780832$export$3b621d86b1566b2 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
const $17a6994453780832$export$c5cbe1656ba71e6c = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
const $17a6994453780832$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        }
    });
const $17a6994453780832$export$e1687335805e1230 = $17a6994453780832$var$baseCSS;
const $17a6994453780832$export$ec98719d3db7f2e4 = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$export$c5cbe1656ba71e6c, null));
};
const $17a6994453780832$export$9c0419fd944c1def = $17a6994453780832$var$baseCSS;
const $17a6994453780832$export$ecf9cf59142dd54a = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$export$3b621d86b1566b2, null));
};
const $17a6994453780832$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1,
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        }
    });
const $17a6994453780832$export$bd638c2ba7915668 = (props)=>{
    const { innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...innerProps,
        ...(0, $DomJ2.getStyleProps)(props, 'indicatorSeparator', {
            'indicator-separator': true
        })
    });
};
// ==============================
// Loading
// ==============================
const $17a6994453780832$var$loadingDotAnimations = (0, $byn9U.keyframes)({
    '0%, 80%, 100%': {
        opacity: 0
    },
    '40%': {
        opacity: 1
    }
});
const $17a6994453780832$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        }
    });
const $17a6994453780832$var$LoadingDot = ({ delay: delay, offset: offset })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $byn9U.css)({
            animation: `${$17a6994453780832$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        })
    });
const $17a6994453780832$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 160,
        offset: true
    }), /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};

});

parcelRegister("fG8ma", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $08ad391264e2f439$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $08ad391264e2f439$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $08ad391264e2f439$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$08ad391264e2f439$var$containerStyle,
        ...unstyled ? {} : {
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        }
    });
const $08ad391264e2f439$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $08ad391264e2f439$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$08ad391264e2f439$var$spacingStyle
    }
};
const $08ad391264e2f439$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$08ad391264e2f439$var$spacingStyle
    });
const $08ad391264e2f439$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, $DomJ2.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || ''
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $08ad391264e2f439$var$inputStyle(isHidden),
        disabled: isDisabled,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$08ad391264e2f439$export$2e2bcd8739ae039 = $08ad391264e2f439$var$Input;

});

parcelRegister("6t2wI", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $b67347fe66559b87$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $b67347fe66559b87$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $b67347fe66559b87$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $b67347fe66559b87$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $b67347fe66559b87$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $b67347fe66559b87$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $b67347fe66559b87$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $b67347fe66559b87$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $b67347fe66559b87$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $b67347fe66559b87$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $b67347fe66559b87$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5O3G9 = parcelRequire("5O3G9");

var $lEfVV = parcelRequire("lEfVV");

var $k286k = parcelRequire("k286k");

var $DomJ2 = parcelRequire("DomJ2");
function $b67347fe66559b87$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $DomJ2.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $DomJ2.normalizedHeight)(scrollParent);
    const scrollTop = (0, $DomJ2.getScrollTop)(scrollParent);
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTop;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $DomJ2.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $b67347fe66559b87$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $b67347fe66559b87$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b67347fe66559b87$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'menu',
        [$b67347fe66559b87$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        ...unstyled ? {} : {
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        }
    });
const $b67347fe66559b87$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $b67347fe66559b87$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $eUqFw.useContext)($b67347fe66559b87$var$PortalPlacementContext) || {};
    const ref = (0, $eUqFw.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $eUqFw.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $eUqFw.useState)(null);
    const { controlHeight: controlHeight } = theme.spacing;
    (0, $k286k.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $b67347fe66559b87$export$bd649b913ec78e4a({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $b67347fe66559b87$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $b67347fe66559b87$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b67347fe66559b87$export$2e2bcd8739ae039 = $b67347fe66559b87$var$Menu;
const $b67347fe66559b87$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        ...unstyled ? {} : {
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        }
    });
const $b67347fe66559b87$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        //@ts-ignore
        ref: innerRef,
        ...innerProps
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $b67347fe66559b87$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        textAlign: 'center',
        ...unstyled ? {} : {
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        }
    });
const $b67347fe66559b87$export$cf0e22534d8b0074 = $b67347fe66559b87$var$noticeCSS;
const $b67347fe66559b87$export$98ec46397a8cb3cd = $b67347fe66559b87$var$noticeCSS;
const $b67347fe66559b87$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return(//@ts-ignore
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, children));
};
const $b67347fe66559b87$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, children);
};
const $b67347fe66559b87$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $b67347fe66559b87$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $eUqFw.useRef)(null);
    const cleanupRef = (0, $eUqFw.useRef)(null);
    const [placement, setPortalPlacement] = (0, $eUqFw.useState)($b67347fe66559b87$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $eUqFw.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $eUqFw.useState)(null);
    const updateComputedPosition = (0, $eUqFw.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $DomJ2.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $k286k.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $eUqFw.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $eUqFw.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $DomJ2.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)($b67347fe66559b87$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("i0VNY", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $b976d04d171aaa69$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $b976d04d171aaa69$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $b976d04d171aaa69$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $b976d04d171aaa69$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $b976d04d171aaa69$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $b976d04d171aaa69$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $b976d04d171aaa69$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");

var $8YZfj = parcelRequire("8YZfj");
const $b976d04d171aaa69$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        ...unstyled ? {} : {
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        }
    });
const $b976d04d171aaa69$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        }
    });
const $b976d04d171aaa69$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
        alignItems: 'center',
        display: 'flex',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        }
    });
const $b976d04d171aaa69$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $b976d04d171aaa69$export$cf9cf2a30a59265c = $b976d04d171aaa69$export$e1de505c1242dc1a;
const $b976d04d171aaa69$export$544aeea2a5ce08ee = $b976d04d171aaa69$export$e1de505c1242dc1a;
function $b976d04d171aaa69$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "button",
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)((0, $8YZfj.CrossIcon), {
        size: 14
    }));
}
const $b976d04d171aaa69$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            'aria-label': `Remove ${children || 'option'}`,
            ...removeProps
        },
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b976d04d171aaa69$export$2e2bcd8739ae039 = $b976d04d171aaa69$var$MultiValue;

});

parcelRegister("35wVQ", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $b618ec36fb5deec3$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $b618ec36fb5deec3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $b618ec36fb5deec3$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        ...unstyled ? {} : {
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            // provide some affordance on touch devices
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        }
    });
const $b618ec36fb5deec3$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        //@ts-ignore
        ref: innerRef,
        "aria-disabled": isDisabled,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b618ec36fb5deec3$export$2e2bcd8739ae039 = $b618ec36fb5deec3$var$Option;

});

parcelRegister("akzU3", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $ee7392090dabd55f$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $ee7392090dabd55f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $ee7392090dabd55f$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        ...unstyled ? {} : {
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $ee7392090dabd55f$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ee7392090dabd55f$export$2e2bcd8739ae039 = $ee7392090dabd55f$var$Placeholder;

});

parcelRegister("7VMaH", function(module, exports) {

$parcel$export(module.exports, "css", () => $bee4e3936873fc73$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $bee4e3936873fc73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $bee4e3936873fc73$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $bee4e3936873fc73$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bee4e3936873fc73$export$2e2bcd8739ae039 = $bee4e3936873fc73$var$SingleValue;

});


parcelRegister("aJuqz", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $a5765027d23d0a83$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $a5765027d23d0a83$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $j8gJ1 = parcelRequire("j8gJ1");
var $8LRlt = parcelRequire("8LRlt");
var $f3klQ = parcelRequire("f3klQ");

var $8R79R = parcelRequire("8R79R");

var $1oOGD = parcelRequire("1oOGD");
const $a5765027d23d0a83$var$packageName = "platform-pkg";
const $a5765027d23d0a83$var$packageVersion = "0.0.0-use.local";
const $a5765027d23d0a83$export$d1de3b251ccaa8a3 = (0, $1oOGD.default)((0, $8R79R.default));
const $a5765027d23d0a83$var$createAndFireEventOnAtlaskit = (0, $j8gJ1.default)('atlaskit');
const $a5765027d23d0a83$var$Select = (0, $8LRlt.default)({
    componentName: 'select',
    packageName: $a5765027d23d0a83$var$packageName,
    packageVersion: $a5765027d23d0a83$var$packageVersion
})((0, $f3klQ.default)({
    onChange: $a5765027d23d0a83$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $a5765027d23d0a83$var$packageName,
            packageVersion: $a5765027d23d0a83$var$packageVersion
        }
    })
})($a5765027d23d0a83$export$d1de3b251ccaa8a3));
var $a5765027d23d0a83$export$2e2bcd8739ae039 = $a5765027d23d0a83$var$Select;

});
parcelRegister("8R79R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68207d5ffd699d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $apnnW = parcelRequire("apnnW");

var $aXltS = parcelRequire("aXltS");
const $c68207d5ffd699d7$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const baseSelectProps = (0, $aXltS.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apnnW.default), {
        ref: ref,
        ...baseSelectProps
    });
});
var $c68207d5ffd699d7$export$2e2bcd8739ae039 = $c68207d5ffd699d7$var$StateManagedSelect;

});
parcelRegister("apnnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $812572970dc92908$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k1Zr4 = parcelRequire("k1Zr4");

var $a9GGG = parcelRequire("a9GGG");

var $6EqnL = parcelRequire("6EqnL");

var $l1pLY = parcelRequire("l1pLY");
var $gxsrN = parcelRequire("gxsrN");
var $4GHZi = parcelRequire("4GHZi");

var $1XbPn = parcelRequire("1XbPn");

var $6t2wI = parcelRequire("6t2wI");

var $f6Vzn = parcelRequire("f6Vzn");

var $8r9C9 = parcelRequire("8r9C9");

var $8ogLA = parcelRequire("8ogLA");

var $DomJ2 = parcelRequire("DomJ2");
const $812572970dc92908$export$9c21a3269931e1e6 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $DomJ2.isTouchCapable)(),
    captureMenuScroll: !(0, $DomJ2.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $f6Vzn.createFilter)(),
    formatGroupLabel: (0, $a9GGG.formatGroupLabel),
    getOptionLabel: (0, $a9GGG.getOptionLabel),
    getOptionValue: (0, $a9GGG.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $a9GGG.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $DomJ2.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $812572970dc92908$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $812572970dc92908$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $812572970dc92908$var$isOptionSelected(props, option, selectValue);
    const label = $812572970dc92908$var$getOptionLabel(props, option);
    const value = $812572970dc92908$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $812572970dc92908$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$812572970dc92908$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$812572970dc92908$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $812572970dc92908$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $812572970dc92908$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $DomJ2.notNullish));
}
function $812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $812572970dc92908$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $812572970dc92908$var$buildFocusableOptions(props, selectValue) {
    return $812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions($812572970dc92908$var$buildCategorizedOptions(props, selectValue));
}
function $812572970dc92908$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$812572970dc92908$var$shouldHideSelectedOptions(props) || !isSelected) && $812572970dc92908$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $812572970dc92908$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $812572970dc92908$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $812572970dc92908$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $812572970dc92908$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $812572970dc92908$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $812572970dc92908$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $812572970dc92908$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $812572970dc92908$var$getOptionValue(props, option);
    return selectValue.some((i)=>$812572970dc92908$var$getOptionValue(props, i) === candidate);
}
function $812572970dc92908$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $812572970dc92908$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $812572970dc92908$var$instanceId = 1;
class $812572970dc92908$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $812572970dc92908$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.isAppleDevice = (0, $k1Zr4.isAppleDevice)();
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $DomJ2.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $DomJ2.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $DomJ2.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $DomJ2.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $DomJ2.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $DomJ2.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $DomJ2.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        this.getFocusedOptionId = (focusedOption)=>{
            return $812572970dc92908$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $812572970dc92908$var$buildFocusableOptionsWithIds($812572970dc92908$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $DomJ2.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $812572970dc92908$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $812572970dc92908$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const { unstyled: unstyled } = this.props;
            const base = (0, $8r9C9.defaultStyles)[key](props, unstyled);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $6EqnL.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$812572970dc92908$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $DomJ2.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $812572970dc92908$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$812572970dc92908$var$instanceId);
        //@ts-ignore
        this.state.selectValue = (0, $DomJ2.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen && this.state.selectValue.length) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $812572970dc92908$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        //@ts-ignore
        const selectValue = (0, $DomJ2.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $812572970dc92908$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $812572970dc92908$var$buildFocusableOptionsWithIds($812572970dc92908$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $812572970dc92908$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $812572970dc92908$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $812572970dc92908$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $DomJ2.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $DomJ2.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $DomJ2.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus]
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    // ==============================
    // Getters
    // ==============================
    getTheme() {
        // Use the default theme if there are no customisations.
        if (!this.props.theme) return 0, $8ogLA.defaultTheme;
        // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.
        if (typeof this.props.theme === 'function') return this.props.theme((0, $8ogLA.defaultTheme));
        // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.
        return {
            ...(0, $8ogLA.defaultTheme),
            ...this.props.theme
        };
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue,
            theme: this.getTheme()
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $812572970dc92908$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $812572970dc92908$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $812572970dc92908$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const description = this.props['aria-describedby'] || descriptionId;
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'list',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            'aria-haspopup': 'listbox',
            'aria-describedby': description,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('live-region')
                ].join(' ') : this.getElementId('live-region')
            } : {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('placeholder')
                ].join(' ') : this.getElementId('placeholder')
            }
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return(//@ts-ignore
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1pLY.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $DomJ2.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            ...ariaAttributes
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder')
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                },
                data: opt
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled
        }, this.formatOptionLabel(singleValue, 'value'));
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ClearIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderIndicatorSeparator() {
        const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
        // separator doesn't make sense without the dropdown indicator
        if (!DropdownIndicator || !IndicatorSeparator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IndicatorSeparator, {
            ...commonProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: 'option',
                'aria-selected': this.isAppleDevice ? undefined : isSelected
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) menuUI = this.getCategorizedOptions().map((item)=>{
            if (item.type === 'group') {
                const { data: data, options: options, index: groupIndex } = item;
                const groupId = `${this.getElementId('group')}-${groupIndex}`;
                const headingId = `${groupId}-heading`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Group, {
                    ...commonProps,
                    key: groupId,
                    data: data,
                    options: options,
                    Heading: GroupHeading,
                    headingProps: {
                        id: headingId,
                        data: item.data
                    },
                    label: this.formatGroupLabel(item.data)
                }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`)));
            } else if (item.type === 'option') return render(item, `${item.index}`);
        });
        else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingMessage, commonProps, message);
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NoOptionsMessage, commonProps, message);
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6t2wI.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps
        }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Menu, {
                ...commonProps,
                ...menuPlacementProps,
                innerRef: ref,
                innerProps: {
                    onMouseDown: this.onMenuMouseDown,
                    onMouseMove: this.onMenuMouseMove,
                    id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                },
                isLoading: isLoading,
                placement: placement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GHZi.default), {
                captureEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom,
                lockEnabled: menuShouldBlockScroll
            }, (scrollTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuList, {
                    ...commonProps,
                    innerRef: (instance)=>{
                        this.getMenuListRef(instance);
                        scrollTargetRef(instance);
                    },
                    innerProps: {
                        role: 'listbox',
                        'aria-multiselectable': commonProps.isMulti,
                        id: this.getElementId('listbox')
                    },
                    isLoading: isLoading,
                    maxHeight: maxHeight,
                    focusedOption: focusedOption
                }, menuUI))));
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition
        }, menuElement) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxsrN.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                        key: `i-${i}`,
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, input);
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XbPn.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isAppleDevice
        });
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown
            },
            isDisabled: isDisabled,
            isFocused: isFocused
        }, this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Control, {
            ...commonProps,
            innerRef: this.getControlRef,
            innerProps: {
                onMouseDown: this.onControlMouseDown,
                onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            menuIsOpen: menuIsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IndicatorsContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
}

});
parcelRegister("k1Zr4", function(module, exports) {

$parcel$export(module.exports, "isAppleDevice", () => $377df83acaf7b466$export$e1865c3bedcd822b);
function $377df83acaf7b466$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $377df83acaf7b466$export$186c6964ca17d99() {
    return $377df83acaf7b466$var$testPlatform(/^iPhone/i);
}
function $377df83acaf7b466$export$9ac100e40613ea10() {
    return $377df83acaf7b466$var$testPlatform(/^Mac/i);
}
function $377df83acaf7b466$export$7bef049ce92e4224() {
    return $377df83acaf7b466$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $377df83acaf7b466$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $377df83acaf7b466$export$fedb369cb70207f1() {
    return $377df83acaf7b466$export$186c6964ca17d99() || $377df83acaf7b466$export$7bef049ce92e4224();
}
function $377df83acaf7b466$export$e1865c3bedcd822b() {
    return $377df83acaf7b466$export$9ac100e40613ea10() || $377df83acaf7b466$export$fedb369cb70207f1();
}

});

parcelRegister("a9GGG", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $c82f797eede48f28$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $c82f797eede48f28$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $c82f797eede48f28$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $c82f797eede48f28$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $c82f797eede48f28$export$f4da216a6ca54656 = (group)=>group.label;
const $c82f797eede48f28$export$dac6ace3020563ca = (option)=>option.label;
const $c82f797eede48f28$export$40be908210c5a79c = (option)=>option.value;
const $c82f797eede48f28$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("6EqnL", function(module, exports) {

$parcel$export(module.exports, "components", () => $676f8cc7fc9199f1$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $676f8cc7fc9199f1$export$71abc632aa29e6fe);

var $kfs3D = parcelRequire("kfs3D");

var $5eRrO = parcelRequire("5eRrO");

var $ngqpF = parcelRequire("ngqpF");

var $8YZfj = parcelRequire("8YZfj");

var $fG8ma = parcelRequire("fG8ma");

var $6t2wI = parcelRequire("6t2wI");

var $i0VNY = parcelRequire("i0VNY");

var $35wVQ = parcelRequire("35wVQ");

var $akzU3 = parcelRequire("akzU3");

var $7VMaH = parcelRequire("7VMaH");
const $676f8cc7fc9199f1$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $8YZfj.ClearIndicator),
    Control: (0, $5eRrO.default),
    DropdownIndicator: (0, $8YZfj.DropdownIndicator),
    DownChevron: (0, $8YZfj.DownChevron),
    CrossIcon: (0, $8YZfj.CrossIcon),
    Group: (0, $ngqpF.default),
    GroupHeading: (0, $ngqpF.GroupHeading),
    IndicatorsContainer: (0, $kfs3D.IndicatorsContainer),
    IndicatorSeparator: (0, $8YZfj.IndicatorSeparator),
    Input: (0, $fG8ma.default),
    LoadingIndicator: (0, $8YZfj.LoadingIndicator),
    Menu: (0, $6t2wI.default),
    MenuList: (0, $6t2wI.MenuList),
    MenuPortal: (0, $6t2wI.MenuPortal),
    LoadingMessage: (0, $6t2wI.LoadingMessage),
    NoOptionsMessage: (0, $6t2wI.NoOptionsMessage),
    MultiValue: (0, $i0VNY.default),
    MultiValueContainer: (0, $i0VNY.MultiValueContainer),
    MultiValueLabel: (0, $i0VNY.MultiValueLabel),
    MultiValueRemove: (0, $i0VNY.MultiValueRemove),
    Option: (0, $35wVQ.default),
    Placeholder: (0, $akzU3.default),
    SelectContainer: (0, $kfs3D.SelectContainer),
    SingleValue: (0, $7VMaH.default),
    ValueContainer: (0, $kfs3D.ValueContainer)
};
const $676f8cc7fc9199f1$export$71abc632aa29e6fe = (props)=>({
        ...$676f8cc7fc9199f1$export$9b5ac10f59f76296,
        ...props.components
    });

});

parcelRegister("l1pLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $edcfea7cbf7f9aab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $edcfea7cbf7f9aab$var$dummyInputStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $edcfea7cbf7f9aab$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $DomJ2.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $edcfea7cbf7f9aab$var$dummyInputStyles
    });
}

});

parcelRegister("gxsrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd01f5e5b5e85fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $iyKES = parcelRequire("iyKES");
function $fcd01f5e5b5e85fd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fcd01f5e5b5e85fd$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $fcd01f5e5b5e85fd$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $fcd01f5e5b5e85fd$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $iyKES.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcd01f5e5b5e85fd$export$2e2bcd8739ae039 = $fcd01f5e5b5e85fd$var$RequiredInput;

});

parcelRegister("4GHZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $edb2811a94dc1026$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $iAaF5 = parcelRequire("iAaF5");

var $eGczi = parcelRequire("eGczi");
function $edb2811a94dc1026$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $edb2811a94dc1026$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $edb2811a94dc1026$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $edb2811a94dc1026$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $iAaF5.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $eGczi.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onClick: $edb2811a94dc1026$var$blurSelectInput,
        css: $edb2811a94dc1026$var$styles
    }), children(targetRef));
}

});
parcelRegister("iAaF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bb9b4882346d814$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $DomJ2 = parcelRequire("DomJ2");
const $8bb9b4882346d814$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $8bb9b4882346d814$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $eUqFw.useRef)(false);
    const isTop = (0, $eUqFw.useRef)(false);
    const touchStart = (0, $eUqFw.useRef)(0);
    const scrollTarget = (0, $eUqFw.useRef)(null);
    const handleEventDelta = (0, $eUqFw.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $8bb9b4882346d814$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $eUqFw.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $eUqFw.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $eUqFw.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $eUqFw.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $DomJ2.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $eUqFw.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("eGczi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece6486884e5b6d9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $ece6486884e5b6d9$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $ece6486884e5b6d9$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $ece6486884e5b6d9$var$preventTouchMove(e) {
    e.preventDefault();
}
function $ece6486884e5b6d9$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $ece6486884e5b6d9$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $ece6486884e5b6d9$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $ece6486884e5b6d9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $ece6486884e5b6d9$var$activeScrollLocks = 0;
const $ece6486884e5b6d9$var$listenerOptions = {
    capture: false,
    passive: false
};
function $ece6486884e5b6d9$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $eUqFw.useRef)({});
    const scrollTarget = (0, $eUqFw.useRef)(null);
    const addScrollLock = (0, $eUqFw.useCallback)((touchScrollTarget)=>{
        if (!$ece6486884e5b6d9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $ece6486884e5b6d9$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $ece6486884e5b6d9$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($ece6486884e5b6d9$var$LOCK_STYLES).forEach((key)=>{
                const val = $ece6486884e5b6d9$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $ece6486884e5b6d9$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $ece6486884e5b6d9$var$preventTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $ece6486884e5b6d9$var$preventInertiaScroll, $ece6486884e5b6d9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $ece6486884e5b6d9$var$allowTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $ece6486884e5b6d9$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $eUqFw.useCallback)((touchScrollTarget)=>{
        if (!$ece6486884e5b6d9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $ece6486884e5b6d9$var$activeScrollLocks = Math.max($ece6486884e5b6d9$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $ece6486884e5b6d9$var$activeScrollLocks < 1) $ece6486884e5b6d9$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $ece6486884e5b6d9$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $ece6486884e5b6d9$var$preventTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $ece6486884e5b6d9$var$preventInertiaScroll, $ece6486884e5b6d9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $ece6486884e5b6d9$var$allowTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("1XbPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0af9987a261c33d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $625wI = parcelRequire("625wI");

var $kULp4 = parcelRequire("kULp4");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $c0af9987a261c33d$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $eUqFw.useMemo)(()=>({
            ...(0, $625wI.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $eUqFw.useMemo)(()=>{
        let message = '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    const ariaFocused = (0, $eUqFw.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    const ariaResults = (0, $eUqFw.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $eUqFw.useMemo)(()=>{
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-results"
    }, ariaResults), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kULp4.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $kULp4.default), {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c0af9987a261c33d$export$2e2bcd8739ae039 = $c0af9987a261c33d$var$LiveRegion;

});
parcelRegister("625wI", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $2e07b4483663f031$export$a7265767c78f9bae);
const $2e07b4483663f031$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return `option ${label}, deselected.`;
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected, isAppleDevice: isAppleDevice } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `${arr.indexOf(item) + 1} of ${arr.length}` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        if (context === 'menu' && isAppleDevice) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ''}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}.`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("kULp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $26f0af153c89be40$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $26f0af153c89be40$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $26f0af153c89be40$var$styles = {
    name: "1j8j4w4-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
};
const $26f0af153c89be40$var$A11yText = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $26f0af153c89be40$var$styles,
        ...props
    });
var $26f0af153c89be40$export$2e2bcd8739ae039 = $26f0af153c89be40$var$A11yText;

});


parcelRegister("f6Vzn", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $fdb4680dbf332fef$export$5d81789ff4aeccdf);

var $5iWql = parcelRequire("5iWql");

var $26i9q = parcelRequire("26i9q");
const $fdb4680dbf332fef$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)((0, $26i9q.stripDiacritics));
const $fdb4680dbf332fef$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $fdb4680dbf332fef$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $fdb4680dbf332fef$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $fdb4680dbf332fef$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $fdb4680dbf332fef$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $fdb4680dbf332fef$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $fdb4680dbf332fef$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $26i9q.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("26i9q", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $3944c2da7f0324a1$export$b5bee4b27048330b);
const $3944c2da7f0324a1$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $3944c2da7f0324a1$var$anyDiacritic = new RegExp('[' + $3944c2da7f0324a1$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $3944c2da7f0324a1$var$diacriticToBase = {};
for(let i = 0; i < $3944c2da7f0324a1$var$diacritics.length; i++){
    let diacritic = $3944c2da7f0324a1$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$3944c2da7f0324a1$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $3944c2da7f0324a1$export$b5bee4b27048330b = (str)=>{
    return str.replace($3944c2da7f0324a1$var$anyDiacritic, (match)=>$3944c2da7f0324a1$var$diacriticToBase[match]);
};

});


parcelRegister("8ogLA", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $aa68feeaf48a7bc6$export$164de7ab8df77ef0);
const $aa68feeaf48a7bc6$export$8f45430ccf837300 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
const $aa68feeaf48a7bc6$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
const $aa68feeaf48a7bc6$var$baseUnit = 4;
// The minimum height of the control
const $aa68feeaf48a7bc6$var$controlHeight = 38;
// The amount of space between the control and menu */
const $aa68feeaf48a7bc6$var$menuGutter = $aa68feeaf48a7bc6$var$baseUnit * 2;
const $aa68feeaf48a7bc6$export$5458b64234d1333c = {
    baseUnit: $aa68feeaf48a7bc6$var$baseUnit,
    controlHeight: $aa68feeaf48a7bc6$var$controlHeight,
    menuGutter: $aa68feeaf48a7bc6$var$menuGutter
};
const $aa68feeaf48a7bc6$export$164de7ab8df77ef0 = {
    borderRadius: $aa68feeaf48a7bc6$var$borderRadius,
    colors: $aa68feeaf48a7bc6$export$8f45430ccf837300,
    spacing: $aa68feeaf48a7bc6$export$5458b64234d1333c
};

});


parcelRegister("aXltS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4446f2908cc6068e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $4446f2908cc6068e$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $eUqFw.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $eUqFw.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $eUqFw.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $eUqFw.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("1oOGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $38250713238549ef$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $8r9C9 = parcelRequire("8r9C9");

var $lL8xO = parcelRequire("lL8xO");
var $grOdA = parcelRequire("grOdA");

var $65zLD = parcelRequire("65zLD");

var $5Doo5 = parcelRequire("5Doo5");

var $a3o6L = parcelRequire("a3o6L");

var $NHgCB = parcelRequire("NHgCB");
function $38250713238549ef$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $lL8xO.ClearIndicator,
                DropdownIndicator: $lL8xO.DropdownIndicator,
                LoadingIndicator: $lL8xO.LoadingIndicator,
                MultiValueRemove: $grOdA.MultiValueRemove,
                IndicatorSeparator: $grOdA.IndicatorSeparator,
                Input: $65zLD.Input,
                NoOptionsMessage: $5Doo5.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $NHgCB.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $NHgCB.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $8r9C9.mergeStyles)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $a3o6L.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("lL8xO", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $b55fa3a6708e6433$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $b55fa3a6708e6433$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $b55fa3a6708e6433$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5IJsn = parcelRequire("5IJsn");

var $3wscq = parcelRequire("3wscq");

var $45qbL = parcelRequire("45qbL");
var $1jsQJ = parcelRequire("1jsQJ");
var $8Vv3m = parcelRequire("8Vv3m");

var $6EqnL = parcelRequire("6EqnL");

var $bBdMg = parcelRequire("bBdMg");
const $b55fa3a6708e6433$var$iconContainerStyles = (0, $8Vv3m.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $b55fa3a6708e6433$var$dropdownWrapperStyles = (0, $8Vv3m.xcss)({
    padding: 'space.075'
});
const $b55fa3a6708e6433$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1jsQJ.default), {
        xcss: $b55fa3a6708e6433$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3wscq))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $b55fa3a6708e6433$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $45qbL.default), {
        as: "span",
        xcss: $b55fa3a6708e6433$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $b55fa3a6708e6433$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bBdMg.default), {
        size: "small"
    })));
};

});
parcelRegister("3wscq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $290a3c11f7e03bc6$var$_react = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $290a3c11f7e03bc6$var$_crossCircle = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("avwnz")));

var $290a3c11f7e03bc6$var$_selectClear = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("93YTD")));
function $290a3c11f7e03bc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $290a3c11f7e03bc6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $290a3c11f7e03bc6$var$_react.default.createElement($290a3c11f7e03bc6$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $290a3c11f7e03bc6$var$_selectClear.default
    }, props));
$290a3c11f7e03bc6$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $290a3c11f7e03bc6$var$_default = module.exports.default = $290a3c11f7e03bc6$var$CrossCircleIcon;

});
parcelRegister("avwnz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a65ea720a647725$var$_react = $7a65ea720a647725$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7a65ea720a647725$var$_UNSAFE_baseNew = $7a65ea720a647725$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $7a65ea720a647725$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a65ea720a647725$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $7a65ea720a647725$var$_react.default.createElement($7a65ea720a647725$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$7a65ea720a647725$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $7a65ea720a647725$var$_default = module.exports.default = $7a65ea720a647725$var$CrossCircleIcon;

});

parcelRegister("93YTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6993a19f4a8ea624$var$_react = $6993a19f4a8ea624$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $6993a19f4a8ea624$var$_crossCircle = $6993a19f4a8ea624$var$_interopRequireDefault((parcelRequire("7jum4")));
function $6993a19f4a8ea624$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6993a19f4a8ea624$var$SelectClearIcon = (props)=>/*#__PURE__*/ $6993a19f4a8ea624$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $6993a19f4a8ea624$var$_crossCircle.default
    }));
$6993a19f4a8ea624$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $6993a19f4a8ea624$var$_default = module.exports.default = $6993a19f4a8ea624$var$SelectClearIcon;

});
parcelRegister("7jum4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5531daa29081c39f$var$_react = $5531daa29081c39f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5531daa29081c39f$var$_UNSAFE_baseNew = $5531daa29081c39f$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $5531daa29081c39f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5531daa29081c39f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $5531daa29081c39f$var$_react.default.createElement($5531daa29081c39f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$5531daa29081c39f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $5531daa29081c39f$var$_default = module.exports.default = $5531daa29081c39f$var$CrossCircleIcon;

});




parcelRegister("grOdA", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $ac39515aa513e4da$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $ac39515aa513e4da$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $93YTD = parcelRequire("93YTD");

var $uSXUV = parcelRequire("uSXUV");

var $gYrJM = parcelRequire("gYrJM");

var $45qbL = parcelRequire("45qbL");
var $8Vv3m = parcelRequire("8Vv3m");

var $6EqnL = parcelRequire("6EqnL");

var $lL8xO = parcelRequire("lL8xO");
function $ac39515aa513e4da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ac39515aa513e4da$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $ac39515aa513e4da$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $ac39515aa513e4da$var$iconWrapperStyles = (0, $8Vv3m.xcss)({
    padding: 'space.025'
});
const $ac39515aa513e4da$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $gYrJM.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($uSXUV))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $gYrJM.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $45qbL.default), {
            xcss: $ac39515aa513e4da$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($uSXUV))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93YTD))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $ac39515aa513e4da$var$disabledStyles : $ac39515aa513e4da$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $ac39515aa513e4da$export$bd638c2ba7915668 = null;

});
parcelRegister("uSXUV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05cd7070e053e072$var$_react = $05cd7070e053e072$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $05cd7070e053e072$var$_UNSAFE_baseNew = $05cd7070e053e072$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $05cd7070e053e072$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05cd7070e053e072$var$CrossIcon = (props)=>/*#__PURE__*/ $05cd7070e053e072$var$_react.default.createElement($05cd7070e053e072$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$05cd7070e053e072$var$CrossIcon.displayName = 'CrossIcon';
var $05cd7070e053e072$var$_default = module.exports.default = $05cd7070e053e072$var$CrossIcon;

});


parcelRegister("65zLD", function(module, exports) {

$parcel$export(module.exports, "Input", () => $23b0d2dc6a551f19$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $6EqnL = parcelRequire("6EqnL");
function $23b0d2dc6a551f19$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute = props['aria-describedby'];
    const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
    if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EqnL.components).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("5Doo5", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $5ed62d2b15567313$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $1JJay = parcelRequire("1JJay");

var $6EqnL = parcelRequire("6EqnL");
const $5ed62d2b15567313$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EqnL.components).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("a3o6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4a10b382601121$export$2e2bcd8739ae039);

var $gYrJM = parcelRequire("gYrJM");

function $fe4a10b382601121$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $1b343b038f6c23ec$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $1b343b038f6c23ec$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $1b343b038f6c23ec$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $1b343b038f6c23ec$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $1b343b038f6c23ec$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $1b343b038f6c23ec$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $1b343b038f6c23ec$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $1b343b038f6c23ec$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $1b343b038f6c23ec$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $1b343b038f6c23ec$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $1b343b038f6c23ec$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $gYrJM.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $1b343b038f6c23ec$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $1b343b038f6c23ec$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $1b343b038f6c23ec$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`,
                fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                textTransform: 'none'
            })
    };
}

});

parcelRegister("NHgCB", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $d9c0a053f0c64587$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $d9c0a053f0c64587$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $d9c0a053f0c64587$export$8ee33f304118fce4);
function $d9c0a053f0c64587$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $d9c0a053f0c64587$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $d9c0a053f0c64587$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("2FrYX", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $0361e695debecd6f$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $0361e695debecd6f$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $0361e695debecd6f$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ddMyj = parcelRequire("ddMyj");

var $6EqnL = parcelRequire("6EqnL");


var $6ZA7b = parcelRequire("6ZA7b");

var $hVx5a = parcelRequire("hVx5a");
function $0361e695debecd6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0361e695debecd6f$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $6ZA7b.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $1b343b038f6c23ec$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $1b343b038f6c23ec$export$46987b49aab6d1a8)}`})`
});
const $0361e695debecd6f$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: [
            $0361e695debecd6f$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $0361e695debecd6f$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $0361e695debecd6f$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $0361e695debecd6f$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ddMyj))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $0361e695debecd6f$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $0361e695debecd6f$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $0361e695debecd6f$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).Control, {
        ...props,
        innerProps: innerProps
    }));
const $0361e695debecd6f$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hVx5a.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $0361e695debecd6f$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $0361e695debecd6f$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).IndicatorSeparator, props);
const $0361e695debecd6f$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).ClearIndicator, props);
const $0361e695debecd6f$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).MultiValueRemove, props);
const $0361e695debecd6f$export$71abc632aa29e6fe = {
    Control: $0361e695debecd6f$var$Control,
    DropdownIndicator: $0361e695debecd6f$var$DropdownIndicator,
    Menu: $0361e695debecd6f$var$Menu,
    IndicatorSeparator: $0361e695debecd6f$var$IndicatorSeparator,
    ClearIndicator: $0361e695debecd6f$var$ClearIndicator,
    MultiValueRemove: $0361e695debecd6f$var$MultiValueRemove
};

});
parcelRegister("ddMyj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a0226c6d5821eba$var$_react = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9a0226c6d5821eba$var$_search = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("eebsR")));

var $9a0226c6d5821eba$var$_search2 = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("hU0Tg")));
function $9a0226c6d5821eba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a0226c6d5821eba$var$SearchIcon = (props)=>/*#__PURE__*/ $9a0226c6d5821eba$var$_react.default.createElement($9a0226c6d5821eba$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $9a0226c6d5821eba$var$_search2.default
    }, props));
$9a0226c6d5821eba$var$SearchIcon.Name = 'SearchIconMigration';
var $9a0226c6d5821eba$var$_default = module.exports.default = $9a0226c6d5821eba$var$SearchIcon;

});
parcelRegister("hU0Tg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0885b6f5437ca77$var$_react = $d0885b6f5437ca77$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $d0885b6f5437ca77$var$_search = $d0885b6f5437ca77$var$_interopRequireDefault((parcelRequire("eebsR")));
function $d0885b6f5437ca77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d0885b6f5437ca77$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $d0885b6f5437ca77$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $d0885b6f5437ca77$var$_search.default
    }));
$d0885b6f5437ca77$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $d0885b6f5437ca77$var$_default = module.exports.default = $d0885b6f5437ca77$var$EditorSearchIcon;

});




parcelRegister("kKVap", function(module, exports) {

$parcel$export(module.exports, "default", () => $3be0f22625b44efd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jl1we = parcelRequire("jl1we");

var $gYrJM = parcelRequire("gYrJM");

var $byn9U = parcelRequire("byn9U");

function $3be0f22625b44efd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3be0f22625b44efd$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id })=>{
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        event.currentTarget.focus();
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jl1we.default), {
        content: label
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        css: [
            $3be0f22625b44efd$var$sharedColorContainerStyles,
            swatchSize === 'small' ? $3be0f22625b44efd$var$smallColorContainerSize : $3be0f22625b44efd$var$defaultColorContainerSize,
            $3be0f22625b44efd$var$colorCardButtonStyles,
            expanded && !(0, $gYrJM.fg)('platform-design-system-dsp-20821-color-pickr-focus') && $3be0f22625b44efd$var$colorCardButtonFocusedStyles
        ],
        disabled: isDisabled,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        "aria-label": label,
        "aria-expanded": expanded,
        "aria-haspopup": true,
        type: "button",
        id: id
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $3be0f22625b44efd$var$colorCardWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $3be0f22625b44efd$var$colorCardContentStyles,
            swatchSize === 'small' ? $3be0f22625b44efd$var$smallColorCardContentSize : $3be0f22625b44efd$var$defaultColorCardContentSize
        ],
        style: {
            background: value || 'transparent'
        }
    }))));
};
var $3be0f22625b44efd$export$2e2bcd8739ae039 = $3be0f22625b44efd$var$ColorCard;
const $3be0f22625b44efd$var$sharedColorContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    border: '2px solid transparent',
    boxSizing: 'border-box',
    borderRadius: '6px',
    transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    borderColor: `var(--ds-background-neutral-subtle, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    padding: "var(--ds-space-0, 0px)",
    cursor: 'pointer',
    outline: 'none'
});
const $3be0f22625b44efd$var$smallColorContainerSize = {
    name: "1435ao5",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);top:var(--ds-space-negative-025, -2px)"
};
const $3be0f22625b44efd$var$defaultColorContainerSize = {
    name: "1uafl10",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px)"
};
const $3be0f22625b44efd$var$colorCardButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':not(:focus):hover, :focus': {
        borderColor: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a)})`,
        outline: 'none'
    }
});
const $3be0f22625b44efd$var$colorCardButtonFocusedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a)})`,
    outline: 'none'
});
const $3be0f22625b44efd$var$colorCardWrapperStyles = {
    name: "10qlvma",
    styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
};
const $3be0f22625b44efd$var$colorCardContentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $1b343b038f6c23ec$export$4b16f52932fda51)})`}`
});
const $3be0f22625b44efd$var$smallColorCardContentSize = {
    name: "1rrhp72",
    styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
};
const $3be0f22625b44efd$var$defaultColorCardContentSize = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};

});

parcelRegister("3WxM1", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $d2ffeff600dce243$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $d2ffeff600dce243$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $d2ffeff600dce243$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $d2ffeff600dce243$export$84712d0562a614b8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSzvc = parcelRequire("iSzvc");

var $mbR6d = parcelRequire("mbR6d");

var $byn9U = parcelRequire("byn9U");


var $gYrJM = parcelRequire("gYrJM");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gCqfn = parcelRequire("gCqfn");
function $d2ffeff600dce243$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d2ffeff600dce243$export$d4c4e98c5044dc8 = (props)=>{
    const { //@ts-ignore react-select unsupported props
    selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $d2ffeff600dce243$var$colorPaletteContainerStyles,
        role: (0, $gYrJM.fg)('platform_color_picker-fix-a11y-violations') ? 'listbox' : 'group',
        ...(0, $gYrJM.fg)('platform_color_picker-fix-a11y-violations') ? {
            'aria-label': formatMessage((0, $gCqfn.default).menuListAriaLabel)
        } : {},
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $mbR6d.getWidth)(cols) : undefined
        },
        //@ts-ignore react-select unsupported props
        ref: innerRef
    }, children);
};
const $d2ffeff600dce243$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, //@ts-ignore react-select unsupported props
    selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $d2ffeff600dce243$var$colorCardWrapperStyles,
        ...innerProps,
        ...(0, $gYrJM.fg)('platform_color_picker-fix-a11y-violations') ? {
            'aria-label': label
        } : {}
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iSzvc.default), {
        type: (0, $df82270178fd50e6$export$9fea11a016bc5bcf),
        label: label,
        value: value,
        checkMarkColor: checkMarkColor,
        isOption: true,
        focused: isFocused,
        selected: isSelected,
        onKeyDown: (value)=>onOptionKeyDown(value),
        isTabbing: isTabbing
    }));
};
const $d2ffeff600dce243$export$ec98719d3db7f2e4 = ()=>null;
const $d2ffeff600dce243$export$84712d0562a614b8 = ()=>null;
const $d2ffeff600dce243$var$colorCardWrapperStyles = {
    name: "yotnll",
    styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
};
const $d2ffeff600dce243$var$colorPaletteContainerStyles = {
    name: "4t056h",
    styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
};

});
parcelRegister("iSzvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69cd2d4e2932b90$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bGu7W = parcelRequire("bGu7W");

var $jl1we = parcelRequire("jl1we");

var $gYrJM = parcelRequire("gYrJM");


var $byn9U = parcelRequire("byn9U");


var $jaTu3 = parcelRequire("jaTu3");
function $b69cd2d4e2932b90$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b69cd2d4e2932b90$var$ColorCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, componentRef)=>{
    const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $1b343b038f6c23ec$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onClickOld: onClickOld, onKeyDown: onKeyDown } = props;
    const ref = (0, $eUqFw.useRef)(null);
    const isInitialFocus = (0, $eUqFw.useRef)(true);
    const isColorPaletteMenu = type === (0, $df82270178fd50e6$export$2643a2cdce1d3963);
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $gYrJM.fg)('platform_color_palette-expose-event')) {
            if (onClick) {
                event.preventDefault();
                onClick(event, value);
            }
        } else if (onClickOld) {
            event.preventDefault();
            onClickOld(value);
        }
    }, [
        onClick,
        onClickOld,
        value
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && (onClickOld && !(0, $gYrJM.fg)('platform_color_palette-expose-event') || onClick && (0, $gYrJM.fg)('platform_color_palette-expose-event')) && (event.key === (0, $df82270178fd50e6$export$8152f929a25a0ff4) || event.key === (0, $df82270178fd50e6$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            // Remove optional call on FG cleanup platform_color_palette-expose-event
            (0, $gYrJM.fg)('platform_color_palette-expose-event') ? onClick?.(event, value) : onClickOld?.(value);
        }
        if (isColorPaletteMenu) onKeyDown?.(event);
        else if (event.key === (0, $df82270178fd50e6$export$10f6869ed0a7d75b)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [
        isColorPaletteMenu,
        isTabbing,
        value,
        onClick,
        onClickOld,
        onKeyDown
    ]);
    (0, $eUqFw.useImperativeHandle)(componentRef, ()=>({
            focus: ()=>{
                if (isColorPaletteMenu) {
                    if (isInitialFocus.current) {
                        autoFocus && !initialFocusRef && ref.current?.focus();
                        isInitialFocus.current = false;
                    } else ref.current?.focus();
                }
            }
        }), [
        autoFocus,
        isColorPaletteMenu,
        initialFocusRef
    ]);
    const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
    const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
    const ariaChecked = isColorPaletteMenu ? selected : undefined;
    const ariaLabel = isColorPaletteMenu ? label : undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jl1we.default), {
        content: label
    }, (tooltipProps)=>{
        delete tooltipProps['aria-describedby'];
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...tooltipProps,
            ref: initialFocusRef ? (0, $jaTu3.mergeRefs)([
                ref,
                tooltipProps.ref,
                initialFocusRef
            ]) : (0, $jaTu3.mergeRefs)([
                ref,
                tooltipProps.ref
            ]),
            role: (0, $gYrJM.fg)('platform_color_picker-fix-a11y-violations') ? role : isInsideMenuRole,
            tabIndex: selected ? 0 : -1,
            "aria-checked": (0, $gYrJM.fg)('platform_color_picker-fix-a11y-violations') ? ariaChecked : selected,
            "aria-label": (0, $gYrJM.fg)('platform_color_picker-fix-a11y-violations') ? ariaLabel : label,
            css: [
                $b69cd2d4e2932b90$var$sharedColorContainerStyles,
                (isColorPaletteMenu || isTabbing === undefined || isTabbing) && $b69cd2d4e2932b90$var$colorCardOptionTabbingStyles,
                focused && (isColorPaletteMenu || !isTabbing) && $b69cd2d4e2932b90$var$colorCardOptionFocusedStyles
            ],
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            onKeyDown: handleKeyDown
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $b69cd2d4e2932b90$var$colorCardWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $b69cd2d4e2932b90$var$colorCardContentStyles,
            style: {
                background: value || 'transparent'
            }
        }, selected && /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bGu7W))), {
            color: checkMarkColor,
            label: "",
            spacing: "spacious",
            LEGACY_margin: "1px"
        }))));
    });
});
var $b69cd2d4e2932b90$export$2e2bcd8739ae039 = $b69cd2d4e2932b90$var$ColorCard;
const $b69cd2d4e2932b90$var$colorCardOptionTabbingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover, :focus': {
        borderColor: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$8c13c2ee36917869)})`
    }
});
const $b69cd2d4e2932b90$var$colorCardOptionFocusedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$8c13c2ee36917869)})`
});
const $b69cd2d4e2932b90$var$sharedColorContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    border: '2px solid transparent',
    boxSizing: 'border-box',
    borderRadius: "var(--ds-border-radius-200, 6px)",
    transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    borderColor: `var(--ds-background-neutral-subtle, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    padding: "var(--ds-space-0, 0px)",
    cursor: 'pointer',
    outline: 'none'
});
const $b69cd2d4e2932b90$var$colorCardWrapperStyles = {
    name: "10qlvma",
    styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
};
const $b69cd2d4e2932b90$var$colorCardContentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $1b343b038f6c23ec$export$4b16f52932fda51)})`}`
});

});
parcelRegister("bGu7W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f201723548e4f57fdc94cbc14d31fc2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $881afc9037662b8b$var$_react = $881afc9037662b8b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $881afc9037662b8b$var$_checkMark = $881afc9037662b8b$var$_interopRequireDefault((parcelRequire("754Ex")));

var $881afc9037662b8b$var$_done = $881afc9037662b8b$var$_interopRequireDefault((parcelRequire("jK61f")));
function $881afc9037662b8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $881afc9037662b8b$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $881afc9037662b8b$var$_react.default.createElement($881afc9037662b8b$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $881afc9037662b8b$var$_done.default
    }, props));
$881afc9037662b8b$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $881afc9037662b8b$var$_default = module.exports.default = $881afc9037662b8b$var$CheckMarkIcon;

});
parcelRegister("754Ex", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $527c9bffe9af78c5$var$_react = $527c9bffe9af78c5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $527c9bffe9af78c5$var$_UNSAFE_baseNew = $527c9bffe9af78c5$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $527c9bffe9af78c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $527c9bffe9af78c5$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $527c9bffe9af78c5$var$_react.default.createElement($527c9bffe9af78c5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$527c9bffe9af78c5$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $527c9bffe9af78c5$var$_default = module.exports.default = $527c9bffe9af78c5$var$CheckMarkIcon;

});

parcelRegister("jK61f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5f6fb73c3fb2460$var$_react = $e5f6fb73c3fb2460$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $e5f6fb73c3fb2460$var$_checkMark = $e5f6fb73c3fb2460$var$_interopRequireDefault((parcelRequire("754Ex")));
function $e5f6fb73c3fb2460$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5f6fb73c3fb2460$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $e5f6fb73c3fb2460$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $e5f6fb73c3fb2460$var$_checkMark.default
    }));
$e5f6fb73c3fb2460$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $e5f6fb73c3fb2460$var$_default = module.exports.default = $e5f6fb73c3fb2460$var$EditorDoneIcon;

});


const $df82270178fd50e6$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $df82270178fd50e6$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $df82270178fd50e6$export$64c9b8c6e6a2c6ac = 32;
const $df82270178fd50e6$export$e51a3576c045c8d5 = ' ';
const $df82270178fd50e6$export$8152f929a25a0ff4 = 'Enter';
const $df82270178fd50e6$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $df82270178fd50e6$export$1734a06b2397c2a8 = 'ArrowDown';
const $df82270178fd50e6$export$842fd6cf65a6b80c = 'ArrowLeft';
const $df82270178fd50e6$export$695331c89a36efd6 = 'ArrowRight';
const $df82270178fd50e6$export$10f6869ed0a7d75b = 'Tab';
const $df82270178fd50e6$export$929c2026f4dd54a2 = 'Escape';

parcelRegister("jaTu3", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $df59fd64c73fe87e$export$c9058316764c140e);

var $iYh9J = parcelRequire("iYh9J");

var $37WxO = parcelRequire("37WxO");
function $df59fd64c73fe87e$export$c9058316764c140e(refs) {
    return (0, $37WxO.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $iYh9J.assignRef)(ref, newValue)));
}

});
parcelRegister("37WxO", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $246f7040b169dc51$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $246f7040b169dc51$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});



parcelRegister("mbR6d", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $bb88ee20728d77da$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $bb88ee20728d77da$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $6ZA7b = parcelRequire("6ZA7b");


var $5iWql = parcelRequire("5iWql");

var $lL6MX = parcelRequire("lL6MX");
const $bb88ee20728d77da$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $df82270178fd50e6$export$64c9b8c6e6a2c6ac) + (0, $6ZA7b.gridSize)() / 2);
    return mode === (0, $lL6MX.Mode).Standard ? width + (0, $6ZA7b.gridSize)() : width;
};
const $bb88ee20728d77da$export$d2312e68e1f5ad00 = (0, $5iWql.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});
parcelRegister("lL6MX", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $50eeec816b3c4bfe$export$9484bbecc3c49a2e);
var $50eeec816b3c4bfe$export$9484bbecc3c49a2e;
(function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
})($50eeec816b3c4bfe$export$9484bbecc3c49a2e || ($50eeec816b3c4bfe$export$9484bbecc3c49a2e = {}));

});


parcelRegister("gCqfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7389ed7d823c6bf0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7389ed7d823c6bf0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    },
    menuListAriaLabel: {
        id: 'jira.color-picker.src.menu-list-aria-label',
        defaultMessage: 'Color picker list',
        description: 'This text is used as aria-label text for the listbox element in color picker component'
    }
});

});



parcelRegister("lXXwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5b707d32fdf6c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $lL6MX = parcelRequire("lL6MX");

var $j8gJ1 = parcelRequire("j8gJ1");
var $8LRlt = parcelRequire("8LRlt");
var $f3klQ = parcelRequire("f3klQ");

var $iSzvc = parcelRequire("iSzvc");

var $gYrJM = parcelRequire("gYrJM");

var $mbR6d = parcelRequire("mbR6d");

var $byn9U = parcelRequire("byn9U");


function $3b5b707d32fdf6c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3b5b707d32fdf6c7$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, onChangeOld: onChangeOld, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $lL6MX.Mode).Standard, initialFocusRef: initialFocusRef })=>{
    const { options: options, value: selectedValue } = (0, $mbR6d.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
    const [focusedIndex, setFocusedIndex] = (0, $eUqFw.useState)(selectedColorIndex);
    const createAndFireEventOnAtlaskit = (0, $j8gJ1.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local"
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const colorCardRefs = (0, $eUqFw.useMemo)(()=>[], []);
    const handleChangeOld = (value)=>{
        onChangeOld?.(value, changeAnalyticsCaller());
    };
    const handleChange = (event, value)=>{
        // Set to required on FG cleanup platform_color_palette-expose-event
        onChange?.(event, value, changeAnalyticsCaller());
    };
    (0, $eUqFw.useEffect)(()=>{
        colorCardRefs[focusedIndex]?.focus();
    }, [
        focusedIndex,
        colorCardRefs
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const numItems = options.length;
        switch(event.key){
            case 0, $df82270178fd50e6$export$1734a06b2397c2a8:
            case 0, $df82270178fd50e6$export$695331c89a36efd6:
                setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                break;
            case 0, $df82270178fd50e6$export$b34c7ae3fd8138d2:
            case 0, $df82270178fd50e6$export$842fd6cf65a6b80c:
                setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                break;
            case 0, $df82270178fd50e6$export$10f6869ed0a7d75b:
                if (isFocusLockEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    setFocusedIndex(selectedColorIndex);
                }
                break;
            default:
                break;
        }
    }, [
        isFocusLockEnabled,
        selectedColorIndex,
        setFocusedIndex,
        options
    ]);
    const isInsideMenuRole = (0, $gYrJM.fg)('platform_color_picker-fix-a11y-violations') ? 'menu' : 'group';
    const role = isInsideMenu ? isInsideMenuRole : 'radiogroup';
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-label": fullLabel,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            $3b5b707d32fdf6c7$var$colorPaletteMenuStyles,
            mode === (0, $lL6MX.Mode).Standard && $3b5b707d32fdf6c7$var$colorPaletteMenuStandardStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $mbR6d.getWidth)(cols, mode)}px`
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $3b5b707d32fdf6c7$var$colorPaletteContainerStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            mode === (0, $lL6MX.Mode).Compact && $3b5b707d32fdf6c7$var$colorPaletteContainerCompactStyles
        ]
    }, options.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $3b5b707d32fdf6c7$var$colorCardWrapperStyles,
            key: value
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iSzvc.default), {
            type: (0, $df82270178fd50e6$export$2643a2cdce1d3963),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            selected: value === selectedValue.value,
            ...(0, $gYrJM.fg)('platform_color_palette-expose-event') ? {
                onClick: handleChange
            } : {
                onClickOld: handleChangeOld
            },
            ref: (ref)=>{
                colorCardRefs[index] = ref;
            },
            autoFocus: autoFocus,
            initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
            isInsideMenu: isInsideMenu,
            onKeyDown: handleKeyDown
        })))));
};
var $3b5b707d32fdf6c7$export$2e2bcd8739ae039 = (0, $8LRlt.default)({
    componentName: 'color-picker',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
})((0, $f3klQ.default)()($3b5b707d32fdf6c7$export$4bbfe93c6a14e8e6));
const $3b5b707d32fdf6c7$var$colorCardWrapperStyles = {
    name: "yotnll",
    styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
};
const $3b5b707d32fdf6c7$var$colorPaletteContainerStyles = {
    name: "4t056h",
    styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
};
const $3b5b707d32fdf6c7$var$colorPaletteContainerCompactStyles = {
    name: "h6te2n",
    styles: "padding:var(--ds-space-0, 0)"
};
const $3b5b707d32fdf6c7$var$colorPaletteMenuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'relative',
    margin: "var(--ds-space-0, 0)",
    backgroundColor: `var(--ds-surface-overlay, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`
});
const $3b5b707d32fdf6c7$var$colorPaletteMenuStandardStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $1b343b038f6c23ec$export$1ce2d1575d444ceb)}, 0 0 8px ${(0, $1b343b038f6c23ec$export$1ce2d1575d444ceb)}`})`
});

});


parcelRegister("5E6sS", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ac3c3a7e824635$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5bNY = parcelRequire("b5bNY");

var $azeZS = parcelRequire("azeZS");

var $hFzXe = parcelRequire("hFzXe");

var $iCgyP = parcelRequire("iCgyP");

var $gYrJM = parcelRequire("gYrJM");

var $lKNwt = parcelRequire("lKNwt");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $35ac3c3a7e824635$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
    const itemRef = (0, $lKNwt.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFzXe.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCgyP.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
});
var $35ac3c3a7e824635$export$2e2bcd8739ae039 = $35ac3c3a7e824635$var$DropdownMenuItem;

});

parcelRegister("e0IEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3df5a6f567feefa8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Pede = parcelRequire("2Pede");

var $cUyTA = parcelRequire("cUyTA");

var $f8stz = parcelRequire("f8stz");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $3df5a6f567feefa8$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $2Pede.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUyTA.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8stz.default), {
        id: titleId,
        title: title
    }), children);
});
var $3df5a6f567feefa8$export$2e2bcd8739ae039 = $3df5a6f567feefa8$var$DropdownMenuItemGroup;

});

parcelRegister("5vJDH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $403340083e640e04$var$_react = $403340083e640e04$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $403340083e640e04$var$_showMoreHorizontal = $403340083e640e04$var$_interopRequireDefault((parcelRequire("6eRT3")));
function $403340083e640e04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $403340083e640e04$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $403340083e640e04$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props, {
        newIcon: $403340083e640e04$var$_showMoreHorizontal.default
    }));
$403340083e640e04$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $403340083e640e04$var$_default = module.exports.default = $403340083e640e04$var$EditorMoreIcon;

});

parcelRegister("4HwSc", function(module, exports) {

$parcel$export(module.exports, "useSwitchModals", () => $219a1920f5678086$export$5ed4b99cbad4ebd6);

var $7qgRx = parcelRequire("7qgRx");
const { useSwitch: $219a1920f5678086$var$useSwitch } = (0, $7qgRx.createSwitchController)('jira-switch-modals');
const $219a1920f5678086$export$5ed4b99cbad4ebd6 = $219a1920f5678086$var$useSwitch;

});
parcelRegister("7qgRx", function(module, exports) {

$parcel$export(module.exports, "createSwitchController", () => $34198a6b757ea1c3$export$1856548326159ec8);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");
const $34198a6b757ea1c3$export$1856548326159ec8 = (name, activeByDefault)=>{
    const actions = {
        on: (active)=>({ setState: setState })=>setState({
                    active: active
                }),
        off: (active)=>({ setState: setState, getState: getState })=>{
                if (getState().active === active || active === undefined) setState({
                    active: undefined
                });
            },
        toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                if (getState().active === active) dispatch(actions.off(active));
                else dispatch(actions.on(active));
            }
    };
    const initialState = {
        active: activeByDefault
    };
    const store = (0, $WBLbN.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    const SwitchContainer = (0, $WBLbN.createContainer)(store);
    const selector = (state, key)=>state.active === key;
    const useSwitchInternal = (0, $WBLbN.createHook)(store, {
        selector: selector
    });
    const useSwitch = (active)=>{
        const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
        const on = (0, $eUqFw.useCallback)(()=>onSwitch(active), [
            onSwitch,
            active
        ]);
        const off = (0, $eUqFw.useCallback)(()=>offSwitch(active), [
            active,
            offSwitch
        ]);
        const toggle = (0, $eUqFw.useCallback)(()=>toggleSwitch(active), [
            toggleSwitch,
            active
        ]);
        return [
            isActive,
            {
                on: on,
                off: off,
                toggle: toggle
            }
        ];
    };
    return {
        SwitchContainer: SwitchContainer,
        useSwitch: useSwitch
    };
};

});


parcelRegister("2phqk", function(module, exports) {

$parcel$export(module.exports, "DeleteGadgetModal", () => $fd7591fe0335069d$export$80937f1cc474f594);

var $eUqFw = parcelRequire("eUqFw");

var $f4cFG = parcelRequire("f4cFG");

var $gGtKh = parcelRequire("gGtKh");

var $4HwSc = parcelRequire("4HwSc");

var $dyfd9 = parcelRequire("dyfd9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fd7591fe0335069d$var$AsyncDeleteGadgetModal = (0, $dyfd9.lazy)(()=>(parcelRequire("GBmyI")), {
    moduleId: "./src/packages/global-pages/dashboard/edit/src/ui/gadget-editable/config-dropdown/delete-gadget-modal/main.tsx"
});
const $fd7591fe0335069d$export$80937f1cc474f594 = ({ id: id, onDeleteGadget: onDeleteGadget, gadgetName: gadgetName, onClose: onClose })=>{
    const [isOpen, { off: close }] = (0, $4HwSc.useSwitchModals)(id);
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "delete-gadget-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4cFG.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd7591fe0335069d$var$AsyncDeleteGadgetModal, {
        gadgetName: gadgetName,
        onClose: ()=>{
            close();
            onClose?.();
        },
        onDeleteGadget: onDeleteGadget
    })) : null;
};

});
parcelRegister("GBmyI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kDbrn")
]).then(()=>parcelRequire('cbuzt'));

});


parcelRegister("5Xtlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2f6dc3f532d1e7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $db2f6dc3f532d1e7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreActions: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.more-actions",
        "defaultMessage": "More actions for {gadgetTitle} gadget"
    },
    expand: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.expand",
        "defaultMessage": "Expand"
    },
    maximize: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.maximize",
        "defaultMessage": "Maximize"
    },
    restore: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.restore",
        "defaultMessage": "Restore"
    },
    delete: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.delete",
        "defaultMessage": "Delete"
    },
    configure: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.configure",
        "defaultMessage": "Configure"
    },
    rename: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.rename",
        "defaultMessage": "Rename"
    },
    duplicate: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.duplicate",
        "defaultMessage": "Duplicate"
    },
    colorHeading: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.color-heading",
        "defaultMessage": "Highlight color"
    }
});

});


parcelRegister("hDBf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d426fd276e2568b5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d426fd276e2568b5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    rename: {
        "id": "dashboard-edit.gadget-editable.rename",
        "defaultMessage": "Rename {gadgetName}"
    }
});

});

parcelRegister("dX4P5", function(module, exports) {

$parcel$export(module.exports, "TitleEditor", () => $1b86d985f144069c$export$b7ae68644199241a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cbhON = parcelRequire("cbhON");

var $cfU5U = parcelRequire("cfU5U");

var $iBeSy = parcelRequire("iBeSy");
var $8Vv3m = parcelRequire("8Vv3m");

var $iSgqw = parcelRequire("iSgqw");


var $5JgJ2 = parcelRequire("5JgJ2");

var $amTzx = parcelRequire("amTzx");
const $1b86d985f144069c$export$b7ae68644199241a = ({ isRenamable: isRenamable, isRenaming: isRenaming, title: title, onConfirmEdit: onConfirmEdit, onCancelEdit: onCancelEdit, onEdit: onEdit, editButtonLabel: editButtonLabel, children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return !isRenamable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), null, !isRenaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b86d985f144069c$var$DragHandlerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cbhON))), {
        label: formatMessage((0, $amTzx.default).dragLabel),
        primaryColor: `var(--ds-text, ${(0, $1b343b038f6c23ec$exports).N80})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b86d985f144069c$var$InlineEditWrapper, {
        "data-testid": "dashboard-edit.ui.gadget-editable.title-editor.inline-edit-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfU5U.default), {
        label: "",
        defaultValue: title,
        isEditing: isRenaming,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iSgqw.default), {
                ...fieldProps,
                "aria-label": "Edit gadget title text input",
                testId: "dashboard-edit.ui.gadget-editable.title-editor.text-input"
            }),
        readView: ()=>children,
        onConfirm: onConfirmEdit,
        onCancel: onCancelEdit,
        readViewFitContainerWidth: true,
        onEdit: onEdit,
        editButtonLabel: editButtonLabel
    })));
};
const $1b86d985f144069c$var$DragHandlerWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
        xcss: $1b86d985f144069c$var$dragHandlerWrapperStyles
    }, children);
const $1b86d985f144069c$var$dragHandlerWrapperStyles = (0, $8Vv3m.xcss)({
    flexShrink: 0
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b86d985f144069c$var$InlineEditWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _80om1kdv _6u9n1osq _wb9k78py",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cbhON", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8de455757cc791d5$var$_react = $8de455757cc791d5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $8de455757cc791d5$var$_dragHandle = $8de455757cc791d5$var$_interopRequireDefault((parcelRequire("51nvi")));
function $8de455757cc791d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8de455757cc791d5$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $8de455757cc791d5$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props, {
        newIcon: $8de455757cc791d5$var$_dragHandle.default
    }));
$8de455757cc791d5$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $8de455757cc791d5$var$_default = module.exports.default = $8de455757cc791d5$var$DragHandlerIcon;

});
parcelRegister("51nvi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b639051269ef116e35808d9097e35bf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a7f471ba251a970$var$_react = $3a7f471ba251a970$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a7f471ba251a970$var$_UNSAFE_baseNew = $3a7f471ba251a970$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $3a7f471ba251a970$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "DragHandle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for draggable elements.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a7f471ba251a970$var$DragHandleIcon = (props)=>/*#__PURE__*/ $3a7f471ba251a970$var$_react.default.createElement($3a7f471ba251a970$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$3a7f471ba251a970$var$DragHandleIcon.displayName = 'DragHandleIcon';
var $3a7f471ba251a970$var$_default = module.exports.default = $3a7f471ba251a970$var$DragHandleIcon;

});


parcelRegister("cfU5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5dfd74fbffa6b4f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $iiktD = parcelRequire("iiktD");

var $kjf2q = parcelRequire("kjf2q");

var $kXuXp = parcelRequire("kXuXp");

var $gYrJM = parcelRequire("gYrJM");

var $1jsQJ = parcelRequire("1jsQJ");

var $hVx5a = parcelRequire("hVx5a");

var $bUp0K = parcelRequire("bUp0K");

var $bSz51 = parcelRequire("bSz51");

var $jokIk = parcelRequire("jokIk");
function $a5dfd74fbffa6b4f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a5dfd74fbffa6b4f$var$fieldStyles = {
    name: "nziz0a",
    styles: "max-width:100%;position:relative"
};
const $a5dfd74fbffa6b4f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $a5dfd74fbffa6b4f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eUqFw.useState)(startWithEditViewOpen);
    const timerRef = (0, $eUqFw.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $bSz51.default)(isEditing, isEditingState);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $iiktD.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$a5dfd74fbffa6b4f$var$analyticsAttributes
    });
    const onCancelClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /**
   * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /**
   * Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jokIk.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kXuXp.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $byn9U.jsx)("form", {
            /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') {
                    if ((0, $gYrJM.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                    onCancel();
                }
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $kjf2q.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $a5dfd74fbffa6b4f$var$fieldStyles,
                onBlur: (e)=>{
                    if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $bUp0K.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $1jsQJ.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hVx5a.default), null, "Submit")))) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $kjf2q.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $a5dfd74fbffa6b4f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $byn9U.jsx)($a5dfd74fbffa6b4f$var$InnerInlineEdit, props);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a5dfd74fbffa6b4f$export$2e2bcd8739ae039 = $a5dfd74fbffa6b4f$var$InlineEdit;

});
parcelRegister("kjf2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $50137fc5c4153c86$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $ac4Xm = parcelRequire("ac4Xm");

var $kXuXp = parcelRequire("kXuXp");

var $5daQk = parcelRequire("5daQk");

var $9wJ3k = parcelRequire("9wJ3k");

var $2fFJv = parcelRequire("2fFJv");
function $50137fc5c4153c86$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $50137fc5c4153c86$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $50137fc5c4153c86$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $50137fc5c4153c86$var$isFunction(x) {
    return typeof x === 'function';
}
function $50137fc5c4153c86$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $50137fc5c4153c86$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $50137fc5c4153c86$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $kXuXp.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $kXuXp.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $50137fc5c4153c86$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $50137fc5c4153c86$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$50137fc5c4153c86$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $50137fc5c4153c86$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $50137fc5c4153c86$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($50137fc5c4153c86$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $50137fc5c4153c86$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5daQk.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $9wJ3k.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $ac4Xm.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("ac4Xm", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $a5ebb4ca1f8f209f$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $a5ebb4ca1f8f209f$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("kXuXp", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $fe0d14c455a1a3a5$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $fe0d14c455a1a3a5$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $fe0d14c455a1a3a5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $fe0d14c455a1a3a5$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $fe0d14c455a1a3a5$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $fe0d14c455a1a3a5$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe0d14c455a1a3a5$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe0d14c455a1a3a5$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("5daQk", function(module, exports) {

$parcel$export(module.exports, "Label", () => $405fa8c1002455c3$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $405fa8c1002455c3$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $405fa8c1002455c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $405fa8c1002455c3$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $405fa8c1002455c3$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $405fa8c1002455c3$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $405fa8c1002455c3$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $405fa8c1002455c3$var$fieldsetLabelStyles
    }, children);
};
var $405fa8c1002455c3$export$2e2bcd8739ae039 = $405fa8c1002455c3$export$b04be29aa201d4f5;

});

parcelRegister("9wJ3k", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae89c844a0b0c9b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $4ae89c844a0b0c9b$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $1b343b038f6c23ec$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $4ae89c844a0b0c9b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $4ae89c844a0b0c9b$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("bUp0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a38d43ab7d59695$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
                                                                                                                                      * @jsxRuntime classic
                                                                                                                                      * @jsx jsx
                                                                                                                                      */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $kRXDJ = parcelRequire("kRXDJ");

var $8VBU9 = parcelRequire("8VBU9");

var $clplI = parcelRequire("clplI");

function $5a38d43ab7d59695$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5a38d43ab7d59695$var$buttonsContainerStyles = {
    name: "ki22df",
    styles: "display:flex;position:absolute;flex-shrink:0;inset-block-start:100%;inset-inline-end:0;margin-block-start:var(--ds-space-075, 6px)"
};
const $5a38d43ab7d59695$var$buttonWrapperBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $1b343b038f6c23ec$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $1b343b038f6c23ec$export$d2d3bedfb276cac0)}`})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:last-child': {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    '& > button': {
        backgroundColor: `var(--ds-surface-overlay, ${(0, $1b343b038f6c23ec$export$8d43898f60b96a82)})`
    },
    '& > button:hover': {
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $1b343b038f6c23ec$export$920c0d5c49070351)})`
    },
    '& > button:active': {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: `var(--ds-text, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`
    }
});
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Buttons__
 *
 * A buttons {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $5a38d43ab7d59695$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5a38d43ab7d59695$var$buttonsContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5a38d43ab7d59695$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kRXDJ.default), {
        type: "submit",
        icon: (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8VBU9))), {
                ...iconProps,
                size: "small"
            }),
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5a38d43ab7d59695$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kRXDJ.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clplI))), {
                ...iconProps,
                size: "small"
            }),
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $5a38d43ab7d59695$export$2e2bcd8739ae039 = $5a38d43ab7d59695$var$Buttons;

});
parcelRegister("8VBU9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68010cb3d3545bb6$var$_react = $68010cb3d3545bb6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $68010cb3d3545bb6$var$_checkMark = $68010cb3d3545bb6$var$_interopRequireDefault((parcelRequire("754Ex")));
function $68010cb3d3545bb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68010cb3d3545bb6$var$CheckIcon = (props)=>/*#__PURE__*/ $68010cb3d3545bb6$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $68010cb3d3545bb6$var$_checkMark.default
    }));
$68010cb3d3545bb6$var$CheckIcon.displayName = 'CheckIcon';
var $68010cb3d3545bb6$var$_default = module.exports.default = $68010cb3d3545bb6$var$CheckIcon;

});


parcelRegister("bSz51", function(module, exports) {

$parcel$export(module.exports, "default", () => $800c5d850cf7be04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $800c5d850cf7be04$var$usePrevious = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $800c5d850cf7be04$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const editViewRef = (0, $eUqFw.useRef)();
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $800c5d850cf7be04$var$usePrevious(shouldBeEditing);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $800c5d850cf7be04$export$2e2bcd8739ae039 = $800c5d850cf7be04$var$useButtonFocusHook;

});

parcelRegister("jokIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $824ecafb10b35862$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1jsQJ = parcelRequire("1jsQJ");
var $8Vv3m = parcelRequire("8Vv3m");

function $824ecafb10b35862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $824ecafb10b35862$var$readViewContainerStyles = {
    name: "1xe63ku",
    styles: "line-height:1"
};
const $824ecafb10b35862$var$editButtonStyles = (0, $8Vv3m.xcss)({
    display: 'block',
    margin: 'space.0',
    padding: 'space.0',
    appearance: 'none',
    background: 'transparent',
    border: 0,
    lineHeight: 1,
    outline: 0,
    ':focus-visible': {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ':focus + div': {
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid'
    }
});
const $824ecafb10b35862$var$readViewWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    border: '2px solid transparent',
    borderRadius: "var(--ds-border-radius, 3px)",
    transition: 'background 0.2s',
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`
    }
});
const $824ecafb10b35862$var$readViewFitContainerWidthStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $824ecafb10b35862$var$DRAG_THRESHOLD = 5;
const $824ecafb10b35862$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $824ecafb10b35862$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $824ecafb10b35862$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $824ecafb10b35862$var$readViewContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1jsQJ.default), {
        xcss: $824ecafb10b35862$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $824ecafb10b35862$var$readViewWrapperStyles,
            readViewFitContainerWidth && $824ecafb10b35862$var$readViewFitContainerWidthStyles
        ],
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $824ecafb10b35862$export$2e2bcd8739ae039 = $824ecafb10b35862$var$ReadView;

});


parcelRegister("iSgqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $82c9623a5869bb9a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $iiktD = parcelRequire("iiktD");

var $6tn9L = parcelRequire("6tn9L");
const $82c9623a5869bb9a$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $82c9623a5869bb9a$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $iiktD.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c9623a5869bb9a$var$analyticsParams
    });
    const handleOnBlur = (0, $iiktD.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c9623a5869bb9a$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $6tn9L.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $6tn9L.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $82c9623a5869bb9a$export$2e2bcd8739ae039 = $82c9623a5869bb9a$var$Textfield;

});
parcelRegister("6tn9L", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $516a227838e26b1c$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $516a227838e26b1c$export$3eeb47dc8e6249d9);

const $516a227838e26b1c$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $1b343b038f6c23ec$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $516a227838e26b1c$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $516a227838e26b1c$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $516a227838e26b1c$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $1b343b038f6c23ec$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $516a227838e26b1c$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $516a227838e26b1c$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $1b343b038f6c23ec$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $516a227838e26b1c$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $516a227838e26b1c$var$backgroundColor[appearance],
        borderColor: $516a227838e26b1c$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $1b343b038f6c23ec$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $516a227838e26b1c$var$backgroundColorHover[appearance],
            borderColor: $516a227838e26b1c$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $516a227838e26b1c$var$backgroundColorFocus[appearance],
            borderColor: $516a227838e26b1c$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$516a227838e26b1c$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $516a227838e26b1c$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $516a227838e26b1c$var$getMaxWidth = (width)=>!width ? `100%` : width in $516a227838e26b1c$var$widthMap ? $516a227838e26b1c$var$widthMap[width] : +width;
const $516a227838e26b1c$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$516a227838e26b1c$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $516a227838e26b1c$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $516a227838e26b1c$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("amTzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd1fadc0eb0a5ed5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd1fadc0eb0a5ed5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dragLabel: {
        "id": "dashboard-edit.gadget-editable.title-editor.drag-label",
        "defaultMessage": "Drag to move gadget"
    }
});

});


parcelRegister("7Vjhj", function(module, exports) {

$parcel$export(module.exports, "useGadgetTitleChangeErrorFlag", () => $d89cd66e1307f477$export$be3e1e1bb367fdda);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $ayz1g = parcelRequire("ayz1g");
const $d89cd66e1307f477$export$be3e1e1bb367fdda = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    return (0, $eUqFw.useCallback)(()=>{
        showFlag({
            key: (0, $eo17r.toFlagId)('gadgetTitleError'),
            type: 'error',
            title: (0, $ayz1g.default).errorFlagTitle,
            description: (0, $ayz1g.default).errorFlagDescription,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            actions: [
                {
                    content: (0, $ayz1g.default).errorFlagAction,
                    onClick: ()=>window.location.reload()
                }
            ]
        });
    }, [
        showFlag
    ]);
};

});
parcelRegister("ayz1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $94692d8704146f07$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $94692d8704146f07$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "dashboard-edit.gadget-editable.utils.error-flag-title",
        "defaultMessage": "Error saving gadget name"
    },
    errorFlagDescription: {
        "id": "dashboard-edit.gadget-editable.utils.error-flag-description",
        "defaultMessage": "Refresh the page and try again"
    },
    errorFlagAction: {
        "id": "dashboard-edit.gadget-editable.utils.error-flag-action",
        "defaultMessage": "Refresh"
    }
});

});



parcelRegister("hoIyF", function(module, exports) {

$parcel$export(module.exports, "AsyncAddGadgetPanel", () => $e1497d031604cbf2$export$6fe03cad6a67ebf8);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

var $ePdsY = parcelRequire("ePdsY");

var $8Dzk5 = parcelRequire("8Dzk5");

var $dlqdQ = parcelRequire("dlqdQ");

var $dytur = parcelRequire("dytur");

var $ct6sD = parcelRequire("ct6sD");

const $e1497d031604cbf2$export$9c81367ce7c2e6b = (0, $dyfd9.lazy)(()=>(parcelRequire("hzxzU")), {
    moduleId: "./src/packages/global-pages/dashboard/edit/src/ui/header-editable/add-gadget-button/add-gadget-panel/main.tsx"
});
const $e1497d031604cbf2$export$6fe03cad6a67ebf8 = ()=>{
    const { isOpen: isRightPanelOpen } = (0, $8Dzk5.useRightPanelState)();
    if (isRightPanelOpen === false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "add-gadget",
        packageName: (0, $ePdsY.PACKAGE_NAME),
        attributes: {
            task: (0, $kEBPk.ADD_GADGET_EXPERIENCE),
            reason: 'AsyncAddGadgetPanel ErrorBoundary'
        },
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ct6sD.PanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dytur.Fallback), {
                type: (0, $dytur.FALLBACK_TYPE).ERROR
            })),
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-gadget-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dlqdQ.AddGadgetPanelSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1497d031604cbf2$export$9c81367ce7c2e6b, null)));
};

});
parcelRegister("dlqdQ", function(module, exports) {

$parcel$export(module.exports, "AddGadgetPanelSkeleton", () => $c6e7d7ed4db19e92$export$c0396ff9a79b8c7a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $c6e7d7ed4db19e92$export$c0396ff9a79b8c7a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$GadgetSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "20px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$GadgetSkeletonItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "40px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "calc(100% - 60px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$GadgetSkeletonItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "40px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "calc(100% - 60px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$GadgetSkeletonItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "40px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "calc(100% - 60px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$GadgetSkeletonItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "40px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e7d7ed4db19e92$var$Skeleton, {
        height: "40px",
        width: "calc(100% - 60px)"
    })));
const $c6e7d7ed4db19e92$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c6e7d7ed4db19e92$var$Skeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_dfjz0w": (0, $9t7rW.default)(`${__cmplp.height}`),
            "--_1icprf0": (0, $9t7rW.default)(`${__cmplp.width}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i16wa _1bsbb8e1 _2rko1y44 _18s8zu5n _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk1yrq _1itknyvn _12vemgnk",
            __cmplp.className
        ])
    });
});
const $c6e7d7ed4db19e92$var$GadgetSkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $c6e7d7ed4db19e92$var$GadgetSkeletonItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dytur", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_TYPE", () => $0280fcd30ee88f1c$export$a5e1f3074f2a926d);
$parcel$export(module.exports, "Fallback", () => $0280fcd30ee88f1c$export$fb8d7f40caaeea67);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $iBeSy = parcelRequire("iBeSy");
var $1JJay = parcelRequire("1JJay");
var $8Vv3m = parcelRequire("8Vv3m");

var $ijwdS = parcelRequire("ijwdS");

var $7QuzF = parcelRequire("7QuzF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dNg92 = parcelRequire("dNg92");
const $0280fcd30ee88f1c$export$a5e1f3074f2a926d = {
    ERROR: 'ERROR',
    NOTFOUND: 'NOTFOUND'
};
const $0280fcd30ee88f1c$var$FALLBACK_ERROR_IMAGE_SIZE = 84;
const $0280fcd30ee88f1c$export$fb8d7f40caaeea67 = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (type === $0280fcd30ee88f1c$export$a5e1f3074f2a926d.ERROR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        xcss: $0280fcd30ee88f1c$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijwdS.default), {
        alt: formatMessage((0, $dNg92.default).errorTitle),
        width: $0280fcd30ee88f1c$var$FALLBACK_ERROR_IMAGE_SIZE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $0280fcd30ee88f1c$var$textWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        color: "color.text.accent.gray",
        size: "UNSAFE_small",
        weight: "bold"
    }, formatMessage((0, $dNg92.default).errorMessage))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        xcss: $0280fcd30ee88f1c$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QuzF.default), {
        alt: formatMessage((0, $dNg92.default).emptyTitle),
        width: $0280fcd30ee88f1c$var$FALLBACK_ERROR_IMAGE_SIZE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $0280fcd30ee88f1c$var$textWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        color: "color.text.accent.gray",
        size: "UNSAFE_small",
        weight: "bold"
    }, formatMessage((0, $dNg92.default).emptyMessage))));
};
const $0280fcd30ee88f1c$var$wrapperStyles = (0, $8Vv3m.xcss)({
    padding: 'space.300',
    marginBottom: 'space.200',
    textAlign: 'center',
    color: 'color.text.accent.gray'
});
const $0280fcd30ee88f1c$var$textWrapperStyles = (0, $8Vv3m.xcss)({
    margin: 'space.300'
});

});
parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $fCVbE = parcelRequire("fCVbE");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fCVbE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fCVbE))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("fCVbE", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("dNg92", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cd76b7c709fd008$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1cd76b7c709fd008$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.error-message",
        "defaultMessage": "We're having some trouble getting all available gadgets, please try again later"
    },
    errorTitle: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.error-title",
        "defaultMessage": "Error"
    },
    emptyTitle: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.empty-title",
        "defaultMessage": "We couldn\u2019t find any gadgets."
    },
    emptyMessage: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.empty-message",
        "defaultMessage": "No gadgets matched your search. Try again with different keywords."
    }
});

});


parcelRegister("ct6sD", function(module, exports) {

$parcel$export(module.exports, "PanelContainer", () => $d5514e249c10cec9$export$7c4d2b536147788a);
$parcel$export(module.exports, "PanelHeaderContainer", () => $d5514e249c10cec9$export$90c3cb85c6ca5262);
$parcel$export(module.exports, "PanelContentContainer", () => $d5514e249c10cec9$export$f69c7d78cc611ef3);
$parcel$export(module.exports, "Header", () => $d5514e249c10cec9$export$8b251419efc915eb);
$parcel$export(module.exports, "CategoryLozengeGroup", () => $d5514e249c10cec9$export$dd826bcc21f46caa);
$parcel$export(module.exports, "CategoryLozengeClickable", () => $d5514e249c10cec9$export$c7b4c423388a9a6c);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $aYtGv = parcelRequire("aYtGv");
const $d5514e249c10cec9$export$7c4d2b536147788a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1reo15vq _18m915vq _4t3i1l47 _1kl71osx",
            __cmplp.className
        ])
    });
});
const $d5514e249c10cec9$export$90c3cb85c6ca5262 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _2lx2vrvc _1bsb1osq _kqsw1if8 _1yt41rfa _154iidpf _1pby18b4 _11q7vuon",
            __cmplp.className
        ])
    });
});
const $d5514e249c10cec9$export$f69c7d78cc611ef3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _18m91wug _1reo15vq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $d5514e249c10cec9$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi _1e0c11p5 _yv0e1ghl _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d5514e249c10cec9$export$dd826bcc21f46caa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $d5514e249c10cec9$export$c7b4c423388a9a6c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1yt418iy _1e0c116y _4cvr1h6o _19itglyw _2rkow1gv _4t3i1ou6 _80omtlke _19pkidpf _otyru2gc _2hwx1b66 _uiztglyw _p12f1osq _1reo15vq _18m915vq _1bto1l2s _o5721q9c _s7n4jp4b _zulp1b66",
            __cmplp.isActive ? "_bfhk115i" : "_bfhk1g33",
            __cmplp.isActive ? "_syaz11ce" : "_syazjjyb",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hzxzU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2CagP").then(()=>parcelRequire('iEv1s'));

});


parcelRegister("jfoA0", function(module, exports) {

$parcel$export(module.exports, "addGadgetPanelId", () => $7394ba7e677d29e1$export$39a49c1fbe587c5b);

var $c9TLT = parcelRequire("c9TLT");
const $7394ba7e677d29e1$export$39a49c1fbe587c5b = 'addGadgetPanel';
const $7394ba7e677d29e1$export$94d3ae1073c5ce2e = (0, $c9TLT.gridSize) * 46;

});

parcelRegister("aPQRs", function(module, exports) {

$parcel$export(module.exports, "HeaderEditable", () => $e63483b73e5181e4$export$3d14c3788ac5dc14);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $kEBPk = parcelRequire("kEBPk");

var $dYru8 = parcelRequire("dYru8");

var $2tuJX = parcelRequire("2tuJX");

var $5kqDj = parcelRequire("5kqDj");

var $iKfz6 = parcelRequire("iKfz6");

var $bCbg2 = parcelRequire("bCbg2");

var $g58Ey = parcelRequire("g58Ey");

var $9nhK9 = parcelRequire("9nhK9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");


var $gd0Sp = parcelRequire("gd0Sp");

var $8rQuz = parcelRequire("8rQuz");


var $xkE4L = parcelRequire("xkE4L");

var $iosuu = parcelRequire("iosuu");

var $arZHy = parcelRequire("arZHy");
const $e63483b73e5181e4$export$3d14c3788ac5dc14 = ({ data: data, banners: banners, onLayoutSelected: onLayoutSelected })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { isAnonymous: isAnonymous } = tenantContext;
    const { id: id, title: title, layout: layout } = data;
    const { headerItems: headerItems, toolItems: toolItems } = (0, $bCbg2.useConnectMenuItems)(id);
    const viewRoute = (0, $10fdS.useRouteByName)((0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const onClickHandler = (0, $eUqFw.useCallback)(()=>{
        fireAnalytics({
            eventType: (0, $41ea3621645e2acc$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'dashboard.done-editing-button',
            actionSubjectId: (0, $kEBPk.DASHBOARD_EDIT_SOURCENAME)
        });
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKfz6.Header), {
        banners: banners
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKfz6.HeaderTitle), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKfz6.HeaderActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kqDj.ConnectHeader), {
        items: headerItems
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g58Ey.FavoriteButton), {
        dashboardId: id,
        dashboardName: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xkE4L.AddGadgetButton), {
        buttonType: (0, $aa8d35770ac9b20b$export$fdb820c8e86996c4),
        columnIndex: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iosuu.ChangeLayoutButton), {
        layout: layout,
        onLayoutSelected: onLayoutSelected
    }), viewRoute && (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nhK9.RouteLinkButton), {
        to: viewRoute,
        params: {
            dashboardId: id
        },
        appearance: "primary",
        onClick: onClickHandler
    }, formatMessage((0, $arZHy.default).done)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nhK9.RouteLinkButtonOld), {
        appearance: "primary",
        to: viewRoute ?? undefined,
        params: {
            dashboardId: id
        },
        prefetch: "hover",
        onClick: onClickHandler
    }, formatMessage((0, $arZHy.default).done)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2tuJX.ActionDropdown), {
        data: data,
        connectToolMenuItems: toolItems
    })));
};

});
parcelRegister("2tuJX", function(module, exports) {

$parcel$export(module.exports, "ActionDropdown", () => $6bef83e7fa13e50c$export$d5503927a7d116d);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $f5xzw = parcelRequire("f5xzw");
var $5E6sS = parcelRequire("5E6sS");
var $e0IEe = parcelRequire("e0IEe");

var $5vJDH = parcelRequire("5vJDH");

var $cUyTA = parcelRequire("cUyTA");

var $kEBPk = parcelRequire("kEBPk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4HwSc = parcelRequire("4HwSc");

var $gd0Sp = parcelRequire("gd0Sp");

var $6khds = parcelRequire("6khds");

var $krycC = parcelRequire("krycC");

var $8gs4I = parcelRequire("8gs4I");

var $kWEdg = parcelRequire("kWEdg");

var $gNwIQ = parcelRequire("gNwIQ");

var $hnDBT = parcelRequire("hnDBT");

var $8agNG = parcelRequire("8agNG");

var $5IOkO = parcelRequire("5IOkO");

var $lerAi = parcelRequire("lerAi");

var $aCGDJ = parcelRequire("aCGDJ");
const $6bef83e7fa13e50c$export$d5503927a7d116d = ({ data: data, connectToolMenuItems: connectToolMenuItems })=>{
    const { isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const { dropdownItemClickHandler: dropdownItemClickHandler } = (0, $6khds.useDropdownItemOnClickHandler)();
    const dropdownTriggerButton = (0, $eUqFw.useRef)(null);
    const [, { on: modalCopyOpen }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).DASHBOARD_COPY);
    const [, { on: modalAutomaticRefreshOpen }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).AUTOMATIC_REFRESH);
    const [, { on: modalRenameAndShareOpen }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).DASHBOARD_RENAME_OR_SHARE);
    const [, { on: modalDeleteOpen }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).DASHBOARD_DELETE);
    const [, { on: modalCreateOpen }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).DASHBOARD_CREATE);
    // This is a hack to focus the trigger button after a modal is closed.
    const onModalCloseCallback = (0, $eUqFw.useCallback)(()=>{
        setTimeout(()=>{
            if (dropdownTriggerButton.current) dropdownTriggerButton.current.focus();
        }, 1);
    }, [
        dropdownTriggerButton
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!data) return null;
    const dashboardId = data.id;
    const isDashboardOwner = atlassianAccountId === data.owner;
    const viewAsWallboardUrl = `/jira/dashboards/wallboard?dashboardId=${dashboardId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lerAi.RenameOrShareModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnDBT.CopyModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kWEdg.AutomaticRefreshModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IOkO.DeleteModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gNwIQ.ConfigureWallboardModal), {
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8agNG.CreateModal), {
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
        isLoading: false,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                ...triggerProps,
                spacing: "default",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5vJDH))), {
                    label: formatMessage((0, $8gs4I.default).moreActions),
                    size: "medium"
                }),
                // To utilise this `ref` for a custom trigger button, only `triggerRef` needs to be the value passed in.
                // However, we've defined a function instead so we can save the ref locally
                // and focus it when modal closes
                ref: (buttonRef)=>{
                    // This is the default call if only `triggerRef` gets passed in. We still call it.
                    if (typeof triggerRef === 'function') triggerRef(buttonRef);
                    // This is a hack so we can focus this button after a modal is closed.
                    if (dropdownTriggerButton.current === null) dropdownTriggerButton.current = buttonRef;
                }
            }),
        shouldFlip: true,
        placement: "bottom-end",
        appearance: "tall",
        testId: "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.dropdown-menu",
        defaultOpen: (0, $krycC.getIsDropdownDefaultOpen)('action-dropdown'),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUyTA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e0IEe.default), {
        title: data.title
    }, data.writable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.rename-and-share",
        onClick: modalRenameAndShareOpen
    }, formatMessage(data.systemDashboard ? (0, $8gs4I.default).share : (0, $8gs4I.default).renameOrShare)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.copy",
        onClick: modalCopyOpen
    }, formatMessage((0, $8gs4I.default).copy)), data.writable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.automatic-refresh",
        onClick: modalAutomaticRefreshOpen
    }, formatMessage((0, $8gs4I.default).automaticRefresh)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard",
        href: viewAsWallboardUrl,
        onClick: (e)=>dropdownItemClickHandler(e, viewAsWallboardUrl, 'dashboard.view-as-wallboard-item'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $8gs4I.default).wallboard)), isDashboardOwner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.delete",
        onClick: modalDeleteOpen
    }, formatMessage((0, $8gs4I.default).moveToTrash)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aCGDJ.WallboardSlideshow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUyTA.default), {
        hasSeparator: true
    }, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.create",
        onClick: modalCreateOpen
    }, formatMessage((0, $8gs4I.default).create)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.find",
        href: "/jira/dashboards",
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $8gs4I.default).find))), connectToolMenuItems && connectToolMenuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUyTA.default), {
        testId: "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.dashboard-connect-menu-items",
        hasSeparator: true
    }, connectToolMenuItems.map(({ id: id, title: title, url: url, styleClass: styleClass })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
            key: id,
            href: url,
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            id: id,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleClass
        }, title)))) : null));
};

});
parcelRegister("6khds", function(module, exports) {

$parcel$export(module.exports, "useDropdownItemOnClickHandler", () => $cef134d223a29790$export$b9ed61ea9e46f071);


var $lB25E = parcelRequire("lB25E");

var $dYru8 = parcelRequire("dYru8");

var $aoqW4 = parcelRequire("aoqW4");
const $cef134d223a29790$export$b9ed61ea9e46f071 = ()=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const dropdownItemClickHandler = (e, url, actionSubject)=>{
        if (actionSubject) fireAnalytics({
            eventType: (0, $41ea3621645e2acc$export$a1562d08625f5d7e),
            actionSubject: actionSubject,
            action: 'clicked',
            actionSubjectId: 'dashboard'
        });
        if (!(0, $aoqW4.clickedWithShortcutKeys)(e)) {
            e.preventDefault();
            push(url);
        }
    };
    return {
        dropdownItemClickHandler: dropdownItemClickHandler
    };
};

});

parcelRegister("krycC", function(module, exports) {

$parcel$export(module.exports, "getIsDropdownDefaultOpen", () => $5afb61a2a957c0b1$export$638abbdcabd86e67);
/**
 * NOTE - this is to assist with VR tests so we can easily di the value for the
 * dropdowns to be opened.
 * @param _ name of your component
 * @returns false in production code
 */ const $5afb61a2a957c0b1$export$638abbdcabd86e67 = (_)=>false;

});

parcelRegister("8gs4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1ebe6ea9d021bc1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c1ebe6ea9d021bc1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreActions: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.more-actions",
        "defaultMessage": "More dashboard actions"
    },
    copy: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.copy",
        "defaultMessage": "Copy"
    },
    automaticRefresh: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.automatic-refresh",
        "defaultMessage": "Configure automatic refresh"
    },
    renameOrShare: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.rename-or-share",
        "defaultMessage": "Rename or share"
    },
    share: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.share",
        "defaultMessage": "Share dashboard"
    },
    moveToTrash: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.move-to-trash",
        "defaultMessage": "Move to trash"
    },
    find: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.find",
        "defaultMessage": "View all dashboards"
    },
    create: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.create",
        "defaultMessage": "Create a dashboard"
    },
    wallboard: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard",
        "defaultMessage": "View as wallboard"
    }
});

});

parcelRegister("kWEdg", function(module, exports) {

$parcel$export(module.exports, "AutomaticRefreshModal", () => $fad0c0ab82772b4c$export$47f35766b426b3bc);

var $eUqFw = parcelRequire("eUqFw");

var $f4cFG = parcelRequire("f4cFG");

var $9lmTX = parcelRequire("9lmTX");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $4HwSc = parcelRequire("4HwSc");

var $dyfd9 = parcelRequire("dyfd9");

var $gNJNY = parcelRequire("gNJNY");

var $aaHle = parcelRequire("aaHle");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fad0c0ab82772b4c$var$LazyDashboardModal = (0, $dyfd9.lazy)(()=>(parcelRequire("kyRQ5")), {
    moduleId: "./src/packages/global-pages/dashboard/internal-common/src/ui/dashboard-content/header/action-dropdown/modals/automatic-refresh-modal/main.tsx"
});
const $fad0c0ab82772b4c$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $fad0c0ab82772b4c$var$sendSuccessExperience = ()=>(0, $9lmTX.default)({
        ...$fad0c0ab82772b4c$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $fad0c0ab82772b4c$var$sendFailedExperience = ()=>(0, $9lmTX.default)({
        ...$fad0c0ab82772b4c$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $fad0c0ab82772b4c$export$47f35766b426b3bc = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).AUTOMATIC_REFRESH);
    const onFailed = (err)=>{
        const error = err || new Error('automatic refresh modal configuration failed.');
        (0, $gNJNY.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $fad0c0ab82772b4c$var$sendSuccessExperience,
            sendFailedExperience: $fad0c0ab82772b4c$var$sendFailedExperience,
            logErrorEvent: (0, $aaHle.logErrorEventFunc)(error, (0, $kEBPk.DASHBOARD_AUTOMATIC_REFRESH))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $9lmTX.default)({
            ...$fad0c0ab82772b4c$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    const onClose = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $kEBPk.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $kEBPk.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4cFG.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fad0c0ab82772b4c$var$LazyDashboardModal, {
        id: id,
        onClose: onClose,
        onSuccess: $fad0c0ab82772b4c$var$sendSuccessExperience,
        onCancel: onCancel,
        onFailed: onFailed
    }))) : null;
};

});
parcelRegister("aaHle", function(module, exports) {

$parcel$export(module.exports, "logErrorEventFunc", () => $9691252c03146cc5$export$e315c4152a211ba8);

var $guiFP = parcelRequire("guiFP");
const $9691252c03146cc5$export$e315c4152a211ba8 = (error, eventId)=>(reason)=>{
        if (error != null) (0, $guiFP.default)({
            error: error,
            meta: {
                id: eventId,
                packageName: 'jiraDashboardInternalCommon'
            },
            attributes: {
                reason: reason
            }
        });
    };

});

parcelRegister("kyRQ5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("g3vvz")
]).then(()=>parcelRequire('i8qaF'));

});


parcelRegister("gNwIQ", function(module, exports) {

$parcel$export(module.exports, "ConfigureWallboardModal", () => $86147ed95adf7558$export$cf7e06d150dcce6d);

var $eUqFw = parcelRequire("eUqFw");

var $f4cFG = parcelRequire("f4cFG");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $4HwSc = parcelRequire("4HwSc");

var $dyfd9 = parcelRequire("dyfd9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $86147ed95adf7558$var$LazyDashboardModal = (0, $dyfd9.lazy)(()=>(parcelRequire("fSsLp")), {
    moduleId: "./src/packages/global-pages/dashboard/internal-common/src/ui/dashboard-content/header/action-dropdown/modals/configure-wallboard-modal/modal/index.tsx"
});
const $86147ed95adf7558$export$cf7e06d150dcce6d = ({ onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).CONFIGURE_WALLBOARD);
    const onModalClose = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "configure-wallboard-modal",
        packageName: "dashboard",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4cFG.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86147ed95adf7558$var$LazyDashboardModal, {
        onClose: onModalClose
    }))) : null;
};

});
parcelRegister("fSsLp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bZUdO")
]).then(()=>parcelRequire('3Tj0N'));

});


parcelRegister("hnDBT", function(module, exports) {

$parcel$export(module.exports, "CopyModal", () => $0f5e8d3d10c38ff1$export$4a7ddad8989462fb);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $f4cFG = parcelRequire("f4cFG");

var $9lmTX = parcelRequire("9lmTX");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $5oIBC = parcelRequire("5oIBC");

var $gGtKh = parcelRequire("gGtKh");

var $4HwSc = parcelRequire("4HwSc");

var $dyfd9 = parcelRequire("dyfd9");

var $lB25E = parcelRequire("lB25E");

var $gNJNY = parcelRequire("gNJNY");

var $aaHle = parcelRequire("aaHle");

const $0f5e8d3d10c38ff1$var$LazyDashboardModal = (0, $5oIBC.default)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $dyfd9.lazy)(()=>(parcelRequire("eLbpM")).then(({ CopyDashboardModal: CopyDashboardModal })=>CopyDashboardModal), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/copy-dashboard-modal/src/index.tsx"
}));
const $0f5e8d3d10c38ff1$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.COPY_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $0f5e8d3d10c38ff1$var$sendSuccessExperience = ()=>(0, $9lmTX.default)({
        ...$0f5e8d3d10c38ff1$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $0f5e8d3d10c38ff1$var$sendFailedExperience = ()=>(0, $9lmTX.default)({
        ...$0f5e8d3d10c38ff1$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $0f5e8d3d10c38ff1$export$bdd968b8df213d5c = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).DASHBOARD_COPY);
    const { push: push } = (0, $lB25E.useRouterActions)();
    const onSuccess = (_, response)=>{
        $0f5e8d3d10c38ff1$var$sendSuccessExperience();
        close();
        if (response.view != null) push(response.view);
        else onModalCloseCallback?.();
    };
    const onInitiateFailed = (error)=>{
        (0, $gNJNY.handleFetchErrorAsExperience)({
            error: error || new Error('copy dashboard modal initialisation failed'),
            sendSuccessExperience: $0f5e8d3d10c38ff1$var$sendSuccessExperience,
            sendFailedExperience: $0f5e8d3d10c38ff1$var$sendFailedExperience,
            logErrorEvent: (0, $aaHle.logErrorEventFunc)(error, (0, $kEBPk.COPY_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $gNJNY.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $0f5e8d3d10c38ff1$var$sendSuccessExperience,
            sendFailedExperience: $0f5e8d3d10c38ff1$var$sendFailedExperience,
            logErrorEvent: (0, $aaHle.logErrorEventFunc)(error, (0, $kEBPk.COPY_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $9lmTX.default)({
            ...$0f5e8d3d10c38ff1$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4cFG.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f5e8d3d10c38ff1$var$LazyDashboardModal, {
        onInitiateFailed: onInitiateFailed,
        onSuccess: onSuccess,
        onFailed: onFailed,
        onCancel: onCancel,
        id: id
    })) : null;
};
const $0f5e8d3d10c38ff1$export$4a7ddad8989462fb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $kEBPk.COPY_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $kEBPk.COPY_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f5e8d3d10c38ff1$export$bdd968b8df213d5c, props));

});
parcelRegister("eLbpM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jJXhf")
]).then(()=>parcelRequire('6Zz4x'));

});


parcelRegister("8agNG", function(module, exports) {

$parcel$export(module.exports, "CreateModal", () => $d3564adc366a6537$export$204e9f8d79be983e);

var $eUqFw = parcelRequire("eUqFw");

var $f4cFG = parcelRequire("f4cFG");

var $umZWz = parcelRequire("umZWz");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $01Qi5 = parcelRequire("01Qi5");

var $4HwSc = parcelRequire("4HwSc");

var $lB25E = parcelRequire("lB25E");
const $d3564adc366a6537$export$e85d11db57ff5836 = ({ onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).DASHBOARD_CREATE);
    const { clear: clear } = (0, $01Qi5.useDashboardResource)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const onSuccess = (_, operationResult)=>{
        clear();
        push(`/jira/dashboards/${operationResult.id}/edit`);
        close();
    };
    const onCancel = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dashboards-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4cFG.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $umZWz.default), {
        onSuccess: onSuccess,
        onCancel: onCancel
    })) : null;
};
const $d3564adc366a6537$export$204e9f8d79be983e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $kEBPk.CREATE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $kEBPk.CREATE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3564adc366a6537$export$e85d11db57ff5836, props));

});
parcelRegister("umZWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d5ee99119d0ae6$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

const $62d5ee99119d0ae6$var$AsyncCreateDashboardModal = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("i09U6")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/create-dashboard-modal/src/index.tsx"
});
const $62d5ee99119d0ae6$var$AsyncCreateDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62d5ee99119d0ae6$var$AsyncCreateDashboardModal, props));
var $62d5ee99119d0ae6$export$2e2bcd8739ae039 = $62d5ee99119d0ae6$var$AsyncCreateDashboardModalContainer;

});
parcelRegister("i09U6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("aElWm")
]).then(()=>parcelRequire('5U3RQ'));

});



parcelRegister("5IOkO", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $89340d7d1ac88570$export$73392e09138fecd6);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $f4cFG = parcelRequire("f4cFG");

var $9lmTX = parcelRequire("9lmTX");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $01Qi5 = parcelRequire("01Qi5");

var $4HwSc = parcelRequire("4HwSc");

var $dyfd9 = parcelRequire("dyfd9");

var $lB25E = parcelRequire("lB25E");

var $gNJNY = parcelRequire("gNJNY");

var $aaHle = parcelRequire("aaHle");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89340d7d1ac88570$var$LazyDeleteModal = (0, $dyfd9.lazy)(()=>(parcelRequire("5QXBf")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/delete-dashboard-modal/src/index.tsx"
});
const $89340d7d1ac88570$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.DELETE_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $89340d7d1ac88570$var$sendSuccessExperience = ()=>(0, $9lmTX.default)({
        ...$89340d7d1ac88570$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $89340d7d1ac88570$var$sendFailedExperience = ()=>(0, $9lmTX.default)({
        ...$89340d7d1ac88570$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $89340d7d1ac88570$export$daf5ee5ed602db71 = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).DASHBOARD_DELETE);
    const { clear: clear } = (0, $01Qi5.useDashboardResource)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const onSuccess = ()=>{
        (0, $9lmTX.default)({
            ...$89340d7d1ac88570$var$expAttributes,
            wasExperienceSuccesful: true
        });
        clear();
        close();
        push('/jira/dashboards');
    };
    const onInitiateFailed = (error)=>{
        (0, $gNJNY.handleFetchErrorAsExperience)({
            error: error || new Error('delete dashboard modal initialisation failed'),
            sendSuccessExperience: $89340d7d1ac88570$var$sendSuccessExperience,
            sendFailedExperience: $89340d7d1ac88570$var$sendFailedExperience,
            logErrorEvent: (0, $aaHle.logErrorEventFunc)(error, (0, $kEBPk.DELETE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $gNJNY.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $89340d7d1ac88570$var$sendSuccessExperience,
            sendFailedExperience: $89340d7d1ac88570$var$sendFailedExperience,
            logErrorEvent: (0, $aaHle.logErrorEventFunc)(error, (0, $kEBPk.DELETE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $9lmTX.default)({
            ...$89340d7d1ac88570$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dashboards-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4cFG.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89340d7d1ac88570$var$LazyDeleteModal, {
        onInitiateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onInitiateFailed: onInitiateFailed,
        onSuccess: onSuccess,
        onCancel: onCancel,
        onFailed: onFailed,
        id: id
    })) : null;
};
const $89340d7d1ac88570$export$73392e09138fecd6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $kEBPk.DELETE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $kEBPk.DELETE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89340d7d1ac88570$export$daf5ee5ed602db71, props));

});
parcelRegister("5QXBf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("7tleo")
]).then(()=>parcelRequire('1mNpB'));

});


parcelRegister("lerAi", function(module, exports) {

$parcel$export(module.exports, "RenameOrShareModal", () => $60670f45b1e06771$export$a113d771e12d2a12);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $f4cFG = parcelRequire("f4cFG");

var $9lmTX = parcelRequire("9lmTX");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $4HwSc = parcelRequire("4HwSc");

var $dyfd9 = parcelRequire("dyfd9");

var $akkHY = parcelRequire("akkHY");

var $gNJNY = parcelRequire("gNJNY");

var $aaHle = parcelRequire("aaHle");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $60670f45b1e06771$var$LazyRenameOrShareModal = (0, $dyfd9.lazy)(()=>(parcelRequire("5iGyY")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/edit-dashboard-modal/src/index.tsx"
});
const $60670f45b1e06771$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $60670f45b1e06771$var$sendSuccessExperience = ()=>(0, $9lmTX.default)({
        ...$60670f45b1e06771$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $60670f45b1e06771$var$sendFailedExperience = ()=>(0, $9lmTX.default)({
        ...$60670f45b1e06771$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $60670f45b1e06771$export$4f6c2201df28de83 = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).DASHBOARD_RENAME_OR_SHARE);
    const onEditDashboard = (0, $akkHY.useEditDashboard)();
    const onSuccess = (_, response)=>{
        onEditDashboard(response);
        $60670f45b1e06771$var$sendSuccessExperience();
        close();
        onModalCloseCallback?.();
    };
    const onInitiateFailed = (error)=>{
        (0, $gNJNY.handleFetchErrorAsExperience)({
            error: error || new Error('rename or share dashboard modal initialisation failed'),
            sendSuccessExperience: $60670f45b1e06771$var$sendSuccessExperience,
            sendFailedExperience: $60670f45b1e06771$var$sendFailedExperience,
            logErrorEvent: (0, $aaHle.logErrorEventFunc)(error, (0, $kEBPk.RENAME_OR_SHARE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $gNJNY.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $60670f45b1e06771$var$sendSuccessExperience,
            sendFailedExperience: $60670f45b1e06771$var$sendFailedExperience,
            logErrorEvent: (0, $aaHle.logErrorEventFunc)(error, (0, $kEBPk.RENAME_OR_SHARE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $9lmTX.default)({
            ...$60670f45b1e06771$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "rename-or-share-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4cFG.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($60670f45b1e06771$var$LazyRenameOrShareModal, {
        onInitiateFailed: onInitiateFailed,
        onInitiateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onSuccess: onSuccess,
        onCancel: onCancel,
        onFailed: onFailed,
        id: id
    })) : null;
};
const $60670f45b1e06771$export$a113d771e12d2a12 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $kEBPk.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $kEBPk.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($60670f45b1e06771$export$4f6c2201df28de83, props));

});
parcelRegister("akkHY", function(module, exports) {

$parcel$export(module.exports, "useEditDashboard", () => $d15fcd32c279b861$export$a7520122589f9056);

var $eUqFw = parcelRequire("eUqFw");

var $01Qi5 = parcelRequire("01Qi5");
const $d15fcd32c279b861$export$a7520122589f9056 = ()=>{
    const { update: update } = (0, $01Qi5.useDashboardResource)();
    return (0, $eUqFw.useCallback)((dashboardData)=>{
        if (!dashboardData) return;
        update((currentData)=>currentData && {
                ...currentData,
                title: dashboardData.name
            });
    }, [
        update
    ]);
};

});

parcelRegister("5iGyY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aMOqA")
]).then(()=>parcelRequire('kZZPO'));

});


parcelRegister("aCGDJ", function(module, exports) {

$parcel$export(module.exports, "WallboardSlideshow", () => $c3638e132235793d$export$db3bf5ee6d309e34);

var $eUqFw = parcelRequire("eUqFw");

var $5E6sS = parcelRequire("5E6sS");

var $cUyTA = parcelRequire("cUyTA");

var $kEBPk = parcelRequire("kEBPk");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");


var $4HwSc = parcelRequire("4HwSc");

var $gd0Sp = parcelRequire("gd0Sp");

var $dYru8 = parcelRequire("dYru8");

var $6khds = parcelRequire("6khds");

var $eVh2l = parcelRequire("eVh2l");
const $c3638e132235793d$var$EMPTY_WALLBOARD_URL = '/';
const $c3638e132235793d$export$11aea547bd3c125e = async ()=>{
    try {
        const response = await fetch('/rest/wallboard/latest/slideshow/url', {
            method: 'GET'
        });
        if (!response.ok) throw new Error(`Error server response: ${response.status}`);
        return response.text();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // if error, then the link would be grayed out
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'viewWallboardSlideshow',
                packageName: 'jiraDashboardInternalCommon'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return $c3638e132235793d$var$EMPTY_WALLBOARD_URL;
    }
};
const $c3638e132235793d$export$db3bf5ee6d309e34 = ()=>{
    const { isAnonymous: isAnonymous } = (0, $gd0Sp.useTenantContext)();
    const [wallboardSlideshowUrl, setWallboardSlideshowUrl] = (0, $eUqFw.useState)(undefined);
    const [, { on: modalWallboardOpen }] = (0, $4HwSc.useSwitchModals)((0, $kEBPk.MODAL_ID).CONFIGURE_WALLBOARD);
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const configureWallboardSlideShowClickHandler = (0, $eUqFw.useCallback)(()=>{
        fireAnalytics({
            eventType: (0, $41ea3621645e2acc$export$a1562d08625f5d7e),
            actionSubjectId: 'dashboard',
            actionSubject: 'wallboard-slideshow.configure',
            action: 'clicked'
        });
        // Wrapping modalWallboardOpen() inside setTimeout
        // for the focus to be on the dropdown button before opening
        // the modal as part of accessibility ticket DAG-903
        setTimeout(()=>{
            modalWallboardOpen();
        }, 1);
    }, [
        fireAnalytics,
        modalWallboardOpen
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dropdownItemClickHandler: dropdownItemClickHandler } = (0, $6khds.useDropdownItemOnClickHandler)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isAnonymous && wallboardSlideshowUrl === undefined) $c3638e132235793d$export$11aea547bd3c125e().then((url)=>{
            setWallboardSlideshowUrl(url || $c3638e132235793d$var$EMPTY_WALLBOARD_URL);
        });
    }, [
        isAnonymous,
        wallboardSlideshowUrl
    ]);
    const isViewWallboardSlideshowEnabled = wallboardSlideshowUrl !== $c3638e132235793d$var$EMPTY_WALLBOARD_URL && !isAnonymous;
    // `wallboardSlideShowUrl` can be undefined and is generated through a fetch call which may be fail,
    // so we have `EMPTY_WALLBOARD_URL` as a fallback
    const wallboardSlideshowUrlWithFallback = wallboardSlideshowUrl || $c3638e132235793d$var$EMPTY_WALLBOARD_URL;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUyTA.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-slideshow",
        isDisabled: !isViewWallboardSlideshowEnabled,
        href: wallboardSlideshowUrlWithFallback,
        onClick: (e)=>dropdownItemClickHandler(e, wallboardSlideshowUrlWithFallback, 'dashboard.view-wallboard-slideshow-item'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $eVh2l.default).wallboardSlideshow)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard-slideshow.configure-wallboard",
        onClick: configureWallboardSlideShowClickHandler
    }, formatMessage((0, $eVh2l.default).wallboardSetup)));
};

});
parcelRegister("eVh2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $675ffb6cd5597aae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $675ffb6cd5597aae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    wallboardSlideshow: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-slideshow",
        "defaultMessage": "View wallboard slide show"
    },
    wallboardSetup: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-setup",
        "defaultMessage": "Configure wallboard slide show"
    }
});

});



parcelRegister("5kqDj", function(module, exports) {

$parcel$export(module.exports, "ConnectHeader", () => $6ebcbdcaddb77680$export$a7c3d2bbc29ad451);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $f5xzw = parcelRequire("f5xzw");
var $5E6sS = parcelRequire("5E6sS");

var $1jsQJ = parcelRequire("1jsQJ");

var $4lxPQ = parcelRequire("4lxPQ");

var $krycC = parcelRequire("krycC");

var $iVqAP = parcelRequire("iVqAP");
const $6ebcbdcaddb77680$export$965e85c1e0261738 = ({ item: item })=>{
    const webItemRef = (0, $eUqFw.useRef)(null);
    const onWebItemClick = ()=>{
        (0, $4lxPQ.withConnectHost)((connectHost)=>{
            if (webItemRef.current) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        id: item.id,
        appearance: "subtle",
        onClick: onWebItemClick,
        ref: webItemRef
    }, item.title);
};
const $6ebcbdcaddb77680$var$DropdownPressableItem = ({ item: item })=>{
    const webItemRef = (0, $eUqFw.useRef)(null);
    const onWebItemClick = ()=>{
        (0, $4lxPQ.withConnectHost)((connectHost)=>{
            if (webItemRef.current) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jsQJ.default), {
        id: item.id,
        onClick: onWebItemClick,
        ref: (ref)=>{
            if (ref) webItemRef.current = ref;
        },
        backgroundColor: "color.background.neutral.subtle"
    }, item.title);
};
const $6ebcbdcaddb77680$export$275428e5ee6cc209 = ({ items: items })=>{
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
        isLoading: false,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                appearance: "subtle",
                spacing: "default",
                ...triggerProps,
                ref: triggerRef
            }, "+", items.length),
        shouldFlip: true,
        placement: "bottom-end",
        testId: "dashboard-internal-common.ui.dashboard-content.header.connect-header.dropdown-menu",
        defaultOpen: (0, $krycC.getIsDropdownDefaultOpen)('connect-header')
    }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ebcbdcaddb77680$var$DropdownPressableItem, {
            item: item
        }))));
};
const $6ebcbdcaddb77680$export$a7c3d2bbc29ad451 = ({ items: items })=>{
    if (!items) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVqAP.ConnectHeaderWrapper), null, items.slice(0, 4).map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ebcbdcaddb77680$export$965e85c1e0261738, {
            item: item,
            key: item.id
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ebcbdcaddb77680$export$275428e5ee6cc209, {
        items: items.slice(4)
    }));
};

});
parcelRegister("iVqAP", function(module, exports) {

$parcel$export(module.exports, "ConnectHeaderWrapper", () => $4ee5c4ac451629b4$export$70cdd2ea5140c2c);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4ee5c4ac451629b4$export$70cdd2ea5140c2c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _13kxotz2",
            __cmplp.className
        ])
    });
});

});


parcelRegister("iKfz6", function(module, exports) {

$parcel$export(module.exports, "HeaderTitle", () => $6adf5647fc631c98$export$edb76fdb8665f52);
$parcel$export(module.exports, "HeaderActions", () => $6adf5647fc631c98$export$223875819fd7cf93);
$parcel$export(module.exports, "Header", () => $6adf5647fc631c98$export$8b251419efc915eb);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $1F29s = parcelRequire("1F29s");
var $6iuk0 = parcelRequire("6iuk0");

var $3a8wJ = parcelRequire("3a8wJ");

var $6xS3y = parcelRequire("6xS3y");
const $6adf5647fc631c98$export$edb76fdb8665f52 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6iuk0.default), {
        medium: 4,
        testId: "dashboard-internal-common.ui.dashboard-content.header.header-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), null, children));
const $6adf5647fc631c98$export$223875819fd7cf93 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6iuk0.default), {
        medium: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xS3y.ActionWrapper), null, children)));
const $6adf5647fc631c98$export$8b251419efc915eb = ({ banners: banners, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("header", {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.dashboard-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1F29s.default), {
        layout: "fluid",
        spacing: "compact"
    }, children), banners && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xS3y.BannersWrapper), null, banners));

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4PvVz = parcelRequire("4PvVz");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4PvVz.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4PvVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f9724b566053b5$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $j1iGE = parcelRequire("j1iGE");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $79f9724b566053b5$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $79f9724b566053b5$export$2e2bcd8739ae039 = $79f9724b566053b5$var$PageHeader;

});
parcelRegister("j1iGE", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $db0664a0dfc3f21a$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $db0664a0dfc3f21a$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $db0664a0dfc3f21a$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $db0664a0dfc3f21a$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $db0664a0dfc3f21a$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $db0664a0dfc3f21a$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");
function $db0664a0dfc3f21a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $db0664a0dfc3f21a$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $db0664a0dfc3f21a$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $db0664a0dfc3f21a$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $db0664a0dfc3f21a$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $db0664a0dfc3f21a$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $db0664a0dfc3f21a$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $db0664a0dfc3f21a$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $db0664a0dfc3f21a$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $db0664a0dfc3f21a$var$bottomBarStyles = (0, $8Vv3m.xcss)({
    marginBlockStart: 'space.200'
});
const $db0664a0dfc3f21a$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $db0664a0dfc3f21a$var$outerStyles
    }, children);
};
const $db0664a0dfc3f21a$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $db0664a0dfc3f21a$var$titleStyles,
            truncateTitle && $db0664a0dfc3f21a$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $db0664a0dfc3f21a$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $db0664a0dfc3f21a$var$titleWrapperStyles,
            truncateTitle && $db0664a0dfc3f21a$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $db0664a0dfc3f21a$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $db0664a0dfc3f21a$var$titleContainerStyles,
            truncateTitle && $db0664a0dfc3f21a$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $db0664a0dfc3f21a$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $db0664a0dfc3f21a$var$actionStyles
    }, children);
};
const $db0664a0dfc3f21a$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $80vF2.default), {
        xcss: $db0664a0dfc3f21a$var$bottomBarStyles
    }, children);
};

});



parcelRegister("6xS3y", function(module, exports) {

$parcel$export(module.exports, "ActionWrapper", () => $b46e5893f481c014$export$3122aab815c89f9a);
$parcel$export(module.exports, "BannersWrapper", () => $b46e5893f481c014$export$ab656bce1543f51a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b46e5893f481c014$export$3122aab815c89f9a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _18s81d9c _zulpu2gc _xlknidpf _dgz5idpf _18sqidpf _wrjxidpf _18vqd8e8",
            __cmplp.className
        ])
    });
});
const $b46e5893f481c014$export$ab656bce1543f51a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc _zum8idpf _10361ejb",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bCbg2", function(module, exports) {

$parcel$export(module.exports, "useConnectMenuItems", () => $296dc3e0a40d0d52$export$58f1b171f06c90ef);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
const $296dc3e0a40d0d52$export$58f1b171f06c90ef = (dashboardId)=>{
    const [connectMenuItems, setConnectMenuItems] = (0, $eUqFw.useState)({
        headerItems: [],
        toolItems: []
    });
    (0, $eUqFw.useEffect)(()=>{
        // TODO - remove this as types say it should not be necessary
        if (dashboardId == null) return;
        (async ()=>{
            const resourceUrl = `/rest/dashboards/1.0/connect/menuItems/${dashboardId}`;
            try {
                const response = await (0, $2OdyW.default)(resourceUrl);
                setConnectMenuItems(response);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'fetchConnectMenuItems',
                        packageName: 'jiraDashboardInternalCommon',
                        teamName: 'endeavour'
                    }
                });
            }
        })();
    }, [
        dashboardId
    ]);
    return connectMenuItems;
};

});

parcelRegister("g58Ey", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $3303d98dd41b778d$export$8d5dab2ad1e19ea0);

var $eUqFw = parcelRequire("eUqFw");

var $eai7U = parcelRequire("eai7U");

var $ktkCe = parcelRequire("ktkCe");

var $jrdvV = parcelRequire("jrdvV");
const $3303d98dd41b778d$export$8d5dab2ad1e19ea0 = ({ dashboardId: dashboardId, dashboardName: dashboardName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktkCe.FavoriteButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eai7U.default), {
        baseUrl: "",
        itemId: dashboardId,
        itemType: (0, $jrdvV.DASHBOARDS_ITEM_TYPE),
        favoriteItemName: dashboardName
    }));

});
parcelRegister("eai7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $851158f210da4df7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dQZ5c = parcelRequire("dQZ5c");


var $gwSUu = parcelRequire("gwSUu");
class $851158f210da4df7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQZ5c.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwSUu.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("gwSUu", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $f43e6d70f6db5981$export$8d5dab2ad1e19ea0);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ktkCe = parcelRequire("ktkCe");

var $jrdvV = parcelRequire("jrdvV");

var $1ybV0 = parcelRequire("1ybV0");

var $hXex1 = parcelRequire("hXex1");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f43e6d70f6db5981$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $f43e6d70f6db5981$export$8d5dab2ad1e19ea0 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    constructor(props){
        super(props);
        this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { baseUrl: baseUrl, itemId: itemId, itemType: itemType } = this.props;
        if (typeof baseUrl === 'undefined' || typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$f43e6d70f6db5981$var$isProduction && !(0, $jrdvV.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $jrdvV.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $hXex1.getFavorite)(baseUrl, {
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", (0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
            'data-testid': 'favorite-button'
        } : {
            'data-test-id': 'favorite-button'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktkCe.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("ktkCe", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $3e4b24f33924a6f9$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $3e4b24f33924a6f9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $lUg8E = parcelRequire("lUg8E");

var $8ygbv = parcelRequire("8ygbv");

var $jnVUH = parcelRequire("jnVUH");

var $d6awU = parcelRequire("d6awU");

var $14Itk = parcelRequire("14Itk");

var $aFZXp = parcelRequire("aFZXp");

var $6rQDs = parcelRequire("6rQDs");

var $jl1we = parcelRequire("jl1we");

var $8un0w = parcelRequire("8un0w");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $giAhk = parcelRequire("giAhk");

var $8rQuz = parcelRequire("8rQuz");

var $lbjCz = parcelRequire("lbjCz");

var $ivkNG = parcelRequire("ivkNG");
const $3e4b24f33924a6f9$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $3e4b24f33924a6f9$export$f8ad2acf0ec4860f extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $3e4b24f33924a6f9$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbjCz.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$db65185b5889c83, {
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            } : {
                'data-test-id': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            },
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, isFavorite ? // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ygbv))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($14Itk))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).removeFromStarred)
            }
        }) : // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jnVUH))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d6awU))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).addToStarred)
            }
        }));
        const renderIcon = ()=>{
            let label = '';
            if ((0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts')) {
                if (isFavorite) label = formatMessage((0, $ivkNG.default).removeFromStarred);
                else label = formatMessage((0, $ivkNG.default).addToStarred);
            }
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($aFZXp))) : (0, (/*@__PURE__*/$parcel$interopDefault($6rQDs)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($8ygbv))) : (0, (/*@__PURE__*/$parcel$interopDefault($jnVUH)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $ivkNG.default).removeFromStarred) : formatMessage((0, $ivkNG.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $ivkNG.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $ivkNG.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }, (0, $8rQuz.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isAnimating: false
        };
        this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        };
        this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $3e4b24f33924a6f9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $giAhk.injectIntlV2))($3e4b24f33924a6f9$export$f8ad2acf0ec4860f);
const $3e4b24f33924a6f9$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBase = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseNew, $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3e4b24f33924a6f9$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isFavorite ? "_syaz2kyj" : "_syaz2u25",
            __cmplp.isFavorite ? "_30l31ebw" : "_30l3w9a8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$db65185b5889c83 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("ivkNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79b2c2cf8a78bb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d79b2c2cf8a78bb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});


parcelRegister("hXex1", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $895d7ed98f35f49b$export$fce5eda070ce88d0);

var $lRmyA = parcelRequire("lRmyA");
const $895d7ed98f35f49b$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $895d7ed98f35f49b$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $lRmyA.performGetRequest)($895d7ed98f35f49b$export$959ca2ee969adb8d(baseUrl, request));

});




parcelRegister("9nhK9", function(module, exports) {

$parcel$export(module.exports, "RouteLinkButtonOld", () => $d53001efb5a7039f$export$c74dddf61fcdf9b0);
$parcel$export(module.exports, "RouteLinkButton", () => $d53001efb5a7039f$export$64b500ddabb836a3);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $kctPi = parcelRequire("kctPi");

var $lB25E = parcelRequire("lB25E");
const $d53001efb5a7039f$export$c74dddf61fcdf9b0 = ({ children: children, to: to, params: params, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        component: (0, $lB25E.Link),
        ...rest,
        ...to && {
            // Link would not update when 'to' prop changes, so we need to force an update with key
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key: to.name,
            // href prop is required to be passed to the Button component for Button to render as an anchor tag
            // instead of a button tag. Remove this line and related code after this issue is fixed for AK Button.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            href: (0, $lB25E.generatePath)(to.path, params),
            to: to,
            params: params
        }
    }, children);
const $d53001efb5a7039f$export$64b500ddabb836a3 = ({ to: to, params: params, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kctPi.default), {
        ...rest,
        key: to.name,
        href: (0, $lB25E.generatePath)(to.path, params)
    }, children);

});
parcelRegister("kctPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbbd4738979168fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aQE4L = parcelRequire("aQE4L");

var $9J813 = parcelRequire("9J813");
const $dbbd4738979168fb$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $9J813.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQE4L.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $dbbd4738979168fb$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($dbbd4738979168fb$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $dbbd4738979168fb$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.memo)($dbbd4738979168fb$var$WithRef);
var $dbbd4738979168fb$export$2e2bcd8739ae039 = $dbbd4738979168fb$var$LinkButton;

});


const $aa8d35770ac9b20b$export$fdb820c8e86996c4 = 'button';
const $aa8d35770ac9b20b$export$e9a9f8a43cd26ad7 = 'link';

parcelRegister("xkE4L", function(module, exports) {

$parcel$export(module.exports, "AddGadgetButton", () => $1158640f32a5c5ae$export$d063cb109cc3ff77);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8Dzk5 = parcelRequire("8Dzk5");

var $jfoA0 = parcelRequire("jfoA0");


var $9tagh = parcelRequire("9tagh");

var $kZXKz = parcelRequire("kZXKz");
const $1158640f32a5c5ae$export$ac0f6789672a17a7 = ({ buttonType: buttonType, columnIndex: columnIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onOpenRightPanel: onOpenRightPanel, onFocusTrigger: onFocusTrigger } = (0, $8Dzk5.useRightPanelToggle)();
    const { isTriggerFocused: isTriggerFocused } = (0, $8Dzk5.useRightPanelState)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const addGadgetButtonOnClick = (0, $eUqFw.useCallback)(()=>{
        onOpenRightPanel(`${(0, $jfoA0.addGadgetPanelId)}-${columnIndex}`);
    }, [
        onOpenRightPanel,
        columnIndex
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        onFocusTrigger(()=>buttonRef.current?.focus?.());
    }, [
        onFocusTrigger,
        isTriggerFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZXKz.AddGadgetWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        ref: buttonRef,
        appearance: buttonType === (0, $aa8d35770ac9b20b$export$fdb820c8e86996c4) ? 'default' : 'link',
        spacing: buttonType === (0, $aa8d35770ac9b20b$export$fdb820c8e86996c4) ? 'default' : 'none',
        onClick: addGadgetButtonOnClick
    }, formatMessage(buttonType === (0, $aa8d35770ac9b20b$export$fdb820c8e86996c4) ? (0, $9tagh.default).title : (0, $9tagh.default).linkTitle)));
};
const $1158640f32a5c5ae$export$d063cb109cc3ff77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "add-gadget",
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $kEBPk.ADD_GADGET_EXPERIENCE),
            reason: 'AddGadgetButton with panel ErrorBoundary'
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1158640f32a5c5ae$export$ac0f6789672a17a7, props));

});
parcelRegister("9tagh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c90ec9e54a2f7528$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c90ec9e54a2f7528$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "dashboard-edit.header-editable.add-gadget-button.title",
        "defaultMessage": "Add gadget"
    },
    linkTitle: {
        "id": "dashboard-edit.header-editable.add-gadget-button.link-title",
        "defaultMessage": "add a new gadget"
    },
    errorFlagTitle: {
        "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-title",
        "defaultMessage": "Error"
    },
    errorFlagDescription: {
        "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-description",
        "defaultMessage": "We cannot add any new gadgets at the moment"
    },
    errorFlagAction: {
        "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-action",
        "defaultMessage": "Refresh"
    }
});

});

parcelRegister("kZXKz", function(module, exports) {

$parcel$export(module.exports, "AddGadgetWrapper", () => $ab1117a97ca38dc3$export$b49fa20d3975c37f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $ab1117a97ca38dc3$export$b49fa20d3975c37f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9",
            __cmplp.className
        ])
    });
});

});


parcelRegister("iosuu", function(module, exports) {

$parcel$export(module.exports, "ChangeLayoutButton", () => $72c9c360e944de7a$export$9a00daacadaaca0d);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $eruWR = parcelRequire("eruWR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aXGDK = parcelRequire("aXGDK");

var $516dp = parcelRequire("516dp");
const $72c9c360e944de7a$export$9a00daacadaaca0d = ({ layout: layout, onLayoutSelected: onLayoutSelected })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aXGDK.LayoutPicker), {
                onLayoutSelected: onLayoutSelected,
                activeLayout: layout
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                testId: "dashboard-edit.ui.header-editable.change-layout-button.layout-picker",
                ...triggerProps,
                onClick: ()=>setIsOpen(!isOpen),
                isSelected: isOpen
            }, formatMessage((0, $516dp.default).title)),
        placement: "bottom-end"
    });
};

});
parcelRegister("aXGDK", function(module, exports) {

$parcel$export(module.exports, "LayoutPicker", () => $6b16ae69ea249a4c$export$6aaa4206f6548ae5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");

var $ka0Jf = parcelRequire("ka0Jf");

var $hukwp = parcelRequire("hukwp");

var $WWuiE = parcelRequire("WWuiE");

var $hq03h = parcelRequire("hq03h");

var $kjOwp = parcelRequire("kjOwp");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $jl1we = parcelRequire("jl1we");

var $kEBPk = parcelRequire("kEBPk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jaejX = parcelRequire("jaejX");
const $6b16ae69ea249a4c$export$6aaa4206f6548ae5 = ({ onLayoutSelected: onLayoutSelected, activeLayout: activeLayout })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const layoutComponents = {
        A: (0, (/*@__PURE__*/$parcel$interopDefault($ka0Jf))),
        AA: (0, (/*@__PURE__*/$parcel$interopDefault($WWuiE))),
        AAA: (0, (/*@__PURE__*/$parcel$interopDefault($hukwp))),
        BA: (0, (/*@__PURE__*/$parcel$interopDefault($hq03h))),
        AB: (0, (/*@__PURE__*/$parcel$interopDefault($kjOwp)))
    };
    const { oneColumn: oneColumn, twoColumns: twoColumns, threeColumns: threeColumns, leftSidebar: leftSidebar, rightSidebar: rightSidebar } = (0, $jaejX.default);
    const tooltips = {
        A: oneColumn,
        AA: twoColumns,
        AAA: threeColumns,
        BA: leftSidebar,
        AB: rightSidebar
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $6b16ae69ea249a4c$var$pickerWrapperStyles,
        role: "radiogroup"
    }, (0, $kEBPk.LAYOUTS).map((layout)=>{
        const Layout = layoutComponents[layout];
        const isSelected = layout === activeLayout;
        const label = formatMessage(tooltips[layout]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b16ae69ea249a4c$var$LayoutWrapper, {
            key: layout,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
            content: label,
            hideTooltipOnClick: true,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b16ae69ea249a4c$var$ButtonStyled, {
            testId: `dashboard-edit.ui.header-editable.change-layout-button.layout-picker.label.${layout}`,
            id: `layout-${layout}`,
            role: "radio",
            appearance: "subtle",
            spacing: "default",
            isSelected: isSelected,
            "aria-checked": isSelected,
            onClick: ()=>onLayoutSelected(layout),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Layout, {
                label: label
            })
        })));
    }));
};
const $6b16ae69ea249a4c$var$pickerWrapperStyles = (0, $8Vv3m.xcss)({
    padding: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b16ae69ea249a4c$var$LayoutWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.isSelected && "_szfs1p4p",
            __cmplp.className
        ])
    });
});
const $6b16ae69ea249a4c$var$ButtonStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lUg8E.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bg41i6y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ka0Jf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::41e644f429ebc31608f0aa82f694b308>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead54e90df591ac0$var$_react = $ead54e90df591ac0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ead54e90df591ac0$var$_layoutOneColumn = $ead54e90df591ac0$var$_interopRequireDefault((parcelRequire("j6I6x")));

var $ead54e90df591ac0$var$_layoutSingle = $ead54e90df591ac0$var$_interopRequireDefault((parcelRequire("3WJKZ")));
function $ead54e90df591ac0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LayoutOneColumnIcon.
 * This component is LayoutOneColumnIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutSingleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ead54e90df591ac0$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $ead54e90df591ac0$var$_react.default.createElement($ead54e90df591ac0$var$_layoutOneColumn.default, Object.assign({
        LEGACY_fallbackIcon: $ead54e90df591ac0$var$_layoutSingle.default
    }, props));
$ead54e90df591ac0$var$LayoutOneColumnIcon.Name = 'LayoutOneColumnIconMigration';
var $ead54e90df591ac0$var$_default = module.exports.default = $ead54e90df591ac0$var$LayoutOneColumnIcon;

});
parcelRegister("j6I6x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::496f3255c64271c15767a53b23a862fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de90ca0f6a1d7e78$var$_react = $de90ca0f6a1d7e78$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de90ca0f6a1d7e78$var$_UNSAFE_baseNew = $de90ca0f6a1d7e78$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $de90ca0f6a1d7e78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutOneColumn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de90ca0f6a1d7e78$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $de90ca0f6a1d7e78$var$_react.default.createElement($de90ca0f6a1d7e78$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.375c0-.345.28-.625.625-.625h13.25c.345 0 .625.28.625.625v11.25c0 .345-.28.625-.625.625H1.375a.625.625 0 0 1-.625-.625z"/>`
    }, props));
$de90ca0f6a1d7e78$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIcon';
var $de90ca0f6a1d7e78$var$_default = module.exports.default = $de90ca0f6a1d7e78$var$LayoutOneColumnIcon;

});

parcelRegister("3WJKZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dfa484482d422ea$var$_react = $2dfa484482d422ea$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $2dfa484482d422ea$var$_layoutOneColumn = $2dfa484482d422ea$var$_interopRequireDefault((parcelRequire("j6I6x")));
function $2dfa484482d422ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2dfa484482d422ea$var$EditorLayoutSingleIcon = (props)=>/*#__PURE__*/ $2dfa484482d422ea$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="16" height="14" x="4" y="5" fill="currentcolor" rx="2"/></svg>`
    }, props, {
        newIcon: $2dfa484482d422ea$var$_layoutOneColumn.default
    }));
$2dfa484482d422ea$var$EditorLayoutSingleIcon.displayName = 'EditorLayoutSingleIcon';
var $2dfa484482d422ea$var$_default = module.exports.default = $2dfa484482d422ea$var$EditorLayoutSingleIcon;

});


parcelRegister("hukwp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a50b39922ba23527cd2664948304a150>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbb5283669d8cc38$var$_react = $cbb5283669d8cc38$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cbb5283669d8cc38$var$_layoutThreeColumns = $cbb5283669d8cc38$var$_interopRequireDefault((parcelRequire("2MSgz")));

var $cbb5283669d8cc38$var$_layoutThreeEqual = $cbb5283669d8cc38$var$_interopRequireDefault((parcelRequire("htGDr")));
function $cbb5283669d8cc38$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LayoutThreeColumnsIcon.
 * This component is LayoutThreeColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutThreeEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbb5283669d8cc38$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $cbb5283669d8cc38$var$_react.default.createElement($cbb5283669d8cc38$var$_layoutThreeColumns.default, Object.assign({
        LEGACY_fallbackIcon: $cbb5283669d8cc38$var$_layoutThreeEqual.default
    }, props));
$cbb5283669d8cc38$var$LayoutThreeColumnsIcon.Name = 'LayoutThreeColumnsIconMigration';
var $cbb5283669d8cc38$var$_default = module.exports.default = $cbb5283669d8cc38$var$LayoutThreeColumnsIcon;

});
parcelRegister("2MSgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd95d66c12bc11130c701a7ecc96b857>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $207a289cb24ef265$var$_react = $207a289cb24ef265$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $207a289cb24ef265$var$_UNSAFE_baseNew = $207a289cb24ef265$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $207a289cb24ef265$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $207a289cb24ef265$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $207a289cb24ef265$var$_react.default.createElement($207a289cb24ef265$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h1.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.5a.63.63 0 0 1-.62-.62zm11.75 0c0-.34.28-.62.63-.62h1.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.5a.63.63 0 0 1-.62-.62zm-6 0c0-.34.28-.62.63-.62h1.75c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63H7.14a.63.63 0 0 1-.62-.62z"/>`
    }, props));
$207a289cb24ef265$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $207a289cb24ef265$var$_default = module.exports.default = $207a289cb24ef265$var$LayoutThreeColumnsIcon;

});

parcelRegister("htGDr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb96378ea2e9dfda$var$_react = $cb96378ea2e9dfda$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $cb96378ea2e9dfda$var$_layoutThreeColumns = $cb96378ea2e9dfda$var$_interopRequireDefault((parcelRequire("2MSgz")));
function $cb96378ea2e9dfda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cb96378ea2e9dfda$var$EditorLayoutThreeEqualIcon = (props)=>/*#__PURE__*/ $cb96378ea2e9dfda$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $cb96378ea2e9dfda$var$_layoutThreeColumns.default
    }));
$cb96378ea2e9dfda$var$EditorLayoutThreeEqualIcon.displayName = 'EditorLayoutThreeEqualIcon';
var $cb96378ea2e9dfda$var$_default = module.exports.default = $cb96378ea2e9dfda$var$EditorLayoutThreeEqualIcon;

});


parcelRegister("WWuiE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e403e3a5feb1bf1bbd2fbfda662020c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b12c9559cd2a2cc$var$_react = $0b12c9559cd2a2cc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0b12c9559cd2a2cc$var$_layoutTwoColumns = $0b12c9559cd2a2cc$var$_interopRequireDefault((parcelRequire("fNL8c")));

var $0b12c9559cd2a2cc$var$_layoutTwoEqual = $0b12c9559cd2a2cc$var$_interopRequireDefault((parcelRequire("8DT8A")));
function $0b12c9559cd2a2cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LayoutTwoColumnsIcon.
 * This component is LayoutTwoColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b12c9559cd2a2cc$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $0b12c9559cd2a2cc$var$_react.default.createElement($0b12c9559cd2a2cc$var$_layoutTwoColumns.default, Object.assign({
        LEGACY_fallbackIcon: $0b12c9559cd2a2cc$var$_layoutTwoEqual.default
    }, props));
$0b12c9559cd2a2cc$var$LayoutTwoColumnsIcon.Name = 'LayoutTwoColumnsIconMigration';
var $0b12c9559cd2a2cc$var$_default = module.exports.default = $0b12c9559cd2a2cc$var$LayoutTwoColumnsIcon;

});
parcelRegister("fNL8c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31ebc2bd4e3c0f44a70db1c36939486a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80ffde85d6edfd6$var$_react = $b80ffde85d6edfd6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b80ffde85d6edfd6$var$_UNSAFE_baseNew = $b80ffde85d6edfd6$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $b80ffde85d6edfd6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b80ffde85d6edfd6$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $b80ffde85d6edfd6$var$_react.default.createElement($b80ffde85d6edfd6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h4.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-4.5a.63.63 0 0 1-.62-.62zm8.75 0c0-.34.28-.62.63-.62h4.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-4.5a.63.63 0 0 1-.62-.62z"/>`
    }, props));
$b80ffde85d6edfd6$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $b80ffde85d6edfd6$var$_default = module.exports.default = $b80ffde85d6edfd6$var$LayoutTwoColumnsIcon;

});

parcelRegister("8DT8A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64acbc651b633f1c$var$_react = $64acbc651b633f1c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $64acbc651b633f1c$var$_layoutTwoColumns = $64acbc651b633f1c$var$_interopRequireDefault((parcelRequire("fNL8c")));
function $64acbc651b633f1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64acbc651b633f1c$var$EditorLayoutTwoEqualIcon = (props)=>/*#__PURE__*/ $64acbc651b633f1c$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m9 0h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $64acbc651b633f1c$var$_layoutTwoColumns.default
    }));
$64acbc651b633f1c$var$EditorLayoutTwoEqualIcon.displayName = 'EditorLayoutTwoEqualIcon';
var $64acbc651b633f1c$var$_default = module.exports.default = $64acbc651b633f1c$var$EditorLayoutTwoEqualIcon;

});


parcelRegister("hq03h", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d714267f784dab97fad7e043a67cf6e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cae4e7af02043d62$var$_react = $cae4e7af02043d62$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cae4e7af02043d62$var$_layoutTwoColumnsSidebarLeft = $cae4e7af02043d62$var$_interopRequireDefault((parcelRequire("aBuxW")));

var $cae4e7af02043d62$var$_layoutTwoLeftSidebar = $cae4e7af02043d62$var$_interopRequireDefault((parcelRequire("deVrP")));
function $cae4e7af02043d62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LayoutTwoColumnsSidebarLeftIcon.
 * This component is LayoutTwoColumnsSidebarLeftIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoLeftSidebarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cae4e7af02043d62$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $cae4e7af02043d62$var$_react.default.createElement($cae4e7af02043d62$var$_layoutTwoColumnsSidebarLeft.default, Object.assign({
        LEGACY_fallbackIcon: $cae4e7af02043d62$var$_layoutTwoLeftSidebar.default
    }, props));
$cae4e7af02043d62$var$LayoutTwoColumnsSidebarLeftIcon.Name = 'LayoutTwoColumnsSidebarLeftIconMigration';
var $cae4e7af02043d62$var$_default = module.exports.default = $cae4e7af02043d62$var$LayoutTwoColumnsSidebarLeftIcon;

});
parcelRegister("aBuxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6397369adbf76bfcdb166691527504ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b850dfd3fe51c21$var$_react = $7b850dfd3fe51c21$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7b850dfd3fe51c21$var$_UNSAFE_baseNew = $7b850dfd3fe51c21$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $7b850dfd3fe51c21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b850dfd3fe51c21$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $7b850dfd3fe51c21$var$_react.default.createElement($7b850dfd3fe51c21$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 2.38a.63.63 0 0 0-.62-.62H6.88a.63.63 0 0 0-.62.63v11.25c0 .35.28.63.63.63h7.75c.35 0 .63-.28.63-.62zm-12 0a.63.63 0 0 0-.62-.62H1.38a.63.63 0 0 0-.62.63v11.25c0 .35.28.63.63.63h1.25c.35 0 .63-.28.63-.62z"/>`
    }, props));
$7b850dfd3fe51c21$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $7b850dfd3fe51c21$var$_default = module.exports.default = $7b850dfd3fe51c21$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("deVrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a39251b4c63a65a$var$_react = $9a39251b4c63a65a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $9a39251b4c63a65a$var$_layoutTwoColumnsSidebarLeft = $9a39251b4c63a65a$var$_interopRequireDefault((parcelRequire("aBuxW")));
function $9a39251b4c63a65a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a39251b4c63a65a$var$EditorLayoutTwoLeftSidebarIcon = (props)=>/*#__PURE__*/ $9a39251b4c63a65a$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m5 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $9a39251b4c63a65a$var$_layoutTwoColumnsSidebarLeft.default
    }));
$9a39251b4c63a65a$var$EditorLayoutTwoLeftSidebarIcon.displayName = 'EditorLayoutTwoLeftSidebarIcon';
var $9a39251b4c63a65a$var$_default = module.exports.default = $9a39251b4c63a65a$var$EditorLayoutTwoLeftSidebarIcon;

});


parcelRegister("kjOwp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::49986130c279c207a10fba4cc9de95c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecacc58a328949f2$var$_react = $ecacc58a328949f2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ecacc58a328949f2$var$_layoutTwoColumnsSidebarRight = $ecacc58a328949f2$var$_interopRequireDefault((parcelRequire("kEfsD")));

var $ecacc58a328949f2$var$_layoutTwoRightSidebar = $ecacc58a328949f2$var$_interopRequireDefault((parcelRequire("8FkLu")));
function $ecacc58a328949f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LayoutTwoColumnsSidebarRightIcon.
 * This component is LayoutTwoColumnsSidebarRightIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoRightSidebarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ecacc58a328949f2$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $ecacc58a328949f2$var$_react.default.createElement($ecacc58a328949f2$var$_layoutTwoColumnsSidebarRight.default, Object.assign({
        LEGACY_fallbackIcon: $ecacc58a328949f2$var$_layoutTwoRightSidebar.default
    }, props));
$ecacc58a328949f2$var$LayoutTwoColumnsSidebarRightIcon.Name = 'LayoutTwoColumnsSidebarRightIconMigration';
var $ecacc58a328949f2$var$_default = module.exports.default = $ecacc58a328949f2$var$LayoutTwoColumnsSidebarRightIcon;

});
parcelRegister("kEfsD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97e3a560e7c99a6460e31781ec0db2de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f08389447c0a2391$var$_react = $f08389447c0a2391$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f08389447c0a2391$var$_UNSAFE_baseNew = $f08389447c0a2391$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $f08389447c0a2391$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LayoutTwoColumnsSidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f08389447c0a2391$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $f08389447c0a2391$var$_react.default.createElement($f08389447c0a2391$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h7.75c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63H1.39a.63.63 0 0 1-.62-.62zm12 0c0-.34.28-.62.63-.62h1.25c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.25a.63.63 0 0 1-.62-.62z"/>`
    }, props));
$f08389447c0a2391$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIcon';
var $f08389447c0a2391$var$_default = module.exports.default = $f08389447c0a2391$var$LayoutTwoColumnsSidebarRightIcon;

});

parcelRegister("8FkLu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64f2428c619782fe$var$_react = $64f2428c619782fe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $64f2428c619782fe$var$_layoutTwoColumnsSidebarRight = $64f2428c619782fe$var$_interopRequireDefault((parcelRequire("kEfsD")));
function $64f2428c619782fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64f2428c619782fe$var$EditorLayoutTwoRightSidebarIcon = (props)=>/*#__PURE__*/ $64f2428c619782fe$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M5 5h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $64f2428c619782fe$var$_layoutTwoColumnsSidebarRight.default
    }));
$64f2428c619782fe$var$EditorLayoutTwoRightSidebarIcon.displayName = 'EditorLayoutTwoRightSidebarIcon';
var $64f2428c619782fe$var$_default = module.exports.default = $64f2428c619782fe$var$EditorLayoutTwoRightSidebarIcon;

});


parcelRegister("jaejX", function(module, exports) {

$parcel$export(module.exports, "default", () => $410637ce93252e70$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $410637ce93252e70$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    oneColumn: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.one-column",
        "defaultMessage": "One column"
    },
    twoColumns: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.two-columns",
        "defaultMessage": "Two columns"
    },
    threeColumns: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.three-columns",
        "defaultMessage": "Three columns"
    },
    leftSidebar: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.left-sidebar",
        "defaultMessage": "Left sidebar"
    },
    rightSidebar: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.right-sidebar",
        "defaultMessage": "Right sidebar"
    }
});

});


parcelRegister("516dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaaf90b9b7be72cb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aaaf90b9b7be72cb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "dashboard-edit.header-editable.change-layout-button.title",
        "defaultMessage": "Change layout"
    }
});

});


parcelRegister("arZHy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce62acf9c17a425c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ce62acf9c17a425c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    done: {
        "id": "dashboard-edit.header-editable.done",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("ljLL8", function(module, exports) {

$parcel$export(module.exports, "ColumnPlaceholder", () => $689b99f5f807bc2a$export$f0705bf8199f32ef);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $iBeSy = parcelRequire("iBeSy");
var $8Vv3m = parcelRequire("8Vv3m");


var $kEBPk = parcelRequire("kEBPk");

var $zdVcQ = parcelRequire("zdVcQ");

var $gyaWd = parcelRequire("gyaWd");

var $5JgJ2 = parcelRequire("5JgJ2");


var $xkE4L = parcelRequire("xkE4L");

var $8RLKu = parcelRequire("8RLKu");
const $689b99f5f807bc2a$var$GadgetPlaceholder = ({ isDraggingOver: isDraggingOver, columnIndex: columnIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const heightRef = (0, $eUqFw.useRef)(null);
    const [height, setHeight] = (0, $eUqFw.useState)();
    // We want the placeholder to take up the rest of the remaining visible space
    // in the column, which we can't really do with CSS, so we'll calculate what
    // the height should be with JavaScript.
    (0, $eUqFw.useEffect)(()=>{
        if (!heightRef.current) return;
        const distanceFromTopOfWindow = heightRef.current.getBoundingClientRect().top;
        setHeight(`calc(100vh - ${distanceFromTopOfWindow}px - ${(0, $kEBPk.FOOTER_MARGIN)}px)`);
    }, [
        heightRef
    ]);
    return(// According to https://hello.atlassian.net/wiki/spaces/AF/pages/2630143294/CSS+and+Styling+Components
    // this is the correct way to handle styles that can't be known ahead of time
    // eslint-disable-next-line jira/react/no-style-attribute
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: heightRef,
        style: {
            height: height
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        xcss: [
            $689b99f5f807bc2a$var$wrapperStyles,
            isDraggingOver ? $689b99f5f807bc2a$var$draggingStyles : $689b99f5f807bc2a$var$notDraggingStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $689b99f5f807bc2a$var$imageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gyaWd.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $689b99f5f807bc2a$var$contentStyles
    }, formatMessage((0, $8RLKu.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xkE4L.AddGadgetButton), {
        buttonType: (0, $aa8d35770ac9b20b$export$e9a9f8a43cd26ad7),
        columnIndex: columnIndex
    })))));
};
const $689b99f5f807bc2a$export$f0705bf8199f32ef = ({ customHeight: customHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $zdVcQ.ColumnPlaceholderContextConsumer), null, (placeholderProps)=>placeholderProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689b99f5f807bc2a$var$GadgetPlaceholder, {
            ...placeholderProps,
            customHeight: customHeight
        }));
const $689b99f5f807bc2a$var$wrapperStyles = (0, $8Vv3m.xcss)({
    height: '100%',
    minHeight: '400px',
    marginBottom: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `dashed ${`var(--ds-border-bold, ${(0, $1b343b038f6c23ec$exports).N60})`} 1px`,
    borderRadius: 'border.radius.050',
    transition: 'background-color 0.2s ease'
});
const $689b99f5f807bc2a$var$notDraggingStyles = (0, $8Vv3m.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-input, ${(0, $1b343b038f6c23ec$exports).N0})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
const $689b99f5f807bc2a$var$draggingStyles = (0, $8Vv3m.xcss)({
    background: `var(--ds-background-input-hovered, ${(0, $1b343b038f6c23ec$exports).N20})`
});
const $689b99f5f807bc2a$var$contentStyles = (0, $8Vv3m.xcss)({
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
    marginTop: 'space.200',
    color: 'color.text.subtlest'
});
const $689b99f5f807bc2a$var$imageStyles = (0, $8Vv3m.xcss)({
    width: '112px',
    marginInline: 'auto'
});

});
parcelRegister("8RLKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e748b2c374320060$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e748b2c374320060$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        "id": "dashboard-edit.placeholder.description",
        "defaultMessage": "Drag a gadget to this column or "
    }
});

});


parcelRegister("9r5zP", function(module, exports) {

$parcel$export(module.exports, "useLayoutChangeErrorFlag", () => $490c3bdf879fbfa9$export$c213d29262fac822);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $hAPnk = parcelRequire("hAPnk");
const $490c3bdf879fbfa9$export$c213d29262fac822 = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    return (0, $eUqFw.useCallback)(()=>{
        showFlag({
            key: (0, $eo17r.toFlagId)('layoutChangeError'),
            type: 'error',
            title: (0, $hAPnk.default).changeLayoutErrorFlagTitle,
            description: (0, $hAPnk.default).changeLayoutErrorFlagDescription,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            actions: [
                {
                    content: (0, $hAPnk.default).errorFlagAction,
                    onClick: ()=>window.location.reload()
                }
            ]
        });
    }, [
        showFlag
    ]);
};

});
parcelRegister("hAPnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3bac5ffa88b9068$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b3bac5ffa88b9068$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changeLayoutErrorFlagTitle: {
        "id": "dashboard-edit.utils.change-layout-error.change-layout-error-flag-title",
        "defaultMessage": "Error"
    },
    changeLayoutErrorFlagDescription: {
        "id": "dashboard-edit.utils.change-layout-error.change-layout-error-flag-description",
        "defaultMessage": "Failed to save layout, please refresh the page"
    },
    errorFlagAction: {
        "id": "dashboard-edit.utils.change-layout-error.error-flag-action",
        "defaultMessage": "Refresh"
    }
});

});




//# sourceMappingURL=async-dashboard-edit.c4c04cdb.js.map
